// @ts-nocheck
// ⚠️ Do not edit ⚠️
// This file is automagically generated
// See codegen.yml under `graphql-codegen`
export type JSONType = null | string | boolean | number | JSONType[] | { [key: string]: JSONType }

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
export const namedOperations = {
  Query: {
    GlobalBars: 'GlobalBars',
    Cart: 'Cart',
    CartSummary: 'CartSummary',
    CheckoutCart: 'CheckoutCart',
    ShippingMethod: 'ShippingMethod',
    Me: 'Me',
    MeWithClub: 'MeWithClub',
    DrawerPage: 'DrawerPage',
    DrawerPages: 'DrawerPages',
    GlobalCMSData: 'GlobalCMSData',
    LatestArticlesAndCollections: 'LatestArticlesAndCollections',
    GlobalNavigation: 'GlobalNavigation',
    ProductForAddToCart: 'ProductForAddToCart',
    ProductReviews: 'ProductReviews',
    ProductTactics: 'ProductTactics',
    SinglePost: 'SinglePost',
    SingleProduct: 'SingleProduct',
    TrackingData: 'TrackingData',
    CustomersGlobalsQuery: 'CustomersGlobalsQuery',
    GlobalFacetDescriptions: 'GlobalFacetDescriptions',
    GlobalInjections: 'GlobalInjections',
    GlobalPaymentMethods: 'GlobalPaymentMethods',
    ProductAnalytics: 'ProductAnalytics',
    ReturnOptionsByEmail: 'ReturnOptionsByEmail',
    EstimateReturnTotals: 'EstimateReturnTotals',
    OrderReview: 'OrderReview',
    Survey: 'Survey',
    ShippingInfo: 'ShippingInfo',
    StoresGlobalsQuery: 'StoresGlobalsQuery',
    success: 'success'
  },
  Mutation: {
    AddToCart: 'AddToCart',
    AuthenticateCart: 'AuthenticateCart',
    FinalizeCart: 'FinalizeCart',
    DetailsForPayment: 'DetailsForPayment',
    InitializePaymentMethod: 'InitializePaymentMethod',
    RefreshCart: 'RefreshCart',
    RemoveFromCart: 'RemoveFromCart',
    SetAddressesInCart: 'SetAddressesInCart',
    SetDiscountCodeInCart: 'SetDiscountCodeInCart',
    SetQuantityInCart: 'SetQuantityInCart',
    SetShippingMethodInCartDelivery: 'SetShippingMethodInCartDelivery',
    SetVariantInCart: 'SetVariantInCart',
    SubscribeToNewsletter: 'SubscribeToNewsletter',
    subscribeToBackInStock: 'subscribeToBackInStock',
    CreateReturn: 'CreateReturn',
    CreateOrderReview: 'CreateOrderReview'
  },
  Fragment: {
    BarContent: 'BarContent',
    AddToCartPromptSuccessTacticFragment: 'AddToCartPromptSuccessTacticFragment',
    CartContent: 'CartContent',
    CartAddressContent: 'CartAddressContent',
    CartAvailableShippingMethodsFragment: 'CartAvailableShippingMethodsFragment',
    MilestoneFragment: 'MilestoneFragment',
    PageItem: 'PageItem',
    LatestPageItem: 'LatestPageItem',
    PageContent: 'PageContent',
    NavigationItemFragment: 'NavigationItemFragment',
    BlockAppearanceFragment: 'BlockAppearanceFragment',
    ElementsContent: 'ElementsContent',
    BlockLinkFragment: 'BlockLinkFragment',
    BlockRTEFieldFragment: 'BlockRTEFieldFragment',
    BlockContent: 'BlockContent',
    DrawerData: 'DrawerData',
    FieldContent: 'FieldContent',
    NestableFieldContent: 'NestableFieldContent',
    Fields: 'Fields',
    MoneyContent: 'MoneyContent',
    MultipleLinkFieldContent: 'MultipleLinkFieldContent',
    OpenGraphContent: 'OpenGraphContent',
    PersonalizationOptions: 'PersonalizationOptions',
    PriceFragment: 'PriceFragment',
    ProductBundle: 'ProductBundle',
    ProductContent: 'ProductContent',
    ProductCrossSellAndPersonalizationContent: 'ProductCrossSellAndPersonalizationContent',
    ProductReviews: 'ProductReviews',
    ProductSizeGuideColumnContent: 'ProductSizeGuideColumnContent',
    ProductSizeGuideContent: 'ProductSizeGuideContent',
    ProductSpecificationItemFragment: 'ProductSpecificationItemFragment',
    ProductSpecificationFragment: 'ProductSpecificationFragment',
    ProductTileFragment: 'ProductTileFragment',
    ImageAssetFragment: 'ImageAssetFragment',
    ImageResourceImageFragment: 'ImageResourceImageFragment',
    ImageResourceFragment: 'ImageResourceFragment',
    VideoResourceFragment: 'VideoResourceFragment',
    ReferenceContent: 'ReferenceContent',
    PageSliderBlock: 'PageSliderBlock',
    ProductListBlockFacetValueFragment: 'ProductListBlockFacetValueFragment',
    ProductListBlockFragment: 'ProductListBlockFragment',
    InjectionSelectorFragment: 'InjectionSelectorFragment',
    InjectionPlacementFragment: 'InjectionPlacementFragment',
    ProductPageTacticFragment: 'ProductPageTacticFragment',
    ProductTile: 'ProductTile',
    RecommendationContent: 'RecommendationContent',
    OrderReviewFragment: 'OrderReviewFragment',
    ShippingInfoPriceFragment: 'ShippingInfoPriceFragment',
    Money: 'Money',
    AddToCartProductTacticFragment: 'AddToCartProductTacticFragment',
    TacticRecommendationsFragment: 'TacticRecommendationsFragment',
    WordbookFragment: 'WordbookFragment'
  }
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: Date;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: JSONType;
};

export type AcceptPostPurchaseUpsellLegacy = {
  __typename?: 'AcceptPostPurchaseUpsellLegacy';
  successPageLegacy?: Maybe<SuccessPageLegacy>;
  postPurchaseUpsellProfit?: Maybe<PostPurchaseUpsellProfitLegacy>;
};

export type AccordionItem = IWithFields & {
  __typename?: 'AccordionItem';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Field>>;
};

export type AccordionListBlock = IBlock & IWithFields & {
  __typename?: 'AccordionListBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Field>>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
  accordions?: Maybe<Array<AccordionItem>>;
};

export type ActiveCampaignBlock = IBlock & {
  __typename?: 'ActiveCampaignBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
  description?: Maybe<RteField>;
  highlightText?: Maybe<Scalars['String']>;
};

export type AddToCartProductChildInput = {
  productID: Scalars['ID'];
  variantID?: Maybe<Scalars['ID']>;
};

export type AddToCartProductGiftcardInput = {
  amount: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
};

export type AddToCartProductInput = {
  productID: Scalars['ID'];
  variantID?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Int']>;
  parentIndex?: Maybe<Scalars['Int']>;
  parentLineItemID?: Maybe<Scalars['ID']>;
  children?: Maybe<Array<AddToCartProductChildInput>>;
  giftcard?: Maybe<AddToCartProductGiftcardInput>;
  personalization?: Maybe<AddToCartProductPersonalizationInput>;
  milestoneID?: Maybe<Scalars['ID']>;
  groupIndex?: Maybe<Scalars['Int']>;
  skipIfExists?: Maybe<Scalars['Boolean']>;
  tactic?: Maybe<AddToCartProductTacticInput>;
};

export type AddToCartProductPersonalizationInput = {
  blobID?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
};

export type AddToCartProductTactic = {
  __typename?: 'AddToCartProductTactic';
  checksum: Scalars['String'];
  type: Scalars['String'];
  price?: Maybe<Price>;
};

export type AddToCartProductTacticInput = {
  checksum: Scalars['String'];
  type: Scalars['String'];
  price: PriceInput;
};

export type AddToCartPrompt = AddToCartPromptError | AddToCartPromptGiftcard | AddToCartPromptPersonalization | AddToCartPromptSelectVariant | AddToCartPromptSuccess;

export type AddToCartPromptError = IWithIndex & {
  __typename?: 'AddToCartPromptError';
  index: Scalars['Int'];
  code: Scalars['String'];
  message: Scalars['String'];
};

export type AddToCartPromptGiftcard = IWithIndex & {
  __typename?: 'AddToCartPromptGiftcard';
  index: Scalars['Int'];
  code: Scalars['String'];
  message: Scalars['String'];
};

export type AddToCartPromptPersonalization = IWithIndex & IWithProduct & IWithProducts & {
  __typename?: 'AddToCartPromptPersonalization';
  index: Scalars['Int'];
  code: Scalars['String'];
  message: Scalars['String'];
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type AddToCartPromptPersonalizationProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};


export type AddToCartPromptPersonalizationProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type AddToCartPromptSelectVariant = IWithIndex & IWithProduct & IWithProducts & {
  __typename?: 'AddToCartPromptSelectVariant';
  index: Scalars['Int'];
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type AddToCartPromptSelectVariantProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};


export type AddToCartPromptSelectVariantProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type AddToCartPromptSuccess = IWithRecommendations & {
  __typename?: 'AddToCartPromptSuccess';
  freeShipping?: Maybe<FreeShipping>;
  primaryLineItemID?: Maybe<Scalars['ID']>;
  secondaryLineItemIDs?: Maybe<Array<Scalars['ID']>>;
  /** @deprecated Use `tactics.silver` field instead */
  recommendations?: Maybe<Array<Recommendation>>;
  /** @deprecated Use `tactics` instead */
  tactic?: Maybe<AddToCartPromptSuccessTactic>;
  tactics?: Maybe<AddToCartPromptSuccessTactics>;
};

export type AddToCartPromptSuccessTactic = TacticAddAndSave | TacticBoughtTogether | TacticBuildYourDiscount | TacticMatchingVariant | TacticRelativeDiscount | TacticUpgradeWith;

export type AddToCartPromptSuccessTactics = {
  __typename?: 'AddToCartPromptSuccessTactics';
  gold?: Maybe<Array<AddToCartPromptSuccessTactic>>;
  silver?: Maybe<Array<AddToCartPromptSuccessTactic>>;
};

export type AddToCartResponse = {
  __typename?: 'AddToCartResponse';
  addedLineItemIDs?: Maybe<Array<Scalars['ID']>>;
  cart?: Maybe<Cart>;
  success: Scalars['Boolean'];
  prompts?: Maybe<Array<AddToCartPrompt>>;
};

export type Address = {
  __typename?: 'Address';
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  additionalStreetInfo?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phonePrefix?: Maybe<Scalars['String']>;
};

export type AddressMetaData = {
  __typename?: 'AddressMetaData';
  countries?: Maybe<Array<Country>>;
  regions?: Maybe<Array<Scalars['String']>>;
  showAdditionalStreetInfo?: Maybe<Scalars['Boolean']>;
  showRegion?: Maybe<Scalars['Boolean']>;
  showState?: Maybe<Scalars['Boolean']>;
  states?: Maybe<Array<Scalars['String']>>;
};

export type AlternateLink = {
  __typename?: 'AlternateLink';
  url?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type AnchorInjection = {
  __typename?: 'AnchorInjection';
  id?: Maybe<Scalars['ID']>;
  selector?: Maybe<InjectionSelector>;
  placement?: Maybe<InjectionPlacement>;
  items?: Maybe<Array<AnchorInjectionType>>;
  splitTest?: Maybe<SplitTest>;
};

export type AnchorInjectionType = InjectionTypeAnchor | InjectionTypeGrid;

export type Asset = {
  __typename?: 'Asset';
  dimensions?: Maybe<Dimensions>;
  url: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type Attribute = BaseAttribute | MoneyAttribute | ProductAttribute | ProductsWithQuantityAttribute;

export type AttributePrice = {
  __typename?: 'AttributePrice';
  difference?: Maybe<Money>;
  originalPrice?: Maybe<Money>;
  price?: Maybe<Money>;
};

export type AuthenticateCartResponse = {
  __typename?: 'AuthenticateCartResponse';
  cart?: Maybe<Cart>;
  success: Scalars['Boolean'];
};

export type Availability = {
  __typename?: 'Availability';
  isInStock?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type Bar = IWithFields & {
  __typename?: 'Bar';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Field>>;
  placement?: Maybe<Array<Scalars['String']>>;
  priority: Scalars['Int'];
  addons?: Maybe<Array<Scalars['String']>>;
  conditions?: Maybe<Array<Scalars['String']>>;
  urgencyTimerDateStart?: Maybe<Scalars['DateTime']>;
  urgencyTimerDateEnd?: Maybe<Scalars['DateTime']>;
  splitTest?: Maybe<SplitTest>;
  theme?: Maybe<Scalars['String']>;
};

export type BaseAttribute = IAttribute & {
  __typename?: 'BaseAttribute';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type Blob = {
  __typename?: 'Blob';
  id?: Maybe<Scalars['ID']>;
  contentType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Block = IBlock & IWithFields & {
  __typename?: 'Block';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Field>>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
};

export type BlockAppearance = {
  __typename?: 'BlockAppearance';
  asset?: Maybe<Reference>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  extraColors?: Maybe<Scalars['JSON']>;
  font?: Maybe<Scalars['String']>;
};

export type BlockCommon = {
  __typename?: 'BlockCommon';
  chips?: Maybe<Array<BlockCommonChip>>;
  label?: Maybe<BlockCommonLabel>;
  position?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  text?: Maybe<RteField>;
  title?: Maybe<Scalars['String']>;
  titleElement?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['JSON']>;
};

export type BlockCommonChip = {
  __typename?: 'BlockCommonChip';
  appearance?: Maybe<BlockAppearance>;
  link?: Maybe<Link>;
};

export type BlockCommonLabel = {
  __typename?: 'BlockCommonLabel';
  appearance?: Maybe<BlockAppearance>;
  text?: Maybe<Wordbook>;
};

export type BlockInjection = IWithBlocks & {
  __typename?: 'BlockInjection';
  id?: Maybe<Scalars['ID']>;
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
  placement?: Maybe<InjectionPlacement>;
  placementModifier?: Maybe<Scalars['Int']>;
  placementOccurrences?: Maybe<Scalars['Int']>;
  priority: Scalars['Int'];
  selector?: Maybe<InjectionSelector>;
  splitTest?: Maybe<SplitTest>;
};

export type BlockType = Block | AccordionListBlock | ActiveCampaignBlock | GalleryBlock | HtmlBlock | InfoPanelBlock | LookDisplayBlock | LookListBlock | PageGridBlock | PageSliderBlock | ProductGridSelectorBlock | ProductListBlock | ProductSliderBlock | UspBlock;

export type BlockTypeWithGlobal = Block | AccordionListBlock | ActiveCampaignBlock | GalleryBlock | GlobalBlock | HtmlBlock | InfoPanelBlock | LookDisplayBlock | LookListBlock | PageGridBlock | PageSliderBlock | ProductGridSelectorBlock | ProductListBlock | ProductSliderBlock | UspBlock;

export type Brand = {
  __typename?: 'Brand';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Button = {
  __typename?: 'Button';
  text?: Maybe<Scalars['String']>;
  link?: Maybe<LinkField>;
};

export type CampaignTag = {
  __typename?: 'CampaignTag';
  text?: Maybe<RteField>;
  appearance?: Maybe<BlockAppearance>;
};

export type CaptionOptions = IWithReferences & {
  __typename?: 'CaptionOptions';
  caption?: Maybe<Scalars['String']>;
  references?: Maybe<Array<Reference>>;
};

export type Cart = IWithRecommendations & {
  __typename?: 'Cart';
  id: Scalars['ID'];
  consents?: Maybe<Array<Scalars['String']>>;
  customerID?: Maybe<Scalars['ID']>;
  billingAddress?: Maybe<CartAddress>;
  shippingAddress?: Maybe<CartAddress>;
  deliveryAddress?: Maybe<CartAddress>;
  shippingMethodID?: Maybe<Scalars['ID']>;
  discountCodes?: Maybe<Array<CartDiscountCode>>;
  lineItems?: Maybe<Array<CartLineItem>>;
  lineItemGroups?: Maybe<Array<CartLineItemGroup>>;
  recoverableLineItemIDs?: Maybe<Array<Scalars['ID']>>;
  totals?: Maybe<Array<CartTotal>>;
  freeShipping?: Maybe<FreeShipping>;
  frozen: Scalars['Boolean'];
  valid: Scalars['Boolean'];
  expectedDelivery?: Maybe<Scalars['String']>;
  clubTrendhim?: Maybe<CartClubTrendhim>;
  milestones?: Maybe<CartMilestones>;
  checksum: Scalars['String'];
  serviceLocationExternalID?: Maybe<Scalars['String']>;
  club?: Maybe<CartClub>;
  availablePaymentMethods?: Maybe<Array<PaymentMethod>>;
  recommendations?: Maybe<Array<Recommendation>>;
  availableShippingMethods?: Maybe<Array<ShippingMethod>>;
};

export type CartAddress = {
  __typename?: 'CartAddress';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  additionalStreetInfo?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phonePrefix?: Maybe<Scalars['String']>;
  externalID?: Maybe<Scalars['String']>;
  externalCustomerID?: Maybe<Scalars['String']>;
};


export type CartAddressEmailArgs = {
  mode?: Maybe<StringFormatMode>;
};


export type CartAddressPhoneArgs = {
  mode?: Maybe<StringFormatMode>;
};

export type CartClub = {
  __typename?: 'CartClub';
  balance?: Maybe<Money>;
  isLoggedIn: Scalars['Boolean'];
  value?: Maybe<Money>;
};

export type CartClubTrendhim = {
  __typename?: 'CartClubTrendhim';
  value?: Maybe<Money>;
};

export type CartDiscountCode = {
  __typename?: 'CartDiscountCode';
  id: Scalars['ID'];
  code: Scalars['String'];
  title: Scalars['String'];
};

export type CartLineItem = IWithProduct & {
  __typename?: 'CartLineItem';
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  eligibleQuantity: Scalars['Int'];
  price?: Maybe<Price>;
  totalPrice?: Maybe<Price>;
  totalTaxedPrice?: Maybe<TaxedPrice>;
  errors?: Maybe<Array<CartLineItemError>>;
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  variant?: Maybe<ProductVariant>;
  type?: Maybe<CartLineItemType>;
  discountText?: Maybe<Scalars['String']>;
  tactic?: Maybe<Array<Scalars['String']>>;
};


export type CartLineItemProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type CartLineItemError = {
  __typename?: 'CartLineItemError';
  code: Scalars['String'];
  message: Scalars['String'];
  suggestion?: Maybe<Wordbook>;
};

export type CartLineItemGroup = {
  __typename?: 'CartLineItemGroup';
  id: Scalars['ID'];
  type: Scalars['String'];
  lineItemIDs?: Maybe<Array<Scalars['ID']>>;
  totalPrice?: Maybe<Price>;
};

export type CartLineItemType = CartLineItemTypeBundle | CartLineItemTypeFreeProduct | CartLineItemTypeGeneric | CartLineItemTypeGiftcard | CartLineItemTypeUpsellBundle | CartLineItemTypeUpsellGeneric | CartLineItemTypeUpsellPersonalization;

export type CartLineItemTypeBundle = IWithCartLineItemLink & {
  __typename?: 'CartLineItemTypeBundle';
  link: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Scalars['String']>>;
  milestoneID?: Maybe<Scalars['ID']>;
};

export type CartLineItemTypeFreeProduct = IWithCartLineItemLink & {
  __typename?: 'CartLineItemTypeFreeProduct';
  link: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Scalars['String']>>;
  milestoneID?: Maybe<Scalars['ID']>;
  hasSelectedVariant?: Maybe<Scalars['Boolean']>;
  disableSizeSelection?: Maybe<Scalars['Boolean']>;
};

export type CartLineItemTypeGeneric = IWithCartLineItemLink & {
  __typename?: 'CartLineItemTypeGeneric';
  link: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Scalars['String']>>;
  milestoneID?: Maybe<Scalars['ID']>;
};

export type CartLineItemTypeGiftcard = IWithCartLineItemLink & {
  __typename?: 'CartLineItemTypeGiftcard';
  link: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Scalars['String']>>;
  milestoneID?: Maybe<Scalars['ID']>;
  amount?: Maybe<Money>;
  text?: Maybe<Scalars['String']>;
};

export type CartLineItemTypeUpsellBundle = IWithCartLineItemLink & {
  __typename?: 'CartLineItemTypeUpsellBundle';
  link: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Scalars['String']>>;
  milestoneID?: Maybe<Scalars['ID']>;
};

export type CartLineItemTypeUpsellGeneric = IWithCartLineItemLink & {
  __typename?: 'CartLineItemTypeUpsellGeneric';
  link: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Scalars['String']>>;
  milestoneID?: Maybe<Scalars['ID']>;
};

export type CartLineItemTypeUpsellPersonalization = IWithCartLineItemLink & {
  __typename?: 'CartLineItemTypeUpsellPersonalization';
  link: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Scalars['String']>>;
  milestoneID?: Maybe<Scalars['ID']>;
  blobID?: Maybe<Scalars['ID']>;
  text?: Maybe<Scalars['String']>;
};

export type CartMilestoneStep = {
  __typename?: 'CartMilestoneStep';
  id: Scalars['ID'];
  type?: Maybe<CartMilestoneStepType>;
  title?: Maybe<Wordbook>;
  status?: Maybe<CartMilestoneStepStatus>;
  progress?: Maybe<Scalars['Int']>;
  asset?: Maybe<Reference>;
  option?: Maybe<CartMilestoneStepOption>;
};

export type CartMilestoneStepOption = CartMilestoneStepOptionDiscountCode | CartMilestoneStepOptionProducts;

export type CartMilestoneStepOptionDiscountCode = {
  __typename?: 'CartMilestoneStepOptionDiscountCode';
  title?: Maybe<Wordbook>;
  callToAction?: Maybe<Wordbook>;
  success?: Maybe<Wordbook>;
  warning?: Maybe<Wordbook>;
  discountCode?: Maybe<Scalars['String']>;
};

export type CartMilestoneStepOptionProducts = IWithProducts & {
  __typename?: 'CartMilestoneStepOptionProducts';
  title?: Maybe<Wordbook>;
  callToAction?: Maybe<Wordbook>;
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type CartMilestoneStepOptionProductsProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export enum CartMilestoneStepStatus {
  Unavailable = 'UNAVAILABLE',
  Progress = 'PROGRESS',
  Unlocked = 'UNLOCKED',
  Complete = 'COMPLETE'
}

export enum CartMilestoneStepType {
  BuyXForY = 'BUY_X_FOR_Y',
  ChooseGift = 'CHOOSE_GIFT',
  Empty = 'EMPTY',
  FreeShipping = 'FREE_SHIPPING',
  RelativeDiscount = 'RELATIVE_DISCOUNT'
}

export type CartMilestones = {
  __typename?: 'CartMilestones';
  title?: Maybe<Wordbook>;
  steps?: Maybe<Array<CartMilestoneStep>>;
  progress?: Maybe<Scalars['Int']>;
  asset?: Maybe<Reference>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  successColor?: Maybe<Scalars['String']>;
};

export type CartTotal = {
  __typename?: 'CartTotal';
  id: Scalars['ID'];
  style: TextStyle;
  title: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Money>;
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID'];
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  parent?: Maybe<Category>;
  parentID?: Maybe<Scalars['ID']>;
  children?: Maybe<Array<Category>>;
  childrenIDs?: Maybe<Array<Scalars['ID']>>;
};


export type CategoryNameArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type Checkout = {
  __typename?: 'Checkout';
  cart?: Maybe<Cart>;
  addressMetaData?: Maybe<AddressMetaData>;
  paymentMetaData?: Maybe<PaymentMetaData>;
  isOptInCountry?: Maybe<Scalars['Boolean']>;
};


export type CheckoutAddressMetaDataArgs = {
  version?: Maybe<Scalars['Int']>;
};

export type ClubExpiringTransaction = {
  __typename?: 'ClubExpiringTransaction';
  amount: Money;
  expiresAt: Scalars['DateTime'];
  expiresIn: Wordbook;
};

export type ClubTransaction = {
  __typename?: 'ClubTransaction';
  orderNumber: Scalars['ID'];
  amount: Money;
  createdAt: Scalars['DateTime'];
  createdAtText: Scalars['String'];
};

export type CommunicationTemplate = IWithBlocks & IWithFields & {
  __typename?: 'CommunicationTemplate';
  activityID: Scalars['ID'];
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
  campaignID: Scalars['ID'];
  disableUnsubscribeHeaders: Scalars['Boolean'];
  fields?: Maybe<Array<Field>>;
  id?: Maybe<Scalars['ID']>;
  isLocalizationV2: Scalars['Boolean'];
  layout?: Maybe<CommunicationTemplateLayout>;
  previewText?: Maybe<Scalars['String']>;
  senderID: Scalars['ID'];
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CommunicationTemplateLayout = {
  __typename?: 'CommunicationTemplateLayout';
  footer?: Maybe<CommunicationTemplateLayoutFooter>;
  header?: Maybe<CommunicationTemplateLayoutHeader>;
};

export type CommunicationTemplateLayoutFooter = IWithBlocks & {
  __typename?: 'CommunicationTemplateLayoutFooter';
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
};

export type CommunicationTemplateLayoutHeader = IWithBlocks & {
  __typename?: 'CommunicationTemplateLayoutHeader';
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
};

export enum CommunicationTemplateType {
  CommercialEmail = 'COMMERCIAL_EMAIL',
  TransactionalEmail = 'TRANSACTIONAL_EMAIL',
  CommercialSms = 'COMMERCIAL_SMS',
  TransactionalSms = 'TRANSACTIONAL_SMS',
  BroadcastEmail = 'BROADCAST_EMAIL'
}

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CreatePersonalizationBlob = {
  __typename?: 'CreatePersonalizationBlob';
  blob?: Maybe<Blob>;
  uploadURL?: Maybe<Scalars['String']>;
};

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  id: Scalars['String'];
  totpUrl: Scalars['String'];
};

export type Customer = {
  __typename?: 'Customer';
  club?: Maybe<CustomerClub>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type CustomerClub = {
  __typename?: 'CustomerClub';
  balance?: Maybe<Money>;
  expiringTransaction?: Maybe<ClubExpiringTransaction>;
  history?: Maybe<Array<ClubTransaction>>;
};


export type DefaultManifestGroup = {
  __typename?: 'DefaultManifestGroup';
  createdAt?: Maybe<Scalars['DateTime']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  countries: Scalars['String'];
  status: ManifestStatus;
  manifests: Array<Manifest>;
};

export type Dimensions = {
  __typename?: 'Dimensions';
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type DiscountCode = {
  __typename?: 'DiscountCode';
  id?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
};

export type DynamicVariable = {
  __typename?: 'DynamicVariable';
  id?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  valueVariation?: Maybe<Scalars['String']>;
  valueTest?: Maybe<Scalars['String']>;
};

export type Element = ElementButton | ElementChip | ElementLabel | ElementTypography | ElementTypographyRte;

export type ElementButton = {
  __typename?: 'ElementButton';
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  reference?: Maybe<Reference>;
  appearance?: Maybe<BlockAppearance>;
};

export type ElementChip = {
  __typename?: 'ElementChip';
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  reference?: Maybe<Reference>;
  appearance?: Maybe<BlockAppearance>;
};

export type ElementLabel = {
  __typename?: 'ElementLabel';
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  reference?: Maybe<Reference>;
  appearance?: Maybe<BlockAppearance>;
};

export type ElementTypography = {
  __typename?: 'ElementTypography';
  id: Scalars['ID'];
  htmlElement?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  appearance?: Maybe<BlockAppearance>;
};

export type ElementTypographyRte = {
  __typename?: 'ElementTypographyRTE';
  id: Scalars['ID'];
  rte?: Maybe<RteField>;
  appearance?: Maybe<BlockAppearance>;
};

export type Elements = {
  __typename?: 'Elements';
  id: Scalars['ID'];
  items?: Maybe<Array<Element>>;
  position?: Maybe<Scalars['String']>;
  stackingMode?: Maybe<Scalars['String']>;
  alignment?: Maybe<Scalars['String']>;
};

export type Email = IWithBlocks & IWithFields & {
  __typename?: 'Email';
  activityID: Scalars['ID'];
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
  campaignID: Scalars['ID'];
  disableUnsubscribeHeaders: Scalars['Boolean'];
  fields?: Maybe<Array<Field>>;
  id?: Maybe<Scalars['ID']>;
  isLocalizationV2: Scalars['Boolean'];
  layout?: Maybe<EmailLayout>;
  previewText?: Maybe<Scalars['String']>;
  senderID: Scalars['ID'];
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type EmailLayout = {
  __typename?: 'EmailLayout';
  footer?: Maybe<EmailLayoutFooter>;
  header?: Maybe<EmailLayoutHeader>;
};

export type EmailLayoutFooter = IWithBlocks & {
  __typename?: 'EmailLayoutFooter';
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
};

export type EmailLayoutHeader = IWithBlocks & {
  __typename?: 'EmailLayoutHeader';
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
};

export enum EmailType {
  Commercial = 'COMMERCIAL',
  Transactional = 'TRANSACTIONAL',
  Broadcast = 'BROADCAST'
}

export type EmailVariable = {
  __typename?: 'EmailVariable';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  variable?: Maybe<Scalars['String']>;
};

export type Employee = {
  __typename?: 'Employee';
  id: Scalars['String'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  rights?: Maybe<Array<Scalars['String']>>;
};

export type EmployeesConnection = {
  __typename?: 'EmployeesConnection';
  employeesList: Array<Maybe<Employee>>;
  nextPageToken: Scalars['String'];
};

export type EmptyCartResponse = {
  __typename?: 'EmptyCartResponse';
  cart?: Maybe<Cart>;
  success: Scalars['Boolean'];
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type FacetDescription = {
  __typename?: 'FacetDescription';
  id?: Maybe<Scalars['ID']>;
  facet?: Maybe<Scalars['String']>;
  facetGroup?: Maybe<Scalars['String']>;
};

export type Field = ProductField | JsonField | LinkField | MultipleLinkField | ReferenceField | RteField | ObjectField | NavigationField;

export type FinalizeCartPrompt = FinalizeCartPromptError;

export type FinalizeCartPromptError = {
  __typename?: 'FinalizeCartPromptError';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type FinalizeCartResponse = {
  __typename?: 'FinalizeCartResponse';
  cart?: Maybe<Cart>;
  orderNumber?: Maybe<Scalars['String']>;
  paymentPayload?: Maybe<Scalars['JSON']>;
  success: Scalars['Boolean'];
  redirect?: Maybe<Scalars['Boolean']>;
  prompts?: Maybe<Array<FinalizeCartPrompt>>;
};

export type FreeShipping = {
  __typename?: 'FreeShipping';
  cheapest?: Maybe<Money>;
  isFree: Scalars['Boolean'];
  remaining?: Maybe<Money>;
  threshold?: Maybe<Money>;
};

export type GalleryBlock = IBlock & IWithFields & {
  __typename?: 'GalleryBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Field>>;
  slides?: Maybe<Array<GalleryBlockSlide>>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
};

export type GalleryBlockSlide = IWithFields & IWithImages & {
  __typename?: 'GalleryBlockSlide';
  id?: Maybe<Scalars['ID']>;
  fields?: Maybe<Array<Field>>;
  images?: Maybe<Array<ImageResource>>;
};

export type GetDetailsForPaymentResponse = {
  __typename?: 'GetDetailsForPaymentResponse';
  details?: Maybe<Scalars['JSON']>;
  success: Scalars['Boolean'];
  redirect?: Maybe<Scalars['Boolean']>;
};

export type Giftcard = {
  __typename?: 'Giftcard';
  code?: Maybe<Scalars['String']>;
  downloadURL?: Maybe<Scalars['String']>;
};

export type GlobalBlock = IBlock & IWithFields & {
  __typename?: 'GlobalBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<BlockType>>;
  fields?: Maybe<Array<Field>>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
};

export type GuidedFilter = GuidedFilterAttributeEnum | GuidedFilterLinkResource;

export type GuidedFilterAttributeEnum = IGuidedFilter & {
  __typename?: 'GuidedFilterAttributeEnum';
  attribute?: Maybe<Scalars['String']>;
  parameter?: Maybe<Scalars['String']>;
  items?: Maybe<Array<GuidedFilterAttributeEnumItem>>;
  asset?: Maybe<Reference>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  header?: Maybe<Wordbook>;
  text?: Maybe<Wordbook>;
  component?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type GuidedFilterAttributeEnumItem = IGuidedFilterItem & {
  __typename?: 'GuidedFilterAttributeEnumItem';
  injections?: Maybe<Array<InjectionTypeBlockData>>;
  key?: Maybe<Scalars['String']>;
  canonical?: Maybe<Scalars['Boolean']>;
  extraBlocks?: Maybe<Array<BlockType>>;
  asset?: Maybe<Reference>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
};

export type GuidedFilterLinkResource = IGuidedFilter & {
  __typename?: 'GuidedFilterLinkResource';
  items?: Maybe<Array<GuidedFilterLinkResourceItem>>;
  asset?: Maybe<Reference>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  header?: Maybe<Wordbook>;
  text?: Maybe<Wordbook>;
  component?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type GuidedFilterLinkResourceItem = IGuidedFilterItem & {
  __typename?: 'GuidedFilterLinkResourceItem';
  link?: Maybe<Link>;
  asset?: Maybe<Reference>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
};

export type HtmlBlock = IBlock & {
  __typename?: 'HTMLBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
  html?: Maybe<Scalars['String']>;
};

export type HouseBrand = IWithProducts & {
  __typename?: 'HouseBrand';
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type HouseBrandProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type IAttribute = {
  key?: Maybe<Scalars['String']>;
};

export type IBlock = {
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
};

export type IField = {
  key: Scalars['String'];
};

export type IGuidedFilter = {
  asset?: Maybe<Reference>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  header?: Maybe<Wordbook>;
  text?: Maybe<Wordbook>;
  component?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type IGuidedFilterItem = {
  asset?: Maybe<Reference>;
  backgroundColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
};

export type IWithAssets = {
  asset?: Maybe<Asset>;
  assets?: Maybe<Array<Asset>>;
};


export type IWithAssetsAssetArgs = {
  tag?: Maybe<Scalars['String']>;
};


export type IWithAssetsAssetsArgs = {
  tag?: Maybe<Scalars['String']>;
};

export type IWithBlocks = {
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
};

export type IWithBrand = {
  brand?: Maybe<Brand>;
};

export type IWithCartLineItemLink = {
  link: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Scalars['String']>>;
  milestoneID?: Maybe<Scalars['ID']>;
};

export type IWithCategories = {
  categoryIDs?: Maybe<Array<Scalars['String']>>;
  categories?: Maybe<Array<Category>>;
};


export type IWithCategoriesCategoriesArgs = {
  onlyEnabled?: Maybe<Scalars['Boolean']>;
};

export type IWithElements = {
  elements?: Maybe<Array<Elements>>;
};

export type IWithFields = {
  fields?: Maybe<Array<Field>>;
};

export type IWithFilter = {
  filter?: Maybe<Scalars['String']>;
  filters?: Maybe<Scalars['String']>;
  facetFilters?: Maybe<Array<Scalars['String']>>;
  optionalFilters?: Maybe<Array<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
};


export type IWithFilterOptionalFiltersArgs = {
  boost?: Maybe<Scalars['ID']>;
};

export type IWithImages = {
  images?: Maybe<Array<ImageResource>>;
};

export type IWithIndex = {
  index: Scalars['Int'];
};

export type IWithMoney = {
  currencyCode: Scalars['String'];
  value: Scalars['Int'];
  format?: Maybe<Scalars['String']>;
};


export type IWithMoneyFormatArgs = {
  decimals?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  mode?: Maybe<MoneyFormatMode>;
};

export type IWithProduct = {
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};


export type IWithProductProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type IWithProducts = {
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type IWithProductsProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type IWithRecommendations = {
  recommendations?: Maybe<Array<Recommendation>>;
};

export type IWithReferences = {
  references?: Maybe<Array<Reference>>;
};

export type IWithReferencesWithKey = {
  referencesWithKey?: Maybe<Array<ReferenceWithKey>>;
};

export type Image = {
  __typename?: 'Image';
  url?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Dimensions>;
  pins?: Maybe<Array<ImagePin>>;
};

export type ImageAsset = {
  __typename?: 'ImageAsset';
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Image>;
  imageMobile?: Maybe<Image>;
};

export type ImagePin = {
  __typename?: 'ImagePin';
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
  reference?: Maybe<Reference>;
};

export type ImageResource = Media & IWithFields & {
  __typename?: 'ImageResource';
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Image>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  mobileURL?: Maybe<Scalars['String']>;
  mobileImage?: Maybe<Image>;
  captionOptions?: Maybe<CaptionOptions>;
  overlayOptions?: Maybe<OverlayOptions>;
  fields?: Maybe<Array<Field>>;
};

export type InfoPanel = {
  __typename?: 'InfoPanel';
  id?: Maybe<Scalars['ID']>;
  icon?: Maybe<Reference>;
  title?: Maybe<Wordbook>;
  subTitle?: Maybe<Wordbook>;
  text?: Maybe<Wordbook>;
};

export type InfoPanelBlock = IBlock & {
  __typename?: 'InfoPanelBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
  infoPanels?: Maybe<Array<InfoPanel>>;
};

export type InitializePaymentMethodResponse = {
  __typename?: 'InitializePaymentMethodResponse';
  payload?: Maybe<Scalars['JSON']>;
  success: Scalars['Boolean'];
};

export type Injection = AnchorInjection | BlockInjection;

export type InjectionPlacement = InjectionPlacementBlocks | InjectionPlacementBlockTypes | InjectionPlacementGlobal | InjectionPlacementPosition;

export type InjectionPlacementBlockTypes = {
  __typename?: 'InjectionPlacementBlockTypes';
  types?: Maybe<Array<Scalars['String']>>;
};

export type InjectionPlacementBlocks = IWithBlocks & {
  __typename?: 'InjectionPlacementBlocks';
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
};

export type InjectionPlacementGlobal = {
  __typename?: 'InjectionPlacementGlobal';
  global: Scalars['Boolean'];
};

export type InjectionPlacementPosition = {
  __typename?: 'InjectionPlacementPosition';
  position: Scalars['String'];
};

export type InjectionSelector = InjectionSelectorPages | InjectionSelectorPageTypes | InjectionSelectorProductData;

export type InjectionSelectorPageTypes = {
  __typename?: 'InjectionSelectorPageTypes';
  types?: Maybe<Array<Scalars['String']>>;
};

export type InjectionSelectorPages = {
  __typename?: 'InjectionSelectorPages';
  pages?: Maybe<Array<Page>>;
};

export type InjectionSelectorProductData = {
  __typename?: 'InjectionSelectorProductData';
  brands?: Maybe<Array<Scalars['String']>>;
  categoryIDs?: Maybe<Array<Scalars['ID']>>;
  collections?: Maybe<Array<Scalars['String']>>;
  primaryMaterials?: Maybe<Array<Scalars['String']>>;
  productTypes?: Maybe<Array<Scalars['String']>>;
};

export type InjectionTypeAnchor = IWithBlocks & {
  __typename?: 'InjectionTypeAnchor';
  id?: Maybe<Scalars['ID']>;
  anchor?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
};

export type InjectionTypeBlockData = IWithBlocks & {
  __typename?: 'InjectionTypeBlockData';
  id?: Maybe<Scalars['ID']>;
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
  slot?: Maybe<Scalars['Int']>;
};

export type InjectionTypeGrid = IWithBlocks & {
  __typename?: 'InjectionTypeGrid';
  id?: Maybe<Scalars['ID']>;
  dimensions?: Maybe<Array<InjectionTypeGridDimensions>>;
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
};

export type InjectionTypeGridDimensions = {
  __typename?: 'InjectionTypeGridDimensions';
  columns: Scalars['Int'];
  x: Scalars['Int'];
  y: Scalars['Int'];
  width: Scalars['Int'];
  height: Scalars['Int'];
};


export type JsonField = IField & {
  __typename?: 'JSONField';
  key: Scalars['String'];
  value?: Maybe<Scalars['JSON']>;
};

export type LineItem = IWithAssets & IWithProduct & {
  __typename?: 'LineItem';
  id?: Maybe<Scalars['ID']>;
  sku?: Maybe<Scalars['String']>;
  ean?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  profits?: Maybe<LineItemProfits>;
  totalPrice?: Maybe<MoneyOrPrice>;
  priceExcludingTax?: Maybe<Price>;
  basePriceLegacy?: Maybe<Price>;
  variantID?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  link?: Maybe<LineItemLink>;
  type?: Maybe<LineItemType>;
  asset?: Maybe<Asset>;
  assets?: Maybe<Array<Asset>>;
};


export type LineItemProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};


export type LineItemAssetArgs = {
  tag?: Maybe<Scalars['String']>;
};


export type LineItemAssetsArgs = {
  tag?: Maybe<Scalars['String']>;
};

export type LineItemLink = {
  __typename?: 'LineItemLink';
  id?: Maybe<Scalars['ID']>;
  childrenIDs?: Maybe<Array<Scalars['ID']>>;
  children?: Maybe<Array<LineItem>>;
  parentID?: Maybe<Scalars['ID']>;
  parent?: Maybe<LineItem>;
};

export enum LineItemMode {
  Flat = 'FLAT',
  Nested = 'NESTED'
}

export type LineItemProfits = {
  __typename?: 'LineItemProfits';
  totals?: Maybe<Array<Money>>;
};

export type LineItemType = {
  __typename?: 'LineItemType';
  type?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Link = IWithReferences & {
  __typename?: 'Link';
  id?: Maybe<Scalars['ID']>;
  overrideTitle?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  imageMobile?: Maybe<Image>;
  url?: Maybe<Scalars['String']>;
  newTab?: Maybe<Scalars['Boolean']>;
  queryParameters?: Maybe<Scalars['String']>;
  references?: Maybe<Array<Reference>>;
};

export type LinkField = IField & IWithReferences & {
  __typename?: 'LinkField';
  key: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  newTab?: Maybe<Scalars['Boolean']>;
  queryParameters?: Maybe<Scalars['String']>;
  references?: Maybe<Array<Reference>>;
};

export type LinkedProduct = IWithProducts & {
  __typename?: 'LinkedProduct';
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
  type?: Maybe<Scalars['String']>;
};


export type LinkedProductProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type LookDisplayBlock = IBlock & {
  __typename?: 'LookDisplayBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
  asset?: Maybe<Reference>;
  products?: Maybe<Array<LookProduct>>;
};

export type LookListBlock = IBlock & {
  __typename?: 'LookListBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
  looks?: Maybe<Array<LookTile>>;
};

export type LookProduct = IWithProduct & {
  __typename?: 'LookProduct';
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};


export type LookProductProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type LookTile = {
  __typename?: 'LookTile';
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  ambassadorHandle?: Maybe<Scalars['String']>;
  asset?: Maybe<Reference>;
  products?: Maybe<Array<LookProduct>>;
};

export type Manifest = {
  __typename?: 'Manifest';
  id: Scalars['String'];
  warehouseKey: WarehouseKey;
  countryCode: Scalars['String'];
  manifestKey: ManifestKey;
  laneNumber: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  status: ManifestStatus;
  group: ManifestGroup;
  documents?: Maybe<Array<ManifestDocument>>;
  error: Scalars['String'];
  closeReference: Scalars['String'];
  parcelCount: Scalars['Int'];
};

export type ManifestDocument = {
  __typename?: 'ManifestDocument';
  id: Scalars['String'];
  parentID: Scalars['String'];
  documentURL: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  country: Scalars['String'];
  manifestKey: Scalars['String'];
};

export enum ManifestGroup {
  ManifestGroupUnspecified = 'MANIFEST_GROUP_UNSPECIFIED',
  ManifestGroupDefault = 'MANIFEST_GROUP_DEFAULT',
  ManifestGroupBring = 'MANIFEST_GROUP_BRING',
  ManifestGroupPostnord = 'MANIFEST_GROUP_POSTNORD'
}

export enum ManifestKey {
  None = 'NONE',
  RoyalMail = 'ROYAL_MAIL',
  ShipmondoProformaNo = 'SHIPMONDO_PROFORMA_NO',
  ShipmondoProformaCh = 'SHIPMONDO_PROFORMA_CH',
  ShipmondoDhlTrackedPaket = 'SHIPMONDO_DHL_TRACKED_PAKET',
  BrtIt = 'BRT_IT',
  AsendiaCh = 'ASENDIA_CH',
  AsendiaFr = 'ASENDIA_FR',
  MagyarHu = 'MAGYAR_HU',
  BringNo = 'BRING_NO',
  PostnordNo = 'POSTNORD_NO',
  ShipmondoAsendiaCh = 'SHIPMONDO_ASENDIA_CH',
  ShipmondoAsendiaSmartgateflexCh = 'SHIPMONDO_ASENDIA_SMARTGATEFLEX_CH'
}

export enum ManifestStatus {
  ManifestStatusUnspecified = 'MANIFEST_STATUS_UNSPECIFIED',
  ManifestStatusPending = 'MANIFEST_STATUS_PENDING',
  ManifestStatusGenerating = 'MANIFEST_STATUS_GENERATING',
  ManifestStatusFailed = 'MANIFEST_STATUS_FAILED',
  ManifestStatusGenerated = 'MANIFEST_STATUS_GENERATED'
}

export type ManifestsPayload = {
  __typename?: 'ManifestsPayload';
  defaultGroup: Array<DefaultManifestGroup>;
  manifests?: Maybe<Array<Manifest>>;
};

export type Me = Customer | Employee | Service;

export type Media = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  captionOptions?: Maybe<CaptionOptions>;
  overlayOptions?: Maybe<OverlayOptions>;
};

export type ModalTab = IWithBlocks & {
  __typename?: 'ModalTab';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
  appearance?: Maybe<BlockAppearance>;
};

export type Money = IWithMoney & {
  __typename?: 'Money';
  currencyCode: Scalars['String'];
  value: Scalars['Int'];
  format?: Maybe<Scalars['String']>;
  convert?: Maybe<Money>;
};


export type MoneyFormatArgs = {
  decimals?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  mode?: Maybe<MoneyFormatMode>;
};


export type MoneyConvertArgs = {
  currencyCode: Scalars['String'];
};

export type MoneyAttribute = IAttribute & {
  __typename?: 'MoneyAttribute';
  key?: Maybe<Scalars['String']>;
  money?: Maybe<Money>;
};

export enum MoneyFormatMode {
  Default = 'DEFAULT',
  Number = 'NUMBER',
  NumberPlain = 'NUMBER_PLAIN'
}

export type MoneyOrPrice = Money | Price;

export type MultipleLinkField = IField & {
  __typename?: 'MultipleLinkField';
  key: Scalars['String'];
  links?: Maybe<Array<Link>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addToCart?: Maybe<AddToCartResponse>;
  authenticateCart?: Maybe<AuthenticateCartResponse>;
  emptyCart?: Maybe<EmptyCartResponse>;
  finalizeCart?: Maybe<FinalizeCartResponse>;
  refreshCart?: Maybe<RefreshCartResponse>;
  removeFromCart?: Maybe<RemoveFromCartResponse>;
  resetCart?: Maybe<ResetCartResponse>;
  setDiscountCodeInCart?: Maybe<SetDiscountCodeInCartResponse>;
  setQuantityInCart?: Maybe<SetQuantityInCartResponse>;
  setVariantInCart?: Maybe<SetVariantInCartResponse>;
  setAddressesInCart?: Maybe<SetAddressesInCartResponse>;
  setShippingMethodInCart?: Maybe<SetShippingMethodInCartResponse>;
  getDetailsForPayment?: Maybe<GetDetailsForPaymentResponse>;
  initializePaymentMethod?: Maybe<InitializePaymentMethodResponse>;
  subscribeToBackInStock?: Maybe<Scalars['Boolean']>;
  subscribeToNewsletter?: Maybe<Scalars['Boolean']>;
  unsubscribeFromNewsletter?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field no longer supported */
  signupClubMember?: Maybe<SignupResponse>;
  createGiftcardsFromOrder?: Maybe<Array<Giftcard>>;
  createPersonalizationBlob?: Maybe<CreatePersonalizationBlob>;
  createPrintJob: Scalars['Boolean'];
  addLinkedProducts?: Maybe<Scalars['Boolean']>;
  softDeleteLinkedProducts?: Maybe<Scalars['Boolean']>;
  createReturn?: Maybe<Return>;
  createOrderReview?: Maybe<OrderReview>;
  closeManifests?: Maybe<Array<Scalars['String']>>;
  closeManifest: Scalars['String'];
  generateManifestDocuments: Scalars['Boolean'];
  acceptPostPurchaseUpsellLegacy?: Maybe<AcceptPostPurchaseUpsellLegacy>;
  createEmployee?: Maybe<Employee>;
  createUser?: Maybe<CreateUserPayload>;
  updateEmployee?: Maybe<Employee>;
  deleteEmployee?: Maybe<Scalars['Boolean']>;
  addEmployeeRight?: Maybe<Scalars['Boolean']>;
  removeEmployeeRight?: Maybe<Scalars['Boolean']>;
  createTeam?: Maybe<Team>;
  updateTeam?: Maybe<Team>;
  deleteTeam?: Maybe<Scalars['Boolean']>;
  addTeamManager?: Maybe<Scalars['Boolean']>;
  removeTeamManager?: Maybe<Scalars['Boolean']>;
};


export type MutationAddToCartArgs = {
  products: Array<AddToCartProductInput>;
  withoutSuccessPrompt?: Maybe<Scalars['Boolean']>;
};


export type MutationFinalizeCartArgs = {
  checksum?: Maybe<Scalars['String']>;
  consents?: Maybe<Array<Scalars['String']>>;
  paymentMethodID?: Maybe<Scalars['ID']>;
  paymentPayload?: Maybe<Scalars['JSON']>;
  recaptchaToken?: Maybe<Scalars['String']>;
};


export type MutationRefreshCartArgs = {
  fixErrors?: Maybe<Scalars['Boolean']>;
};


export type MutationRemoveFromCartArgs = {
  lineItemIDs: Array<Scalars['ID']>;
};


export type MutationSetDiscountCodeInCartArgs = {
  customerID?: Maybe<Scalars['ID']>;
  discountCode?: Maybe<Scalars['ID']>;
};


export type MutationSetQuantityInCartArgs = {
  lineItems: Array<SetQuantityInCartLineItemInput>;
};


export type MutationSetVariantInCartArgs = {
  lineItems: Array<SetVariantInCartLineItemInput>;
};


export type MutationSetAddressesInCartArgs = {
  billingAddress: AddressInput;
  shippingAddress: AddressInput;
};


export type MutationSetShippingMethodInCartArgs = {
  shippingMethod: ShippingMethodInput;
};


export type MutationGetDetailsForPaymentArgs = {
  payload?: Maybe<Scalars['JSON']>;
};


export type MutationInitializePaymentMethodArgs = {
  paymentMethodID: Scalars['ID'];
  payload?: Maybe<Scalars['JSON']>;
};


export type MutationSubscribeToBackInStockArgs = {
  productID: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};


export type MutationSubscribeToNewsletterArgs = {
  input: SubscribeToNewsletterInput;
};


export type MutationUnsubscribeFromNewsletterArgs = {
  email: Scalars['String'];
};


export type MutationSignupClubMemberArgs = {
  input: SignupClubMemberInput;
};


export type MutationCreateGiftcardsFromOrderArgs = {
  orderNumber: Scalars['String'];
};


export type MutationCreatePersonalizationBlobArgs = {
  contentType: Scalars['String'];
  name: Scalars['String'];
};


export type MutationCreatePrintJobArgs = {
  document: Scalars['String'];
  printer?: Maybe<Scalars['String']>;
};


export type MutationAddLinkedProductsArgs = {
  type: Scalars['String'];
  productIDs: Array<Scalars['ID']>;
};


export type MutationSoftDeleteLinkedProductsArgs = {
  items: Array<SoftDeleteLinkedProduct>;
};


export type MutationCreateReturnArgs = {
  orderNumber: Scalars['String'];
  returningItems: Array<ReturningItemInput>;
  refundMethod: ReturnRefundMethod;
  bankDetails?: Maybe<ReturnBankDetailsInput>;
  email: Scalars['String'];
};


export type MutationCreateOrderReviewArgs = {
  orderNumber: Scalars['String'];
  reviewToken: Scalars['String'];
  productReviews?: Maybe<Array<OrderReviewProductReviewInput>>;
  surveyAnswers?: Maybe<Array<OrderReviewSurveyAnswerInput>>;
};


export type MutationCloseManifestsArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationCloseManifestArgs = {
  id: Scalars['String'];
};


export type MutationGenerateManifestDocumentsArgs = {
  manifestID: Scalars['String'];
};


export type MutationAcceptPostPurchaseUpsellLegacyArgs = {
  orderNumber: Scalars['String'];
  productID: Scalars['String'];
  variantID?: Maybe<Scalars['String']>;
};


export type MutationCreateEmployeeArgs = {
  email: Scalars['String'];
  displayName: Scalars['String'];
  rights?: Maybe<Array<Scalars['String']>>;
};


export type MutationCreateUserArgs = {
  name: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUpdateEmployeeArgs = {
  where?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  data: UpdateEmployeeData;
};


export type MutationDeleteEmployeeArgs = {
  id: Scalars['String'];
  where?: Maybe<Scalars['String']>;
};


export type MutationAddEmployeeRightArgs = {
  id: Scalars['String'];
  right: Scalars['String'];
  where?: Maybe<Scalars['String']>;
};


export type MutationRemoveEmployeeRightArgs = {
  id: Scalars['String'];
  right: Scalars['String'];
  where?: Maybe<Scalars['String']>;
};


export type MutationCreateTeamArgs = {
  displayName: Scalars['String'];
  rights?: Maybe<Array<Scalars['String']>>;
};


export type MutationUpdateTeamArgs = {
  id: Scalars['String'];
  displayName: Scalars['String'];
  where?: Maybe<Scalars['String']>;
};


export type MutationDeleteTeamArgs = {
  id: Scalars['String'];
  where?: Maybe<Scalars['String']>;
};


export type MutationAddTeamManagerArgs = {
  teamID: Scalars['String'];
  employeeId: Scalars['String'];
};


export type MutationRemoveTeamManagerArgs = {
  teamID: Scalars['String'];
  employeeId: Scalars['String'];
};

export type NavigationField = IField & {
  __typename?: 'NavigationField';
  key: Scalars['String'];
  navigation?: Maybe<Array<NavigationItem>>;
};

export type NavigationItem = IWithBlocks & {
  __typename?: 'NavigationItem';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  link?: Maybe<Link>;
  features?: Maybe<Array<Scalars['String']>>;
  items?: Maybe<Array<NavigationItem>>;
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
  appearanceDesktop?: Maybe<BlockAppearance>;
  appearanceMobile?: Maybe<BlockAppearance>;
};

export enum NavigationPlacement {
  Default = 'DEFAULT',
  Top = 'TOP'
}

export type ObjectField = IField & {
  __typename?: 'ObjectField';
  key: Scalars['String'];
  fields?: Maybe<Array<Field>>;
};

export type OpenGraph = {
  __typename?: 'OpenGraph';
  siteName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageURL?: Maybe<Scalars['String']>;
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  closes?: Maybe<OpeningTime>;
  dayOfWeek?: Maybe<Scalars['String']>;
  opens?: Maybe<OpeningTime>;
};

export type OpeningTime = {
  __typename?: 'OpeningTime';
  hours?: Maybe<Scalars['Int']>;
  minutes?: Maybe<Scalars['Int']>;
  nanos?: Maybe<Scalars['Int']>;
  seconds?: Maybe<Scalars['Int']>;
};

export type Order = {
  __typename?: 'Order';
  orderNumber?: Maybe<Scalars['String']>;
  couponCodeLegacy?: Maybe<Scalars['String']>;
  status?: Maybe<OrderStatus>;
  state?: Maybe<OrderState>;
  storeID?: Maybe<Scalars['ID']>;
  lineItems?: Maybe<Array<LineItem>>;
  previousOrderNumber?: Maybe<Scalars['String']>;
  previousOrder?: Maybe<Order>;
  isCustomerReturning?: Maybe<Scalars['Boolean']>;
  isOrderExchange?: Maybe<Scalars['Boolean']>;
  isOrderResend?: Maybe<Scalars['Boolean']>;
  subTotalLegacy?: Maybe<Money>;
  basePriceLegacy?: Maybe<Money>;
  shippingTotal?: Maybe<Money>;
  totalTax?: Maybe<Money>;
  totalPrice?: Maybe<MoneyOrPrice>;
  customer?: Maybe<Customer>;
  shipping?: Maybe<Shipping>;
  profits?: Maybe<Profits>;
};


export type OrderLineItemsArgs = {
  mode: LineItemMode;
};

export type OrderReview = {
  __typename?: 'OrderReview';
  id?: Maybe<Scalars['ID']>;
  productReviews?: Maybe<Array<OrderReviewProductReview>>;
  surveyQuestions?: Maybe<Array<OrderReviewSurveyQuestion>>;
};

export type OrderReviewProductReview = IWithProduct & {
  __typename?: 'OrderReviewProductReview';
  id?: Maybe<Scalars['String']>;
  isReviewed?: Maybe<Scalars['Boolean']>;
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};


export type OrderReviewProductReviewProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type OrderReviewProductReviewInput = {
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
};

export type OrderReviewSurveyAnswerInput = {
  questionID: Scalars['ID'];
  optionID: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
};

export type OrderReviewSurveyQuestion = {
  __typename?: 'OrderReviewSurveyQuestion';
  id: Scalars['ID'];
  title: Scalars['String'];
  options?: Maybe<Array<OrderReviewSurveyQuestionOption>>;
  parentOptionID?: Maybe<Scalars['ID']>;
};

export type OrderReviewSurveyQuestionOption = {
  __typename?: 'OrderReviewSurveyQuestionOption';
  id: Scalars['ID'];
  title: Scalars['String'];
  showTextInput: Scalars['Boolean'];
};

export enum OrderState {
  AwaitingLabel = 'AWAITING_LABEL',
  AwaitingStock = 'AWAITING_STOCK',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  LabelError = 'LABEL_ERROR',
  OnHold = 'ON_HOLD',
  Packed = 'PACKED',
  Picked = 'PICKED',
  Ready = 'READY'
}

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Confirmed = 'CONFIRMED',
  Open = 'OPEN'
}

export type OverlayOptions = {
  __typename?: 'OverlayOptions';
  position?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type Page = IWithBlocks & IWithBrand & IWithFields & {
  __typename?: 'Page';
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  id?: Maybe<Scalars['ID']>;
  type: Scalars['String'];
  presentation?: Maybe<PagePresentation>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  seo?: Maybe<Seo>;
  openGraph?: Maybe<OpenGraph>;
  alternateLinks?: Maybe<Array<AlternateLink>>;
  brand?: Maybe<Brand>;
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
  fields?: Maybe<Array<Field>>;
  /** @deprecated no longer in use */
  layout?: Maybe<Scalars['String']>;
  modalTabs?: Maybe<Array<ModalTab>>;
  settings?: Maybe<Scalars['JSON']>;
};


export type PageBreadcrumbsArgs = {
  version?: Maybe<Scalars['Int']>;
};

export type PageGridBlock = IBlock & IWithReferences & {
  __typename?: 'PageGridBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  columns?: Maybe<Scalars['Int']>;
  showDescription?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  titlePosition?: Maybe<Position>;
  limit?: Maybe<Scalars['Int']>;
  pageType?: Maybe<Scalars['String']>;
  references?: Maybe<Array<Reference>>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
};

export type PageIdentifier = {
  type: PageType;
  id: Scalars['ID'];
};

export enum PagePresentation {
  Full = 'FULL',
  Modal = 'MODAL',
  Navigation = 'NAVIGATION',
  Sidebar = 'SIDEBAR'
}

export type PageSliderBlock = IBlock & IWithReferences & {
  __typename?: 'PageSliderBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  showDescription?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  pageType?: Maybe<Scalars['String']>;
  references?: Maybe<Array<Reference>>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
};

export enum PageType {
  Account = 'ACCOUNT',
  Ambassador = 'AMBASSADOR',
  Article = 'ARTICLE',
  Bestsellers = 'BESTSELLERS',
  Brand = 'BRAND',
  Category = 'CATEGORY',
  Career = 'CAREER',
  CheckoutSuccess = 'CHECKOUT_SUCCESS',
  Collection = 'COLLECTION',
  Csr = 'CSR',
  Error = 'ERROR',
  FacetDescription = 'FACET_DESCRIPTION',
  Filter = 'FILTER',
  Frontpage = 'FRONTPAGE',
  GiftIdeas = 'GIFT_IDEAS',
  Landingpage = 'LANDINGPAGE',
  Look = 'LOOK',
  Manual = 'MANUAL',
  Modal = 'MODAL',
  NewArrivals = 'NEW_ARRIVALS',
  Personalization = 'PERSONALIZATION',
  Press = 'PRESS',
  Product = 'PRODUCT',
  Returns = 'RETURNS',
  Reviews = 'REVIEWS',
  Search = 'SEARCH',
  SizeGuide = 'SIZE_GUIDE',
  Terms = 'TERMS',
  Tracking = 'TRACKING',
  WishList = 'WISH_LIST'
}

export type PaymentMetaData = {
  __typename?: 'PaymentMetaData';
  adyenConfig?: Maybe<Scalars['JSON']>;
  braintreeConfig?: Maybe<Scalars['JSON']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  id?: Maybe<Scalars['ID']>;
  provider: Scalars['String'];
  type: Scalars['String'];
  logo?: Maybe<Asset>;
  icons?: Maybe<Array<PaymentMethodIcon>>;
  title?: Maybe<Scalars['String']>;
};

export type PaymentMethodIcon = {
  __typename?: 'PaymentMethodIcon';
  name: Scalars['String'];
  url: Scalars['String'];
  logo?: Maybe<Asset>;
};

export type PhonePrefix = {
  __typename?: 'PhonePrefix';
  countryCodes?: Maybe<Array<Scalars['String']>>;
  prefix?: Maybe<Scalars['String']>;
};

export enum Position {
  Bottom = 'BOTTOM',
  Left = 'LEFT',
  Overlay = 'OVERLAY',
  Right = 'RIGHT',
  Top = 'TOP'
}

export type PostPurchaseUpsellProfitLegacy = {
  __typename?: 'PostPurchaseUpsellProfitLegacy';
  localRevenue?: Maybe<Scalars['Float']>;
  baseRevenue?: Maybe<Scalars['Float']>;
  localProfit?: Maybe<Scalars['Float']>;
  baseProfit?: Maybe<Scalars['Float']>;
};

export type Price = IWithMoney & {
  __typename?: 'Price';
  clubValue?: Maybe<Money>;
  countryCode?: Maybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  value: Scalars['Int'];
  format?: Maybe<Scalars['String']>;
  discount?: Maybe<PriceDiscount>;
  convert?: Maybe<Price>;
};


export type PriceFormatArgs = {
  decimals?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  mode?: Maybe<MoneyFormatMode>;
};


export type PriceConvertArgs = {
  currencyCode: Scalars['String'];
};

export type PriceDiscount = IWithMoney & {
  __typename?: 'PriceDiscount';
  clubValue?: Maybe<Money>;
  code?: Maybe<DiscountCode>;
  currencyCode: Scalars['String'];
  percent?: Maybe<Scalars['Float']>;
  value: Scalars['Int'];
  format?: Maybe<Scalars['String']>;
  convert?: Maybe<PriceDiscount>;
};


export type PriceDiscountFormatArgs = {
  decimals?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  mode?: Maybe<MoneyFormatMode>;
};


export type PriceDiscountConvertArgs = {
  currencyCode: Scalars['String'];
};

export type PriceDiscountInput = {
  currencyCode: Scalars['String'];
  percent?: Maybe<Scalars['Float']>;
  value: Scalars['Int'];
};

export type PriceInput = {
  currencyCode: Scalars['String'];
  value: Scalars['Int'];
  discount?: Maybe<PriceDiscountInput>;
};

export type Product = IWithCategories & IWithBrand & IWithAssets & {
  __typename?: 'Product';
  categoryIDs?: Maybe<Array<Scalars['String']>>;
  categories?: Maybe<Array<Category>>;
  primaryCategoryIDs?: Maybe<Array<Scalars['String']>>;
  primaryCategories?: Maybe<Array<Category>>;
  brand?: Maybe<Brand>;
  sizeGuide?: Maybe<Page>;
  sizeGuideFits?: Maybe<Array<ProductSizeGuideFits>>;
  sizeGuideItems?: Maybe<Array<ProductSizeGuideItem>>;
  /** @deprecated removed in favor of related categories */
  linkTags?: Maybe<Array<Link>>;
  productReviews?: Maybe<Product_ProductReviewsConnection>;
  linkedProducts?: Maybe<Array<LinkedProduct>>;
  id: Scalars['ID'];
  enabled?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  asset?: Maybe<Asset>;
  assets?: Maybe<Array<Asset>>;
  availability?: Maybe<Availability>;
  masterVariant?: Maybe<ProductVariant>;
  variants?: Maybe<Array<ProductVariant>>;
  houseBrand?: Maybe<HouseBrand>;
  fitDimensions?: Maybe<Array<ProductFitDimension>>;
  specifications?: Maybe<ProductSpecifications>;
  tactics?: Maybe<ProductTactics>;
};


export type ProductCategoriesArgs = {
  onlyEnabled?: Maybe<Scalars['Boolean']>;
};


export type ProductPrimaryCategoriesArgs = {
  onlyEnabled?: Maybe<Scalars['Boolean']>;
};


export type ProductProductReviewsArgs = {
  cursor: Scalars['String'];
  limit: Scalars['Int'];
};


export type ProductAssetArgs = {
  tag?: Maybe<Scalars['String']>;
};


export type ProductAssetsArgs = {
  tag?: Maybe<Scalars['String']>;
};

export type ProductAttribute = IAttribute & IWithProducts & {
  __typename?: 'ProductAttribute';
  key?: Maybe<Scalars['String']>;
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type ProductAttributeProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export enum ProductFetchMode {
  Current = 'CURRENT',
  Projection = 'PROJECTION'
}

export type ProductField = IField & IWithProduct & {
  __typename?: 'ProductField';
  key: Scalars['String'];
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};


export type ProductFieldProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type ProductFitDimension = {
  __typename?: 'ProductFitDimension';
  id: Scalars['ID'];
  title: Wordbook;
};

/** @deprecated No longer supported */
export type ProductGridSelectorBlock = IBlock & IWithFields & {
  __typename?: 'ProductGridSelectorBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Field>>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
};

export type ProductListBlock = IBlock & IWithFields & IWithFilter & IWithReferences & {
  __typename?: 'ProductListBlock';
  injections?: Maybe<Array<InjectionTypeBlockData>>;
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topLinks?: Maybe<Array<Link>>;
  header?: Maybe<Scalars['String']>;
  boosts?: Maybe<Array<Scalars['ID']>>;
  description?: Maybe<RteField>;
  display?: Maybe<Array<Scalars['String']>>;
  facets?: Maybe<Array<Scalars['String']>>;
  filter?: Maybe<Scalars['String']>;
  filters?: Maybe<Scalars['String']>;
  facetFilters?: Maybe<Array<Scalars['String']>>;
  optionalFilters?: Maybe<Array<Scalars['String']>>;
  guidedFilters?: Maybe<Array<GuidedFilter>>;
  limit?: Maybe<Scalars['Int']>;
  fields?: Maybe<Array<Field>>;
  references?: Maybe<Array<Reference>>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
  extraBlocks?: Maybe<Array<BlockType>>;
  facetConfig?: Maybe<Array<ProductListBlockFacet>>;
  looks?: Maybe<Array<LookTile>>;
};


export type ProductListBlockOptionalFiltersArgs = {
  boost?: Maybe<Scalars['ID']>;
};

export type ProductListBlockFacet = {
  __typename?: 'ProductListBlockFacet';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Wordbook>;
  key?: Maybe<Scalars['String']>;
  parameter?: Maybe<Scalars['String']>;
  type?: Maybe<ProductListBlockFacetType>;
  values?: Maybe<Array<ProductListBlockFacetValue>>;
  groups?: Maybe<Array<ProductListBlockFacetGroup>>;
  facetDescriptionButton?: Maybe<Wordbook>;
  facetDescriptionIDs?: Maybe<Array<Scalars['ID']>>;
};

export type ProductListBlockFacetGroup = {
  __typename?: 'ProductListBlockFacetGroup';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Wordbook>;
  key?: Maybe<Scalars['String']>;
  values?: Maybe<Array<ProductListBlockFacetValue>>;
};

export enum ProductListBlockFacetType {
  EnumerableDefault = 'ENUMERABLE_DEFAULT',
  EnumerableBoolean = 'ENUMERABLE_BOOLEAN',
  EnumerableColor = 'ENUMERABLE_COLOR',
  EnumerableNumeric = 'ENUMERABLE_NUMERIC',
  RangeDefault = 'RANGE_DEFAULT',
  RangePrice = 'RANGE_PRICE'
}

export type ProductListBlockFacetValue = {
  __typename?: 'ProductListBlockFacetValue';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Wordbook>;
  key?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
};

export type ProductReview = {
  __typename?: 'ProductReview';
  customerID?: Maybe<Scalars['ID']>;
  customerName: Scalars['String'];
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  localizedText?: Maybe<Scalars['String']>;
  localizedTitle?: Maybe<Scalars['String']>;
  productID: Scalars['String'];
  rating: Scalars['Int'];
  text: Scalars['String'];
  title: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ProductSizeGuideColumn = {
  __typename?: 'ProductSizeGuideColumn';
  id?: Maybe<Scalars['ID']>;
  isHeader?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Wordbook>;
};

export type ProductSizeGuideFitItem = {
  __typename?: 'ProductSizeGuideFitItem';
  id?: Maybe<Scalars['ID']>;
  fit: Scalars['ID'];
  fitLabel?: Maybe<Wordbook>;
  disabled: Scalars['Boolean'];
  quantity: Scalars['Int'];
  size: Scalars['ID'];
  sizeLabel?: Maybe<Wordbook>;
};

export type ProductSizeGuideFits = {
  __typename?: 'ProductSizeGuideFits';
  id?: Maybe<Scalars['ID']>;
  circumference: Scalars['ID'];
  title?: Maybe<Wordbook>;
  fits: Array<ProductSizeGuideFitItem>;
};

export type ProductSizeGuideItem = {
  __typename?: 'ProductSizeGuideItem';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Wordbook>;
  headers?: Maybe<Array<ProductSizeGuideColumn>>;
  rows?: Maybe<Array<ProductSizeGuideRow>>;
};

export type ProductSizeGuideRow = {
  __typename?: 'ProductSizeGuideRow';
  id?: Maybe<Scalars['ID']>;
  columns?: Maybe<Array<ProductSizeGuideColumn>>;
};

export type ProductSlider = IWithProducts & {
  __typename?: 'ProductSlider';
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type ProductSliderProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type ProductSliderBlock = IBlock & IWithFilter & IWithReferences & {
  __typename?: 'ProductSliderBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
  filters?: Maybe<Scalars['String']>;
  facetFilters?: Maybe<Array<Scalars['String']>>;
  optionalFilters?: Maybe<Array<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  references?: Maybe<Array<Reference>>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
  sorting?: Maybe<Scalars['String']>;
  slider?: Maybe<ProductSlider>;
};


export type ProductSliderBlockOptionalFiltersArgs = {
  boost?: Maybe<Scalars['ID']>;
};

export type ProductSpecificationGroup = {
  __typename?: 'ProductSpecificationGroup';
  name?: Maybe<Scalars['String']>;
  items?: Maybe<Array<ProductSpecificationItemWithMultiple>>;
};

export type ProductSpecificationItem = ProductSpecificationItemReference | ProductSpecificationItemText | ProductSpecificationItemUnit;

export type ProductSpecificationItemMultiple = {
  __typename?: 'ProductSpecificationItemMultiple';
  name?: Maybe<Scalars['String']>;
  items?: Maybe<Array<ProductSpecificationItem>>;
};

export type ProductSpecificationItemReference = IWithReferences & {
  __typename?: 'ProductSpecificationItemReference';
  references?: Maybe<Array<Reference>>;
  name?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ProductSpecificationItemText = {
  __typename?: 'ProductSpecificationItemText';
  name?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ProductSpecificationItemUnit = {
  __typename?: 'ProductSpecificationItemUnit';
  name?: Maybe<Scalars['String']>;
  unit?: Maybe<ProductSpecificationUnit>;
  value?: Maybe<Scalars['Int']>;
  from?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Int']>;
  format?: Maybe<Scalars['String']>;
};

export type ProductSpecificationItemWithMultiple = ProductSpecificationItemMultiple | ProductSpecificationItemReference | ProductSpecificationItemText | ProductSpecificationItemUnit;

export enum ProductSpecificationType {
  LengthAutomatic = 'LENGTH_AUTOMATIC',
  LengthCentimeter = 'LENGTH_CENTIMETER',
  LengthInch = 'LENGTH_INCH',
  LengthMeter = 'LENGTH_METER',
  LengthMillimeter = 'LENGTH_MILLIMETER',
  VolumeAutomatic = 'VOLUME_AUTOMATIC',
  VolumeFluidOunce = 'VOLUME_FLUID_OUNCE',
  VolumeLiter = 'VOLUME_LITER',
  VolumeMilliliter = 'VOLUME_MILLILITER',
  WeightAutomatic = 'WEIGHT_AUTOMATIC',
  WeightGram = 'WEIGHT_GRAM',
  WeightKilogram = 'WEIGHT_KILOGRAM',
  WeightOunce = 'WEIGHT_OUNCE'
}

export type ProductSpecificationUnit = {
  __typename?: 'ProductSpecificationUnit';
  category?: Maybe<ProductSpecificationUnitCategory>;
  type?: Maybe<ProductSpecificationType>;
};

export enum ProductSpecificationUnitCategory {
  Length = 'LENGTH',
  Time = 'TIME',
  Volume = 'VOLUME',
  Weight = 'WEIGHT'
}

export type ProductSpecifications = {
  __typename?: 'ProductSpecifications';
  groups?: Maybe<Array<ProductSpecificationGroup>>;
};

export type ProductTactic = TacticActiveCampaign | TacticAssortmentLadder | TacticBlocks | TacticBuildYourDiscount | TacticBundleInfo | TacticComplementaryProducts | TacticLinkedProductsColor | TacticLinkedProductsSizeAndVariation | TacticLooks | TacticMatchingVariant | TacticOthersBought | TacticOthersBoughtGrid | TacticRecommendedForYou | TacticRelatedProducts | TacticRelativeDiscount | TacticSimilarProducts | TacticUpgradeWith;

export type ProductTactics = {
  __typename?: 'ProductTactics';
  gold?: Maybe<Array<ProductTactic>>;
  silver?: Maybe<Array<ProductTactic>>;
  bronze?: Maybe<Array<ProductTactic>>;
  temporary?: Maybe<Array<ProductTactic>>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  id?: Maybe<Scalars['ID']>;
  attribute?: Maybe<Attribute>;
  attributePrice?: Maybe<AttributePrice>;
  attributes?: Maybe<Array<Attribute>>;
  availability?: Maybe<Availability>;
  price?: Maybe<Price>;
  /** @deprecated use price instead */
  prices?: Maybe<Array<Price>>;
  fits?: Maybe<Array<ProductVariantFit>>;
};


export type ProductVariantAttributeArgs = {
  key: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
};


export type ProductVariantAttributePriceArgs = {
  key: Scalars['String'];
};


export type ProductVariantPriceArgs = {
  currencyCode?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
};

export type ProductVariantFit = {
  __typename?: 'ProductVariantFit';
  id: Scalars['ID'];
  dimension: Scalars['ID'];
  fit: Wordbook;
};

export type ProductWithQuantity = IWithProduct & {
  __typename?: 'ProductWithQuantity';
  quantity?: Maybe<Scalars['Int']>;
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};


export type ProductWithQuantityProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type Product_ProductReviewsConnection = {
  __typename?: 'Product_ProductReviewsConnection';
  cursor: Scalars['String'];
  count: Scalars['Int'];
  translatedCount: Scalars['Int'];
  averageRating: Scalars['Float'];
  productReviews?: Maybe<Array<ProductReview>>;
};

export type ProductsWithQuantityAttribute = IAttribute & {
  __typename?: 'ProductsWithQuantityAttribute';
  key?: Maybe<Scalars['String']>;
  productsWithQuantity?: Maybe<Array<ProductWithQuantity>>;
};

export type Profit = {
  __typename?: 'Profit';
  orderNumber: Scalars['String'];
  profitInfo?: Maybe<Array<Maybe<ProfitInfo>>>;
};

export type ProfitInfo = {
  __typename?: 'ProfitInfo';
  currencyCode?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ProfitItem>>>;
  grandTotal?: Maybe<Money>;
  cost?: Maybe<Money>;
  profit?: Maybe<Money>;
};

export type ProfitItem = {
  __typename?: 'ProfitItem';
  id: Scalars['ID'];
  profit?: Maybe<Money>;
};

export type Profits = {
  __typename?: 'Profits';
  orderNumber?: Maybe<Scalars['String']>;
  totals?: Maybe<Array<Money>>;
};

export type Query = {
  __typename?: 'Query';
  cart?: Maybe<Cart>;
  category?: Maybe<Category>;
  categories?: Maybe<Array<Category>>;
  checkout?: Maybe<Checkout>;
  injections?: Maybe<Array<Injection>>;
  navigation?: Maybe<Array<NavigationItem>>;
  bars?: Maybe<Array<Bar>>;
  brands?: Maybe<Array<Brand>>;
  facetDescriptions?: Maybe<Array<FacetDescription>>;
  latestPages: Array<Page>;
  page?: Maybe<Page>;
  pages: Array<Page>;
  communicationTemplate?: Maybe<CommunicationTemplate>;
  email?: Maybe<Email>;
  customer?: Maybe<Customer>;
  me?: Maybe<Me>;
  order?: Maybe<Order>;
  /** @deprecated Use paymentMethods instead */
  paymentIcons?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  product?: Maybe<Product>;
  products?: Maybe<Array<Product>>;
  returnOptionsByEmail?: Maybe<ReturnOptions>;
  estimateReturnTotals?: Maybe<ReturnTotals>;
  orderReview?: Maybe<OrderReview>;
  manifests: ManifestsPayload;
  shippingInfo?: Maybe<ShippingInfo>;
  shippingMethod?: Maybe<ShippingMethod>;
  stores?: Maybe<Array<Maybe<Store>>>;
  phonePrefixes?: Maybe<Array<PhonePrefix>>;
  successPage?: Maybe<SuccessPage>;
  successPageLegacy?: Maybe<SuccessPageLegacy>;
  tracking?: Maybe<Tracking>;
  getEmployee?: Maybe<Employee>;
  listEmployees: EmployeesConnection;
  listTeams: TeamsConnection;
  getTeam?: Maybe<Team>;
  getTeamManagers: TeamManagersConnection;
};


export type QueryCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryCategoriesArgs = {
  onlyEnabled?: Maybe<Scalars['Boolean']>;
};


export type QueryNavigationArgs = {
  placement?: Maybe<NavigationPlacement>;
};


export type QueryLatestPagesArgs = {
  type: PageType;
  limit?: Maybe<Scalars['Int']>;
  excludeIDs?: Maybe<Array<Scalars['String']>>;
};


export type QueryPageArgs = {
  type: PageType;
  slug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  presentation?: Maybe<PagePresentation>;
};


export type QueryPagesArgs = {
  pages: Array<PageIdentifier>;
  presentation?: Maybe<PagePresentation>;
};


export type QueryCommunicationTemplateArgs = {
  type: CommunicationTemplateType;
  id: Scalars['ID'];
};


export type QueryEmailArgs = {
  type: EmailType;
  id: Scalars['ID'];
};


export type QueryCustomerArgs = {
  customerID?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
};


export type QueryOrderArgs = {
  orderNumber: Scalars['String'];
};


export type QueryPaymentIconsArgs = {
  storeID?: Maybe<Scalars['ID']>;
};


export type QueryProductArgs = {
  id?: Maybe<Scalars['ID']>;
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};


export type QueryProductsArgs = {
  ids?: Maybe<Array<Scalars['ID']>>;
  limit?: Maybe<Scalars['Int']>;
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};


export type QueryReturnOptionsByEmailArgs = {
  orderNumber: Scalars['String'];
  email: Scalars['String'];
};


export type QueryEstimateReturnTotalsArgs = {
  orderNumber: Scalars['String'];
  returningItems: Array<ReturningItemInput>;
  email: Scalars['String'];
};


export type QueryOrderReviewArgs = {
  orderNumber: Scalars['String'];
  reviewToken: Scalars['String'];
};


export type QueryShippingMethodArgs = {
  id: Scalars['ID'];
  postalCode?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
};


export type QuerySuccessPageArgs = {
  orderNumberOverride?: Maybe<Scalars['String']>;
};


export type QuerySuccessPageLegacyArgs = {
  orderNumber?: Maybe<Scalars['String']>;
};


export type QueryTrackingArgs = {
  token?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
};


export type QueryGetEmployeeArgs = {
  name: Scalars['String'];
};


export type QueryListEmployeesArgs = {
  cursor: Scalars['String'];
  limit: Scalars['Int'];
};


export type QueryListTeamsArgs = {
  cursor: Scalars['String'];
  limit: Scalars['Int'];
};


export type QueryGetTeamArgs = {
  id: Scalars['String'];
};


export type QueryGetTeamManagersArgs = {
  cursor: Scalars['String'];
  limit: Scalars['Int'];
  teamID: Scalars['String'];
};

export type RteField = IField & IWithReferencesWithKey & {
  __typename?: 'RTEField';
  key: Scalars['String'];
  value?: Maybe<Scalars['JSON']>;
  referencesWithKey?: Maybe<Array<ReferenceWithKey>>;
};

export type Recommendation = IWithProducts & {
  __typename?: 'Recommendation';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  placement?: Maybe<Scalars['String']>;
  splitTest?: Maybe<SplitTest>;
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type RecommendationProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type Reference = DynamicVariable | EmailVariable | ExternalLink | Image | ImageAsset | ImageResource | Link | ModalTab | Page | TileResource | VideoResource | Wordbook;

export type ReferenceField = IField & IWithReferences & {
  __typename?: 'ReferenceField';
  key: Scalars['String'];
  references?: Maybe<Array<Reference>>;
};

export type ReferenceWithKey = {
  __typename?: 'ReferenceWithKey';
  key?: Maybe<Scalars['String']>;
  reference?: Maybe<Reference>;
};

export type RefreshCartResponse = {
  __typename?: 'RefreshCartResponse';
  cart?: Maybe<Cart>;
  success: Scalars['Boolean'];
};

export type RemoveFromCartPrompt = RemoveFromCartPromptError;

export type RemoveFromCartPromptError = IWithIndex & {
  __typename?: 'RemoveFromCartPromptError';
  index: Scalars['Int'];
  code: Scalars['String'];
  message: Scalars['String'];
};

export type RemoveFromCartResponse = {
  __typename?: 'RemoveFromCartResponse';
  cart?: Maybe<Cart>;
  success: Scalars['Boolean'];
  prompts?: Maybe<Array<RemoveFromCartPrompt>>;
};

export type ResetCartResponse = {
  __typename?: 'ResetCartResponse';
  cart?: Maybe<Cart>;
  success: Scalars['Boolean'];
};

export type Return = {
  __typename?: 'Return';
  ID: Scalars['ID'];
  key: Scalars['String'];
  orderNumber: Scalars['String'];
  state: ReturnState;
  lineItems?: Maybe<Array<ReturnLineItem>>;
  shippingMethodID?: Maybe<Scalars['String']>;
  refundMethod: ReturnRefundMethod;
  bankDetails?: Maybe<ReturnBankDetails>;
  locale?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type ReturnBankDetails = {
  __typename?: 'ReturnBankDetails';
  accountHolderName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
};

export type ReturnBankDetailsInput = {
  accountHolderName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
};

export enum ReturnItemReason {
  WrongSize = 'WRONG_SIZE',
  Broken = 'BROKEN',
  Other = 'OTHER'
}

export type ReturnLineItem = {
  __typename?: 'ReturnLineItem';
  ID: Scalars['String'];
  orderLineItemID: Scalars['String'];
  quantity: Scalars['Int'];
  reason: ReturnItemReason;
  swapToProductKey?: Maybe<Scalars['String']>;
};

export type ReturnOptionLineItem = IWithProduct & {
  __typename?: 'ReturnOptionLineItem';
  orderLineItemID: Scalars['String'];
  fallbackTitle?: Maybe<Scalars['String']>;
  productID: Scalars['String'];
  product?: Maybe<Product>;
  returnableQuantity: Scalars['Int'];
  isPersonalized: Scalars['Boolean'];
};


export type ReturnOptionLineItemProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type ReturnOptions = {
  __typename?: 'ReturnOptions';
  optionLineItems?: Maybe<Array<ReturnOptionLineItem>>;
  refundMethods?: Maybe<Array<ReturnRefundMethod>>;
  previousReturns?: Maybe<Array<Return>>;
  orderNumber: Scalars['String'];
  isSwapEnabled: Scalars['Boolean'];
};

export enum ReturnRefundMethod {
  Unknown = 'UNKNOWN',
  BankTransfer = 'BANK_TRANSFER',
  PaymentMethod = 'PAYMENT_METHOD'
}

export enum ReturnState {
  Initial = 'INITIAL',
  LabelError = 'LABEL_ERROR',
  Ready = 'READY',
  Processing = 'PROCESSING',
  ProcessingAwaitingSwapOrder = 'PROCESSING_AWAITING_SWAP_ORDER',
  Processed = 'PROCESSED',
  Cancelled = 'CANCELLED'
}

export type ReturnTotalSwapItem = {
  __typename?: 'ReturnTotalSwapItem';
  orderLineItemID: Scalars['String'];
  quantity: Scalars['Int'];
  swapToProductKey?: Maybe<Scalars['String']>;
  value?: Maybe<Money>;
};

export type ReturnTotals = {
  __typename?: 'ReturnTotals';
  shippingToRefund?: Maybe<Money>;
  shippingToPay?: Maybe<Money>;
  itemsToRefund?: Maybe<Money>;
  totalToRefund?: Maybe<Money>;
  swapItems?: Maybe<Array<ReturnTotalSwapItem>>;
};

export type ReturningItemInput = {
  orderLineItemID: Scalars['String'];
  quantity: Scalars['Int'];
  reason: ReturnItemReason;
  swapToProductKey?: Maybe<Scalars['String']>;
};

export type Seo = {
  __typename?: 'SEO';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  noIndex: Scalars['Boolean'];
  includeInSitemap: Scalars['Boolean'];
};

export type Service = {
  __typename?: 'Service';
  displayName: Scalars['String'];
};

export type ServiceLocation = {
  __typename?: 'ServiceLocation';
  additionalStreetInfo?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  externalID?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Array<OpeningHours>>;
  postalCode?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type ServiceLocationInput = {
  additionalStreetInfo?: Maybe<Scalars['String']>;
  checksum: Scalars['String'];
  city: Scalars['String'];
  externalID: Scalars['String'];
  externalCustomerID?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  streetName: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type SetAddressesInCartPrompt = SetAdressesInCartPromptError;

export type SetAddressesInCartResponse = {
  __typename?: 'SetAddressesInCartResponse';
  cart?: Maybe<Cart>;
  success: Scalars['Boolean'];
  prompts?: Maybe<Array<SetAddressesInCartPrompt>>;
};

export type SetAdressesInCartPromptError = {
  __typename?: 'SetAdressesInCartPromptError';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type SetDiscountCodeInCartPrompt = SetDiscountCodeInCartPromptError | SetDiscountCodeInCartPromptSuccess;

export type SetDiscountCodeInCartPromptError = {
  __typename?: 'SetDiscountCodeInCartPromptError';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type SetDiscountCodeInCartPromptSuccess = {
  __typename?: 'SetDiscountCodeInCartPromptSuccess';
  bars?: Maybe<Array<Bar>>;
};

export type SetDiscountCodeInCartResponse = {
  __typename?: 'SetDiscountCodeInCartResponse';
  cart?: Maybe<Cart>;
  success: Scalars['Boolean'];
  prompts?: Maybe<Array<SetDiscountCodeInCartPrompt>>;
};

export type SetQuantityInCartLineItemInput = {
  lineItemID: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type SetQuantityInCartPrompt = SetQuantityInCartPromptError;

export type SetQuantityInCartPromptError = IWithIndex & {
  __typename?: 'SetQuantityInCartPromptError';
  index: Scalars['Int'];
  code: Scalars['String'];
  message: Scalars['String'];
};

export type SetQuantityInCartResponse = {
  __typename?: 'SetQuantityInCartResponse';
  cart?: Maybe<Cart>;
  success: Scalars['Boolean'];
  prompts?: Maybe<Array<SetQuantityInCartPrompt>>;
};

export type SetShippingMethodInCartPrompt = SetShippingMethodInCartPromptError;

export type SetShippingMethodInCartPromptError = {
  __typename?: 'SetShippingMethodInCartPromptError';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type SetShippingMethodInCartResponse = {
  __typename?: 'SetShippingMethodInCartResponse';
  cart?: Maybe<Cart>;
  success: Scalars['Boolean'];
  prompts?: Maybe<Array<SetShippingMethodInCartPrompt>>;
};

export type SetVariantInCartLineItemInput = {
  lineItemID: Scalars['ID'];
  variantID: Scalars['ID'];
};

export type SetVariantInCartPrompt = SetVariantInCartPromptError;

export type SetVariantInCartPromptError = IWithIndex & {
  __typename?: 'SetVariantInCartPromptError';
  index: Scalars['Int'];
  code: Scalars['String'];
  message: Scalars['String'];
};

export type SetVariantInCartResponse = {
  __typename?: 'SetVariantInCartResponse';
  cart?: Maybe<Cart>;
  success: Scalars['Boolean'];
  prompts?: Maybe<Array<SetVariantInCartPrompt>>;
};

export type Shipping = {
  __typename?: 'Shipping';
  expectedDispatchAt?: Maybe<Scalars['String']>;
  deliveries?: Maybe<Array<Maybe<Transceiver>>>;
};

export type ShippingInfo = {
  __typename?: 'ShippingInfo';
  items?: Maybe<Array<ShippingInfoItem>>;
  threshold?: Maybe<Money>;
};

export type ShippingInfoDeliveryTime = {
  __typename?: 'ShippingInfoDeliveryTime';
  from?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type ShippingInfoItem = {
  __typename?: 'ShippingInfoItem';
  deliveryTime?: Maybe<ShippingInfoDeliveryTime>;
  title?: Maybe<Scalars['String']>;
  logo?: Maybe<Asset>;
  price?: Maybe<ShippingInfoPrice>;
  priceBefore?: Maybe<ShippingInfoPrice>;
  priceAboveThreshold?: Maybe<ShippingInfoPrice>;
};

export type ShippingInfoPrice = {
  __typename?: 'ShippingInfoPrice';
  style: TextStyle;
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Money>;
};

export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  id: Scalars['ID'];
  key: Scalars['String'];
  deliveryTimeText?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  logo?: Maybe<Asset>;
  isRecommended?: Maybe<Scalars['Boolean']>;
  isServiceLocation?: Maybe<Scalars['Boolean']>;
  isCOD?: Maybe<Scalars['Boolean']>;
  isUnavailable?: Maybe<Scalars['Boolean']>;
  serviceLocations?: Maybe<Array<ServiceLocation>>;
  isExternalCustomerIDRequired?: Maybe<Scalars['Boolean']>;
};


export type ShippingMethodServiceLocationsArgs = {
  version?: Maybe<Scalars['Int']>;
};

export type ShippingMethodInput = {
  shippingMethodID: Scalars['ID'];
  serviceLocation?: Maybe<ServiceLocationInput>;
};

/** @deprecated No longer supported */
export type SignupClubMemberInput = {
  firstName: Scalars['String'];
  email: Scalars['String'];
  gender: Scalars['String'];
  phonePrefix: Scalars['String'];
  phone: Scalars['String'];
  birthDay: Scalars['String'];
  birthMonth: Scalars['String'];
  birthYear: Scalars['String'];
  source?: Maybe<Scalars['String']>;
};

/** @deprecated No longer supported */
export type SignupResponse = {
  __typename?: 'SignupResponse';
  success?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};

export type SoftDeleteLinkedProduct = {
  type: Scalars['String'];
  productID: Scalars['ID'];
  linkedProductID: Scalars['ID'];
};

export type SplitTest = {
  __typename?: 'SplitTest';
  test: Scalars['String'];
  groups: Array<SplitTestGroup>;
};

export enum SplitTestGroup {
  Unknown = 'UNKNOWN',
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D'
}

export type Store = {
  __typename?: 'Store';
  id?: Maybe<Scalars['ID']>;
  parentID?: Maybe<Scalars['ID']>;
  parent?: Maybe<Store>;
  title?: Maybe<Scalars['String']>;
  config?: Maybe<StoreConfig>;
};

export type StoreConfig = {
  __typename?: 'StoreConfig';
  adwordsCurrencyRates?: Maybe<Array<Maybe<StoreConfigAdwordsCurrencyRate>>>;
  adwordsTrackingID?: Maybe<Scalars['String']>;
  analyticsTrackingID?: Maybe<Scalars['String']>;
  cheapestShippingPrice?: Maybe<Money>;
  /** @deprecated shipping price split tests are deprecated */
  cheapestShippingPriceVariation?: Maybe<Money>;
  /** @deprecated shipping price split tests are deprecated */
  cheapestShippingPriceTest?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  currencyFraction?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  freeShippingThreshold?: Maybe<Money>;
  freeShippingThresholdClub?: Maybe<Money>;
  /** @deprecated shipping price split tests are deprecated */
  freeShippingThresholdVariation?: Maybe<Money>;
  /** @deprecated shipping price split tests are deprecated */
  freeShippingThresholdTest?: Maybe<Scalars['String']>;
  giftcards?: Maybe<StoreGiftcardConfig>;
  localeCode?: Maybe<Scalars['String']>;
  merchantAccount?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phonePrefix?: Maybe<PhonePrefix>;
  trustpilotBusinessID?: Maybe<Scalars['String']>;
  trustpilotDomain?: Maybe<Scalars['String']>;
  urlDomain?: Maybe<Scalars['String']>;
  urlFull?: Maybe<Scalars['String']>;
  urlPath?: Maybe<Scalars['String']>;
  usercentricsEnabled?: Maybe<Scalars['Boolean']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type StoreConfigAdwordsCurrencyRate = {
  __typename?: 'StoreConfigAdwordsCurrencyRate';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type StoreGiftcardConfig = {
  __typename?: 'StoreGiftcardConfig';
  moneyBefore?: Maybe<Scalars['String']>;
  moneyAfter?: Maybe<Scalars['String']>;
  valueMin?: Maybe<Money>;
  valueMax?: Maybe<Money>;
  predefinedValues?: Maybe<Array<Money>>;
};

export enum StringFormatMode {
  Default = 'DEFAULT',
  Hash256 = 'HASH256'
}

export type SubscribeToNewsletterInput = {
  email: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  campaign?: Maybe<Scalars['String']>;
};

export type SuccessPage = {
  __typename?: 'SuccessPage';
  cart?: Maybe<Cart>;
  profit?: Maybe<Profit>;
  orderNumber?: Maybe<Scalars['String']>;
  expectedDispatchAt?: Maybe<Scalars['String']>;
};

export type SuccessPageLegacy = {
  __typename?: 'SuccessPageLegacy';
  order?: Maybe<Order>;
  upsell?: Maybe<Upsell>;
  customerOrderCount?: Maybe<Scalars['Int']>;
};

/** @deprecated use TacticBlocks instead */
export type TacticActiveCampaign = {
  __typename?: 'TacticActiveCampaign';
  id?: Maybe<Scalars['ID']>;
};

export type TacticAddAndSave = {
  __typename?: 'TacticAddAndSave';
  id?: Maybe<Scalars['ID']>;
  offers?: Maybe<Array<TacticGenericOffer>>;
};

export type TacticAssortmentLadder = {
  __typename?: 'TacticAssortmentLadder';
  id?: Maybe<Scalars['ID']>;
  items?: Maybe<Array<TacticAssortmentLadderItem>>;
};

export type TacticAssortmentLadderItem = {
  __typename?: 'TacticAssortmentLadderItem';
  id?: Maybe<Scalars['ID']>;
  header?: Maybe<Wordbook>;
  tag?: Maybe<Wordbook>;
  text?: Maybe<Wordbook>;
  iconURL?: Maybe<Scalars['String']>;
};

export type TacticBlocks = IWithBlocks & {
  __typename?: 'TacticBlocks';
  blocks?: Maybe<Array<BlockTypeWithGlobal>>;
  id?: Maybe<Scalars['ID']>;
};

export type TacticBoughtTogether = IWithRecommendations & {
  __typename?: 'TacticBoughtTogether';
  recommendations?: Maybe<Array<Recommendation>>;
  id?: Maybe<Scalars['ID']>;
};

export type TacticBuildYourDiscount = IWithProducts & {
  __typename?: 'TacticBuildYourDiscount';
  id?: Maybe<Scalars['ID']>;
  items?: Maybe<Array<TacticBuildYourDiscountItem>>;
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type TacticBuildYourDiscountProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type TacticBuildYourDiscountItem = {
  __typename?: 'TacticBuildYourDiscountItem';
  offers?: Maybe<Array<TacticBuildYourDiscountItemOffer>>;
  price: Price;
};

export type TacticBuildYourDiscountItemOffer = {
  __typename?: 'TacticBuildYourDiscountItemOffer';
  productID: Scalars['String'];
  offer: AddToCartProductTactic;
};

export type TacticBundleInfo = {
  __typename?: 'TacticBundleInfo';
  id?: Maybe<Scalars['ID']>;
  bundlePrice?: Maybe<AttributePrice>;
  bundleProducts?: Maybe<Array<ProductWithQuantity>>;
  settings?: Maybe<Scalars['JSON']>;
};

export type TacticComplementaryProducts = IWithProducts & {
  __typename?: 'TacticComplementaryProducts';
  id?: Maybe<Scalars['ID']>;
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type TacticComplementaryProductsProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type TacticGenericOffer = IWithProduct & {
  __typename?: 'TacticGenericOffer';
  offer: AddToCartProductTactic;
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};


export type TacticGenericOfferProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type TacticLinkedProductsColor = {
  __typename?: 'TacticLinkedProductsColor';
  id?: Maybe<Scalars['ID']>;
  color?: Maybe<TacticLinkedProductsGroup>;
};

export type TacticLinkedProductsGroup = IWithProducts & {
  __typename?: 'TacticLinkedProductsGroup';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type TacticLinkedProductsGroupProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type TacticLinkedProductsSizeAndVariation = {
  __typename?: 'TacticLinkedProductsSizeAndVariation';
  id?: Maybe<Scalars['ID']>;
  size?: Maybe<TacticLinkedProductsGroup>;
  variation?: Maybe<TacticLinkedProductsGroup>;
};

export type TacticLooks = {
  __typename?: 'TacticLooks';
  looks?: Maybe<Array<LookTile>>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Wordbook>;
  settings?: Maybe<Scalars['JSON']>;
};

export type TacticMatchingVariant = IWithProduct & {
  __typename?: 'TacticMatchingVariant';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Wordbook>;
  tag?: Maybe<Wordbook>;
  productHeader?: Maybe<Wordbook>;
  offer?: Maybe<AddToCartProductTactic>;
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};


export type TacticMatchingVariantProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type TacticOthersBought = IWithRecommendations & {
  __typename?: 'TacticOthersBought';
  recommendations?: Maybe<Array<Recommendation>>;
  id?: Maybe<Scalars['ID']>;
};

export type TacticOthersBoughtGrid = IWithRecommendations & {
  __typename?: 'TacticOthersBoughtGrid';
  recommendations?: Maybe<Array<Recommendation>>;
  id?: Maybe<Scalars['ID']>;
};

export type TacticRecommendedForYou = IWithRecommendations & {
  __typename?: 'TacticRecommendedForYou';
  recommendations?: Maybe<Array<Recommendation>>;
  id?: Maybe<Scalars['ID']>;
};

export type TacticRelatedProducts = IWithProducts & {
  __typename?: 'TacticRelatedProducts';
  id?: Maybe<Scalars['ID']>;
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type TacticRelatedProductsProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type TacticRelativeDiscount = IWithProducts & {
  __typename?: 'TacticRelativeDiscount';
  id?: Maybe<Scalars['ID']>;
  relativeDiscounts?: Maybe<Array<TacticRelativeDiscountItem>>;
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type TacticRelativeDiscountProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type TacticRelativeDiscountItem = {
  __typename?: 'TacticRelativeDiscountItem';
  quantity: Scalars['Int'];
  percentage: Scalars['Int'];
  price?: Maybe<Price>;
};

export type TacticSimilarProducts = IWithProducts & {
  __typename?: 'TacticSimilarProducts';
  id?: Maybe<Scalars['ID']>;
  productIDs?: Maybe<Array<Scalars['String']>>;
  products?: Maybe<Array<Product>>;
};


export type TacticSimilarProductsProductsArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type TacticUpgradeWith = {
  __typename?: 'TacticUpgradeWith';
  id?: Maybe<Scalars['ID']>;
  items?: Maybe<Array<TacticUpgradeWithItem>>;
};

export type TacticUpgradeWithItem = IWithProduct & {
  __typename?: 'TacticUpgradeWithItem';
  type?: Maybe<Scalars['String']>;
  productID?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};


export type TacticUpgradeWithItemProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type TaxPortion = {
  __typename?: 'TaxPortion';
  name?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['String']>;
  amount?: Maybe<Money>;
};

export type TaxedPrice = {
  __typename?: 'TaxedPrice';
  totalNet?: Maybe<Money>;
  totalGross?: Maybe<Money>;
  totalTax?: Maybe<Money>;
  taxPortions?: Maybe<Array<TaxPortion>>;
};

export type Team = {
  __typename?: 'Team';
  id: Scalars['String'];
  displayName: Scalars['String'];
  rights?: Maybe<Array<Scalars['String']>>;
  members?: Maybe<EmployeesConnection>;
  managers?: Maybe<TeamManagersConnection>;
};


export type TeamMembersArgs = {
  cursor: Scalars['String'];
  limit: Scalars['Int'];
};


export type TeamManagersArgs = {
  cursor: Scalars['String'];
  limit: Scalars['Int'];
};

export type TeamManagersConnection = {
  __typename?: 'TeamManagersConnection';
  teamManagersList: Array<Maybe<Employee>>;
  nextPageToken: Scalars['String'];
};

export type TeamsConnection = {
  __typename?: 'TeamsConnection';
  teamsList: Array<Maybe<Team>>;
  nextPageToken: Scalars['String'];
};

export enum TextStyle {
  Normal = 'NORMAL',
  Bold = 'BOLD'
}

export type TileResource = IWithElements & IWithReferences & {
  __typename?: 'TileResource';
  elements?: Maybe<Array<Elements>>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  display?: Maybe<Array<Scalars['String']>>;
  header?: Maybe<Scalars['String']>;
  description?: Maybe<RteField>;
  button?: Maybe<Button>;
  campaignTag?: Maybe<CampaignTag>;
  references?: Maybe<Array<Reference>>;
  appearance?: Maybe<BlockAppearance>;
};

export type Tracking = {
  __typename?: 'Tracking';
  club?: Maybe<TrackingClub>;
  trackingNumber: Scalars['String'];
  carrierKey?: Maybe<Scalars['String']>;
  orderID?: Maybe<Scalars['String']>;
  returnID?: Maybe<Scalars['String']>;
  originCountryCode?: Maybe<Scalars['String']>;
  destinationCountryCode?: Maybe<Scalars['String']>;
  trackingURL?: Maybe<Scalars['String']>;
  events?: Maybe<Array<TrackingEvent>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  shouldRedirectToCarrier?: Maybe<Scalars['Boolean']>;
};

export type TrackingClub = {
  __typename?: 'TrackingClub';
  value?: Maybe<Money>;
};

export type TrackingEvent = {
  __typename?: 'TrackingEvent';
  state?: Maybe<TrackingState>;
  subState?: Maybe<TrackingSubState>;
  timestamp?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<TrackingType>;
};

export enum TrackingState {
  Unspecified = 'UNSPECIFIED',
  AvailableForPickup = 'AVAILABLE_FOR_PICKUP',
  AwaitingCarrierPickup = 'AWAITING_CARRIER_PICKUP',
  AwaitingPacking = 'AWAITING_PACKING',
  Delivered = 'DELIVERED',
  Exception = 'EXCEPTION',
  Expired = 'EXPIRED',
  FailedAttempt = 'FAILED_ATTEMPT',
  InTransit = 'IN_TRANSIT',
  InfoReceived = 'INFO_RECEIVED',
  InformationReceived = 'INFORMATION_RECEIVED',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  OrderPlaced = 'ORDER_PLACED',
  Packed = 'PACKED',
  Pending = 'PENDING',
  Shipped = 'SHIPPED'
}

export enum TrackingSubState {
  Unspecified = 'UNSPECIFIED',
  CustomerMoved = 'CUSTOMER_MOVED',
  CustomerRefusedDelivery = 'CUSTOMER_REFUSED_DELIVERY',
  DelayedCustomsClearance = 'DELAYED_CUSTOMS_CLEARANCE',
  DelayedExternalFactors = 'DELAYED_EXTERNAL_FACTORS',
  Exception = 'EXCEPTION',
  HeldForPayment = 'HELD_FOR_PAYMENT',
  IncorrectAddress = 'INCORRECT_ADDRESS',
  PickupMissed = 'PICKUP_MISSED',
  RejectedByCarrier = 'REJECTED_BY_CARRIER',
  ReturningReceivedBySender = 'RETURNING_RECEIVED_BY_SENDER',
  ReturningToSender = 'RETURNING_TO_SENDER',
  ShipmentDamage = 'SHIPMENT_DAMAGE',
  ShipmentLost = 'SHIPMENT_LOST'
}

export enum TrackingType {
  Unspecified = 'UNSPECIFIED',
  Bulk = 'BULK',
  Internal = 'INTERNAL'
}

export type Transceiver = {
  __typename?: 'Transceiver';
  address?: Maybe<Address>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type UspBlock = IBlock & {
  __typename?: 'USPBlock';
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  splitTest?: Maybe<SplitTest>;
  appearance?: Maybe<BlockAppearance>;
  common?: Maybe<BlockCommon>;
  settings?: Maybe<Scalars['JSON']>;
  asset?: Maybe<Reference>;
  items?: Maybe<Array<UspBlockItem>>;
};

export type UspBlockItem = {
  __typename?: 'USPBlockItem';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  text?: Maybe<RteField>;
  link?: Maybe<LinkField>;
  linkTitle?: Maybe<Scalars['String']>;
};

export type UpdateEmployeeData = {
  email?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
};

export type Upsell = IWithProduct & {
  __typename?: 'Upsell';
  productID: Scalars['String'];
  discountPercentage?: Maybe<Scalars['Int']>;
  price?: Maybe<Price>;
  product?: Maybe<Product>;
  shipping?: Maybe<UpsellShipping>;
};


export type UpsellProductArgs = {
  mode?: Maybe<ProductFetchMode>;
  combineVariants?: Maybe<Scalars['Boolean']>;
  sortVariants?: Maybe<Scalars['Boolean']>;
  onlyAvailable?: Maybe<Scalars['Boolean']>;
  onlyEnabled?: Maybe<Scalars['Boolean']>;
  onlySafeAvailability?: Maybe<Scalars['Boolean']>;
};

export type UpsellShipping = {
  __typename?: 'UpsellShipping';
  originalPrice?: Maybe<Money>;
  newPrice?: Maybe<Money>;
};

export type VideoAsset = {
  __typename?: 'VideoAsset';
  type: Scalars['String'];
  key: Scalars['String'];
};

export type VideoResource = Media & {
  __typename?: 'VideoResource';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  asset?: Maybe<VideoAsset>;
  mobileAsset?: Maybe<VideoAsset>;
  settings?: Maybe<Scalars['JSON']>;
  captionOptions?: Maybe<CaptionOptions>;
  overlayOptions?: Maybe<OverlayOptions>;
};

export enum WarehouseKey {
  None = 'NONE',
  TrendhimDk = 'TRENDHIM_DK'
}

export type Wordbook = {
  __typename?: 'Wordbook';
  id?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
  defaults?: Maybe<Scalars['String']>;
  values?: Maybe<Scalars['JSON']>;
};

export type GlobalBarsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalBarsQuery = (
  { __typename?: 'Query' }
  & { bars?: Maybe<Array<(
    { __typename?: 'Bar' }
    & BarContentFragment
  )>> }
);

export type BarContentFragment = (
  { __typename?: 'Bar' }
  & Pick<Bar, 'id' | 'textColor' | 'backgroundColor' | 'placement' | 'priority' | 'type' | 'theme' | 'addons' | 'conditions' | 'urgencyTimerDateEnd' | 'urgencyTimerDateStart'>
  & { splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, fields?: Maybe<Array<{ __typename?: 'ProductField' } | { __typename?: 'JSONField' } | (
    { __typename?: 'LinkField' }
    & Pick<LinkField, 'key' | 'url' | 'newTab'>
    & { references?: Maybe<Array<{ __typename: 'DynamicVariable' } | { __typename: 'EmailVariable' } | { __typename: 'ExternalLink' } | { __typename: 'Image' } | { __typename: 'ImageAsset' } | { __typename: 'ImageResource' } | { __typename: 'Link' } | { __typename: 'ModalTab' } | (
      { __typename: 'Page' }
      & Pick<Page, 'id' | 'type'>
    ) | { __typename: 'TileResource' } | { __typename: 'VideoResource' } | { __typename: 'Wordbook' }>> }
  ) | { __typename?: 'MultipleLinkField' } | { __typename?: 'ReferenceField' } | (
    { __typename?: 'RTEField' }
    & Pick<RteField, 'key' | 'value'>
    & { referencesWithKey?: Maybe<Array<(
      { __typename?: 'ReferenceWithKey' }
      & Pick<ReferenceWithKey, 'key'>
      & { reference?: Maybe<(
        { __typename?: 'DynamicVariable' }
        & Pick<DynamicVariable, 'id' | 'value' | 'url'>
      ) | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
        { __typename?: 'Page' }
        & Pick<Page, 'id' | 'type' | 'title' | 'url'>
      ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }> }
    )>> }
  ) | { __typename?: 'ObjectField' } | { __typename?: 'NavigationField' }>> }
);

export type AddToCartMutationVariables = Exact<{
  products: Array<AddToCartProductInput> | AddToCartProductInput;
  withoutSuccessPrompt?: Maybe<Scalars['Boolean']>;
  boost?: Maybe<Scalars['ID']>;
  loadRecommendations: Scalars['Boolean'];
}>;


export type AddToCartMutation = (
  { __typename?: 'Mutation' }
  & { addToCart?: Maybe<(
    { __typename?: 'AddToCartResponse' }
    & Pick<AddToCartResponse, 'addedLineItemIDs' | 'success'>
    & { cart?: Maybe<(
      { __typename?: 'Cart' }
      & CartContentFragment
      & RecommendationContent_Cart_Fragment
    )>, prompts?: Maybe<Array<(
      { __typename: 'AddToCartPromptError' }
      & Pick<AddToCartPromptError, 'index' | 'code' | 'message'>
    ) | { __typename: 'AddToCartPromptGiftcard' } | (
      { __typename: 'AddToCartPromptPersonalization' }
      & Pick<AddToCartPromptPersonalization, 'index' | 'code' | 'message' | 'productID'>
      & { selectedPersonalization?: Maybe<(
        { __typename?: 'Product' }
        & ProductCrossSellAndPersonalizationContentFragment
      )>, personalizations?: Maybe<Array<(
        { __typename?: 'Product' }
        & ProductCrossSellAndPersonalizationContentFragment
      )>> }
    ) | (
      { __typename: 'AddToCartPromptSelectVariant' }
      & Pick<AddToCartPromptSelectVariant, 'index' | 'productID' | 'productIDs'>
      & { product?: Maybe<(
        { __typename?: 'Product' }
        & Pick<Product, 'id' | 'name' | 'type'>
        & { primaryAsset?: Maybe<(
          { __typename?: 'Asset' }
          & Pick<Asset, 'url'>
        )>, fitDimensions?: Maybe<Array<(
          { __typename?: 'ProductFitDimension' }
          & Pick<ProductFitDimension, 'id'>
          & { title: (
            { __typename?: 'Wordbook' }
            & WordbookFragmentFragment
          ) }
        )>>, variants?: Maybe<Array<(
          { __typename?: 'ProductVariant' }
          & Pick<ProductVariant, 'id'>
          & { availability?: Maybe<(
            { __typename?: 'Availability' }
            & Pick<Availability, 'isInStock' | 'quantity'>
          )>, fits?: Maybe<Array<(
            { __typename?: 'ProductVariantFit' }
            & Pick<ProductVariantFit, 'id' | 'dimension'>
            & { fit: (
              { __typename?: 'Wordbook' }
              & WordbookFragmentFragment
            ) }
          )>>, restock?: Maybe<(
            { __typename?: 'BaseAttribute' }
            & Pick<BaseAttribute, 'value'>
          ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, size?: Maybe<(
            { __typename?: 'BaseAttribute' }
            & Pick<BaseAttribute, 'key' | 'value'>
          ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }> }
        )>> }
        & ProductSizeGuideContentFragment
      )>, products?: Maybe<Array<(
        { __typename?: 'Product' }
        & { variants?: Maybe<Array<(
          { __typename?: 'ProductVariant' }
          & Pick<ProductVariant, 'id'>
          & { size?: Maybe<(
            { __typename?: 'BaseAttribute' }
            & Pick<BaseAttribute, 'value'>
          ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }> }
        )>> }
      )>> }
    ) | (
      { __typename: 'AddToCartPromptSuccess' }
      & Pick<AddToCartPromptSuccess, 'primaryLineItemID' | 'secondaryLineItemIDs'>
      & { freeShipping?: Maybe<(
        { __typename?: 'FreeShipping' }
        & Pick<FreeShipping, 'isFree'>
        & { remaining?: Maybe<(
          { __typename?: 'Money' }
          & MoneyContent_Money_Fragment
        )> }
      )>, tactics?: Maybe<(
        { __typename?: 'AddToCartPromptSuccessTactics' }
        & { gold?: Maybe<Array<(
          { __typename?: 'TacticAddAndSave' }
          & AddToCartPromptSuccessTacticFragment_TacticAddAndSave_Fragment
        ) | (
          { __typename?: 'TacticBoughtTogether' }
          & AddToCartPromptSuccessTacticFragment_TacticBoughtTogether_Fragment
        ) | (
          { __typename?: 'TacticBuildYourDiscount' }
          & AddToCartPromptSuccessTacticFragment_TacticBuildYourDiscount_Fragment
        ) | (
          { __typename?: 'TacticMatchingVariant' }
          & AddToCartPromptSuccessTacticFragment_TacticMatchingVariant_Fragment
        ) | (
          { __typename?: 'TacticRelativeDiscount' }
          & AddToCartPromptSuccessTacticFragment_TacticRelativeDiscount_Fragment
        ) | (
          { __typename?: 'TacticUpgradeWith' }
          & AddToCartPromptSuccessTacticFragment_TacticUpgradeWith_Fragment
        )>>, silver?: Maybe<Array<(
          { __typename?: 'TacticAddAndSave' }
          & AddToCartPromptSuccessTacticFragment_TacticAddAndSave_Fragment
        ) | (
          { __typename?: 'TacticBoughtTogether' }
          & AddToCartPromptSuccessTacticFragment_TacticBoughtTogether_Fragment
        ) | (
          { __typename?: 'TacticBuildYourDiscount' }
          & AddToCartPromptSuccessTacticFragment_TacticBuildYourDiscount_Fragment
        ) | (
          { __typename?: 'TacticMatchingVariant' }
          & AddToCartPromptSuccessTacticFragment_TacticMatchingVariant_Fragment
        ) | (
          { __typename?: 'TacticRelativeDiscount' }
          & AddToCartPromptSuccessTacticFragment_TacticRelativeDiscount_Fragment
        ) | (
          { __typename?: 'TacticUpgradeWith' }
          & AddToCartPromptSuccessTacticFragment_TacticUpgradeWith_Fragment
        )>> }
      )> }
    )>> }
  )> }
);

export type AuthenticateCartMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthenticateCartMutation = (
  { __typename?: 'Mutation' }
  & { authenticateCart?: Maybe<(
    { __typename?: 'AuthenticateCartResponse' }
    & Pick<AuthenticateCartResponse, 'success'>
    & { cart?: Maybe<(
      { __typename?: 'Cart' }
      & CartContentFragment
    )> }
  )> }
);

export type CartQueryVariables = Exact<{ [key: string]: never; }>;


export type CartQuery = (
  { __typename?: 'Query' }
  & { cart?: Maybe<(
    { __typename?: 'Cart' }
    & CartContentFragment
    & RecommendationContent_Cart_Fragment
  )> }
);

export type CartSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type CartSummaryQuery = (
  { __typename?: 'Query' }
  & { cart?: Maybe<(
    { __typename?: 'Cart' }
    & CartContentFragment
  )> }
);

export type CheckoutCartQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutCartQuery = (
  { __typename?: 'Query' }
  & { checkout?: Maybe<(
    { __typename?: 'Checkout' }
    & Pick<Checkout, 'isOptInCountry'>
    & { addressMetaData?: Maybe<(
      { __typename?: 'AddressMetaData' }
      & Pick<AddressMetaData, 'showAdditionalStreetInfo' | 'states' | 'regions' | 'showRegion' | 'showState'>
      & { countries?: Maybe<Array<(
        { __typename?: 'Country' }
        & Pick<Country, 'code' | 'name'>
      )>> }
    )>, paymentMetaData?: Maybe<(
      { __typename?: 'PaymentMetaData' }
      & Pick<PaymentMetaData, 'adyenConfig' | 'braintreeConfig'>
    )>, cart?: Maybe<(
      { __typename?: 'Cart' }
      & Pick<Cart, 'shippingMethodID'>
      & { availablePaymentMethods?: Maybe<Array<(
        { __typename?: 'PaymentMethod' }
        & Pick<PaymentMethod, 'type' | 'title' | 'provider' | 'id'>
        & { logo?: Maybe<(
          { __typename?: 'Asset' }
          & Pick<Asset, 'url'>
        )>, icons?: Maybe<Array<(
          { __typename?: 'PaymentMethodIcon' }
          & Pick<PaymentMethodIcon, 'name'>
          & { logo?: Maybe<(
            { __typename?: 'Asset' }
            & Pick<Asset, 'url' | 'tags'>
            & { dimensions?: Maybe<(
              { __typename?: 'Dimensions' }
              & Pick<Dimensions, 'height' | 'width'>
            )> }
          )> }
        )>> }
      )>>, deliveryAddress?: Maybe<(
        { __typename?: 'CartAddress' }
        & Pick<CartAddress, 'email' | 'firstName' | 'lastName' | 'company' | 'streetName' | 'additionalStreetInfo' | 'postalCode' | 'city' | 'state' | 'country' | 'region' | 'phone' | 'phonePrefix' | 'externalID' | 'externalCustomerID'>
      )> }
      & CartContentFragment
      & CartAddressContentFragment
      & CartAvailableShippingMethodsFragmentFragment
    )> }
  )> }
);

export type FinalizeCartMutationVariables = Exact<{
  checksum?: Maybe<Scalars['String']>;
  consents?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  paymentMethodID?: Maybe<Scalars['ID']>;
  paymentPayload?: Maybe<Scalars['JSON']>;
  recaptchaToken?: Maybe<Scalars['String']>;
}>;


export type FinalizeCartMutation = (
  { __typename?: 'Mutation' }
  & { finalizeCart?: Maybe<(
    { __typename?: 'FinalizeCartResponse' }
    & Pick<FinalizeCartResponse, 'success' | 'orderNumber' | 'paymentPayload' | 'redirect'>
    & { prompts?: Maybe<Array<(
      { __typename?: 'FinalizeCartPromptError' }
      & Pick<FinalizeCartPromptError, 'code' | 'message'>
    )>> }
  )> }
);

export type DetailsForPaymentMutationVariables = Exact<{
  payload?: Maybe<Scalars['JSON']>;
}>;


export type DetailsForPaymentMutation = (
  { __typename?: 'Mutation' }
  & { getDetailsForPayment?: Maybe<(
    { __typename?: 'GetDetailsForPaymentResponse' }
    & Pick<GetDetailsForPaymentResponse, 'redirect' | 'success' | 'details'>
  )> }
);

export type InitializePaymentMethodMutationVariables = Exact<{
  paymentMethodID: Scalars['ID'];
  payload?: Maybe<Scalars['JSON']>;
}>;


export type InitializePaymentMethodMutation = (
  { __typename?: 'Mutation' }
  & { initializePaymentMethod?: Maybe<(
    { __typename?: 'InitializePaymentMethodResponse' }
    & Pick<InitializePaymentMethodResponse, 'payload' | 'success'>
  )> }
);

export type RefreshCartMutationVariables = Exact<{
  fixErrors?: Maybe<Scalars['Boolean']>;
}>;


export type RefreshCartMutation = (
  { __typename?: 'Mutation' }
  & { refreshCart?: Maybe<(
    { __typename?: 'RefreshCartResponse' }
    & Pick<RefreshCartResponse, 'success'>
    & { cart?: Maybe<(
      { __typename?: 'Cart' }
      & CartContentFragment
      & RecommendationContent_Cart_Fragment
    )> }
  )> }
);

export type RemoveFromCartMutationVariables = Exact<{
  lineItemID: Scalars['ID'];
}>;


export type RemoveFromCartMutation = (
  { __typename?: 'Mutation' }
  & { removeFromCart?: Maybe<(
    { __typename?: 'RemoveFromCartResponse' }
    & Pick<RemoveFromCartResponse, 'success'>
    & { cart?: Maybe<(
      { __typename?: 'Cart' }
      & CartContentFragment
    )>, prompts?: Maybe<Array<(
      { __typename: 'RemoveFromCartPromptError' }
      & Pick<RemoveFromCartPromptError, 'index' | 'code' | 'message'>
    )>> }
  )> }
);

export type SetAddressesInCartMutationVariables = Exact<{
  shippingAddress: AddressInput;
  billingAddress: AddressInput;
}>;


export type SetAddressesInCartMutation = (
  { __typename?: 'Mutation' }
  & { setAddressesInCart?: Maybe<(
    { __typename?: 'SetAddressesInCartResponse' }
    & Pick<SetAddressesInCartResponse, 'success'>
    & { cart?: Maybe<(
      { __typename?: 'Cart' }
      & Pick<Cart, 'id' | 'checksum' | 'expectedDelivery' | 'shippingMethodID'>
      & { totals?: Maybe<Array<(
        { __typename?: 'CartTotal' }
        & Pick<CartTotal, 'id' | 'style' | 'title' | 'text'>
        & { value?: Maybe<(
          { __typename?: 'Money' }
          & MoneyContent_Money_Fragment
        )> }
      )>>, deliveryAddress?: Maybe<(
        { __typename?: 'CartAddress' }
        & Pick<CartAddress, 'email' | 'firstName' | 'lastName' | 'company' | 'streetName' | 'additionalStreetInfo' | 'postalCode' | 'city' | 'state' | 'country' | 'region' | 'phone' | 'phonePrefix' | 'externalID' | 'externalCustomerID'>
      )> }
      & CartAddressContentFragment
      & CartAvailableShippingMethodsFragmentFragment
    )> }
  )> }
);

export type SetDiscountCodeInCartMutationVariables = Exact<{
  customerID?: Maybe<Scalars['ID']>;
  discountCode?: Maybe<Scalars['ID']>;
}>;


export type SetDiscountCodeInCartMutation = (
  { __typename?: 'Mutation' }
  & { setDiscountCodeInCart?: Maybe<(
    { __typename?: 'SetDiscountCodeInCartResponse' }
    & Pick<SetDiscountCodeInCartResponse, 'success'>
    & { cart?: Maybe<(
      { __typename?: 'Cart' }
      & CartContentFragment
    )>, prompts?: Maybe<Array<(
      { __typename: 'SetDiscountCodeInCartPromptError' }
      & Pick<SetDiscountCodeInCartPromptError, 'code' | 'message'>
    ) | (
      { __typename: 'SetDiscountCodeInCartPromptSuccess' }
      & { bars?: Maybe<Array<(
        { __typename?: 'Bar' }
        & BarContentFragment
      )>> }
    )>> }
  )> }
);

export type SetQuantityInCartMutationVariables = Exact<{
  lineItems: Array<SetQuantityInCartLineItemInput> | SetQuantityInCartLineItemInput;
}>;


export type SetQuantityInCartMutation = (
  { __typename?: 'Mutation' }
  & { setQuantityInCart?: Maybe<(
    { __typename?: 'SetQuantityInCartResponse' }
    & Pick<SetQuantityInCartResponse, 'success'>
    & { cart?: Maybe<(
      { __typename?: 'Cart' }
      & CartContentFragment
      & RecommendationContent_Cart_Fragment
    )>, prompts?: Maybe<Array<(
      { __typename: 'SetQuantityInCartPromptError' }
      & Pick<SetQuantityInCartPromptError, 'index' | 'code' | 'message'>
    )>> }
  )> }
);

export type SetShippingMethodInCartDeliveryMutationVariables = Exact<{
  shippingMethod: ShippingMethodInput;
}>;


export type SetShippingMethodInCartDeliveryMutation = (
  { __typename?: 'Mutation' }
  & { setShippingMethodInCart?: Maybe<(
    { __typename?: 'SetShippingMethodInCartResponse' }
    & Pick<SetShippingMethodInCartResponse, 'success'>
    & { cart?: Maybe<(
      { __typename?: 'Cart' }
      & Pick<Cart, 'id' | 'checksum' | 'shippingMethodID' | 'expectedDelivery'>
      & { totals?: Maybe<Array<(
        { __typename?: 'CartTotal' }
        & Pick<CartTotal, 'id' | 'style' | 'title' | 'text'>
        & { value?: Maybe<(
          { __typename?: 'Money' }
          & MoneyContent_Money_Fragment
        )> }
      )>>, deliveryAddress?: Maybe<(
        { __typename?: 'CartAddress' }
        & Pick<CartAddress, 'email' | 'firstName' | 'lastName' | 'company' | 'streetName' | 'additionalStreetInfo' | 'postalCode' | 'city' | 'state' | 'country' | 'region' | 'phone' | 'phonePrefix' | 'externalID' | 'externalCustomerID'>
      )> }
      & CartAvailableShippingMethodsFragmentFragment
    )> }
  )> }
);

export type SetVariantInCartMutationVariables = Exact<{
  lineItems: Array<SetVariantInCartLineItemInput> | SetVariantInCartLineItemInput;
}>;


export type SetVariantInCartMutation = (
  { __typename?: 'Mutation' }
  & { setVariantInCart?: Maybe<(
    { __typename?: 'SetVariantInCartResponse' }
    & Pick<SetVariantInCartResponse, 'success'>
    & { cart?: Maybe<(
      { __typename?: 'Cart' }
      & CartContentFragment
    )> }
  )> }
);

export type ShippingMethodQueryVariables = Exact<{
  shippingMethodId: Scalars['ID'];
  postalCode?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
}>;


export type ShippingMethodQuery = (
  { __typename?: 'Query' }
  & { shippingMethod?: Maybe<(
    { __typename?: 'ShippingMethod' }
    & Pick<ShippingMethod, 'id'>
    & { serviceLocations?: Maybe<Array<(
      { __typename?: 'ServiceLocation' }
      & Pick<ServiceLocation, 'checksum' | 'city' | 'distance' | 'externalID' | 'latitude' | 'longitude' | 'name' | 'postalCode' | 'streetName' | 'additionalStreetInfo' | 'version'>
      & { openingHours?: Maybe<Array<(
        { __typename?: 'OpeningHours' }
        & Pick<OpeningHours, 'dayOfWeek'>
        & { closes?: Maybe<(
          { __typename?: 'OpeningTime' }
          & Pick<OpeningTime, 'hours' | 'minutes' | 'nanos' | 'seconds'>
        )>, opens?: Maybe<(
          { __typename?: 'OpeningTime' }
          & Pick<OpeningTime, 'hours' | 'minutes' | 'nanos' | 'seconds'>
        )> }
      )>> }
    )>> }
  )> }
);

type AddToCartPromptSuccessTacticFragment_TacticAddAndSave_Fragment = (
  { __typename: 'TacticAddAndSave' }
  & Pick<TacticAddAndSave, 'id'>
  & { offers?: Maybe<Array<(
    { __typename?: 'TacticGenericOffer' }
    & Pick<TacticGenericOffer, 'productID'>
    & { offer: (
      { __typename?: 'AddToCartProductTactic' }
      & AddToCartProductTacticFragmentFragment
    ), product?: Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'id' | 'name' | 'url'>
      & { primaryAsset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )> }
    )> }
  )>> }
);

type AddToCartPromptSuccessTacticFragment_TacticBoughtTogether_Fragment = (
  { __typename: 'TacticBoughtTogether' }
  & Pick<TacticBoughtTogether, 'id'>
  & TacticRecommendationsFragment_TacticBoughtTogether_Fragment
);

type AddToCartPromptSuccessTacticFragment_TacticBuildYourDiscount_Fragment = (
  { __typename: 'TacticBuildYourDiscount' }
  & Pick<TacticBuildYourDiscount, 'id'>
);

type AddToCartPromptSuccessTacticFragment_TacticMatchingVariant_Fragment = (
  { __typename: 'TacticMatchingVariant' }
  & Pick<TacticMatchingVariant, 'id' | 'type' | 'productID'>
  & { title?: Maybe<(
    { __typename?: 'Wordbook' }
    & WordbookFragmentFragment
  )>, tag?: Maybe<(
    { __typename?: 'Wordbook' }
    & WordbookFragmentFragment
  )>, offer?: Maybe<(
    { __typename?: 'AddToCartProductTactic' }
    & AddToCartProductTacticFragmentFragment
  )>, product?: Maybe<(
    { __typename?: 'Product' }
    & Pick<Product, 'id' | 'name'>
    & { primaryAsset?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )>, masterVariant?: Maybe<(
      { __typename?: 'ProductVariant' }
      & { price?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'currencyCode' | 'value' | 'format'>
        & { discount?: Maybe<(
          { __typename?: 'PriceDiscount' }
          & Pick<PriceDiscount, 'currencyCode' | 'percent' | 'value' | 'format'>
        )> }
      )> }
    )> }
  )> }
);

type AddToCartPromptSuccessTacticFragment_TacticRelativeDiscount_Fragment = (
  { __typename: 'TacticRelativeDiscount' }
  & Pick<TacticRelativeDiscount, 'id' | 'productIDs'>
  & { products?: Maybe<Array<(
    { __typename?: 'Product' }
    & Pick<Product, 'id' | 'name'>
    & { primaryAsset?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )> }
  )>>, relativeDiscounts?: Maybe<Array<(
    { __typename?: 'TacticRelativeDiscountItem' }
    & Pick<TacticRelativeDiscountItem, 'quantity' | 'percentage'>
    & { price?: Maybe<(
      { __typename?: 'Price' }
      & Pick<Price, 'format' | 'value'>
      & { discount?: Maybe<(
        { __typename?: 'PriceDiscount' }
        & Pick<PriceDiscount, 'format' | 'value'>
      )> }
    )> }
  )>> }
);

type AddToCartPromptSuccessTacticFragment_TacticUpgradeWith_Fragment = (
  { __typename: 'TacticUpgradeWith' }
  & Pick<TacticUpgradeWith, 'id'>
  & { items?: Maybe<Array<(
    { __typename?: 'TacticUpgradeWithItem' }
    & Pick<TacticUpgradeWithItem, 'type'>
    & { product?: Maybe<(
      { __typename?: 'Product' }
      & ProductCrossSellAndPersonalizationContentFragment
    )> }
  )>> }
);

export type AddToCartPromptSuccessTacticFragmentFragment = AddToCartPromptSuccessTacticFragment_TacticAddAndSave_Fragment | AddToCartPromptSuccessTacticFragment_TacticBoughtTogether_Fragment | AddToCartPromptSuccessTacticFragment_TacticBuildYourDiscount_Fragment | AddToCartPromptSuccessTacticFragment_TacticMatchingVariant_Fragment | AddToCartPromptSuccessTacticFragment_TacticRelativeDiscount_Fragment | AddToCartPromptSuccessTacticFragment_TacticUpgradeWith_Fragment;

export type CartContentFragment = (
  { __typename?: 'Cart' }
  & Pick<Cart, 'valid' | 'id' | 'checksum' | 'customerID' | 'recoverableLineItemIDs' | 'expectedDelivery'>
  & { lineItemGroups?: Maybe<Array<(
    { __typename?: 'CartLineItemGroup' }
    & Pick<CartLineItemGroup, 'id' | 'lineItemIDs' | 'type'>
    & { totalPrice?: Maybe<(
      { __typename?: 'Price' }
      & PriceFragmentFragment
    )> }
  )>>, lineItems?: Maybe<Array<(
    { __typename?: 'CartLineItem' }
    & Pick<CartLineItem, 'discountText' | 'id' | 'tactic' | 'productID' | 'quantity'>
    & { price?: Maybe<(
      { __typename?: 'Price' }
      & PriceFragmentFragment
    )>, totalPrice?: Maybe<(
      { __typename?: 'Price' }
      & PriceFragmentFragment
    )>, totalTaxedPrice?: Maybe<(
      { __typename?: 'TaxedPrice' }
      & { totalNet?: Maybe<(
        { __typename?: 'Money' }
        & { base?: Maybe<(
          { __typename?: 'Money' }
          & { plain: Money['format'] }
        )> }
        & MoneyContent_Money_Fragment
      )> }
    )>, errors?: Maybe<Array<(
      { __typename?: 'CartLineItemError' }
      & Pick<CartLineItemError, 'code' | 'message'>
      & { suggestion?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>>, product?: Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'id' | 'type' | 'name' | 'url' | 'categoryIDs'>
      & { primaryCategories?: Maybe<Array<(
        { __typename?: 'Category' }
        & Pick<Category, 'name'>
      )>>, availability?: Maybe<(
        { __typename?: 'Availability' }
        & Pick<Availability, 'isInStock' | 'quantity'>
      )>, brand?: Maybe<(
        { __typename?: 'Brand' }
        & Pick<Brand, 'title' | 'url' | 'logo' | 'id'>
      )>, assets?: Maybe<Array<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'tags'>
      )>>, primaryAsset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, variants?: Maybe<Array<(
        { __typename?: 'ProductVariant' }
        & Pick<ProductVariant, 'id'>
        & { availability?: Maybe<(
          { __typename?: 'Availability' }
          & Pick<Availability, 'isInStock' | 'quantity'>
        )>, size?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'value'>
        ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }> }
      )>> }
    )>, variant?: Maybe<(
      { __typename?: 'ProductVariant' }
      & Pick<ProductVariant, 'id'>
      & { giftWrappings?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
        { __typename?: 'ProductAttribute' }
        & { products?: Maybe<Array<(
          { __typename?: 'Product' }
          & Pick<Product, 'id'>
          & { asset?: Maybe<(
            { __typename?: 'Asset' }
            & Pick<Asset, 'url'>
          )>, masterVariant?: Maybe<(
            { __typename?: 'ProductVariant' }
            & { price?: Maybe<(
              { __typename?: 'Price' }
              & { discount?: Maybe<(
                { __typename?: 'PriceDiscount' }
                & MoneyContent_PriceDiscount_Fragment
              )> }
              & MoneyContent_Price_Fragment
            )> }
          )> }
        )>> }
      ) | { __typename?: 'ProductsWithQuantityAttribute' }>, size?: Maybe<(
        { __typename?: 'BaseAttribute' }
        & Pick<BaseAttribute, 'value'>
      ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, isNew?: Maybe<(
        { __typename?: 'BaseAttribute' }
        & Pick<BaseAttribute, 'value'>
      ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, personalizations?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
        { __typename?: 'ProductAttribute' }
        & { products?: Maybe<Array<(
          { __typename?: 'Product' }
          & { asset?: Maybe<(
            { __typename?: 'Asset' }
            & Pick<Asset, 'url'>
          )> }
          & ProductCrossSellAndPersonalizationContentFragment
        )>> }
      ) | { __typename?: 'ProductsWithQuantityAttribute' }>, crossSells?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
        { __typename?: 'ProductAttribute' }
        & { products?: Maybe<Array<(
          { __typename?: 'Product' }
          & Pick<Product, 'id'>
        )>> }
      ) | { __typename?: 'ProductsWithQuantityAttribute' }>, type?: Maybe<(
        { __typename?: 'BaseAttribute' }
        & Pick<BaseAttribute, 'value'>
      ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, subType?: Maybe<(
        { __typename?: 'BaseAttribute' }
        & Pick<BaseAttribute, 'value'>
      ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }> }
    )>, type?: Maybe<(
      { __typename?: 'CartLineItemTypeBundle' }
      & Pick<CartLineItemTypeBundle, 'link' | 'parent' | 'children' | 'milestoneID'>
    ) | (
      { __typename?: 'CartLineItemTypeFreeProduct' }
      & Pick<CartLineItemTypeFreeProduct, 'link' | 'parent' | 'children' | 'milestoneID' | 'disableSizeSelection' | 'hasSelectedVariant'>
    ) | (
      { __typename?: 'CartLineItemTypeGeneric' }
      & Pick<CartLineItemTypeGeneric, 'link' | 'parent' | 'children' | 'milestoneID'>
    ) | (
      { __typename?: 'CartLineItemTypeGiftcard' }
      & Pick<CartLineItemTypeGiftcard, 'link' | 'parent' | 'children' | 'milestoneID' | 'text'>
      & { amount?: Maybe<(
        { __typename?: 'Money' }
        & Pick<Money, 'format' | 'value' | 'currencyCode'>
      )> }
    ) | (
      { __typename?: 'CartLineItemTypeUpsellBundle' }
      & Pick<CartLineItemTypeUpsellBundle, 'link' | 'parent' | 'children' | 'milestoneID'>
    ) | (
      { __typename?: 'CartLineItemTypeUpsellGeneric' }
      & Pick<CartLineItemTypeUpsellGeneric, 'link' | 'parent' | 'children' | 'milestoneID'>
    ) | (
      { __typename?: 'CartLineItemTypeUpsellPersonalization' }
      & Pick<CartLineItemTypeUpsellPersonalization, 'link' | 'parent' | 'children' | 'milestoneID' | 'text' | 'blobID'>
    )> }
  )>>, totals?: Maybe<Array<(
    { __typename?: 'CartTotal' }
    & Pick<CartTotal, 'id' | 'style' | 'title' | 'text'>
    & { value?: Maybe<(
      { __typename?: 'Money' }
      & MoneyContent_Money_Fragment
    )> }
  )>>, freeShipping?: Maybe<(
    { __typename?: 'FreeShipping' }
    & Pick<FreeShipping, 'isFree'>
    & { cheapest?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currencyCode' | 'value' | 'format'>
    )>, remaining?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currencyCode' | 'value' | 'format'>
    )>, threshold?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currencyCode' | 'value' | 'format'>
    )> }
  )>, discountCodes?: Maybe<Array<(
    { __typename?: 'CartDiscountCode' }
    & Pick<CartDiscountCode, 'code' | 'id' | 'title'>
  )>>, club?: Maybe<(
    { __typename?: 'CartClub' }
    & Pick<CartClub, 'isLoggedIn'>
    & { balance?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currencyCode' | 'format' | 'value'>
    )>, value?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currencyCode' | 'format' | 'value'>
    )> }
  )> }
  & MilestoneFragmentFragment
);

export type CartAddressContentFragment = (
  { __typename?: 'Cart' }
  & { billingAddress?: Maybe<(
    { __typename?: 'CartAddress' }
    & Pick<CartAddress, 'email' | 'firstName' | 'lastName' | 'company' | 'streetName' | 'additionalStreetInfo' | 'postalCode' | 'city' | 'state' | 'country' | 'region' | 'phone' | 'phonePrefix' | 'externalID' | 'externalCustomerID'>
  )>, shippingAddress?: Maybe<(
    { __typename?: 'CartAddress' }
    & Pick<CartAddress, 'email' | 'firstName' | 'lastName' | 'company' | 'streetName' | 'additionalStreetInfo' | 'postalCode' | 'city' | 'state' | 'country' | 'region' | 'phone' | 'phonePrefix' | 'externalID' | 'externalCustomerID'>
  )> }
);

export type CartAvailableShippingMethodsFragmentFragment = (
  { __typename?: 'Cart' }
  & Pick<Cart, 'expectedDelivery'>
  & { availableShippingMethods?: Maybe<Array<(
    { __typename?: 'ShippingMethod' }
    & Pick<ShippingMethod, 'id' | 'key' | 'deliveryTimeText' | 'isUnavailable' | 'isExternalCustomerIDRequired' | 'title' | 'description' | 'icon' | 'isRecommended' | 'isServiceLocation' | 'isCOD'>
    & { price?: Maybe<(
      { __typename?: 'Price' }
      & Pick<Price, 'countryCode' | 'currencyCode' | 'value' | 'format'>
      & { discount?: Maybe<(
        { __typename?: 'PriceDiscount' }
        & Pick<PriceDiscount, 'currencyCode' | 'percent' | 'value' | 'format'>
        & { code?: Maybe<(
          { __typename?: 'DiscountCode' }
          & Pick<DiscountCode, 'id' | 'context'>
        )> }
      )> }
    )>, logo?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )>, serviceLocations?: Maybe<Array<(
      { __typename?: 'ServiceLocation' }
      & Pick<ServiceLocation, 'checksum' | 'city' | 'distance' | 'externalID' | 'latitude' | 'longitude' | 'name' | 'postalCode' | 'streetName' | 'additionalStreetInfo' | 'version'>
      & { openingHours?: Maybe<Array<(
        { __typename?: 'OpeningHours' }
        & Pick<OpeningHours, 'dayOfWeek'>
        & { closes?: Maybe<(
          { __typename?: 'OpeningTime' }
          & Pick<OpeningTime, 'hours' | 'minutes' | 'nanos' | 'seconds'>
        )>, opens?: Maybe<(
          { __typename?: 'OpeningTime' }
          & Pick<OpeningTime, 'hours' | 'minutes' | 'nanos' | 'seconds'>
        )> }
      )>> }
    )>> }
  )>> }
);

export type MilestoneFragmentFragment = (
  { __typename?: 'Cart' }
  & { milestones?: Maybe<(
    { __typename?: 'CartMilestones' }
    & Pick<CartMilestones, 'progress' | 'backgroundColor' | 'textColor' | 'successColor'>
    & { title?: Maybe<(
      { __typename?: 'Wordbook' }
      & WordbookFragmentFragment
    )>, steps?: Maybe<Array<(
      { __typename?: 'CartMilestoneStep' }
      & Pick<CartMilestoneStep, 'id' | 'type' | 'status' | 'progress'>
      & { title?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )>, option?: Maybe<(
        { __typename?: 'CartMilestoneStepOptionDiscountCode' }
        & Pick<CartMilestoneStepOptionDiscountCode, 'discountCode'>
        & { callToAction?: Maybe<(
          { __typename?: 'Wordbook' }
          & WordbookFragmentFragment
        )>, title?: Maybe<(
          { __typename?: 'Wordbook' }
          & WordbookFragmentFragment
        )>, success?: Maybe<(
          { __typename?: 'Wordbook' }
          & WordbookFragmentFragment
        )>, warning?: Maybe<(
          { __typename?: 'Wordbook' }
          & WordbookFragmentFragment
        )> }
      ) | (
        { __typename?: 'CartMilestoneStepOptionProducts' }
        & Pick<CartMilestoneStepOptionProducts, 'productIDs'>
        & { callToAction?: Maybe<(
          { __typename?: 'Wordbook' }
          & WordbookFragmentFragment
        )>, title?: Maybe<(
          { __typename?: 'Wordbook' }
          & WordbookFragmentFragment
        )>, products?: Maybe<Array<(
          { __typename?: 'Product' }
          & Pick<Product, 'categoryIDs' | 'primaryCategoryIDs' | 'id' | 'enabled' | 'type' | 'name' | 'slug' | 'url' | 'description'>
          & { asset?: Maybe<(
            { __typename?: 'Asset' }
            & Pick<Asset, 'url' | 'tags'>
          )>, masterVariant?: Maybe<(
            { __typename?: 'ProductVariant' }
            & { price?: Maybe<(
              { __typename?: 'Price' }
              & Pick<Price, 'countryCode' | 'currencyCode' | 'value' | 'format'>
              & { discount?: Maybe<(
                { __typename?: 'PriceDiscount' }
                & Pick<PriceDiscount, 'currencyCode' | 'percent' | 'value' | 'format'>
              )> }
            )> }
          )> }
        )>> }
      )> }
    )>>, asset?: Maybe<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | { __typename?: 'Page' } | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | (
      { __typename?: 'Wordbook' }
      & Pick<Wordbook, 'id' | 'value' | 'defaults' | 'values'>
    )> }
  )> }
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me?: Maybe<(
    { __typename?: 'Customer' }
    & Pick<Customer, 'id'>
  ) | { __typename?: 'Employee' } | { __typename?: 'Service' }> }
);

export type MeWithClubQueryVariables = Exact<{ [key: string]: never; }>;


export type MeWithClubQuery = (
  { __typename?: 'Query' }
  & { me?: Maybe<(
    { __typename?: 'Customer' }
    & Pick<Customer, 'id' | 'email'>
    & { club?: Maybe<(
      { __typename?: 'CustomerClub' }
      & { history?: Maybe<Array<(
        { __typename?: 'ClubTransaction' }
        & Pick<ClubTransaction, 'createdAt' | 'createdAtText' | 'orderNumber'>
        & { amount: (
          { __typename?: 'Money' }
          & Pick<Money, 'format' | 'currencyCode' | 'value'>
        ) }
      )>>, expiringTransaction?: Maybe<(
        { __typename?: 'ClubExpiringTransaction' }
        & { expiresIn: (
          { __typename?: 'Wordbook' }
          & WordbookFragmentFragment
        ), amount: (
          { __typename?: 'Money' }
          & Pick<Money, 'value' | 'format' | 'currencyCode'>
        ) }
      )>, balance?: Maybe<(
        { __typename?: 'Money' }
        & Pick<Money, 'currencyCode' | 'format' | 'value'>
      )> }
    )> }
  ) | { __typename?: 'Employee' } | { __typename?: 'Service' }> }
);

export type DrawerPageQueryVariables = Exact<{
  type: PageType;
  id?: Maybe<Scalars['ID']>;
  presentation?: Maybe<PagePresentation>;
  boost?: Maybe<Scalars['ID']>;
}>;


export type DrawerPageQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<(
    { __typename?: 'Page' }
    & DrawerDataFragment
  )> }
);

export type DrawerPagesQueryVariables = Exact<{
  pages: Array<PageIdentifier> | PageIdentifier;
  presentation?: Maybe<PagePresentation>;
  boost?: Maybe<Scalars['ID']>;
}>;


export type DrawerPagesQuery = (
  { __typename?: 'Query' }
  & { pages: Array<(
    { __typename?: 'Page' }
    & DrawerDataFragment
  )> }
);

export type PageItemFragment = (
  { __typename?: 'Page' }
  & Pick<Page, 'id' | 'type' | 'url' | 'title'>
);

export type LatestPageItemFragment = (
  { __typename?: 'Page' }
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
  & PageItemFragment
);

export type GlobalCmsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalCmsDataQuery = (
  { __typename?: 'Query' }
  & { latestCollections: Array<(
    { __typename?: 'Page' }
    & { brand?: Maybe<(
      { __typename?: 'Brand' }
      & Pick<Brand, 'id' | 'url' | 'title' | 'logo'>
    )> }
    & LatestPageItemFragment
  )>, pageAboutUs?: Maybe<(
    { __typename?: 'Page' }
    & PageItemFragment
  )>, pageArticles?: Maybe<(
    { __typename?: 'Page' }
    & PageItemFragment
  )>, pageCookiePolicy?: Maybe<(
    { __typename?: 'Page' }
    & PageItemFragment
  )>, pageCSR?: Maybe<(
    { __typename?: 'Page' }
    & PageItemFragment
  )>, pageFAQ?: Maybe<(
    { __typename?: 'Page' }
    & PageItemFragment
  )>, pagePress?: Maybe<(
    { __typename?: 'Page' }
    & PageItemFragment
  )>, pagePrivacyPolicy?: Maybe<(
    { __typename?: 'Page' }
    & PageItemFragment
  )>, pageReturns?: Maybe<(
    { __typename?: 'Page' }
    & PageItemFragment
  )>, pageTerms?: Maybe<(
    { __typename?: 'Page' }
    & PageItemFragment
  )>, menuGiftGuide?: Maybe<(
    { __typename?: 'Page' }
    & PageItemFragment
  )> }
);

export type PageContentFragment = (
  { __typename?: 'Page' }
  & Pick<Page, 'id' | 'type' | 'url'>
  & { openGraph?: Maybe<(
    { __typename?: 'OpenGraph' }
    & Pick<OpenGraph, 'title' | 'description' | 'imageURL' | 'type'>
  )> }
);

export type LatestArticlesAndCollectionsQueryVariables = Exact<{
  excludeArticleIDs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  excludeCollectionIDs?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type LatestArticlesAndCollectionsQuery = (
  { __typename?: 'Query' }
  & { articles: Array<(
    { __typename?: 'Page' }
    & PageContentFragment
  )>, collections: Array<(
    { __typename?: 'Page' }
    & { brand?: Maybe<(
      { __typename?: 'Brand' }
      & Pick<Brand, 'id' | 'logo' | 'title'>
    )> }
    & PageContentFragment
  )> }
);

export type NavigationItemFragmentFragment = (
  { __typename?: 'NavigationItem' }
  & Pick<NavigationItem, 'id' | 'features' | 'title'>
  & { link?: Maybe<(
    { __typename?: 'Link' }
    & Pick<Link, 'id' | 'url'>
    & { image?: Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>, references?: Maybe<Array<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
      { __typename?: 'Page' }
      & Pick<Page, 'id' | 'type' | 'title'>
    ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }>> }
  )>, appearanceDesktop?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, appearanceMobile?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )> }
);

export type GlobalNavigationQueryVariables = Exact<{
  boost?: Maybe<Scalars['ID']>;
}>;


export type GlobalNavigationQuery = (
  { __typename?: 'Query' }
  & { navigation?: Maybe<Array<(
    { __typename?: 'NavigationItem' }
    & { blocks?: Maybe<Array<(
      { __typename?: 'Block' }
      & BlockContent_Block_Fragment
    ) | (
      { __typename?: 'AccordionListBlock' }
      & BlockContent_AccordionListBlock_Fragment
    ) | (
      { __typename?: 'ActiveCampaignBlock' }
      & BlockContent_ActiveCampaignBlock_Fragment
    ) | (
      { __typename?: 'GalleryBlock' }
      & BlockContent_GalleryBlock_Fragment
    ) | (
      { __typename?: 'GlobalBlock' }
      & Pick<GlobalBlock, 'id' | 'type'>
      & { blocks?: Maybe<Array<(
        { __typename?: 'Block' }
        & BlockContent_Block_Fragment
      ) | (
        { __typename?: 'AccordionListBlock' }
        & BlockContent_AccordionListBlock_Fragment
      ) | (
        { __typename?: 'ActiveCampaignBlock' }
        & BlockContent_ActiveCampaignBlock_Fragment
      ) | (
        { __typename?: 'GalleryBlock' }
        & BlockContent_GalleryBlock_Fragment
      ) | (
        { __typename?: 'HTMLBlock' }
        & BlockContent_HtmlBlock_Fragment
      ) | (
        { __typename?: 'InfoPanelBlock' }
        & BlockContent_InfoPanelBlock_Fragment
      ) | (
        { __typename?: 'LookDisplayBlock' }
        & BlockContent_LookDisplayBlock_Fragment
      ) | (
        { __typename?: 'LookListBlock' }
        & BlockContent_LookListBlock_Fragment
      ) | (
        { __typename?: 'PageGridBlock' }
        & BlockContent_PageGridBlock_Fragment
      ) | (
        { __typename?: 'PageSliderBlock' }
        & BlockContent_PageSliderBlock_Fragment
      ) | (
        { __typename?: 'ProductGridSelectorBlock' }
        & BlockContent_ProductGridSelectorBlock_Fragment
      ) | (
        { __typename?: 'ProductListBlock' }
        & BlockContent_ProductListBlock_Fragment
      ) | (
        { __typename?: 'ProductSliderBlock' }
        & BlockContent_ProductSliderBlock_Fragment
      ) | (
        { __typename?: 'USPBlock' }
        & BlockContent_UspBlock_Fragment
      )>> }
      & BlockContent_GlobalBlock_Fragment
    ) | (
      { __typename?: 'HTMLBlock' }
      & BlockContent_HtmlBlock_Fragment
    ) | (
      { __typename?: 'InfoPanelBlock' }
      & BlockContent_InfoPanelBlock_Fragment
    ) | (
      { __typename?: 'LookDisplayBlock' }
      & BlockContent_LookDisplayBlock_Fragment
    ) | (
      { __typename?: 'LookListBlock' }
      & BlockContent_LookListBlock_Fragment
    ) | (
      { __typename?: 'PageGridBlock' }
      & BlockContent_PageGridBlock_Fragment
    ) | (
      { __typename?: 'PageSliderBlock' }
      & BlockContent_PageSliderBlock_Fragment
    ) | (
      { __typename?: 'ProductGridSelectorBlock' }
      & BlockContent_ProductGridSelectorBlock_Fragment
    ) | (
      { __typename?: 'ProductListBlock' }
      & BlockContent_ProductListBlock_Fragment
    ) | (
      { __typename?: 'ProductSliderBlock' }
      & BlockContent_ProductSliderBlock_Fragment
    ) | (
      { __typename?: 'USPBlock' }
      & BlockContent_UspBlock_Fragment
    )>>, items?: Maybe<Array<(
      { __typename?: 'NavigationItem' }
      & { items?: Maybe<Array<(
        { __typename?: 'NavigationItem' }
        & NavigationItemFragmentFragment
      )>> }
      & NavigationItemFragmentFragment
    )>> }
    & NavigationItemFragmentFragment
  )>>, navigationTop?: Maybe<Array<(
    { __typename?: 'NavigationItem' }
    & NavigationItemFragmentFragment
  )>> }
);

export type ProductForAddToCartQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type ProductForAddToCartQuery = (
  { __typename?: 'Query' }
  & { product?: Maybe<(
    { __typename?: 'Product' }
    & ProductContentFragment
  )> }
);

export type ProductReviewsQueryVariables = Exact<{
  type: PageType;
  slug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  reviewLimit?: Maybe<Scalars['Int']>;
  reviewCursor?: Maybe<Scalars['String']>;
}>;


export type ProductReviewsQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<(
    { __typename?: 'Page' }
    & Pick<Page, 'id' | 'type'>
    & { fields?: Maybe<Array<(
      { __typename?: 'ProductField' }
      & Pick<ProductField, 'key'>
      & { product?: Maybe<(
        { __typename?: 'Product' }
        & ProductReviewsFragment
      )> }
    ) | { __typename?: 'JSONField' } | { __typename?: 'LinkField' } | { __typename?: 'MultipleLinkField' } | { __typename?: 'ReferenceField' } | { __typename?: 'RTEField' } | { __typename?: 'ObjectField' } | { __typename?: 'NavigationField' }>> }
  )> }
);

export type ProductTacticsQueryVariables = Exact<{
  type: PageType;
  slug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  loadRecommendations?: Maybe<Scalars['Boolean']>;
  boost?: Maybe<Scalars['ID']>;
}>;


export type ProductTacticsQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<(
    { __typename?: 'Page' }
    & Pick<Page, 'id' | 'type'>
    & { fields?: Maybe<Array<(
      { __typename?: 'ProductField' }
      & Pick<ProductField, 'key'>
      & { product?: Maybe<(
        { __typename?: 'Product' }
        & { tactics?: Maybe<(
          { __typename?: 'ProductTactics' }
          & { gold?: Maybe<Array<(
            { __typename?: 'TacticActiveCampaign' }
            & ProductPageTacticFragment_TacticActiveCampaign_Fragment
          ) | (
            { __typename?: 'TacticAssortmentLadder' }
            & ProductPageTacticFragment_TacticAssortmentLadder_Fragment
          ) | (
            { __typename?: 'TacticBlocks' }
            & ProductPageTacticFragment_TacticBlocks_Fragment
          ) | (
            { __typename?: 'TacticBuildYourDiscount' }
            & ProductPageTacticFragment_TacticBuildYourDiscount_Fragment
          ) | (
            { __typename?: 'TacticBundleInfo' }
            & ProductPageTacticFragment_TacticBundleInfo_Fragment
          ) | (
            { __typename?: 'TacticComplementaryProducts' }
            & ProductPageTacticFragment_TacticComplementaryProducts_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsColor' }
            & ProductPageTacticFragment_TacticLinkedProductsColor_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsSizeAndVariation' }
            & ProductPageTacticFragment_TacticLinkedProductsSizeAndVariation_Fragment
          ) | (
            { __typename?: 'TacticLooks' }
            & ProductPageTacticFragment_TacticLooks_Fragment
          ) | (
            { __typename?: 'TacticMatchingVariant' }
            & ProductPageTacticFragment_TacticMatchingVariant_Fragment
          ) | (
            { __typename?: 'TacticOthersBought' }
            & ProductPageTacticFragment_TacticOthersBought_Fragment
          ) | (
            { __typename?: 'TacticOthersBoughtGrid' }
            & ProductPageTacticFragment_TacticOthersBoughtGrid_Fragment
          ) | (
            { __typename?: 'TacticRecommendedForYou' }
            & ProductPageTacticFragment_TacticRecommendedForYou_Fragment
          ) | (
            { __typename?: 'TacticRelatedProducts' }
            & ProductPageTacticFragment_TacticRelatedProducts_Fragment
          ) | (
            { __typename?: 'TacticRelativeDiscount' }
            & ProductPageTacticFragment_TacticRelativeDiscount_Fragment
          ) | (
            { __typename?: 'TacticSimilarProducts' }
            & ProductPageTacticFragment_TacticSimilarProducts_Fragment
          ) | (
            { __typename?: 'TacticUpgradeWith' }
            & ProductPageTacticFragment_TacticUpgradeWith_Fragment
          )>>, silver?: Maybe<Array<(
            { __typename?: 'TacticActiveCampaign' }
            & ProductPageTacticFragment_TacticActiveCampaign_Fragment
          ) | (
            { __typename?: 'TacticAssortmentLadder' }
            & ProductPageTacticFragment_TacticAssortmentLadder_Fragment
          ) | (
            { __typename?: 'TacticBlocks' }
            & ProductPageTacticFragment_TacticBlocks_Fragment
          ) | (
            { __typename?: 'TacticBuildYourDiscount' }
            & ProductPageTacticFragment_TacticBuildYourDiscount_Fragment
          ) | (
            { __typename?: 'TacticBundleInfo' }
            & ProductPageTacticFragment_TacticBundleInfo_Fragment
          ) | (
            { __typename?: 'TacticComplementaryProducts' }
            & ProductPageTacticFragment_TacticComplementaryProducts_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsColor' }
            & ProductPageTacticFragment_TacticLinkedProductsColor_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsSizeAndVariation' }
            & ProductPageTacticFragment_TacticLinkedProductsSizeAndVariation_Fragment
          ) | (
            { __typename?: 'TacticLooks' }
            & ProductPageTacticFragment_TacticLooks_Fragment
          ) | (
            { __typename?: 'TacticMatchingVariant' }
            & ProductPageTacticFragment_TacticMatchingVariant_Fragment
          ) | (
            { __typename?: 'TacticOthersBought' }
            & ProductPageTacticFragment_TacticOthersBought_Fragment
          ) | (
            { __typename?: 'TacticOthersBoughtGrid' }
            & ProductPageTacticFragment_TacticOthersBoughtGrid_Fragment
          ) | (
            { __typename?: 'TacticRecommendedForYou' }
            & ProductPageTacticFragment_TacticRecommendedForYou_Fragment
          ) | (
            { __typename?: 'TacticRelatedProducts' }
            & ProductPageTacticFragment_TacticRelatedProducts_Fragment
          ) | (
            { __typename?: 'TacticRelativeDiscount' }
            & ProductPageTacticFragment_TacticRelativeDiscount_Fragment
          ) | (
            { __typename?: 'TacticSimilarProducts' }
            & ProductPageTacticFragment_TacticSimilarProducts_Fragment
          ) | (
            { __typename?: 'TacticUpgradeWith' }
            & ProductPageTacticFragment_TacticUpgradeWith_Fragment
          )>>, bronze?: Maybe<Array<(
            { __typename?: 'TacticActiveCampaign' }
            & ProductPageTacticFragment_TacticActiveCampaign_Fragment
          ) | (
            { __typename?: 'TacticAssortmentLadder' }
            & ProductPageTacticFragment_TacticAssortmentLadder_Fragment
          ) | (
            { __typename?: 'TacticBlocks' }
            & ProductPageTacticFragment_TacticBlocks_Fragment
          ) | (
            { __typename?: 'TacticBuildYourDiscount' }
            & ProductPageTacticFragment_TacticBuildYourDiscount_Fragment
          ) | (
            { __typename?: 'TacticBundleInfo' }
            & ProductPageTacticFragment_TacticBundleInfo_Fragment
          ) | (
            { __typename?: 'TacticComplementaryProducts' }
            & ProductPageTacticFragment_TacticComplementaryProducts_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsColor' }
            & ProductPageTacticFragment_TacticLinkedProductsColor_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsSizeAndVariation' }
            & ProductPageTacticFragment_TacticLinkedProductsSizeAndVariation_Fragment
          ) | (
            { __typename?: 'TacticLooks' }
            & ProductPageTacticFragment_TacticLooks_Fragment
          ) | (
            { __typename?: 'TacticMatchingVariant' }
            & ProductPageTacticFragment_TacticMatchingVariant_Fragment
          ) | (
            { __typename?: 'TacticOthersBought' }
            & ProductPageTacticFragment_TacticOthersBought_Fragment
          ) | (
            { __typename?: 'TacticOthersBoughtGrid' }
            & ProductPageTacticFragment_TacticOthersBoughtGrid_Fragment
          ) | (
            { __typename?: 'TacticRecommendedForYou' }
            & ProductPageTacticFragment_TacticRecommendedForYou_Fragment
          ) | (
            { __typename?: 'TacticRelatedProducts' }
            & ProductPageTacticFragment_TacticRelatedProducts_Fragment
          ) | (
            { __typename?: 'TacticRelativeDiscount' }
            & ProductPageTacticFragment_TacticRelativeDiscount_Fragment
          ) | (
            { __typename?: 'TacticSimilarProducts' }
            & ProductPageTacticFragment_TacticSimilarProducts_Fragment
          ) | (
            { __typename?: 'TacticUpgradeWith' }
            & ProductPageTacticFragment_TacticUpgradeWith_Fragment
          )>> }
        )> }
      )> }
    ) | { __typename?: 'JSONField' } | { __typename?: 'LinkField' } | { __typename?: 'MultipleLinkField' } | { __typename?: 'ReferenceField' } | { __typename?: 'RTEField' } | { __typename?: 'ObjectField' } | { __typename?: 'NavigationField' }>> }
  )> }
);

export type SinglePostQueryVariables = Exact<{
  type: PageType;
  slug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  breadcrumbsVersion?: Maybe<Scalars['Int']>;
  presentation?: Maybe<PagePresentation>;
  boost?: Maybe<Scalars['ID']>;
}>;


export type SinglePostQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<(
    { __typename?: 'Page' }
    & Pick<Page, 'id' | 'type' | 'title' | 'url'>
    & { brand?: Maybe<(
      { __typename?: 'Brand' }
      & Pick<Brand, 'id' | 'logo' | 'title'>
    )>, seo?: Maybe<(
      { __typename?: 'SEO' }
      & Pick<Seo, 'title' | 'description' | 'noIndex' | 'includeInSitemap'>
    )>, breadcrumbs?: Maybe<Array<(
      { __typename?: 'Breadcrumb' }
      & Pick<Breadcrumb, 'id' | 'type' | 'title' | 'url'>
    )>>, openGraph?: Maybe<(
      { __typename?: 'OpenGraph' }
      & OpenGraphContentFragment
    )>, alternateLinks?: Maybe<Array<(
      { __typename?: 'AlternateLink' }
      & Pick<AlternateLink, 'locale' | 'url'>
    )>>, image?: Maybe<(
      { __typename?: 'Image' }
      & ImageResourceImageFragmentFragment
    )>, blocks?: Maybe<Array<(
      { __typename?: 'Block' }
      & BlockContent_Block_Fragment
    ) | (
      { __typename?: 'AccordionListBlock' }
      & BlockContent_AccordionListBlock_Fragment
    ) | (
      { __typename?: 'ActiveCampaignBlock' }
      & BlockContent_ActiveCampaignBlock_Fragment
    ) | (
      { __typename?: 'GalleryBlock' }
      & BlockContent_GalleryBlock_Fragment
    ) | (
      { __typename?: 'GlobalBlock' }
      & Pick<GlobalBlock, 'id' | 'type'>
      & { blocks?: Maybe<Array<(
        { __typename?: 'Block' }
        & BlockContent_Block_Fragment
      ) | (
        { __typename?: 'AccordionListBlock' }
        & BlockContent_AccordionListBlock_Fragment
      ) | (
        { __typename?: 'ActiveCampaignBlock' }
        & BlockContent_ActiveCampaignBlock_Fragment
      ) | (
        { __typename?: 'GalleryBlock' }
        & BlockContent_GalleryBlock_Fragment
      ) | (
        { __typename?: 'HTMLBlock' }
        & BlockContent_HtmlBlock_Fragment
      ) | (
        { __typename?: 'InfoPanelBlock' }
        & BlockContent_InfoPanelBlock_Fragment
      ) | (
        { __typename?: 'LookDisplayBlock' }
        & BlockContent_LookDisplayBlock_Fragment
      ) | (
        { __typename?: 'LookListBlock' }
        & BlockContent_LookListBlock_Fragment
      ) | (
        { __typename?: 'PageGridBlock' }
        & BlockContent_PageGridBlock_Fragment
      ) | (
        { __typename?: 'PageSliderBlock' }
        & BlockContent_PageSliderBlock_Fragment
      ) | (
        { __typename?: 'ProductGridSelectorBlock' }
        & BlockContent_ProductGridSelectorBlock_Fragment
      ) | (
        { __typename?: 'ProductListBlock' }
        & BlockContent_ProductListBlock_Fragment
      ) | (
        { __typename?: 'ProductSliderBlock' }
        & BlockContent_ProductSliderBlock_Fragment
      ) | (
        { __typename?: 'USPBlock' }
        & BlockContent_UspBlock_Fragment
      )>> }
      & BlockContent_GlobalBlock_Fragment
    ) | (
      { __typename?: 'HTMLBlock' }
      & BlockContent_HtmlBlock_Fragment
    ) | (
      { __typename?: 'InfoPanelBlock' }
      & BlockContent_InfoPanelBlock_Fragment
    ) | (
      { __typename?: 'LookDisplayBlock' }
      & BlockContent_LookDisplayBlock_Fragment
    ) | (
      { __typename?: 'LookListBlock' }
      & BlockContent_LookListBlock_Fragment
    ) | (
      { __typename?: 'PageGridBlock' }
      & BlockContent_PageGridBlock_Fragment
    ) | (
      { __typename?: 'PageSliderBlock' }
      & BlockContent_PageSliderBlock_Fragment
    ) | (
      { __typename?: 'ProductGridSelectorBlock' }
      & BlockContent_ProductGridSelectorBlock_Fragment
    ) | (
      { __typename?: 'ProductListBlock' }
      & { extraBlocks?: Maybe<Array<(
        { __typename?: 'Block' }
        & BlockContent_Block_Fragment
      ) | (
        { __typename?: 'AccordionListBlock' }
        & BlockContent_AccordionListBlock_Fragment
      ) | (
        { __typename?: 'ActiveCampaignBlock' }
        & BlockContent_ActiveCampaignBlock_Fragment
      ) | (
        { __typename?: 'GalleryBlock' }
        & BlockContent_GalleryBlock_Fragment
      ) | (
        { __typename?: 'HTMLBlock' }
        & BlockContent_HtmlBlock_Fragment
      ) | (
        { __typename?: 'InfoPanelBlock' }
        & BlockContent_InfoPanelBlock_Fragment
      ) | (
        { __typename?: 'LookDisplayBlock' }
        & BlockContent_LookDisplayBlock_Fragment
      ) | (
        { __typename?: 'LookListBlock' }
        & BlockContent_LookListBlock_Fragment
      ) | (
        { __typename?: 'PageGridBlock' }
        & BlockContent_PageGridBlock_Fragment
      ) | (
        { __typename?: 'PageSliderBlock' }
        & BlockContent_PageSliderBlock_Fragment
      ) | (
        { __typename?: 'ProductGridSelectorBlock' }
        & BlockContent_ProductGridSelectorBlock_Fragment
      ) | (
        { __typename?: 'ProductListBlock' }
        & BlockContent_ProductListBlock_Fragment
      ) | (
        { __typename?: 'ProductSliderBlock' }
        & BlockContent_ProductSliderBlock_Fragment
      ) | (
        { __typename?: 'USPBlock' }
        & BlockContent_UspBlock_Fragment
      )>>, injections?: Maybe<Array<(
        { __typename?: 'InjectionTypeBlockData' }
        & Pick<InjectionTypeBlockData, 'id' | 'slot'>
        & { blocks?: Maybe<Array<(
          { __typename?: 'Block' }
          & BlockContent_Block_Fragment
        ) | (
          { __typename?: 'AccordionListBlock' }
          & BlockContent_AccordionListBlock_Fragment
        ) | (
          { __typename?: 'ActiveCampaignBlock' }
          & BlockContent_ActiveCampaignBlock_Fragment
        ) | (
          { __typename?: 'GalleryBlock' }
          & BlockContent_GalleryBlock_Fragment
        ) | (
          { __typename?: 'GlobalBlock' }
          & BlockContent_GlobalBlock_Fragment
        ) | (
          { __typename?: 'HTMLBlock' }
          & BlockContent_HtmlBlock_Fragment
        ) | (
          { __typename?: 'InfoPanelBlock' }
          & BlockContent_InfoPanelBlock_Fragment
        ) | (
          { __typename?: 'LookDisplayBlock' }
          & BlockContent_LookDisplayBlock_Fragment
        ) | (
          { __typename?: 'LookListBlock' }
          & BlockContent_LookListBlock_Fragment
        ) | (
          { __typename?: 'PageGridBlock' }
          & BlockContent_PageGridBlock_Fragment
        ) | (
          { __typename?: 'PageSliderBlock' }
          & BlockContent_PageSliderBlock_Fragment
        ) | (
          { __typename?: 'ProductGridSelectorBlock' }
          & BlockContent_ProductGridSelectorBlock_Fragment
        ) | (
          { __typename?: 'ProductListBlock' }
          & BlockContent_ProductListBlock_Fragment
        ) | (
          { __typename?: 'ProductSliderBlock' }
          & BlockContent_ProductSliderBlock_Fragment
        ) | (
          { __typename?: 'USPBlock' }
          & BlockContent_UspBlock_Fragment
        )>> }
      )>>, guidedFilters?: Maybe<Array<(
        { __typename?: 'GuidedFilterAttributeEnum' }
        & { items?: Maybe<Array<(
          { __typename?: 'GuidedFilterAttributeEnumItem' }
          & { extraBlocks?: Maybe<Array<(
            { __typename?: 'Block' }
            & BlockContent_Block_Fragment
          ) | (
            { __typename?: 'AccordionListBlock' }
            & BlockContent_AccordionListBlock_Fragment
          ) | (
            { __typename?: 'ActiveCampaignBlock' }
            & BlockContent_ActiveCampaignBlock_Fragment
          ) | (
            { __typename?: 'GalleryBlock' }
            & BlockContent_GalleryBlock_Fragment
          ) | (
            { __typename?: 'HTMLBlock' }
            & BlockContent_HtmlBlock_Fragment
          ) | (
            { __typename?: 'InfoPanelBlock' }
            & BlockContent_InfoPanelBlock_Fragment
          ) | (
            { __typename?: 'LookDisplayBlock' }
            & BlockContent_LookDisplayBlock_Fragment
          ) | (
            { __typename?: 'LookListBlock' }
            & BlockContent_LookListBlock_Fragment
          ) | (
            { __typename?: 'PageGridBlock' }
            & BlockContent_PageGridBlock_Fragment
          ) | (
            { __typename?: 'PageSliderBlock' }
            & BlockContent_PageSliderBlock_Fragment
          ) | (
            { __typename?: 'ProductGridSelectorBlock' }
            & BlockContent_ProductGridSelectorBlock_Fragment
          ) | (
            { __typename?: 'ProductListBlock' }
            & BlockContent_ProductListBlock_Fragment
          ) | (
            { __typename?: 'ProductSliderBlock' }
            & BlockContent_ProductSliderBlock_Fragment
          ) | (
            { __typename?: 'USPBlock' }
            & BlockContent_UspBlock_Fragment
          )>>, injections?: Maybe<Array<(
            { __typename?: 'InjectionTypeBlockData' }
            & Pick<InjectionTypeBlockData, 'id' | 'slot'>
            & { blocks?: Maybe<Array<(
              { __typename?: 'Block' }
              & BlockContent_Block_Fragment
            ) | (
              { __typename?: 'AccordionListBlock' }
              & BlockContent_AccordionListBlock_Fragment
            ) | (
              { __typename?: 'ActiveCampaignBlock' }
              & BlockContent_ActiveCampaignBlock_Fragment
            ) | (
              { __typename?: 'GalleryBlock' }
              & BlockContent_GalleryBlock_Fragment
            ) | (
              { __typename?: 'GlobalBlock' }
              & BlockContent_GlobalBlock_Fragment
            ) | (
              { __typename?: 'HTMLBlock' }
              & BlockContent_HtmlBlock_Fragment
            ) | (
              { __typename?: 'InfoPanelBlock' }
              & BlockContent_InfoPanelBlock_Fragment
            ) | (
              { __typename?: 'LookDisplayBlock' }
              & BlockContent_LookDisplayBlock_Fragment
            ) | (
              { __typename?: 'LookListBlock' }
              & BlockContent_LookListBlock_Fragment
            ) | (
              { __typename?: 'PageGridBlock' }
              & BlockContent_PageGridBlock_Fragment
            ) | (
              { __typename?: 'PageSliderBlock' }
              & BlockContent_PageSliderBlock_Fragment
            ) | (
              { __typename?: 'ProductGridSelectorBlock' }
              & BlockContent_ProductGridSelectorBlock_Fragment
            ) | (
              { __typename?: 'ProductListBlock' }
              & BlockContent_ProductListBlock_Fragment
            ) | (
              { __typename?: 'ProductSliderBlock' }
              & BlockContent_ProductSliderBlock_Fragment
            ) | (
              { __typename?: 'USPBlock' }
              & BlockContent_UspBlock_Fragment
            )>> }
          )>> }
        )>> }
      ) | { __typename?: 'GuidedFilterLinkResource' }>> }
      & BlockContent_ProductListBlock_Fragment
    ) | (
      { __typename?: 'ProductSliderBlock' }
      & BlockContent_ProductSliderBlock_Fragment
    ) | (
      { __typename?: 'USPBlock' }
      & BlockContent_UspBlock_Fragment
    )>>, fields?: Maybe<Array<(
      { __typename?: 'ProductField' }
      & Fields_ProductField_Fragment
    ) | (
      { __typename?: 'JSONField' }
      & Fields_JsonField_Fragment
    ) | (
      { __typename?: 'LinkField' }
      & Fields_LinkField_Fragment
    ) | (
      { __typename?: 'MultipleLinkField' }
      & Fields_MultipleLinkField_Fragment
    ) | (
      { __typename?: 'ReferenceField' }
      & Fields_ReferenceField_Fragment
    ) | (
      { __typename?: 'RTEField' }
      & Fields_RteField_Fragment
    ) | (
      { __typename?: 'ObjectField' }
      & Fields_ObjectField_Fragment
    ) | (
      { __typename?: 'NavigationField' }
      & Fields_NavigationField_Fragment
    )>> }
  )> }
);

export type SingleProductQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  reviewLimit?: Maybe<Scalars['Int']>;
  reviewCursor?: Maybe<Scalars['String']>;
  breadcrumbsVersion?: Maybe<Scalars['Int']>;
  presentation?: Maybe<PagePresentation>;
  loadRecommendations?: Maybe<Scalars['Boolean']>;
  boost?: Maybe<Scalars['ID']>;
}>;


export type SingleProductQuery = (
  { __typename?: 'Query' }
  & { page?: Maybe<(
    { __typename?: 'Page' }
    & Pick<Page, 'id' | 'type' | 'title' | 'url'>
    & { seo?: Maybe<(
      { __typename?: 'SEO' }
      & Pick<Seo, 'title' | 'description' | 'noIndex' | 'includeInSitemap'>
    )>, breadcrumbs?: Maybe<Array<(
      { __typename?: 'Breadcrumb' }
      & Pick<Breadcrumb, 'id' | 'type' | 'title' | 'url'>
    )>>, openGraph?: Maybe<(
      { __typename?: 'OpenGraph' }
      & OpenGraphContentFragment
    )>, alternateLinks?: Maybe<Array<(
      { __typename?: 'AlternateLink' }
      & Pick<AlternateLink, 'locale' | 'url'>
    )>>, blocks?: Maybe<Array<(
      { __typename?: 'Block' }
      & BlockContent_Block_Fragment
    ) | (
      { __typename?: 'AccordionListBlock' }
      & BlockContent_AccordionListBlock_Fragment
    ) | (
      { __typename?: 'ActiveCampaignBlock' }
      & BlockContent_ActiveCampaignBlock_Fragment
    ) | (
      { __typename?: 'GalleryBlock' }
      & BlockContent_GalleryBlock_Fragment
    ) | (
      { __typename?: 'GlobalBlock' }
      & Pick<GlobalBlock, 'id' | 'type'>
      & { blocks?: Maybe<Array<(
        { __typename?: 'Block' }
        & BlockContent_Block_Fragment
      ) | (
        { __typename?: 'AccordionListBlock' }
        & BlockContent_AccordionListBlock_Fragment
      ) | (
        { __typename?: 'ActiveCampaignBlock' }
        & BlockContent_ActiveCampaignBlock_Fragment
      ) | (
        { __typename?: 'GalleryBlock' }
        & BlockContent_GalleryBlock_Fragment
      ) | (
        { __typename?: 'HTMLBlock' }
        & BlockContent_HtmlBlock_Fragment
      ) | (
        { __typename?: 'InfoPanelBlock' }
        & BlockContent_InfoPanelBlock_Fragment
      ) | (
        { __typename?: 'LookDisplayBlock' }
        & BlockContent_LookDisplayBlock_Fragment
      ) | (
        { __typename?: 'LookListBlock' }
        & BlockContent_LookListBlock_Fragment
      ) | (
        { __typename?: 'PageGridBlock' }
        & BlockContent_PageGridBlock_Fragment
      ) | (
        { __typename?: 'PageSliderBlock' }
        & BlockContent_PageSliderBlock_Fragment
      ) | (
        { __typename?: 'ProductGridSelectorBlock' }
        & BlockContent_ProductGridSelectorBlock_Fragment
      ) | (
        { __typename?: 'ProductListBlock' }
        & BlockContent_ProductListBlock_Fragment
      ) | (
        { __typename?: 'ProductSliderBlock' }
        & BlockContent_ProductSliderBlock_Fragment
      ) | (
        { __typename?: 'USPBlock' }
        & BlockContent_UspBlock_Fragment
      )>> }
      & BlockContent_GlobalBlock_Fragment
    ) | (
      { __typename?: 'HTMLBlock' }
      & BlockContent_HtmlBlock_Fragment
    ) | (
      { __typename?: 'InfoPanelBlock' }
      & BlockContent_InfoPanelBlock_Fragment
    ) | (
      { __typename?: 'LookDisplayBlock' }
      & BlockContent_LookDisplayBlock_Fragment
    ) | (
      { __typename?: 'LookListBlock' }
      & BlockContent_LookListBlock_Fragment
    ) | (
      { __typename?: 'PageGridBlock' }
      & BlockContent_PageGridBlock_Fragment
    ) | (
      { __typename?: 'PageSliderBlock' }
      & BlockContent_PageSliderBlock_Fragment
    ) | (
      { __typename?: 'ProductGridSelectorBlock' }
      & BlockContent_ProductGridSelectorBlock_Fragment
    ) | (
      { __typename?: 'ProductListBlock' }
      & { extraBlocks?: Maybe<Array<(
        { __typename?: 'Block' }
        & BlockContent_Block_Fragment
      ) | (
        { __typename?: 'AccordionListBlock' }
        & BlockContent_AccordionListBlock_Fragment
      ) | (
        { __typename?: 'ActiveCampaignBlock' }
        & BlockContent_ActiveCampaignBlock_Fragment
      ) | (
        { __typename?: 'GalleryBlock' }
        & BlockContent_GalleryBlock_Fragment
      ) | (
        { __typename?: 'HTMLBlock' }
        & BlockContent_HtmlBlock_Fragment
      ) | (
        { __typename?: 'InfoPanelBlock' }
        & BlockContent_InfoPanelBlock_Fragment
      ) | (
        { __typename?: 'LookDisplayBlock' }
        & BlockContent_LookDisplayBlock_Fragment
      ) | (
        { __typename?: 'LookListBlock' }
        & BlockContent_LookListBlock_Fragment
      ) | (
        { __typename?: 'PageGridBlock' }
        & BlockContent_PageGridBlock_Fragment
      ) | (
        { __typename?: 'PageSliderBlock' }
        & BlockContent_PageSliderBlock_Fragment
      ) | (
        { __typename?: 'ProductGridSelectorBlock' }
        & BlockContent_ProductGridSelectorBlock_Fragment
      ) | (
        { __typename?: 'ProductListBlock' }
        & BlockContent_ProductListBlock_Fragment
      ) | (
        { __typename?: 'ProductSliderBlock' }
        & BlockContent_ProductSliderBlock_Fragment
      ) | (
        { __typename?: 'USPBlock' }
        & BlockContent_UspBlock_Fragment
      )>>, injections?: Maybe<Array<(
        { __typename?: 'InjectionTypeBlockData' }
        & Pick<InjectionTypeBlockData, 'id' | 'slot'>
        & { blocks?: Maybe<Array<(
          { __typename?: 'Block' }
          & BlockContent_Block_Fragment
        ) | (
          { __typename?: 'AccordionListBlock' }
          & BlockContent_AccordionListBlock_Fragment
        ) | (
          { __typename?: 'ActiveCampaignBlock' }
          & BlockContent_ActiveCampaignBlock_Fragment
        ) | (
          { __typename?: 'GalleryBlock' }
          & BlockContent_GalleryBlock_Fragment
        ) | (
          { __typename?: 'GlobalBlock' }
          & BlockContent_GlobalBlock_Fragment
        ) | (
          { __typename?: 'HTMLBlock' }
          & BlockContent_HtmlBlock_Fragment
        ) | (
          { __typename?: 'InfoPanelBlock' }
          & BlockContent_InfoPanelBlock_Fragment
        ) | (
          { __typename?: 'LookDisplayBlock' }
          & BlockContent_LookDisplayBlock_Fragment
        ) | (
          { __typename?: 'LookListBlock' }
          & BlockContent_LookListBlock_Fragment
        ) | (
          { __typename?: 'PageGridBlock' }
          & BlockContent_PageGridBlock_Fragment
        ) | (
          { __typename?: 'PageSliderBlock' }
          & BlockContent_PageSliderBlock_Fragment
        ) | (
          { __typename?: 'ProductGridSelectorBlock' }
          & BlockContent_ProductGridSelectorBlock_Fragment
        ) | (
          { __typename?: 'ProductListBlock' }
          & BlockContent_ProductListBlock_Fragment
        ) | (
          { __typename?: 'ProductSliderBlock' }
          & BlockContent_ProductSliderBlock_Fragment
        ) | (
          { __typename?: 'USPBlock' }
          & BlockContent_UspBlock_Fragment
        )>> }
      )>>, guidedFilters?: Maybe<Array<(
        { __typename?: 'GuidedFilterAttributeEnum' }
        & { items?: Maybe<Array<(
          { __typename?: 'GuidedFilterAttributeEnumItem' }
          & { extraBlocks?: Maybe<Array<(
            { __typename?: 'Block' }
            & BlockContent_Block_Fragment
          ) | (
            { __typename?: 'AccordionListBlock' }
            & BlockContent_AccordionListBlock_Fragment
          ) | (
            { __typename?: 'ActiveCampaignBlock' }
            & BlockContent_ActiveCampaignBlock_Fragment
          ) | (
            { __typename?: 'GalleryBlock' }
            & BlockContent_GalleryBlock_Fragment
          ) | (
            { __typename?: 'HTMLBlock' }
            & BlockContent_HtmlBlock_Fragment
          ) | (
            { __typename?: 'InfoPanelBlock' }
            & BlockContent_InfoPanelBlock_Fragment
          ) | (
            { __typename?: 'LookDisplayBlock' }
            & BlockContent_LookDisplayBlock_Fragment
          ) | (
            { __typename?: 'LookListBlock' }
            & BlockContent_LookListBlock_Fragment
          ) | (
            { __typename?: 'PageGridBlock' }
            & BlockContent_PageGridBlock_Fragment
          ) | (
            { __typename?: 'PageSliderBlock' }
            & BlockContent_PageSliderBlock_Fragment
          ) | (
            { __typename?: 'ProductGridSelectorBlock' }
            & BlockContent_ProductGridSelectorBlock_Fragment
          ) | (
            { __typename?: 'ProductListBlock' }
            & BlockContent_ProductListBlock_Fragment
          ) | (
            { __typename?: 'ProductSliderBlock' }
            & BlockContent_ProductSliderBlock_Fragment
          ) | (
            { __typename?: 'USPBlock' }
            & BlockContent_UspBlock_Fragment
          )>>, injections?: Maybe<Array<(
            { __typename?: 'InjectionTypeBlockData' }
            & Pick<InjectionTypeBlockData, 'id' | 'slot'>
            & { blocks?: Maybe<Array<(
              { __typename?: 'Block' }
              & BlockContent_Block_Fragment
            ) | (
              { __typename?: 'AccordionListBlock' }
              & BlockContent_AccordionListBlock_Fragment
            ) | (
              { __typename?: 'ActiveCampaignBlock' }
              & BlockContent_ActiveCampaignBlock_Fragment
            ) | (
              { __typename?: 'GalleryBlock' }
              & BlockContent_GalleryBlock_Fragment
            ) | (
              { __typename?: 'GlobalBlock' }
              & BlockContent_GlobalBlock_Fragment
            ) | (
              { __typename?: 'HTMLBlock' }
              & BlockContent_HtmlBlock_Fragment
            ) | (
              { __typename?: 'InfoPanelBlock' }
              & BlockContent_InfoPanelBlock_Fragment
            ) | (
              { __typename?: 'LookDisplayBlock' }
              & BlockContent_LookDisplayBlock_Fragment
            ) | (
              { __typename?: 'LookListBlock' }
              & BlockContent_LookListBlock_Fragment
            ) | (
              { __typename?: 'PageGridBlock' }
              & BlockContent_PageGridBlock_Fragment
            ) | (
              { __typename?: 'PageSliderBlock' }
              & BlockContent_PageSliderBlock_Fragment
            ) | (
              { __typename?: 'ProductGridSelectorBlock' }
              & BlockContent_ProductGridSelectorBlock_Fragment
            ) | (
              { __typename?: 'ProductListBlock' }
              & BlockContent_ProductListBlock_Fragment
            ) | (
              { __typename?: 'ProductSliderBlock' }
              & BlockContent_ProductSliderBlock_Fragment
            ) | (
              { __typename?: 'USPBlock' }
              & BlockContent_UspBlock_Fragment
            )>> }
          )>> }
        )>> }
      ) | { __typename?: 'GuidedFilterLinkResource' }>> }
      & BlockContent_ProductListBlock_Fragment
    ) | (
      { __typename?: 'ProductSliderBlock' }
      & BlockContent_ProductSliderBlock_Fragment
    ) | (
      { __typename?: 'USPBlock' }
      & BlockContent_UspBlock_Fragment
    )>>, fields?: Maybe<Array<(
      { __typename?: 'ProductField' }
      & Pick<ProductField, 'key'>
      & { product?: Maybe<(
        { __typename?: 'Product' }
        & Pick<Product, 'categoryIDs'>
        & { tactics?: Maybe<(
          { __typename?: 'ProductTactics' }
          & { gold?: Maybe<Array<(
            { __typename?: 'TacticActiveCampaign' }
            & ProductPageTacticFragment_TacticActiveCampaign_Fragment
          ) | (
            { __typename?: 'TacticAssortmentLadder' }
            & ProductPageTacticFragment_TacticAssortmentLadder_Fragment
          ) | (
            { __typename?: 'TacticBlocks' }
            & ProductPageTacticFragment_TacticBlocks_Fragment
          ) | (
            { __typename?: 'TacticBuildYourDiscount' }
            & ProductPageTacticFragment_TacticBuildYourDiscount_Fragment
          ) | (
            { __typename?: 'TacticBundleInfo' }
            & ProductPageTacticFragment_TacticBundleInfo_Fragment
          ) | (
            { __typename?: 'TacticComplementaryProducts' }
            & ProductPageTacticFragment_TacticComplementaryProducts_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsColor' }
            & ProductPageTacticFragment_TacticLinkedProductsColor_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsSizeAndVariation' }
            & ProductPageTacticFragment_TacticLinkedProductsSizeAndVariation_Fragment
          ) | (
            { __typename?: 'TacticLooks' }
            & ProductPageTacticFragment_TacticLooks_Fragment
          ) | (
            { __typename?: 'TacticMatchingVariant' }
            & ProductPageTacticFragment_TacticMatchingVariant_Fragment
          ) | (
            { __typename?: 'TacticOthersBought' }
            & ProductPageTacticFragment_TacticOthersBought_Fragment
          ) | (
            { __typename?: 'TacticOthersBoughtGrid' }
            & ProductPageTacticFragment_TacticOthersBoughtGrid_Fragment
          ) | (
            { __typename?: 'TacticRecommendedForYou' }
            & ProductPageTacticFragment_TacticRecommendedForYou_Fragment
          ) | (
            { __typename?: 'TacticRelatedProducts' }
            & ProductPageTacticFragment_TacticRelatedProducts_Fragment
          ) | (
            { __typename?: 'TacticRelativeDiscount' }
            & ProductPageTacticFragment_TacticRelativeDiscount_Fragment
          ) | (
            { __typename?: 'TacticSimilarProducts' }
            & ProductPageTacticFragment_TacticSimilarProducts_Fragment
          ) | (
            { __typename?: 'TacticUpgradeWith' }
            & ProductPageTacticFragment_TacticUpgradeWith_Fragment
          )>>, silver?: Maybe<Array<(
            { __typename?: 'TacticActiveCampaign' }
            & ProductPageTacticFragment_TacticActiveCampaign_Fragment
          ) | (
            { __typename?: 'TacticAssortmentLadder' }
            & ProductPageTacticFragment_TacticAssortmentLadder_Fragment
          ) | (
            { __typename?: 'TacticBlocks' }
            & ProductPageTacticFragment_TacticBlocks_Fragment
          ) | (
            { __typename?: 'TacticBuildYourDiscount' }
            & ProductPageTacticFragment_TacticBuildYourDiscount_Fragment
          ) | (
            { __typename?: 'TacticBundleInfo' }
            & ProductPageTacticFragment_TacticBundleInfo_Fragment
          ) | (
            { __typename?: 'TacticComplementaryProducts' }
            & ProductPageTacticFragment_TacticComplementaryProducts_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsColor' }
            & ProductPageTacticFragment_TacticLinkedProductsColor_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsSizeAndVariation' }
            & ProductPageTacticFragment_TacticLinkedProductsSizeAndVariation_Fragment
          ) | (
            { __typename?: 'TacticLooks' }
            & ProductPageTacticFragment_TacticLooks_Fragment
          ) | (
            { __typename?: 'TacticMatchingVariant' }
            & ProductPageTacticFragment_TacticMatchingVariant_Fragment
          ) | (
            { __typename?: 'TacticOthersBought' }
            & ProductPageTacticFragment_TacticOthersBought_Fragment
          ) | (
            { __typename?: 'TacticOthersBoughtGrid' }
            & ProductPageTacticFragment_TacticOthersBoughtGrid_Fragment
          ) | (
            { __typename?: 'TacticRecommendedForYou' }
            & ProductPageTacticFragment_TacticRecommendedForYou_Fragment
          ) | (
            { __typename?: 'TacticRelatedProducts' }
            & ProductPageTacticFragment_TacticRelatedProducts_Fragment
          ) | (
            { __typename?: 'TacticRelativeDiscount' }
            & ProductPageTacticFragment_TacticRelativeDiscount_Fragment
          ) | (
            { __typename?: 'TacticSimilarProducts' }
            & ProductPageTacticFragment_TacticSimilarProducts_Fragment
          ) | (
            { __typename?: 'TacticUpgradeWith' }
            & ProductPageTacticFragment_TacticUpgradeWith_Fragment
          )>>, bronze?: Maybe<Array<(
            { __typename?: 'TacticActiveCampaign' }
            & ProductPageTacticFragment_TacticActiveCampaign_Fragment
          ) | (
            { __typename?: 'TacticAssortmentLadder' }
            & ProductPageTacticFragment_TacticAssortmentLadder_Fragment
          ) | (
            { __typename?: 'TacticBlocks' }
            & ProductPageTacticFragment_TacticBlocks_Fragment
          ) | (
            { __typename?: 'TacticBuildYourDiscount' }
            & ProductPageTacticFragment_TacticBuildYourDiscount_Fragment
          ) | (
            { __typename?: 'TacticBundleInfo' }
            & ProductPageTacticFragment_TacticBundleInfo_Fragment
          ) | (
            { __typename?: 'TacticComplementaryProducts' }
            & ProductPageTacticFragment_TacticComplementaryProducts_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsColor' }
            & ProductPageTacticFragment_TacticLinkedProductsColor_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsSizeAndVariation' }
            & ProductPageTacticFragment_TacticLinkedProductsSizeAndVariation_Fragment
          ) | (
            { __typename?: 'TacticLooks' }
            & ProductPageTacticFragment_TacticLooks_Fragment
          ) | (
            { __typename?: 'TacticMatchingVariant' }
            & ProductPageTacticFragment_TacticMatchingVariant_Fragment
          ) | (
            { __typename?: 'TacticOthersBought' }
            & ProductPageTacticFragment_TacticOthersBought_Fragment
          ) | (
            { __typename?: 'TacticOthersBoughtGrid' }
            & ProductPageTacticFragment_TacticOthersBoughtGrid_Fragment
          ) | (
            { __typename?: 'TacticRecommendedForYou' }
            & ProductPageTacticFragment_TacticRecommendedForYou_Fragment
          ) | (
            { __typename?: 'TacticRelatedProducts' }
            & ProductPageTacticFragment_TacticRelatedProducts_Fragment
          ) | (
            { __typename?: 'TacticRelativeDiscount' }
            & ProductPageTacticFragment_TacticRelativeDiscount_Fragment
          ) | (
            { __typename?: 'TacticSimilarProducts' }
            & ProductPageTacticFragment_TacticSimilarProducts_Fragment
          ) | (
            { __typename?: 'TacticUpgradeWith' }
            & ProductPageTacticFragment_TacticUpgradeWith_Fragment
          )>>, temporary?: Maybe<Array<(
            { __typename?: 'TacticActiveCampaign' }
            & ProductPageTacticFragment_TacticActiveCampaign_Fragment
          ) | (
            { __typename?: 'TacticAssortmentLadder' }
            & ProductPageTacticFragment_TacticAssortmentLadder_Fragment
          ) | (
            { __typename?: 'TacticBlocks' }
            & ProductPageTacticFragment_TacticBlocks_Fragment
          ) | (
            { __typename?: 'TacticBuildYourDiscount' }
            & ProductPageTacticFragment_TacticBuildYourDiscount_Fragment
          ) | (
            { __typename?: 'TacticBundleInfo' }
            & ProductPageTacticFragment_TacticBundleInfo_Fragment
          ) | (
            { __typename?: 'TacticComplementaryProducts' }
            & ProductPageTacticFragment_TacticComplementaryProducts_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsColor' }
            & ProductPageTacticFragment_TacticLinkedProductsColor_Fragment
          ) | (
            { __typename?: 'TacticLinkedProductsSizeAndVariation' }
            & ProductPageTacticFragment_TacticLinkedProductsSizeAndVariation_Fragment
          ) | (
            { __typename?: 'TacticLooks' }
            & ProductPageTacticFragment_TacticLooks_Fragment
          ) | (
            { __typename?: 'TacticMatchingVariant' }
            & ProductPageTacticFragment_TacticMatchingVariant_Fragment
          ) | (
            { __typename?: 'TacticOthersBought' }
            & ProductPageTacticFragment_TacticOthersBought_Fragment
          ) | (
            { __typename?: 'TacticOthersBoughtGrid' }
            & ProductPageTacticFragment_TacticOthersBoughtGrid_Fragment
          ) | (
            { __typename?: 'TacticRecommendedForYou' }
            & ProductPageTacticFragment_TacticRecommendedForYou_Fragment
          ) | (
            { __typename?: 'TacticRelatedProducts' }
            & ProductPageTacticFragment_TacticRelatedProducts_Fragment
          ) | (
            { __typename?: 'TacticRelativeDiscount' }
            & ProductPageTacticFragment_TacticRelativeDiscount_Fragment
          ) | (
            { __typename?: 'TacticSimilarProducts' }
            & ProductPageTacticFragment_TacticSimilarProducts_Fragment
          ) | (
            { __typename?: 'TacticUpgradeWith' }
            & ProductPageTacticFragment_TacticUpgradeWith_Fragment
          )>> }
        )>, masterVariant?: Maybe<(
          { __typename?: 'ProductVariant' }
          & { bundleContent?: Maybe<(
            { __typename?: 'BaseAttribute' }
            & ProductBundle_BaseAttribute_Fragment
          ) | (
            { __typename?: 'MoneyAttribute' }
            & ProductBundle_MoneyAttribute_Fragment
          ) | (
            { __typename?: 'ProductAttribute' }
            & ProductBundle_ProductAttribute_Fragment
          ) | (
            { __typename?: 'ProductsWithQuantityAttribute' }
            & ProductBundle_ProductsWithQuantityAttribute_Fragment
          )>, bundlePrice?: Maybe<(
            { __typename?: 'AttributePrice' }
            & { difference?: Maybe<(
              { __typename?: 'Money' }
              & MoneyContent_Money_Fragment
            )>, originalPrice?: Maybe<(
              { __typename?: 'Money' }
              & MoneyContent_Money_Fragment
            )>, price?: Maybe<(
              { __typename?: 'Money' }
              & MoneyContent_Money_Fragment
            )> }
          )>, crossSells?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
            { __typename?: 'ProductAttribute' }
            & { products?: Maybe<Array<(
              { __typename?: 'Product' }
              & ProductCrossSellAndPersonalizationContentFragment
            )>> }
          ) | { __typename?: 'ProductsWithQuantityAttribute' }>, personalizations?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
            { __typename?: 'ProductAttribute' }
            & { products?: Maybe<Array<(
              { __typename?: 'Product' }
              & ProductCrossSellAndPersonalizationContentFragment
            )>> }
          ) | { __typename?: 'ProductsWithQuantityAttribute' }>, linkingDataColors?: Maybe<(
            { __typename?: 'BaseAttribute' }
            & Pick<BaseAttribute, 'value'>
          ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, linkingDataMaterials?: Maybe<(
            { __typename?: 'BaseAttribute' }
            & Pick<BaseAttribute, 'value'>
          ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, linkingDataPrice?: Maybe<(
            { __typename?: 'Price' }
            & Pick<Price, 'currencyCode' | 'format'>
            & { discount?: Maybe<(
              { __typename?: 'PriceDiscount' }
              & Pick<PriceDiscount, 'format'>
            )> }
          )> }
        )>, linkedProducts?: Maybe<Array<(
          { __typename?: 'LinkedProduct' }
          & Pick<LinkedProduct, 'type' | 'productIDs'>
        )>>, houseBrand?: Maybe<(
          { __typename?: 'HouseBrand' }
          & { products?: Maybe<Array<(
            { __typename?: 'Product' }
            & ProductTileFragment
          )>> }
        )> }
        & ProductContentFragment
        & ProductReviewsFragment
        & ProductSpecificationFragmentFragment
      )> }
    ) | { __typename?: 'JSONField' } | { __typename?: 'LinkField' } | { __typename?: 'MultipleLinkField' } | { __typename?: 'ReferenceField' } | { __typename?: 'RTEField' } | { __typename?: 'ObjectField' } | { __typename?: 'NavigationField' }>> }
  )> }
);

export type TrackingDataQueryVariables = Exact<{
  token?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
}>;


export type TrackingDataQuery = (
  { __typename?: 'Query' }
  & { tracking?: Maybe<(
    { __typename?: 'Tracking' }
    & Pick<Tracking, 'trackingNumber' | 'orderID' | 'returnID' | 'originCountryCode' | 'destinationCountryCode' | 'trackingURL' | 'createdAt'>
    & { events?: Maybe<Array<(
      { __typename?: 'TrackingEvent' }
      & Pick<TrackingEvent, 'state' | 'subState' | 'timestamp' | 'location' | 'messages' | 'type'>
    )>> }
  )> }
);

export type BlockAppearanceFragmentFragment = (
  { __typename?: 'BlockAppearance' }
  & Pick<BlockAppearance, 'backgroundColor' | 'textColor' | 'extraColors' | 'font'>
  & { asset?: Maybe<(
    { __typename?: 'DynamicVariable' }
    & ReferenceContent_DynamicVariable_Fragment
  ) | (
    { __typename?: 'EmailVariable' }
    & ReferenceContent_EmailVariable_Fragment
  ) | (
    { __typename?: 'ExternalLink' }
    & ReferenceContent_ExternalLink_Fragment
  ) | (
    { __typename?: 'Image' }
    & ReferenceContent_Image_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & ReferenceContent_ImageAsset_Fragment
  ) | (
    { __typename?: 'ImageResource' }
    & ReferenceContent_ImageResource_Fragment
  ) | (
    { __typename?: 'Link' }
    & ReferenceContent_Link_Fragment
  ) | (
    { __typename?: 'ModalTab' }
    & ReferenceContent_ModalTab_Fragment
  ) | (
    { __typename?: 'Page' }
    & ReferenceContent_Page_Fragment
  ) | (
    { __typename?: 'TileResource' }
    & ReferenceContent_TileResource_Fragment
  ) | (
    { __typename?: 'VideoResource' }
    & ReferenceContent_VideoResource_Fragment
  ) | (
    { __typename?: 'Wordbook' }
    & ReferenceContent_Wordbook_Fragment
  )> }
);

export type ElementsContentFragment = (
  { __typename?: 'Elements' }
  & Pick<Elements, 'id' | 'alignment' | 'position' | 'stackingMode'>
  & { items?: Maybe<Array<(
    { __typename: 'ElementButton' }
    & Pick<ElementButton, 'id' | 'text' | 'style'>
    & { reference?: Maybe<(
      { __typename?: 'DynamicVariable' }
      & ReferenceContent_DynamicVariable_Fragment
    ) | (
      { __typename?: 'EmailVariable' }
      & ReferenceContent_EmailVariable_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & ReferenceContent_ExternalLink_Fragment
    ) | (
      { __typename?: 'Image' }
      & ReferenceContent_Image_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ReferenceContent_ImageAsset_Fragment
    ) | (
      { __typename?: 'ImageResource' }
      & ReferenceContent_ImageResource_Fragment
    ) | (
      { __typename?: 'Link' }
      & ReferenceContent_Link_Fragment
    ) | (
      { __typename?: 'ModalTab' }
      & ReferenceContent_ModalTab_Fragment
    ) | (
      { __typename?: 'Page' }
      & ReferenceContent_Page_Fragment
    ) | (
      { __typename?: 'TileResource' }
      & ReferenceContent_TileResource_Fragment
    ) | (
      { __typename?: 'VideoResource' }
      & ReferenceContent_VideoResource_Fragment
    ) | (
      { __typename?: 'Wordbook' }
      & ReferenceContent_Wordbook_Fragment
    )>, appearance?: Maybe<(
      { __typename?: 'BlockAppearance' }
      & BlockAppearanceFragmentFragment
    )> }
  ) | (
    { __typename: 'ElementChip' }
    & Pick<ElementChip, 'id' | 'text'>
    & { reference?: Maybe<(
      { __typename?: 'DynamicVariable' }
      & ReferenceContent_DynamicVariable_Fragment
    ) | (
      { __typename?: 'EmailVariable' }
      & ReferenceContent_EmailVariable_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & ReferenceContent_ExternalLink_Fragment
    ) | (
      { __typename?: 'Image' }
      & ReferenceContent_Image_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ReferenceContent_ImageAsset_Fragment
    ) | (
      { __typename?: 'ImageResource' }
      & ReferenceContent_ImageResource_Fragment
    ) | (
      { __typename?: 'Link' }
      & ReferenceContent_Link_Fragment
    ) | (
      { __typename?: 'ModalTab' }
      & ReferenceContent_ModalTab_Fragment
    ) | (
      { __typename?: 'Page' }
      & ReferenceContent_Page_Fragment
    ) | (
      { __typename?: 'TileResource' }
      & ReferenceContent_TileResource_Fragment
    ) | (
      { __typename?: 'VideoResource' }
      & ReferenceContent_VideoResource_Fragment
    ) | (
      { __typename?: 'Wordbook' }
      & ReferenceContent_Wordbook_Fragment
    )>, appearance?: Maybe<(
      { __typename?: 'BlockAppearance' }
      & BlockAppearanceFragmentFragment
    )> }
  ) | (
    { __typename: 'ElementLabel' }
    & Pick<ElementLabel, 'id' | 'text'>
    & { reference?: Maybe<(
      { __typename?: 'DynamicVariable' }
      & ReferenceContent_DynamicVariable_Fragment
    ) | (
      { __typename?: 'EmailVariable' }
      & ReferenceContent_EmailVariable_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & ReferenceContent_ExternalLink_Fragment
    ) | (
      { __typename?: 'Image' }
      & ReferenceContent_Image_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ReferenceContent_ImageAsset_Fragment
    ) | (
      { __typename?: 'ImageResource' }
      & ReferenceContent_ImageResource_Fragment
    ) | (
      { __typename?: 'Link' }
      & ReferenceContent_Link_Fragment
    ) | (
      { __typename?: 'ModalTab' }
      & ReferenceContent_ModalTab_Fragment
    ) | (
      { __typename?: 'Page' }
      & ReferenceContent_Page_Fragment
    ) | (
      { __typename?: 'TileResource' }
      & ReferenceContent_TileResource_Fragment
    ) | (
      { __typename?: 'VideoResource' }
      & ReferenceContent_VideoResource_Fragment
    ) | (
      { __typename?: 'Wordbook' }
      & ReferenceContent_Wordbook_Fragment
    )>, appearance?: Maybe<(
      { __typename?: 'BlockAppearance' }
      & BlockAppearanceFragmentFragment
    )> }
  ) | (
    { __typename: 'ElementTypography' }
    & Pick<ElementTypography, 'id' | 'text' | 'htmlElement' | 'style'>
    & { appearance?: Maybe<(
      { __typename?: 'BlockAppearance' }
      & BlockAppearanceFragmentFragment
    )> }
  ) | (
    { __typename: 'ElementTypographyRTE' }
    & Pick<ElementTypographyRte, 'id'>
    & { rte?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'key' | 'value'>
    )>, appearance?: Maybe<(
      { __typename?: 'BlockAppearance' }
      & BlockAppearanceFragmentFragment
    )> }
  )>> }
);

export type BlockLinkFragmentFragment = (
  { __typename?: 'Link' }
  & Pick<Link, 'id' | 'overrideTitle' | 'url' | 'newTab' | 'queryParameters'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )>, imageMobile?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )>, references?: Maybe<Array<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
    { __typename?: 'Page' }
    & Pick<Page, 'id' | 'type' | 'title'>
  ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }>> }
);

export type BlockRteFieldFragmentFragment = (
  { __typename: 'RTEField' }
  & Pick<RteField, 'key' | 'value'>
  & { referencesWithKey?: Maybe<Array<(
    { __typename?: 'ReferenceWithKey' }
    & Pick<ReferenceWithKey, 'key'>
    & { reference?: Maybe<(
      { __typename?: 'DynamicVariable' }
      & ReferenceContent_DynamicVariable_Fragment
    ) | (
      { __typename?: 'EmailVariable' }
      & ReferenceContent_EmailVariable_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & ReferenceContent_ExternalLink_Fragment
    ) | (
      { __typename?: 'Image' }
      & ReferenceContent_Image_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ReferenceContent_ImageAsset_Fragment
    ) | (
      { __typename?: 'ImageResource' }
      & ReferenceContent_ImageResource_Fragment
    ) | (
      { __typename?: 'Link' }
      & ReferenceContent_Link_Fragment
    ) | (
      { __typename?: 'ModalTab' }
      & ReferenceContent_ModalTab_Fragment
    ) | (
      { __typename?: 'Page' }
      & ReferenceContent_Page_Fragment
    ) | (
      { __typename?: 'TileResource' }
      & ReferenceContent_TileResource_Fragment
    ) | (
      { __typename?: 'VideoResource' }
      & ReferenceContent_VideoResource_Fragment
    ) | (
      { __typename?: 'Wordbook' }
      & ReferenceContent_Wordbook_Fragment
    )> }
  )>> }
);

type BlockContent_AccordionListBlock_Fragment = (
  { __typename: 'AccordionListBlock' }
  & Pick<AccordionListBlock, 'id' | 'type' | 'title' | 'settings'>
  & { fields?: Maybe<Array<(
    { __typename?: 'ProductField' }
    & Fields_ProductField_Fragment
  ) | (
    { __typename?: 'JSONField' }
    & Fields_JsonField_Fragment
  ) | (
    { __typename?: 'LinkField' }
    & Fields_LinkField_Fragment
  ) | (
    { __typename?: 'MultipleLinkField' }
    & Fields_MultipleLinkField_Fragment
  ) | (
    { __typename?: 'ReferenceField' }
    & Fields_ReferenceField_Fragment
  ) | (
    { __typename?: 'RTEField' }
    & Fields_RteField_Fragment
  ) | (
    { __typename?: 'ObjectField' }
    & Fields_ObjectField_Fragment
  ) | (
    { __typename?: 'NavigationField' }
    & Fields_NavigationField_Fragment
  )>>, accordions?: Maybe<Array<(
    { __typename?: 'AccordionItem' }
    & Pick<AccordionItem, 'title'>
    & { fields?: Maybe<Array<(
      { __typename?: 'ProductField' }
      & Fields_ProductField_Fragment
    ) | (
      { __typename?: 'JSONField' }
      & Fields_JsonField_Fragment
    ) | (
      { __typename?: 'LinkField' }
      & Fields_LinkField_Fragment
    ) | (
      { __typename?: 'MultipleLinkField' }
      & Fields_MultipleLinkField_Fragment
    ) | (
      { __typename?: 'ReferenceField' }
      & Fields_ReferenceField_Fragment
    ) | (
      { __typename?: 'RTEField' }
      & Fields_RteField_Fragment
    ) | (
      { __typename?: 'ObjectField' }
      & Fields_ObjectField_Fragment
    ) | (
      { __typename?: 'NavigationField' }
      & Fields_NavigationField_Fragment
    )>> }
  )>>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_ActiveCampaignBlock_Fragment = (
  { __typename: 'ActiveCampaignBlock' }
  & Pick<ActiveCampaignBlock, 'highlightText' | 'id' | 'type' | 'title' | 'settings'>
  & { description?: Maybe<(
    { __typename?: 'RTEField' }
    & BlockRteFieldFragmentFragment
  )>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_Block_Fragment = (
  { __typename: 'Block' }
  & Pick<Block, 'id' | 'type' | 'title' | 'settings'>
  & { fields?: Maybe<Array<(
    { __typename?: 'ProductField' }
    & Fields_ProductField_Fragment
  ) | (
    { __typename?: 'JSONField' }
    & Fields_JsonField_Fragment
  ) | (
    { __typename?: 'LinkField' }
    & Fields_LinkField_Fragment
  ) | (
    { __typename?: 'MultipleLinkField' }
    & Fields_MultipleLinkField_Fragment
  ) | (
    { __typename?: 'ReferenceField' }
    & Fields_ReferenceField_Fragment
  ) | (
    { __typename?: 'RTEField' }
    & Fields_RteField_Fragment
  ) | (
    { __typename?: 'ObjectField' }
    & Fields_ObjectField_Fragment
  ) | (
    { __typename?: 'NavigationField' }
    & Fields_NavigationField_Fragment
  )>>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_GalleryBlock_Fragment = (
  { __typename: 'GalleryBlock' }
  & Pick<GalleryBlock, 'id' | 'type' | 'title' | 'settings'>
  & { fields?: Maybe<Array<(
    { __typename?: 'ProductField' }
    & Fields_ProductField_Fragment
  ) | (
    { __typename?: 'JSONField' }
    & Fields_JsonField_Fragment
  ) | (
    { __typename?: 'LinkField' }
    & Fields_LinkField_Fragment
  ) | (
    { __typename?: 'MultipleLinkField' }
    & Fields_MultipleLinkField_Fragment
  ) | (
    { __typename?: 'ReferenceField' }
    & Fields_ReferenceField_Fragment
  ) | (
    { __typename?: 'RTEField' }
    & Fields_RteField_Fragment
  ) | (
    { __typename?: 'ObjectField' }
    & Fields_ObjectField_Fragment
  ) | (
    { __typename?: 'NavigationField' }
    & Fields_NavigationField_Fragment
  )>>, slides?: Maybe<Array<(
    { __typename: 'GalleryBlockSlide' }
    & { images?: Maybe<Array<(
      { __typename?: 'ImageResource' }
      & Pick<ImageResource, 'id' | 'url' | 'mobileURL'>
      & { captionOptions?: Maybe<(
        { __typename?: 'CaptionOptions' }
        & Pick<CaptionOptions, 'caption'>
        & { references?: Maybe<Array<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
          { __typename: 'Page' }
          & Pick<Page, 'type' | 'id'>
          & { fields?: Maybe<Array<(
            { __typename: 'ProductField' }
            & Pick<ProductField, 'key'>
            & { product?: Maybe<(
              { __typename?: 'Product' }
              & ProductContentFragment
            )> }
          ) | { __typename?: 'JSONField' } | { __typename?: 'LinkField' } | { __typename?: 'MultipleLinkField' } | { __typename?: 'ReferenceField' } | { __typename?: 'RTEField' } | { __typename?: 'ObjectField' } | { __typename?: 'NavigationField' }>> }
        ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }>> }
      )>, fields?: Maybe<Array<(
        { __typename?: 'ProductField' }
        & FieldContent_ProductField_Fragment
      ) | (
        { __typename?: 'JSONField' }
        & FieldContent_JsonField_Fragment
      ) | (
        { __typename?: 'LinkField' }
        & FieldContent_LinkField_Fragment
      ) | (
        { __typename?: 'MultipleLinkField' }
        & FieldContent_MultipleLinkField_Fragment
      ) | (
        { __typename?: 'ReferenceField' }
        & FieldContent_ReferenceField_Fragment
      ) | (
        { __typename?: 'RTEField' }
        & FieldContent_RteField_Fragment
      ) | (
        { __typename?: 'ObjectField' }
        & FieldContent_ObjectField_Fragment
      ) | (
        { __typename?: 'NavigationField' }
        & FieldContent_NavigationField_Fragment
      )>> }
    )>>, fields?: Maybe<Array<(
      { __typename?: 'ProductField' }
      & Fields_ProductField_Fragment
    ) | (
      { __typename?: 'JSONField' }
      & Fields_JsonField_Fragment
    ) | (
      { __typename?: 'LinkField' }
      & Fields_LinkField_Fragment
    ) | (
      { __typename?: 'MultipleLinkField' }
      & Fields_MultipleLinkField_Fragment
    ) | (
      { __typename?: 'ReferenceField' }
      & Fields_ReferenceField_Fragment
    ) | (
      { __typename?: 'RTEField' }
      & Fields_RteField_Fragment
    ) | (
      { __typename?: 'ObjectField' }
      & Fields_ObjectField_Fragment
    ) | (
      { __typename?: 'NavigationField' }
      & Fields_NavigationField_Fragment
    )>> }
  )>>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_GlobalBlock_Fragment = (
  { __typename: 'GlobalBlock' }
  & Pick<GlobalBlock, 'id' | 'type' | 'title' | 'settings'>
  & { fields?: Maybe<Array<(
    { __typename?: 'ProductField' }
    & Fields_ProductField_Fragment
  ) | (
    { __typename?: 'JSONField' }
    & Fields_JsonField_Fragment
  ) | (
    { __typename?: 'LinkField' }
    & Fields_LinkField_Fragment
  ) | (
    { __typename?: 'MultipleLinkField' }
    & Fields_MultipleLinkField_Fragment
  ) | (
    { __typename?: 'ReferenceField' }
    & Fields_ReferenceField_Fragment
  ) | (
    { __typename?: 'RTEField' }
    & Fields_RteField_Fragment
  ) | (
    { __typename?: 'ObjectField' }
    & Fields_ObjectField_Fragment
  ) | (
    { __typename?: 'NavigationField' }
    & Fields_NavigationField_Fragment
  )>>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_HtmlBlock_Fragment = (
  { __typename: 'HTMLBlock' }
  & Pick<HtmlBlock, 'html' | 'id' | 'type' | 'title' | 'settings'>
  & { splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_InfoPanelBlock_Fragment = (
  { __typename: 'InfoPanelBlock' }
  & Pick<InfoPanelBlock, 'id' | 'type' | 'title' | 'settings'>
  & { infoPanels?: Maybe<Array<(
    { __typename?: 'InfoPanel' }
    & { icon?: Maybe<(
      { __typename?: 'DynamicVariable' }
      & ReferenceContent_DynamicVariable_Fragment
    ) | (
      { __typename?: 'EmailVariable' }
      & ReferenceContent_EmailVariable_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & ReferenceContent_ExternalLink_Fragment
    ) | (
      { __typename?: 'Image' }
      & ReferenceContent_Image_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ReferenceContent_ImageAsset_Fragment
    ) | (
      { __typename?: 'ImageResource' }
      & ReferenceContent_ImageResource_Fragment
    ) | (
      { __typename?: 'Link' }
      & ReferenceContent_Link_Fragment
    ) | (
      { __typename?: 'ModalTab' }
      & ReferenceContent_ModalTab_Fragment
    ) | (
      { __typename?: 'Page' }
      & ReferenceContent_Page_Fragment
    ) | (
      { __typename?: 'TileResource' }
      & ReferenceContent_TileResource_Fragment
    ) | (
      { __typename?: 'VideoResource' }
      & ReferenceContent_VideoResource_Fragment
    ) | (
      { __typename?: 'Wordbook' }
      & ReferenceContent_Wordbook_Fragment
    )>, title?: Maybe<(
      { __typename?: 'Wordbook' }
      & WordbookFragmentFragment
    )>, subTitle?: Maybe<(
      { __typename?: 'Wordbook' }
      & WordbookFragmentFragment
    )>, text?: Maybe<(
      { __typename?: 'Wordbook' }
      & WordbookFragmentFragment
    )> }
  )>>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_LookDisplayBlock_Fragment = (
  { __typename: 'LookDisplayBlock' }
  & Pick<LookDisplayBlock, 'id' | 'type' | 'title' | 'settings'>
  & { asset?: Maybe<(
    { __typename?: 'DynamicVariable' }
    & ReferenceContent_DynamicVariable_Fragment
  ) | (
    { __typename?: 'EmailVariable' }
    & ReferenceContent_EmailVariable_Fragment
  ) | (
    { __typename?: 'ExternalLink' }
    & ReferenceContent_ExternalLink_Fragment
  ) | (
    { __typename?: 'Image' }
    & ReferenceContent_Image_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & ReferenceContent_ImageAsset_Fragment
  ) | (
    { __typename?: 'ImageResource' }
    & ReferenceContent_ImageResource_Fragment
  ) | (
    { __typename?: 'Link' }
    & ReferenceContent_Link_Fragment
  ) | (
    { __typename?: 'ModalTab' }
    & ReferenceContent_ModalTab_Fragment
  ) | (
    { __typename?: 'Page' }
    & ReferenceContent_Page_Fragment
  ) | (
    { __typename?: 'TileResource' }
    & ReferenceContent_TileResource_Fragment
  ) | (
    { __typename?: 'VideoResource' }
    & ReferenceContent_VideoResource_Fragment
  ) | (
    { __typename?: 'Wordbook' }
    & ReferenceContent_Wordbook_Fragment
  )>, products?: Maybe<Array<(
    { __typename?: 'LookProduct' }
    & Pick<LookProduct, 'x' | 'y'>
    & { product?: Maybe<(
      { __typename?: 'Product' }
      & ProductTileFragmentFragment
    )> }
  )>>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_LookListBlock_Fragment = (
  { __typename: 'LookListBlock' }
  & Pick<LookListBlock, 'id' | 'type' | 'title' | 'settings'>
  & { looks?: Maybe<Array<(
    { __typename?: 'LookTile' }
    & Pick<LookTile, 'id' | 'url' | 'ambassadorHandle'>
    & { asset?: Maybe<(
      { __typename?: 'DynamicVariable' }
      & ReferenceContent_DynamicVariable_Fragment
    ) | (
      { __typename?: 'EmailVariable' }
      & ReferenceContent_EmailVariable_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & ReferenceContent_ExternalLink_Fragment
    ) | (
      { __typename?: 'Image' }
      & ReferenceContent_Image_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ReferenceContent_ImageAsset_Fragment
    ) | (
      { __typename?: 'ImageResource' }
      & ReferenceContent_ImageResource_Fragment
    ) | (
      { __typename?: 'Link' }
      & ReferenceContent_Link_Fragment
    ) | (
      { __typename?: 'ModalTab' }
      & ReferenceContent_ModalTab_Fragment
    ) | (
      { __typename?: 'Page' }
      & ReferenceContent_Page_Fragment
    ) | (
      { __typename?: 'TileResource' }
      & ReferenceContent_TileResource_Fragment
    ) | (
      { __typename?: 'VideoResource' }
      & ReferenceContent_VideoResource_Fragment
    ) | (
      { __typename?: 'Wordbook' }
      & ReferenceContent_Wordbook_Fragment
    )>, products?: Maybe<Array<(
      { __typename?: 'LookProduct' }
      & Pick<LookProduct, 'productID' | 'x' | 'y'>
    )>> }
  )>>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_PageGridBlock_Fragment = (
  { __typename: 'PageGridBlock' }
  & Pick<PageGridBlock, 'columns' | 'showDescription' | 'titlePosition' | 'id' | 'type' | 'title' | 'settings'>
  & { references?: Maybe<Array<{ __typename: 'DynamicVariable' } | { __typename: 'EmailVariable' } | { __typename: 'ExternalLink' } | { __typename: 'Image' } | { __typename: 'ImageAsset' } | { __typename: 'ImageResource' } | { __typename: 'Link' } | { __typename: 'ModalTab' } | (
    { __typename: 'Page' }
    & Pick<Page, 'id' | 'type' | 'url'>
    & { brand?: Maybe<(
      { __typename?: 'Brand' }
      & Pick<Brand, 'id' | 'logo' | 'title'>
    )>, openGraph?: Maybe<(
      { __typename?: 'OpenGraph' }
      & Pick<OpenGraph, 'title' | 'description' | 'imageURL'>
    )> }
  ) | { __typename: 'TileResource' } | { __typename: 'VideoResource' } | { __typename: 'Wordbook' }>>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_PageSliderBlock_Fragment = (
  { __typename: 'PageSliderBlock' }
  & Pick<PageSliderBlock, 'id' | 'type' | 'title' | 'settings'>
  & { splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
  & PageSliderBlockFragment
);

type BlockContent_ProductGridSelectorBlock_Fragment = (
  { __typename: 'ProductGridSelectorBlock' }
  & Pick<ProductGridSelectorBlock, 'id' | 'type' | 'title' | 'settings'>
  & { fields?: Maybe<Array<(
    { __typename?: 'ProductField' }
    & Fields_ProductField_Fragment
  ) | (
    { __typename?: 'JSONField' }
    & Fields_JsonField_Fragment
  ) | (
    { __typename?: 'LinkField' }
    & Fields_LinkField_Fragment
  ) | (
    { __typename?: 'MultipleLinkField' }
    & Fields_MultipleLinkField_Fragment
  ) | (
    { __typename?: 'ReferenceField' }
    & Fields_ReferenceField_Fragment
  ) | (
    { __typename?: 'RTEField' }
    & Fields_RteField_Fragment
  ) | (
    { __typename?: 'ObjectField' }
    & Fields_ObjectField_Fragment
  ) | (
    { __typename?: 'NavigationField' }
    & Fields_NavigationField_Fragment
  )>>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_ProductListBlock_Fragment = (
  { __typename: 'ProductListBlock' }
  & Pick<ProductListBlock, 'id' | 'type' | 'title' | 'settings'>
  & { fields?: Maybe<Array<(
    { __typename?: 'ProductField' }
    & Fields_ProductField_Fragment
  ) | (
    { __typename?: 'JSONField' }
    & Fields_JsonField_Fragment
  ) | (
    { __typename?: 'LinkField' }
    & Fields_LinkField_Fragment
  ) | (
    { __typename?: 'MultipleLinkField' }
    & Fields_MultipleLinkField_Fragment
  ) | (
    { __typename?: 'ReferenceField' }
    & Fields_ReferenceField_Fragment
  ) | (
    { __typename?: 'RTEField' }
    & Fields_RteField_Fragment
  ) | (
    { __typename?: 'ObjectField' }
    & Fields_ObjectField_Fragment
  ) | (
    { __typename?: 'NavigationField' }
    & Fields_NavigationField_Fragment
  )>>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
  & ProductListBlockFragmentFragment
);

type BlockContent_ProductSliderBlock_Fragment = (
  { __typename: 'ProductSliderBlock' }
  & Pick<ProductSliderBlock, 'facetFilters' | 'filter' | 'filters' | 'header' | 'limit' | 'sorting' | 'id' | 'type' | 'title' | 'settings'>
  & { slider?: Maybe<(
    { __typename?: 'ProductSlider' }
    & { products?: Maybe<Array<(
      { __typename?: 'Product' }
      & ProductTileFragmentFragment
    )>> }
  )>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

type BlockContent_UspBlock_Fragment = (
  { __typename: 'USPBlock' }
  & Pick<UspBlock, 'id' | 'type' | 'title' | 'settings'>
  & { asset?: Maybe<(
    { __typename?: 'DynamicVariable' }
    & ReferenceContent_DynamicVariable_Fragment
  ) | (
    { __typename?: 'EmailVariable' }
    & ReferenceContent_EmailVariable_Fragment
  ) | (
    { __typename?: 'ExternalLink' }
    & ReferenceContent_ExternalLink_Fragment
  ) | (
    { __typename?: 'Image' }
    & ReferenceContent_Image_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & ReferenceContent_ImageAsset_Fragment
  ) | (
    { __typename?: 'ImageResource' }
    & ReferenceContent_ImageResource_Fragment
  ) | (
    { __typename?: 'Link' }
    & ReferenceContent_Link_Fragment
  ) | (
    { __typename?: 'ModalTab' }
    & ReferenceContent_ModalTab_Fragment
  ) | (
    { __typename?: 'Page' }
    & ReferenceContent_Page_Fragment
  ) | (
    { __typename?: 'TileResource' }
    & ReferenceContent_TileResource_Fragment
  ) | (
    { __typename?: 'VideoResource' }
    & ReferenceContent_VideoResource_Fragment
  ) | (
    { __typename?: 'Wordbook' }
    & ReferenceContent_Wordbook_Fragment
  )>, items?: Maybe<Array<(
    { __typename?: 'USPBlockItem' }
    & Pick<UspBlockItem, 'id' | 'linkTitle' | 'title'>
    & { link?: Maybe<(
      { __typename?: 'LinkField' }
      & Pick<LinkField, 'key' | 'url' | 'newTab'>
      & { references?: Maybe<Array<{ __typename: 'DynamicVariable' } | { __typename: 'EmailVariable' } | { __typename: 'ExternalLink' } | { __typename: 'Image' } | { __typename: 'ImageAsset' } | { __typename: 'ImageResource' } | { __typename: 'Link' } | { __typename: 'ModalTab' } | (
        { __typename: 'Page' }
        & Pick<Page, 'id' | 'type' | 'title'>
      ) | { __typename: 'TileResource' } | { __typename: 'VideoResource' } | { __typename: 'Wordbook' }>> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & BlockRteFieldFragmentFragment
    )> }
  )>>, splitTest?: Maybe<(
    { __typename?: 'SplitTest' }
    & Pick<SplitTest, 'test' | 'groups'>
  )>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & BlockAppearanceFragmentFragment
  )>, common?: Maybe<(
    { __typename?: 'BlockCommon' }
    & Pick<BlockCommon, 'position' | 'status' | 'title' | 'titleElement' | 'settings'>
    & { chips?: Maybe<Array<(
      { __typename?: 'BlockCommonChip' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>>, label?: Maybe<(
      { __typename?: 'BlockCommonLabel' }
      & { appearance?: Maybe<(
        { __typename?: 'BlockAppearance' }
        & BlockAppearanceFragmentFragment
      )>, text?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )>, text?: Maybe<(
      { __typename?: 'RTEField' }
      & Pick<RteField, 'value'>
    )> }
  )> }
);

export type BlockContentFragment = BlockContent_AccordionListBlock_Fragment | BlockContent_ActiveCampaignBlock_Fragment | BlockContent_Block_Fragment | BlockContent_GalleryBlock_Fragment | BlockContent_GlobalBlock_Fragment | BlockContent_HtmlBlock_Fragment | BlockContent_InfoPanelBlock_Fragment | BlockContent_LookDisplayBlock_Fragment | BlockContent_LookListBlock_Fragment | BlockContent_PageGridBlock_Fragment | BlockContent_PageSliderBlock_Fragment | BlockContent_ProductGridSelectorBlock_Fragment | BlockContent_ProductListBlock_Fragment | BlockContent_ProductSliderBlock_Fragment | BlockContent_UspBlock_Fragment;

export type DrawerDataFragment = (
  { __typename?: 'Page' }
  & Pick<Page, 'id' | 'type' | 'title' | 'settings'>
  & { blocks?: Maybe<Array<(
    { __typename?: 'Block' }
    & BlockContent_Block_Fragment
  ) | (
    { __typename?: 'AccordionListBlock' }
    & BlockContent_AccordionListBlock_Fragment
  ) | (
    { __typename?: 'ActiveCampaignBlock' }
    & BlockContent_ActiveCampaignBlock_Fragment
  ) | (
    { __typename?: 'GalleryBlock' }
    & BlockContent_GalleryBlock_Fragment
  ) | (
    { __typename?: 'GlobalBlock' }
    & BlockContent_GlobalBlock_Fragment
  ) | (
    { __typename?: 'HTMLBlock' }
    & BlockContent_HtmlBlock_Fragment
  ) | (
    { __typename?: 'InfoPanelBlock' }
    & BlockContent_InfoPanelBlock_Fragment
  ) | (
    { __typename?: 'LookDisplayBlock' }
    & BlockContent_LookDisplayBlock_Fragment
  ) | (
    { __typename?: 'LookListBlock' }
    & BlockContent_LookListBlock_Fragment
  ) | (
    { __typename?: 'PageGridBlock' }
    & BlockContent_PageGridBlock_Fragment
  ) | (
    { __typename?: 'PageSliderBlock' }
    & BlockContent_PageSliderBlock_Fragment
  ) | (
    { __typename?: 'ProductGridSelectorBlock' }
    & BlockContent_ProductGridSelectorBlock_Fragment
  ) | (
    { __typename?: 'ProductListBlock' }
    & BlockContent_ProductListBlock_Fragment
  ) | (
    { __typename?: 'ProductSliderBlock' }
    & BlockContent_ProductSliderBlock_Fragment
  ) | (
    { __typename?: 'USPBlock' }
    & BlockContent_UspBlock_Fragment
  )>>, modalTabs?: Maybe<Array<(
    { __typename?: 'ModalTab' }
    & Pick<ModalTab, 'id' | 'title'>
    & { blocks?: Maybe<Array<(
      { __typename?: 'Block' }
      & BlockContent_Block_Fragment
    ) | (
      { __typename?: 'AccordionListBlock' }
      & BlockContent_AccordionListBlock_Fragment
    ) | (
      { __typename?: 'ActiveCampaignBlock' }
      & BlockContent_ActiveCampaignBlock_Fragment
    ) | (
      { __typename?: 'GalleryBlock' }
      & BlockContent_GalleryBlock_Fragment
    ) | (
      { __typename?: 'GlobalBlock' }
      & BlockContent_GlobalBlock_Fragment
    ) | (
      { __typename?: 'HTMLBlock' }
      & BlockContent_HtmlBlock_Fragment
    ) | (
      { __typename?: 'InfoPanelBlock' }
      & BlockContent_InfoPanelBlock_Fragment
    ) | (
      { __typename?: 'LookDisplayBlock' }
      & BlockContent_LookDisplayBlock_Fragment
    ) | (
      { __typename?: 'LookListBlock' }
      & BlockContent_LookListBlock_Fragment
    ) | (
      { __typename?: 'PageGridBlock' }
      & BlockContent_PageGridBlock_Fragment
    ) | (
      { __typename?: 'PageSliderBlock' }
      & BlockContent_PageSliderBlock_Fragment
    ) | (
      { __typename?: 'ProductGridSelectorBlock' }
      & BlockContent_ProductGridSelectorBlock_Fragment
    ) | (
      { __typename?: 'ProductListBlock' }
      & BlockContent_ProductListBlock_Fragment
    ) | (
      { __typename?: 'ProductSliderBlock' }
      & BlockContent_ProductSliderBlock_Fragment
    ) | (
      { __typename?: 'USPBlock' }
      & BlockContent_UspBlock_Fragment
    )>>, appearance?: Maybe<(
      { __typename?: 'BlockAppearance' }
      & BlockAppearanceFragmentFragment
    )> }
  )>> }
);

type FieldContent_JsonField_Fragment = (
  { __typename: 'JSONField' }
  & Pick<JsonField, 'value' | 'key'>
);

type FieldContent_LinkField_Fragment = (
  { __typename: 'LinkField' }
  & Pick<LinkField, 'key' | 'url' | 'newTab'>
  & { references?: Maybe<Array<{ __typename: 'DynamicVariable' } | { __typename: 'EmailVariable' } | { __typename: 'ExternalLink' } | { __typename: 'Image' } | { __typename: 'ImageAsset' } | { __typename: 'ImageResource' } | { __typename: 'Link' } | { __typename: 'ModalTab' } | (
    { __typename: 'Page' }
    & Pick<Page, 'id' | 'type'>
  ) | { __typename: 'TileResource' } | { __typename: 'VideoResource' } | { __typename: 'Wordbook' }>> }
);

type FieldContent_MultipleLinkField_Fragment = (
  { __typename: 'MultipleLinkField' }
  & Pick<MultipleLinkField, 'key'>
  & MultipleLinkFieldContentFragment
);

type FieldContent_NavigationField_Fragment = (
  { __typename: 'NavigationField' }
  & Pick<NavigationField, 'key'>
);

type FieldContent_ObjectField_Fragment = (
  { __typename: 'ObjectField' }
  & Pick<ObjectField, 'key'>
);

type FieldContent_ProductField_Fragment = (
  { __typename: 'ProductField' }
  & Pick<ProductField, 'key'>
);

type FieldContent_RteField_Fragment = (
  { __typename: 'RTEField' }
  & Pick<RteField, 'key'>
);

type FieldContent_ReferenceField_Fragment = (
  { __typename: 'ReferenceField' }
  & Pick<ReferenceField, 'key'>
);

export type FieldContentFragment = FieldContent_JsonField_Fragment | FieldContent_LinkField_Fragment | FieldContent_MultipleLinkField_Fragment | FieldContent_NavigationField_Fragment | FieldContent_ObjectField_Fragment | FieldContent_ProductField_Fragment | FieldContent_RteField_Fragment | FieldContent_ReferenceField_Fragment;

type NestableFieldContent_JsonField_Fragment = (
  { __typename?: 'JSONField' }
  & FieldContent_JsonField_Fragment
);

type NestableFieldContent_LinkField_Fragment = (
  { __typename?: 'LinkField' }
  & FieldContent_LinkField_Fragment
);

type NestableFieldContent_MultipleLinkField_Fragment = (
  { __typename?: 'MultipleLinkField' }
  & FieldContent_MultipleLinkField_Fragment
);

type NestableFieldContent_NavigationField_Fragment = (
  { __typename?: 'NavigationField' }
  & FieldContent_NavigationField_Fragment
);

type NestableFieldContent_ObjectField_Fragment = (
  { __typename?: 'ObjectField' }
  & FieldContent_ObjectField_Fragment
);

type NestableFieldContent_ProductField_Fragment = (
  { __typename?: 'ProductField' }
  & FieldContent_ProductField_Fragment
);

type NestableFieldContent_RteField_Fragment = (
  { __typename?: 'RTEField' }
  & FieldContent_RteField_Fragment
);

type NestableFieldContent_ReferenceField_Fragment = (
  { __typename?: 'ReferenceField' }
  & { references?: Maybe<Array<(
    { __typename?: 'DynamicVariable' }
    & ReferenceContent_DynamicVariable_Fragment
  ) | (
    { __typename?: 'EmailVariable' }
    & ReferenceContent_EmailVariable_Fragment
  ) | (
    { __typename?: 'ExternalLink' }
    & ReferenceContent_ExternalLink_Fragment
  ) | (
    { __typename?: 'Image' }
    & ReferenceContent_Image_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & ReferenceContent_ImageAsset_Fragment
  ) | (
    { __typename?: 'ImageResource' }
    & ReferenceContent_ImageResource_Fragment
  ) | (
    { __typename?: 'Link' }
    & ReferenceContent_Link_Fragment
  ) | (
    { __typename?: 'ModalTab' }
    & ReferenceContent_ModalTab_Fragment
  ) | (
    { __typename?: 'Page' }
    & ReferenceContent_Page_Fragment
  ) | (
    { __typename?: 'TileResource' }
    & { elements?: Maybe<Array<(
      { __typename?: 'Elements' }
      & ElementsContentFragment
    )>> }
    & ReferenceContent_TileResource_Fragment
  ) | (
    { __typename?: 'VideoResource' }
    & ReferenceContent_VideoResource_Fragment
  ) | (
    { __typename?: 'Wordbook' }
    & ReferenceContent_Wordbook_Fragment
  )>> }
  & FieldContent_ReferenceField_Fragment
);

export type NestableFieldContentFragment = NestableFieldContent_JsonField_Fragment | NestableFieldContent_LinkField_Fragment | NestableFieldContent_MultipleLinkField_Fragment | NestableFieldContent_NavigationField_Fragment | NestableFieldContent_ObjectField_Fragment | NestableFieldContent_ProductField_Fragment | NestableFieldContent_RteField_Fragment | NestableFieldContent_ReferenceField_Fragment;

type Fields_JsonField_Fragment = (
  { __typename?: 'JSONField' }
  & NestableFieldContent_JsonField_Fragment
);

type Fields_LinkField_Fragment = (
  { __typename?: 'LinkField' }
  & NestableFieldContent_LinkField_Fragment
);

type Fields_MultipleLinkField_Fragment = (
  { __typename?: 'MultipleLinkField' }
  & NestableFieldContent_MultipleLinkField_Fragment
);

type Fields_NavigationField_Fragment = (
  { __typename?: 'NavigationField' }
  & Pick<NavigationField, 'key'>
  & { navigation?: Maybe<Array<(
    { __typename?: 'NavigationItem' }
    & Pick<NavigationItem, 'id' | 'title'>
    & { link?: Maybe<(
      { __typename?: 'Link' }
      & Pick<Link, 'id' | 'url'>
      & { image?: Maybe<(
        { __typename?: 'Image' }
        & Pick<Image, 'url'>
      )>, references?: Maybe<Array<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
        { __typename?: 'Page' }
        & Pick<Page, 'id' | 'type' | 'title'>
      ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }>> }
    )> }
  )>> }
  & NestableFieldContent_NavigationField_Fragment
);

type Fields_ObjectField_Fragment = (
  { __typename?: 'ObjectField' }
  & Pick<ObjectField, 'key'>
  & { fields?: Maybe<Array<(
    { __typename?: 'ProductField' }
    & NestableFieldContent_ProductField_Fragment
  ) | (
    { __typename?: 'JSONField' }
    & NestableFieldContent_JsonField_Fragment
  ) | (
    { __typename?: 'LinkField' }
    & NestableFieldContent_LinkField_Fragment
  ) | (
    { __typename?: 'MultipleLinkField' }
    & NestableFieldContent_MultipleLinkField_Fragment
  ) | (
    { __typename?: 'ReferenceField' }
    & NestableFieldContent_ReferenceField_Fragment
  ) | (
    { __typename?: 'RTEField' }
    & NestableFieldContent_RteField_Fragment
  ) | (
    { __typename?: 'ObjectField' }
    & Pick<ObjectField, 'key'>
    & { fields?: Maybe<Array<(
      { __typename?: 'ProductField' }
      & NestableFieldContent_ProductField_Fragment
    ) | (
      { __typename?: 'JSONField' }
      & NestableFieldContent_JsonField_Fragment
    ) | (
      { __typename?: 'LinkField' }
      & NestableFieldContent_LinkField_Fragment
    ) | (
      { __typename?: 'MultipleLinkField' }
      & NestableFieldContent_MultipleLinkField_Fragment
    ) | (
      { __typename?: 'ReferenceField' }
      & NestableFieldContent_ReferenceField_Fragment
    ) | (
      { __typename?: 'RTEField' }
      & NestableFieldContent_RteField_Fragment
    ) | (
      { __typename?: 'ObjectField' }
      & NestableFieldContent_ObjectField_Fragment
    ) | (
      { __typename?: 'NavigationField' }
      & NestableFieldContent_NavigationField_Fragment
    )>> }
    & NestableFieldContent_ObjectField_Fragment
  ) | (
    { __typename?: 'NavigationField' }
    & NestableFieldContent_NavigationField_Fragment
  )>> }
  & NestableFieldContent_ObjectField_Fragment
);

type Fields_ProductField_Fragment = (
  { __typename?: 'ProductField' }
  & NestableFieldContent_ProductField_Fragment
);

type Fields_RteField_Fragment = (
  { __typename?: 'RTEField' }
  & Pick<RteField, 'key' | 'value'>
  & { referencesWithKey?: Maybe<Array<(
    { __typename?: 'ReferenceWithKey' }
    & Pick<ReferenceWithKey, 'key'>
    & { reference?: Maybe<(
      { __typename?: 'DynamicVariable' }
      & ReferenceContent_DynamicVariable_Fragment
    ) | (
      { __typename?: 'EmailVariable' }
      & ReferenceContent_EmailVariable_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & ReferenceContent_ExternalLink_Fragment
    ) | (
      { __typename?: 'Image' }
      & ReferenceContent_Image_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ReferenceContent_ImageAsset_Fragment
    ) | (
      { __typename?: 'ImageResource' }
      & ReferenceContent_ImageResource_Fragment
    ) | (
      { __typename?: 'Link' }
      & ReferenceContent_Link_Fragment
    ) | (
      { __typename?: 'ModalTab' }
      & ReferenceContent_ModalTab_Fragment
    ) | (
      { __typename?: 'Page' }
      & ReferenceContent_Page_Fragment
    ) | (
      { __typename?: 'TileResource' }
      & ReferenceContent_TileResource_Fragment
    ) | (
      { __typename?: 'VideoResource' }
      & ReferenceContent_VideoResource_Fragment
    ) | (
      { __typename?: 'Wordbook' }
      & ReferenceContent_Wordbook_Fragment
    )> }
  )>> }
  & NestableFieldContent_RteField_Fragment
);

type Fields_ReferenceField_Fragment = (
  { __typename?: 'ReferenceField' }
  & NestableFieldContent_ReferenceField_Fragment
);

export type FieldsFragment = Fields_JsonField_Fragment | Fields_LinkField_Fragment | Fields_MultipleLinkField_Fragment | Fields_NavigationField_Fragment | Fields_ObjectField_Fragment | Fields_ProductField_Fragment | Fields_RteField_Fragment | Fields_ReferenceField_Fragment;

type MoneyContent_Money_Fragment = (
  { __typename?: 'Money' }
  & Pick<Money, 'currencyCode' | 'value' | 'format'>
  & { plain: Money['format'] }
);

type MoneyContent_Price_Fragment = (
  { __typename?: 'Price' }
  & Pick<Price, 'currencyCode' | 'value' | 'format'>
  & { plain: Price['format'] }
);

type MoneyContent_PriceDiscount_Fragment = (
  { __typename?: 'PriceDiscount' }
  & Pick<PriceDiscount, 'currencyCode' | 'value' | 'format'>
  & { plain: PriceDiscount['format'] }
);

export type MoneyContentFragment = MoneyContent_Money_Fragment | MoneyContent_Price_Fragment | MoneyContent_PriceDiscount_Fragment;

export type MultipleLinkFieldContentFragment = (
  { __typename?: 'MultipleLinkField' }
  & { links?: Maybe<Array<(
    { __typename?: 'Link' }
    & Pick<Link, 'url' | 'newTab' | 'queryParameters'>
    & { references?: Maybe<Array<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
      { __typename?: 'Page' }
      & Pick<Page, 'id' | 'type' | 'title'>
    ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }>> }
  )>> }
);

export type OpenGraphContentFragment = (
  { __typename?: 'OpenGraph' }
  & Pick<OpenGraph, 'siteName' | 'type' | 'title' | 'description' | 'imageURL'>
);

export type PersonalizationOptionsFragment = (
  { __typename?: 'ProductVariant' }
  & { maxCharacters?: Maybe<(
    { __typename?: 'BaseAttribute' }
    & Pick<BaseAttribute, 'value'>
  ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, type?: Maybe<(
    { __typename?: 'BaseAttribute' }
    & Pick<BaseAttribute, 'value'>
  ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, legacyID?: Maybe<(
    { __typename?: 'BaseAttribute' }
    & Pick<BaseAttribute, 'value'>
  ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, shortName?: Maybe<(
    { __typename?: 'BaseAttribute' }
    & Pick<BaseAttribute, 'value'>
  ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, price?: Maybe<(
    { __typename?: 'Price' }
    & PriceFragmentFragment
  )> }
);

export type PriceFragmentFragment = (
  { __typename?: 'Price' }
  & { discount?: Maybe<(
    { __typename?: 'PriceDiscount' }
    & Pick<PriceDiscount, 'percent'>
    & { code?: Maybe<(
      { __typename?: 'DiscountCode' }
      & Pick<DiscountCode, 'context'>
    )> }
    & MoneyContent_PriceDiscount_Fragment
  )> }
  & MoneyContent_Price_Fragment
);

type ProductBundle_BaseAttribute_Fragment = { __typename?: 'BaseAttribute' };

type ProductBundle_MoneyAttribute_Fragment = { __typename?: 'MoneyAttribute' };

type ProductBundle_ProductAttribute_Fragment = { __typename?: 'ProductAttribute' };

type ProductBundle_ProductsWithQuantityAttribute_Fragment = (
  { __typename?: 'ProductsWithQuantityAttribute' }
  & { products?: Maybe<Array<(
    { __typename?: 'ProductWithQuantity' }
    & Pick<ProductWithQuantity, 'quantity' | 'productID'>
    & { product?: Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'id' | 'name' | 'type' | 'url'>
      & { image?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
        & { dimensions?: Maybe<(
          { __typename?: 'Dimensions' }
          & Pick<Dimensions, 'width' | 'height'>
        )> }
      )>, masterVariant?: Maybe<(
        { __typename?: 'ProductVariant' }
        & Pick<ProductVariant, 'id'>
        & { price?: Maybe<(
          { __typename?: 'Price' }
          & PriceFragmentFragment
        )> }
      )> }
      & ProductSpecificationFragmentFragment
    )> }
  )>> }
);

export type ProductBundleFragment = ProductBundle_BaseAttribute_Fragment | ProductBundle_MoneyAttribute_Fragment | ProductBundle_ProductAttribute_Fragment | ProductBundle_ProductsWithQuantityAttribute_Fragment;

export type ProductContentFragment = (
  { __typename?: 'Product' }
  & Pick<Product, 'id' | 'type' | 'name' | 'url' | 'description' | 'categoryIDs'>
  & { availability?: Maybe<(
    { __typename?: 'Availability' }
    & Pick<Availability, 'isInStock' | 'quantity'>
  )>, brand?: Maybe<(
    { __typename?: 'Brand' }
    & Pick<Brand, 'id' | 'logo' | 'title' | 'url'>
  )>, primaryCategories?: Maybe<Array<(
    { __typename?: 'Category' }
    & Pick<Category, 'id' | 'name'>
  )>>, masterVariant?: Maybe<(
    { __typename?: 'ProductVariant' }
    & Pick<ProductVariant, 'id'>
    & { price?: Maybe<(
      { __typename?: 'Price' }
      & { clubValue?: Maybe<(
        { __typename?: 'Money' }
        & MoneyContent_Money_Fragment
      )>, discount?: Maybe<(
        { __typename?: 'PriceDiscount' }
        & { clubValue?: Maybe<(
          { __typename?: 'Money' }
          & MoneyContent_Money_Fragment
        )> }
      )> }
      & PriceFragmentFragment
    )>, basePrice?: Maybe<(
      { __typename?: 'Price' }
      & { plain: Price['format'] }
      & { discount?: Maybe<(
        { __typename?: 'PriceDiscount' }
        & { plain: PriceDiscount['format'] }
      )> }
    )>, availability?: Maybe<(
      { __typename?: 'Availability' }
      & Pick<Availability, 'isInStock' | 'quantity'>
    )>, attributes?: Maybe<Array<(
      { __typename?: 'BaseAttribute' }
      & Pick<BaseAttribute, 'key' | 'value'>
    ) | (
      { __typename?: 'MoneyAttribute' }
      & Pick<MoneyAttribute, 'key'>
      & { money?: Maybe<(
        { __typename?: 'Money' }
        & MoneyContent_Money_Fragment
      )> }
    ) | (
      { __typename?: 'ProductAttribute' }
      & Pick<ProductAttribute, 'key'>
    ) | (
      { __typename?: 'ProductsWithQuantityAttribute' }
      & Pick<ProductsWithQuantityAttribute, 'key'>
    )>> }
  )>, primaryAsset?: Maybe<(
    { __typename?: 'Asset' }
    & Pick<Asset, 'url' | 'tags'>
  )>, moneyShotAsset?: Maybe<(
    { __typename?: 'Asset' }
    & Pick<Asset, 'url' | 'tags'>
  )>, assets?: Maybe<Array<(
    { __typename?: 'Asset' }
    & Pick<Asset, 'url' | 'tags'>
    & { dimensions?: Maybe<(
      { __typename?: 'Dimensions' }
      & Pick<Dimensions, 'width' | 'height'>
    )> }
  )>>, variants?: Maybe<Array<(
    { __typename?: 'ProductVariant' }
    & Pick<ProductVariant, 'id'>
    & { price?: Maybe<(
      { __typename?: 'Price' }
      & PriceFragmentFragment
    )>, availability?: Maybe<(
      { __typename?: 'Availability' }
      & Pick<Availability, 'isInStock' | 'quantity'>
    )>, attributes?: Maybe<Array<(
      { __typename?: 'BaseAttribute' }
      & Pick<BaseAttribute, 'key' | 'value'>
    ) | (
      { __typename?: 'MoneyAttribute' }
      & Pick<MoneyAttribute, 'key'>
      & { money?: Maybe<(
        { __typename?: 'Money' }
        & MoneyContent_Money_Fragment
      )> }
    ) | (
      { __typename?: 'ProductAttribute' }
      & Pick<ProductAttribute, 'key'>
    ) | (
      { __typename?: 'ProductsWithQuantityAttribute' }
      & Pick<ProductsWithQuantityAttribute, 'key'>
    )>> }
  )>> }
);

export type ProductCrossSellAndPersonalizationContentFragment = (
  { __typename?: 'Product' }
  & Pick<Product, 'id' | 'type' | 'name' | 'url'>
  & { brand?: Maybe<(
    { __typename?: 'Brand' }
    & Pick<Brand, 'title'>
  )>, primaryAsset?: Maybe<(
    { __typename?: 'Asset' }
    & Pick<Asset, 'url' | 'tags'>
  )>, moneyShotAsset?: Maybe<(
    { __typename?: 'Asset' }
    & Pick<Asset, 'url' | 'tags'>
  )>, masterVariant?: Maybe<(
    { __typename?: 'ProductVariant' }
    & Pick<ProductVariant, 'id'>
    & { price?: Maybe<(
      { __typename?: 'Price' }
      & PriceFragmentFragment
    )> }
    & PersonalizationOptionsFragment
  )> }
);

export type ProductReviewsFragment = (
  { __typename?: 'Product' }
  & { productReviews?: Maybe<(
    { __typename?: 'Product_ProductReviewsConnection' }
    & Pick<Product_ProductReviewsConnection, 'averageRating' | 'count' | 'translatedCount' | 'cursor'>
    & { productReviews?: Maybe<Array<(
      { __typename?: 'ProductReview' }
      & Pick<ProductReview, 'id' | 'createdAt' | 'customerName' | 'locale' | 'localizedText' | 'localizedTitle' | 'rating'>
    )>> }
  )> }
);

export type ProductSizeGuideColumnContentFragment = (
  { __typename?: 'ProductSizeGuideColumn' }
  & Pick<ProductSizeGuideColumn, 'id' | 'isHeader'>
  & { text?: Maybe<(
    { __typename?: 'Wordbook' }
    & WordbookFragmentFragment
  )> }
);

export type ProductSizeGuideContentFragment = (
  { __typename?: 'Product' }
  & { sizeGuide?: Maybe<(
    { __typename?: 'Page' }
    & DrawerDataFragment
  )>, sizeGuideFits?: Maybe<Array<(
    { __typename?: 'ProductSizeGuideFits' }
    & Pick<ProductSizeGuideFits, 'id' | 'circumference'>
    & { title?: Maybe<(
      { __typename?: 'Wordbook' }
      & WordbookFragmentFragment
    )>, fits: Array<(
      { __typename?: 'ProductSizeGuideFitItem' }
      & Pick<ProductSizeGuideFitItem, 'id' | 'fit' | 'disabled' | 'quantity' | 'size'>
      & { fitLabel?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )>, sizeLabel?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )> }
    )> }
  )>>, sizeGuideItems?: Maybe<Array<(
    { __typename?: 'ProductSizeGuideItem' }
    & Pick<ProductSizeGuideItem, 'id'>
    & { title?: Maybe<(
      { __typename?: 'Wordbook' }
      & WordbookFragmentFragment
    )>, headers?: Maybe<Array<(
      { __typename?: 'ProductSizeGuideColumn' }
      & ProductSizeGuideColumnContentFragment
    )>>, rows?: Maybe<Array<(
      { __typename?: 'ProductSizeGuideRow' }
      & Pick<ProductSizeGuideRow, 'id'>
      & { columns?: Maybe<Array<(
        { __typename?: 'ProductSizeGuideColumn' }
        & ProductSizeGuideColumnContentFragment
      )>> }
    )>> }
  )>> }
);

type ProductSpecificationItemFragment_ProductSpecificationItemReference_Fragment = (
  { __typename: 'ProductSpecificationItemReference' }
  & Pick<ProductSpecificationItemReference, 'name' | 'text'>
  & { references?: Maybe<Array<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
    { __typename?: 'Page' }
    & Pick<Page, 'id' | 'title' | 'type' | 'url'>
  ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }>> }
);

type ProductSpecificationItemFragment_ProductSpecificationItemText_Fragment = (
  { __typename: 'ProductSpecificationItemText' }
  & Pick<ProductSpecificationItemText, 'name' | 'text'>
);

type ProductSpecificationItemFragment_ProductSpecificationItemUnit_Fragment = (
  { __typename: 'ProductSpecificationItemUnit' }
  & Pick<ProductSpecificationItemUnit, 'name' | 'format'>
  & { unit?: Maybe<(
    { __typename?: 'ProductSpecificationUnit' }
    & Pick<ProductSpecificationUnit, 'category' | 'type'>
  )> }
);

export type ProductSpecificationItemFragmentFragment = ProductSpecificationItemFragment_ProductSpecificationItemReference_Fragment | ProductSpecificationItemFragment_ProductSpecificationItemText_Fragment | ProductSpecificationItemFragment_ProductSpecificationItemUnit_Fragment;

export type ProductSpecificationFragmentFragment = (
  { __typename?: 'Product' }
  & { specifications?: Maybe<(
    { __typename?: 'ProductSpecifications' }
    & { groups?: Maybe<Array<(
      { __typename?: 'ProductSpecificationGroup' }
      & Pick<ProductSpecificationGroup, 'name'>
      & { items?: Maybe<Array<(
        { __typename?: 'ProductSpecificationItemMultiple' }
        & Pick<ProductSpecificationItemMultiple, 'name'>
        & { items?: Maybe<Array<(
          { __typename?: 'ProductSpecificationItemReference' }
          & ProductSpecificationItemFragment_ProductSpecificationItemReference_Fragment
        ) | (
          { __typename?: 'ProductSpecificationItemText' }
          & ProductSpecificationItemFragment_ProductSpecificationItemText_Fragment
        ) | (
          { __typename?: 'ProductSpecificationItemUnit' }
          & ProductSpecificationItemFragment_ProductSpecificationItemUnit_Fragment
        )>> }
      ) | (
        { __typename?: 'ProductSpecificationItemReference' }
        & ProductSpecificationItemFragment_ProductSpecificationItemReference_Fragment
      ) | (
        { __typename?: 'ProductSpecificationItemText' }
        & ProductSpecificationItemFragment_ProductSpecificationItemText_Fragment
      ) | (
        { __typename?: 'ProductSpecificationItemUnit' }
        & ProductSpecificationItemFragment_ProductSpecificationItemUnit_Fragment
      )>> }
    )>> }
  )> }
);

export type ProductTileFragmentFragment = (
  { __typename?: 'Product' }
  & Pick<Product, 'id' | 'type' | 'name' | 'url'>
  & { primaryAsset?: Maybe<(
    { __typename?: 'Asset' }
    & Pick<Asset, 'url' | 'tags'>
  )>, hoverAsset?: Maybe<(
    { __typename?: 'Asset' }
    & Pick<Asset, 'url' | 'tags'>
  )>, availability?: Maybe<(
    { __typename?: 'Availability' }
    & Pick<Availability, 'isInStock'>
  )>, masterVariant?: Maybe<(
    { __typename?: 'ProductVariant' }
    & Pick<ProductVariant, 'id'>
    & { isBestSeller?: Maybe<(
      { __typename?: 'BaseAttribute' }
      & Pick<BaseAttribute, 'value'>
    ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, isNew?: Maybe<(
      { __typename?: 'BaseAttribute' }
      & Pick<BaseAttribute, 'value'>
    ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, isPopularGift?: Maybe<(
      { __typename?: 'BaseAttribute' }
      & Pick<BaseAttribute, 'value'>
    ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, personalizations?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
      { __typename?: 'ProductAttribute' }
      & Pick<ProductAttribute, 'productIDs'>
    ) | { __typename?: 'ProductsWithQuantityAttribute' }>, price?: Maybe<(
      { __typename?: 'Price' }
      & PriceFragmentFragment
    )> }
  )> }
);

export type ImageAssetFragmentFragment = (
  { __typename?: 'ImageAsset' }
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
    & { dimensions?: Maybe<(
      { __typename?: 'Dimensions' }
      & Pick<Dimensions, 'height' | 'width'>
    )> }
  )>, imageMobile?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
    & { dimensions?: Maybe<(
      { __typename?: 'Dimensions' }
      & Pick<Dimensions, 'height' | 'width'>
    )> }
  )> }
);

export type ImageResourceImageFragmentFragment = (
  { __typename?: 'Image' }
  & Pick<Image, 'url'>
  & { dimensions?: Maybe<(
    { __typename?: 'Dimensions' }
    & Pick<Dimensions, 'width' | 'height'>
  )>, pins?: Maybe<Array<(
    { __typename?: 'ImagePin' }
    & Pick<ImagePin, 'x' | 'y'>
    & { reference?: Maybe<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
      { __typename: 'Page' }
      & Pick<Page, 'id' | 'type'>
    ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }> }
  )>> }
);

export type ImageResourceFragmentFragment = (
  { __typename?: 'ImageResource' }
  & Pick<ImageResource, 'id' | 'url' | 'mobileURL'>
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & ImageResourceImageFragmentFragment
  )>, mobileImage?: Maybe<(
    { __typename?: 'Image' }
    & ImageResourceImageFragmentFragment
  )>, fields?: Maybe<Array<(
    { __typename?: 'ProductField' }
    & FieldContent_ProductField_Fragment
  ) | (
    { __typename?: 'JSONField' }
    & FieldContent_JsonField_Fragment
  ) | (
    { __typename?: 'LinkField' }
    & FieldContent_LinkField_Fragment
  ) | (
    { __typename?: 'MultipleLinkField' }
    & FieldContent_MultipleLinkField_Fragment
  ) | (
    { __typename?: 'ReferenceField' }
    & FieldContent_ReferenceField_Fragment
  ) | (
    { __typename?: 'RTEField' }
    & FieldContent_RteField_Fragment
  ) | (
    { __typename?: 'ObjectField' }
    & FieldContent_ObjectField_Fragment
  ) | (
    { __typename?: 'NavigationField' }
    & FieldContent_NavigationField_Fragment
  )>> }
);

export type VideoResourceFragmentFragment = (
  { __typename?: 'VideoResource' }
  & Pick<VideoResource, 'settings'>
  & { asset?: Maybe<(
    { __typename?: 'VideoAsset' }
    & Pick<VideoAsset, 'type' | 'key'>
  )>, mobileAsset?: Maybe<(
    { __typename?: 'VideoAsset' }
    & Pick<VideoAsset, 'type' | 'key'>
  )> }
);

type ReferenceContent_DynamicVariable_Fragment = { __typename: 'DynamicVariable' };

type ReferenceContent_EmailVariable_Fragment = { __typename: 'EmailVariable' };

type ReferenceContent_ExternalLink_Fragment = (
  { __typename: 'ExternalLink' }
  & Pick<ExternalLink, 'id' | 'url'>
);

type ReferenceContent_Image_Fragment = (
  { __typename: 'Image' }
  & ImageResourceImageFragmentFragment
);

type ReferenceContent_ImageAsset_Fragment = (
  { __typename: 'ImageAsset' }
  & ImageAssetFragmentFragment
);

type ReferenceContent_ImageResource_Fragment = (
  { __typename: 'ImageResource' }
  & Pick<ImageResource, 'id' | 'title'>
  & { captionOptions?: Maybe<(
    { __typename?: 'CaptionOptions' }
    & Pick<CaptionOptions, 'caption'>
    & { references?: Maybe<Array<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
      { __typename: 'Page' }
      & Pick<Page, 'id' | 'type'>
      & { fields?: Maybe<Array<(
        { __typename: 'ProductField' }
        & Pick<ProductField, 'key'>
        & { product?: Maybe<(
          { __typename?: 'Product' }
          & ProductContentFragment
        )> }
      ) | { __typename?: 'JSONField' } | { __typename?: 'LinkField' } | { __typename?: 'MultipleLinkField' } | { __typename?: 'ReferenceField' } | { __typename?: 'RTEField' } | { __typename?: 'ObjectField' } | { __typename?: 'NavigationField' }>> }
    ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }>> }
  )>, overlayOptions?: Maybe<(
    { __typename?: 'OverlayOptions' }
    & Pick<OverlayOptions, 'icon' | 'caption' | 'position'>
  )> }
  & ImageResourceFragmentFragment
);

type ReferenceContent_Link_Fragment = (
  { __typename: 'Link' }
  & { image?: Maybe<(
    { __typename?: 'Image' }
    & Pick<Image, 'url'>
  )> }
);

type ReferenceContent_ModalTab_Fragment = { __typename: 'ModalTab' };

type ReferenceContent_Page_Fragment = (
  { __typename: 'Page' }
  & Pick<Page, 'id' | 'type' | 'title' | 'url'>
  & { brand?: Maybe<(
    { __typename?: 'Brand' }
    & Pick<Brand, 'id' | 'logo' | 'title'>
  )>, openGraph?: Maybe<(
    { __typename?: 'OpenGraph' }
    & OpenGraphContentFragment
  )>, fields?: Maybe<Array<(
    { __typename?: 'ProductField' }
    & Pick<ProductField, 'key'>
    & { product?: Maybe<(
      { __typename?: 'Product' }
      & ProductContentFragment
    )> }
  ) | { __typename?: 'JSONField' } | { __typename?: 'LinkField' } | { __typename?: 'MultipleLinkField' } | { __typename?: 'ReferenceField' } | { __typename?: 'RTEField' } | { __typename?: 'ObjectField' } | { __typename?: 'NavigationField' }>> }
);

type ReferenceContent_TileResource_Fragment = (
  { __typename: 'TileResource' }
  & Pick<TileResource, 'id' | 'title' | 'display' | 'header'>
  & { description?: Maybe<(
    { __typename?: 'RTEField' }
    & Pick<RteField, 'key' | 'value'>
    & { referencesWithKey?: Maybe<Array<(
      { __typename?: 'ReferenceWithKey' }
      & Pick<ReferenceWithKey, 'key'>
      & { reference?: Maybe<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | (
        { __typename?: 'ExternalLink' }
        & Pick<ExternalLink, 'url'>
      ) | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
        { __typename?: 'Page' }
        & Pick<Page, 'id' | 'type' | 'url'>
      ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }> }
    )>> }
  )>, button?: Maybe<(
    { __typename?: 'Button' }
    & Pick<Button, 'text'>
    & { link?: Maybe<(
      { __typename?: 'LinkField' }
      & Pick<LinkField, 'newTab' | 'url'>
    )> }
  )>, campaignTag?: Maybe<(
    { __typename: 'CampaignTag' }
    & { text?: Maybe<(
      { __typename: 'RTEField' }
      & Pick<RteField, 'key' | 'value'>
      & { referencesWithKey?: Maybe<Array<(
        { __typename?: 'ReferenceWithKey' }
        & Pick<ReferenceWithKey, 'key'>
        & { reference?: Maybe<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | (
          { __typename?: 'ExternalLink' }
          & Pick<ExternalLink, 'url'>
        ) | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
          { __typename?: 'Page' }
          & Pick<Page, 'id' | 'type' | 'url'>
        ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }> }
      )>> }
    )>, appearance?: Maybe<(
      { __typename: 'BlockAppearance' }
      & Pick<BlockAppearance, 'backgroundColor' | 'textColor'>
      & { asset?: Maybe<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | (
        { __typename?: 'Image' }
        & ImageResourceImageFragmentFragment
      ) | (
        { __typename?: 'ImageAsset' }
        & ImageAssetFragmentFragment
      ) | (
        { __typename?: 'ImageResource' }
        & ImageResourceFragmentFragment
      ) | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | { __typename?: 'Page' } | { __typename?: 'TileResource' } | (
        { __typename?: 'VideoResource' }
        & VideoResourceFragmentFragment
      ) | { __typename?: 'Wordbook' }> }
    )> }
  )>, references?: Maybe<Array<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | (
    { __typename?: 'Image' }
    & ImageResourceImageFragmentFragment
  ) | { __typename?: 'ImageAsset' } | (
    { __typename?: 'ImageResource' }
    & ImageResourceFragmentFragment
  ) | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | { __typename?: 'Page' } | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }>>, appearance?: Maybe<(
    { __typename?: 'BlockAppearance' }
    & Pick<BlockAppearance, 'backgroundColor' | 'textColor'>
    & { asset?: Maybe<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | (
      { __typename?: 'Image' }
      & ImageResourceImageFragmentFragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ImageAssetFragmentFragment
    ) | (
      { __typename?: 'ImageResource' }
      & ImageResourceFragmentFragment
    ) | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | { __typename?: 'Page' } | { __typename?: 'TileResource' } | (
      { __typename?: 'VideoResource' }
      & VideoResourceFragmentFragment
    ) | { __typename?: 'Wordbook' }> }
  )> }
);

type ReferenceContent_VideoResource_Fragment = (
  { __typename: 'VideoResource' }
  & Pick<VideoResource, 'id' | 'title'>
  & { captionOptions?: Maybe<(
    { __typename?: 'CaptionOptions' }
    & Pick<CaptionOptions, 'caption'>
    & { references?: Maybe<Array<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
      { __typename: 'Page' }
      & Pick<Page, 'id' | 'type'>
      & { fields?: Maybe<Array<(
        { __typename: 'ProductField' }
        & Pick<ProductField, 'key'>
        & { product?: Maybe<(
          { __typename?: 'Product' }
          & ProductContentFragment
        )> }
      ) | { __typename?: 'JSONField' } | { __typename?: 'LinkField' } | { __typename?: 'MultipleLinkField' } | { __typename?: 'ReferenceField' } | { __typename?: 'RTEField' } | { __typename?: 'ObjectField' } | { __typename?: 'NavigationField' }>> }
    ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }>> }
  )>, overlayOptions?: Maybe<(
    { __typename?: 'OverlayOptions' }
    & Pick<OverlayOptions, 'icon' | 'caption' | 'position'>
  )> }
  & VideoResourceFragmentFragment
);

type ReferenceContent_Wordbook_Fragment = { __typename: 'Wordbook' };

export type ReferenceContentFragment = ReferenceContent_DynamicVariable_Fragment | ReferenceContent_EmailVariable_Fragment | ReferenceContent_ExternalLink_Fragment | ReferenceContent_Image_Fragment | ReferenceContent_ImageAsset_Fragment | ReferenceContent_ImageResource_Fragment | ReferenceContent_Link_Fragment | ReferenceContent_ModalTab_Fragment | ReferenceContent_Page_Fragment | ReferenceContent_TileResource_Fragment | ReferenceContent_VideoResource_Fragment | ReferenceContent_Wordbook_Fragment;

export type PageSliderBlockFragment = (
  { __typename?: 'PageSliderBlock' }
  & Pick<PageSliderBlock, 'type' | 'showDescription'>
  & { references?: Maybe<Array<{ __typename: 'DynamicVariable' } | { __typename: 'EmailVariable' } | { __typename: 'ExternalLink' } | { __typename: 'Image' } | { __typename: 'ImageAsset' } | { __typename: 'ImageResource' } | { __typename: 'Link' } | { __typename: 'ModalTab' } | (
    { __typename: 'Page' }
    & Pick<Page, 'type' | 'id' | 'url'>
    & { brand?: Maybe<(
      { __typename?: 'Brand' }
      & Pick<Brand, 'id' | 'logo' | 'title'>
    )>, openGraph?: Maybe<(
      { __typename?: 'OpenGraph' }
      & Pick<OpenGraph, 'title' | 'description' | 'imageURL'>
    )> }
  ) | { __typename: 'TileResource' } | { __typename: 'VideoResource' } | { __typename: 'Wordbook' }>> }
);

export type ProductListBlockFacetValueFragmentFragment = (
  { __typename?: 'ProductListBlockFacetValue' }
  & Pick<ProductListBlockFacetValue, 'id' | 'key' | 'color'>
  & { name?: Maybe<(
    { __typename?: 'Wordbook' }
    & WordbookFragmentFragment
  )> }
);

export type ProductListBlockFragmentFragment = (
  { __typename?: 'ProductListBlock' }
  & Pick<ProductListBlock, 'header' | 'filters' | 'optionalFilters' | 'limit' | 'display' | 'boosts' | 'facets' | 'filter'>
  & { guidedFilters?: Maybe<Array<(
    { __typename: 'GuidedFilterAttributeEnum' }
    & Pick<GuidedFilterAttributeEnum, 'backgroundColor' | 'textColor' | 'priority' | 'component' | 'variant' | 'attribute' | 'parameter'>
    & { asset?: Maybe<(
      { __typename?: 'DynamicVariable' }
      & ReferenceContent_DynamicVariable_Fragment
    ) | (
      { __typename?: 'EmailVariable' }
      & ReferenceContent_EmailVariable_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & ReferenceContent_ExternalLink_Fragment
    ) | (
      { __typename?: 'Image' }
      & ReferenceContent_Image_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ReferenceContent_ImageAsset_Fragment
    ) | (
      { __typename?: 'ImageResource' }
      & ReferenceContent_ImageResource_Fragment
    ) | (
      { __typename?: 'Link' }
      & ReferenceContent_Link_Fragment
    ) | (
      { __typename?: 'ModalTab' }
      & ReferenceContent_ModalTab_Fragment
    ) | (
      { __typename?: 'Page' }
      & ReferenceContent_Page_Fragment
    ) | (
      { __typename?: 'TileResource' }
      & ReferenceContent_TileResource_Fragment
    ) | (
      { __typename?: 'VideoResource' }
      & ReferenceContent_VideoResource_Fragment
    ) | (
      { __typename?: 'Wordbook' }
      & ReferenceContent_Wordbook_Fragment
    )>, header?: Maybe<(
      { __typename?: 'Wordbook' }
      & Pick<Wordbook, 'value'>
    )>, text?: Maybe<(
      { __typename?: 'Wordbook' }
      & Pick<Wordbook, 'value'>
    )>, items?: Maybe<Array<(
      { __typename?: 'GuidedFilterAttributeEnumItem' }
      & Pick<GuidedFilterAttributeEnumItem, 'backgroundColor' | 'textColor' | 'priority' | 'key' | 'canonical'>
      & { asset?: Maybe<(
        { __typename?: 'DynamicVariable' }
        & ReferenceContent_DynamicVariable_Fragment
      ) | (
        { __typename?: 'EmailVariable' }
        & ReferenceContent_EmailVariable_Fragment
      ) | (
        { __typename?: 'ExternalLink' }
        & ReferenceContent_ExternalLink_Fragment
      ) | (
        { __typename?: 'Image' }
        & ReferenceContent_Image_Fragment
      ) | (
        { __typename?: 'ImageAsset' }
        & ReferenceContent_ImageAsset_Fragment
      ) | (
        { __typename?: 'ImageResource' }
        & ReferenceContent_ImageResource_Fragment
      ) | (
        { __typename?: 'Link' }
        & ReferenceContent_Link_Fragment
      ) | (
        { __typename?: 'ModalTab' }
        & ReferenceContent_ModalTab_Fragment
      ) | (
        { __typename?: 'Page' }
        & ReferenceContent_Page_Fragment
      ) | (
        { __typename?: 'TileResource' }
        & ReferenceContent_TileResource_Fragment
      ) | (
        { __typename?: 'VideoResource' }
        & ReferenceContent_VideoResource_Fragment
      ) | (
        { __typename?: 'Wordbook' }
        & ReferenceContent_Wordbook_Fragment
      )> }
    )>> }
  ) | (
    { __typename: 'GuidedFilterLinkResource' }
    & Pick<GuidedFilterLinkResource, 'backgroundColor' | 'textColor' | 'priority' | 'component' | 'variant'>
    & { asset?: Maybe<(
      { __typename?: 'DynamicVariable' }
      & ReferenceContent_DynamicVariable_Fragment
    ) | (
      { __typename?: 'EmailVariable' }
      & ReferenceContent_EmailVariable_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & ReferenceContent_ExternalLink_Fragment
    ) | (
      { __typename?: 'Image' }
      & ReferenceContent_Image_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ReferenceContent_ImageAsset_Fragment
    ) | (
      { __typename?: 'ImageResource' }
      & ReferenceContent_ImageResource_Fragment
    ) | (
      { __typename?: 'Link' }
      & ReferenceContent_Link_Fragment
    ) | (
      { __typename?: 'ModalTab' }
      & ReferenceContent_ModalTab_Fragment
    ) | (
      { __typename?: 'Page' }
      & ReferenceContent_Page_Fragment
    ) | (
      { __typename?: 'TileResource' }
      & ReferenceContent_TileResource_Fragment
    ) | (
      { __typename?: 'VideoResource' }
      & ReferenceContent_VideoResource_Fragment
    ) | (
      { __typename?: 'Wordbook' }
      & ReferenceContent_Wordbook_Fragment
    )>, header?: Maybe<(
      { __typename?: 'Wordbook' }
      & Pick<Wordbook, 'value'>
    )>, text?: Maybe<(
      { __typename?: 'Wordbook' }
      & Pick<Wordbook, 'value'>
    )>, items?: Maybe<Array<(
      { __typename?: 'GuidedFilterLinkResourceItem' }
      & Pick<GuidedFilterLinkResourceItem, 'backgroundColor' | 'textColor' | 'priority'>
      & { link?: Maybe<(
        { __typename?: 'Link' }
        & BlockLinkFragmentFragment
      )> }
    )>> }
  )>>, topLinks?: Maybe<Array<(
    { __typename?: 'Link' }
    & Pick<Link, 'id' | 'url' | 'newTab' | 'queryParameters'>
    & { image?: Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>, imageMobile?: Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )>, references?: Maybe<Array<{ __typename?: 'DynamicVariable' } | { __typename?: 'EmailVariable' } | { __typename?: 'ExternalLink' } | { __typename?: 'Image' } | { __typename?: 'ImageAsset' } | { __typename?: 'ImageResource' } | { __typename?: 'Link' } | { __typename?: 'ModalTab' } | (
      { __typename?: 'Page' }
      & Pick<Page, 'id' | 'type' | 'title'>
    ) | { __typename?: 'TileResource' } | { __typename?: 'VideoResource' } | { __typename?: 'Wordbook' }>> }
  )>>, looks?: Maybe<Array<(
    { __typename?: 'LookTile' }
    & Pick<LookTile, 'id' | 'ambassadorHandle'>
    & { asset?: Maybe<(
      { __typename?: 'DynamicVariable' }
      & ReferenceContent_DynamicVariable_Fragment
    ) | (
      { __typename?: 'EmailVariable' }
      & ReferenceContent_EmailVariable_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & ReferenceContent_ExternalLink_Fragment
    ) | (
      { __typename?: 'Image' }
      & ReferenceContent_Image_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ReferenceContent_ImageAsset_Fragment
    ) | (
      { __typename?: 'ImageResource' }
      & ReferenceContent_ImageResource_Fragment
    ) | (
      { __typename?: 'Link' }
      & ReferenceContent_Link_Fragment
    ) | (
      { __typename?: 'ModalTab' }
      & ReferenceContent_ModalTab_Fragment
    ) | (
      { __typename?: 'Page' }
      & ReferenceContent_Page_Fragment
    ) | (
      { __typename?: 'TileResource' }
      & ReferenceContent_TileResource_Fragment
    ) | (
      { __typename?: 'VideoResource' }
      & ReferenceContent_VideoResource_Fragment
    ) | (
      { __typename?: 'Wordbook' }
      & ReferenceContent_Wordbook_Fragment
    )>, products?: Maybe<Array<(
      { __typename?: 'LookProduct' }
      & Pick<LookProduct, 'productID' | 'x' | 'y'>
    )>> }
  )>>, description?: Maybe<(
    { __typename?: 'RTEField' }
    & BlockRteFieldFragmentFragment
  )>, facetConfig?: Maybe<Array<(
    { __typename?: 'ProductListBlockFacet' }
    & Pick<ProductListBlockFacet, 'id' | 'key' | 'parameter' | 'type' | 'facetDescriptionIDs'>
    & { name?: Maybe<(
      { __typename?: 'Wordbook' }
      & Pick<Wordbook, 'defaults'>
    )>, facetDescriptionButton?: Maybe<(
      { __typename?: 'Wordbook' }
      & WordbookFragmentFragment
    )>, values?: Maybe<Array<(
      { __typename?: 'ProductListBlockFacetValue' }
      & ProductListBlockFacetValueFragmentFragment
    )>>, groups?: Maybe<Array<(
      { __typename?: 'ProductListBlockFacetGroup' }
      & Pick<ProductListBlockFacetGroup, 'id' | 'key'>
      & { name?: Maybe<(
        { __typename?: 'Wordbook' }
        & WordbookFragmentFragment
      )>, values?: Maybe<Array<(
        { __typename?: 'ProductListBlockFacetValue' }
        & ProductListBlockFacetValueFragmentFragment
      )>> }
    )>> }
  )>> }
);

export type CustomersGlobalsQueryQueryVariables = Exact<{
  email?: Maybe<Scalars['String']>;
}>;


export type CustomersGlobalsQueryQuery = (
  { __typename?: 'Query' }
  & { customer?: Maybe<(
    { __typename?: 'Customer' }
    & Pick<Customer, 'id'>
  )> }
);

export type GlobalFacetDescriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalFacetDescriptionsQuery = (
  { __typename?: 'Query' }
  & { facetDescriptions?: Maybe<Array<(
    { __typename?: 'FacetDescription' }
    & Pick<FacetDescription, 'id' | 'facet' | 'facetGroup'>
  )>> }
);

type InjectionSelectorFragment_InjectionSelectorPages_Fragment = (
  { __typename: 'InjectionSelectorPages' }
  & { pages?: Maybe<Array<(
    { __typename?: 'Page' }
    & Pick<Page, 'type' | 'id'>
  )>> }
);

type InjectionSelectorFragment_InjectionSelectorPageTypes_Fragment = (
  { __typename: 'InjectionSelectorPageTypes' }
  & Pick<InjectionSelectorPageTypes, 'types'>
);

type InjectionSelectorFragment_InjectionSelectorProductData_Fragment = (
  { __typename: 'InjectionSelectorProductData' }
  & Pick<InjectionSelectorProductData, 'brands' | 'categoryIDs' | 'collections' | 'primaryMaterials' | 'productTypes'>
);

export type InjectionSelectorFragmentFragment = InjectionSelectorFragment_InjectionSelectorPages_Fragment | InjectionSelectorFragment_InjectionSelectorPageTypes_Fragment | InjectionSelectorFragment_InjectionSelectorProductData_Fragment;

type InjectionPlacementFragment_InjectionPlacementBlocks_Fragment = (
  { __typename: 'InjectionPlacementBlocks' }
  & { blocks?: Maybe<Array<(
    { __typename?: 'Block' }
    & BlockContent_Block_Fragment
  ) | (
    { __typename?: 'AccordionListBlock' }
    & BlockContent_AccordionListBlock_Fragment
  ) | (
    { __typename?: 'ActiveCampaignBlock' }
    & BlockContent_ActiveCampaignBlock_Fragment
  ) | (
    { __typename?: 'GalleryBlock' }
    & BlockContent_GalleryBlock_Fragment
  ) | (
    { __typename?: 'GlobalBlock' }
    & BlockContent_GlobalBlock_Fragment
  ) | (
    { __typename?: 'HTMLBlock' }
    & BlockContent_HtmlBlock_Fragment
  ) | (
    { __typename?: 'InfoPanelBlock' }
    & BlockContent_InfoPanelBlock_Fragment
  ) | (
    { __typename?: 'LookDisplayBlock' }
    & BlockContent_LookDisplayBlock_Fragment
  ) | (
    { __typename?: 'LookListBlock' }
    & BlockContent_LookListBlock_Fragment
  ) | (
    { __typename?: 'PageGridBlock' }
    & BlockContent_PageGridBlock_Fragment
  ) | (
    { __typename?: 'PageSliderBlock' }
    & BlockContent_PageSliderBlock_Fragment
  ) | (
    { __typename?: 'ProductGridSelectorBlock' }
    & BlockContent_ProductGridSelectorBlock_Fragment
  ) | (
    { __typename?: 'ProductListBlock' }
    & BlockContent_ProductListBlock_Fragment
  ) | (
    { __typename?: 'ProductSliderBlock' }
    & BlockContent_ProductSliderBlock_Fragment
  ) | (
    { __typename?: 'USPBlock' }
    & BlockContent_UspBlock_Fragment
  )>> }
);

type InjectionPlacementFragment_InjectionPlacementBlockTypes_Fragment = (
  { __typename: 'InjectionPlacementBlockTypes' }
  & Pick<InjectionPlacementBlockTypes, 'types'>
);

type InjectionPlacementFragment_InjectionPlacementGlobal_Fragment = (
  { __typename: 'InjectionPlacementGlobal' }
  & Pick<InjectionPlacementGlobal, 'global'>
);

type InjectionPlacementFragment_InjectionPlacementPosition_Fragment = (
  { __typename: 'InjectionPlacementPosition' }
  & Pick<InjectionPlacementPosition, 'position'>
);

export type InjectionPlacementFragmentFragment = InjectionPlacementFragment_InjectionPlacementBlocks_Fragment | InjectionPlacementFragment_InjectionPlacementBlockTypes_Fragment | InjectionPlacementFragment_InjectionPlacementGlobal_Fragment | InjectionPlacementFragment_InjectionPlacementPosition_Fragment;

export type GlobalInjectionsQueryVariables = Exact<{
  boost?: Maybe<Scalars['ID']>;
}>;


export type GlobalInjectionsQuery = (
  { __typename?: 'Query' }
  & { injections?: Maybe<Array<(
    { __typename: 'AnchorInjection' }
    & Pick<AnchorInjection, 'id'>
    & { selector?: Maybe<(
      { __typename?: 'InjectionSelectorPages' }
      & InjectionSelectorFragment_InjectionSelectorPages_Fragment
    ) | (
      { __typename?: 'InjectionSelectorPageTypes' }
      & InjectionSelectorFragment_InjectionSelectorPageTypes_Fragment
    ) | (
      { __typename?: 'InjectionSelectorProductData' }
      & InjectionSelectorFragment_InjectionSelectorProductData_Fragment
    )>, placement?: Maybe<(
      { __typename?: 'InjectionPlacementBlocks' }
      & InjectionPlacementFragment_InjectionPlacementBlocks_Fragment
    ) | (
      { __typename?: 'InjectionPlacementBlockTypes' }
      & InjectionPlacementFragment_InjectionPlacementBlockTypes_Fragment
    ) | (
      { __typename?: 'InjectionPlacementGlobal' }
      & InjectionPlacementFragment_InjectionPlacementGlobal_Fragment
    ) | (
      { __typename?: 'InjectionPlacementPosition' }
      & InjectionPlacementFragment_InjectionPlacementPosition_Fragment
    )>, items?: Maybe<Array<(
      { __typename: 'InjectionTypeAnchor' }
      & Pick<InjectionTypeAnchor, 'id' | 'anchor'>
      & { blocks?: Maybe<Array<(
        { __typename?: 'Block' }
        & BlockContent_Block_Fragment
      ) | (
        { __typename?: 'AccordionListBlock' }
        & BlockContent_AccordionListBlock_Fragment
      ) | (
        { __typename?: 'ActiveCampaignBlock' }
        & BlockContent_ActiveCampaignBlock_Fragment
      ) | (
        { __typename?: 'GalleryBlock' }
        & BlockContent_GalleryBlock_Fragment
      ) | (
        { __typename?: 'GlobalBlock' }
        & BlockContent_GlobalBlock_Fragment
      ) | (
        { __typename?: 'HTMLBlock' }
        & BlockContent_HtmlBlock_Fragment
      ) | (
        { __typename?: 'InfoPanelBlock' }
        & BlockContent_InfoPanelBlock_Fragment
      ) | (
        { __typename?: 'LookDisplayBlock' }
        & BlockContent_LookDisplayBlock_Fragment
      ) | (
        { __typename?: 'LookListBlock' }
        & BlockContent_LookListBlock_Fragment
      ) | (
        { __typename?: 'PageGridBlock' }
        & BlockContent_PageGridBlock_Fragment
      ) | (
        { __typename?: 'PageSliderBlock' }
        & BlockContent_PageSliderBlock_Fragment
      ) | (
        { __typename?: 'ProductGridSelectorBlock' }
        & BlockContent_ProductGridSelectorBlock_Fragment
      ) | (
        { __typename?: 'ProductListBlock' }
        & BlockContent_ProductListBlock_Fragment
      ) | (
        { __typename?: 'ProductSliderBlock' }
        & BlockContent_ProductSliderBlock_Fragment
      ) | (
        { __typename?: 'USPBlock' }
        & BlockContent_UspBlock_Fragment
      )>> }
    ) | (
      { __typename: 'InjectionTypeGrid' }
      & Pick<InjectionTypeGrid, 'id'>
      & { dimensions?: Maybe<Array<(
        { __typename?: 'InjectionTypeGridDimensions' }
        & Pick<InjectionTypeGridDimensions, 'columns' | 'x' | 'y' | 'width' | 'height'>
      )>>, blocks?: Maybe<Array<(
        { __typename?: 'Block' }
        & BlockContent_Block_Fragment
      ) | (
        { __typename?: 'AccordionListBlock' }
        & BlockContent_AccordionListBlock_Fragment
      ) | (
        { __typename?: 'ActiveCampaignBlock' }
        & BlockContent_ActiveCampaignBlock_Fragment
      ) | (
        { __typename?: 'GalleryBlock' }
        & BlockContent_GalleryBlock_Fragment
      ) | (
        { __typename?: 'GlobalBlock' }
        & BlockContent_GlobalBlock_Fragment
      ) | (
        { __typename?: 'HTMLBlock' }
        & BlockContent_HtmlBlock_Fragment
      ) | (
        { __typename?: 'InfoPanelBlock' }
        & BlockContent_InfoPanelBlock_Fragment
      ) | (
        { __typename?: 'LookDisplayBlock' }
        & BlockContent_LookDisplayBlock_Fragment
      ) | (
        { __typename?: 'LookListBlock' }
        & BlockContent_LookListBlock_Fragment
      ) | (
        { __typename?: 'PageGridBlock' }
        & BlockContent_PageGridBlock_Fragment
      ) | (
        { __typename?: 'PageSliderBlock' }
        & BlockContent_PageSliderBlock_Fragment
      ) | (
        { __typename?: 'ProductGridSelectorBlock' }
        & BlockContent_ProductGridSelectorBlock_Fragment
      ) | (
        { __typename?: 'ProductListBlock' }
        & BlockContent_ProductListBlock_Fragment
      ) | (
        { __typename?: 'ProductSliderBlock' }
        & BlockContent_ProductSliderBlock_Fragment
      ) | (
        { __typename?: 'USPBlock' }
        & BlockContent_UspBlock_Fragment
      )>> }
    )>>, splitTest?: Maybe<(
      { __typename?: 'SplitTest' }
      & Pick<SplitTest, 'test' | 'groups'>
    )> }
  ) | (
    { __typename: 'BlockInjection' }
    & Pick<BlockInjection, 'id' | 'placementModifier' | 'placementOccurrences' | 'priority'>
    & { selector?: Maybe<(
      { __typename?: 'InjectionSelectorPages' }
      & InjectionSelectorFragment_InjectionSelectorPages_Fragment
    ) | (
      { __typename?: 'InjectionSelectorPageTypes' }
      & InjectionSelectorFragment_InjectionSelectorPageTypes_Fragment
    ) | (
      { __typename?: 'InjectionSelectorProductData' }
      & InjectionSelectorFragment_InjectionSelectorProductData_Fragment
    )>, blocks?: Maybe<Array<(
      { __typename?: 'Block' }
      & BlockContent_Block_Fragment
    ) | (
      { __typename?: 'AccordionListBlock' }
      & BlockContent_AccordionListBlock_Fragment
    ) | (
      { __typename?: 'ActiveCampaignBlock' }
      & BlockContent_ActiveCampaignBlock_Fragment
    ) | (
      { __typename?: 'GalleryBlock' }
      & BlockContent_GalleryBlock_Fragment
    ) | (
      { __typename?: 'GlobalBlock' }
      & BlockContent_GlobalBlock_Fragment
    ) | (
      { __typename?: 'HTMLBlock' }
      & BlockContent_HtmlBlock_Fragment
    ) | (
      { __typename?: 'InfoPanelBlock' }
      & BlockContent_InfoPanelBlock_Fragment
    ) | (
      { __typename?: 'LookDisplayBlock' }
      & BlockContent_LookDisplayBlock_Fragment
    ) | (
      { __typename?: 'LookListBlock' }
      & BlockContent_LookListBlock_Fragment
    ) | (
      { __typename?: 'PageGridBlock' }
      & BlockContent_PageGridBlock_Fragment
    ) | (
      { __typename?: 'PageSliderBlock' }
      & BlockContent_PageSliderBlock_Fragment
    ) | (
      { __typename?: 'ProductGridSelectorBlock' }
      & BlockContent_ProductGridSelectorBlock_Fragment
    ) | (
      { __typename?: 'ProductListBlock' }
      & BlockContent_ProductListBlock_Fragment
    ) | (
      { __typename?: 'ProductSliderBlock' }
      & BlockContent_ProductSliderBlock_Fragment
    ) | (
      { __typename?: 'USPBlock' }
      & BlockContent_UspBlock_Fragment
    )>>, placement?: Maybe<(
      { __typename?: 'InjectionPlacementBlocks' }
      & InjectionPlacementFragment_InjectionPlacementBlocks_Fragment
    ) | (
      { __typename?: 'InjectionPlacementBlockTypes' }
      & InjectionPlacementFragment_InjectionPlacementBlockTypes_Fragment
    ) | (
      { __typename?: 'InjectionPlacementGlobal' }
      & InjectionPlacementFragment_InjectionPlacementGlobal_Fragment
    ) | (
      { __typename?: 'InjectionPlacementPosition' }
      & InjectionPlacementFragment_InjectionPlacementPosition_Fragment
    )>, splitTest?: Maybe<(
      { __typename?: 'SplitTest' }
      & Pick<SplitTest, 'test' | 'groups'>
    )> }
  )>> }
);

export type SubscribeToNewsletterMutationVariables = Exact<{
  email: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  campaign?: Maybe<Scalars['String']>;
}>;


export type SubscribeToNewsletterMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'subscribeToNewsletter'>
);

export type GlobalPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalPaymentMethodsQuery = (
  { __typename?: 'Query' }
  & { paymentMethods?: Maybe<Array<(
    { __typename?: 'PaymentMethod' }
    & Pick<PaymentMethod, 'provider' | 'type'>
    & { icons?: Maybe<Array<(
      { __typename?: 'PaymentMethodIcon' }
      & Pick<PaymentMethodIcon, 'name'>
      & { logo?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'tags' | 'url'>
        & { dimensions?: Maybe<(
          { __typename?: 'Dimensions' }
          & Pick<Dimensions, 'width' | 'height'>
        )> }
      )> }
    )>>, logo?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'tags' | 'url'>
      & { dimensions?: Maybe<(
        { __typename?: 'Dimensions' }
        & Pick<Dimensions, 'width' | 'height'>
      )> }
    )> }
  )>> }
);

export type ProductAnalyticsQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type ProductAnalyticsQuery = (
  { __typename?: 'Query' }
  & { product?: Maybe<(
    { __typename?: 'Product' }
    & Pick<Product, 'id' | 'categoryIDs'>
    & { brand?: Maybe<(
      { __typename?: 'Brand' }
      & Pick<Brand, 'title'>
    )>, primaryCategories?: Maybe<Array<(
      { __typename?: 'Category' }
      & Pick<Category, 'id' | 'name'>
    )>>, masterVariant?: Maybe<(
      { __typename?: 'ProductVariant' }
      & { isNew?: Maybe<(
        { __typename: 'BaseAttribute' }
        & Pick<BaseAttribute, 'value'>
      ) | { __typename: 'MoneyAttribute' } | { __typename: 'ProductAttribute' } | { __typename: 'ProductsWithQuantityAttribute' }>, price?: Maybe<(
        { __typename?: 'Price' }
        & { discount?: Maybe<(
          { __typename?: 'PriceDiscount' }
          & Pick<PriceDiscount, 'value'>
        )> }
      )> }
    )>, videoAsset?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )> }
  )> }
);

export type SubscribeToBackInStockMutationVariables = Exact<{
  productID: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
}>;


export type SubscribeToBackInStockMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'subscribeToBackInStock'>
);

type ProductPageTacticFragment_TacticActiveCampaign_Fragment = { __typename: 'TacticActiveCampaign' };

type ProductPageTacticFragment_TacticAssortmentLadder_Fragment = (
  { __typename: 'TacticAssortmentLadder' }
  & Pick<TacticAssortmentLadder, 'id'>
  & { items?: Maybe<Array<(
    { __typename?: 'TacticAssortmentLadderItem' }
    & Pick<TacticAssortmentLadderItem, 'id' | 'iconURL'>
    & { header?: Maybe<(
      { __typename?: 'Wordbook' }
      & WordbookFragmentFragment
    )>, text?: Maybe<(
      { __typename?: 'Wordbook' }
      & WordbookFragmentFragment
    )> }
  )>> }
);

type ProductPageTacticFragment_TacticBlocks_Fragment = (
  { __typename: 'TacticBlocks' }
  & Pick<TacticBlocks, 'id'>
  & { blocks?: Maybe<Array<(
    { __typename?: 'Block' }
    & BlockContent_Block_Fragment
  ) | (
    { __typename?: 'AccordionListBlock' }
    & BlockContent_AccordionListBlock_Fragment
  ) | (
    { __typename?: 'ActiveCampaignBlock' }
    & BlockContent_ActiveCampaignBlock_Fragment
  ) | (
    { __typename?: 'GalleryBlock' }
    & BlockContent_GalleryBlock_Fragment
  ) | (
    { __typename?: 'GlobalBlock' }
    & BlockContent_GlobalBlock_Fragment
  ) | (
    { __typename?: 'HTMLBlock' }
    & BlockContent_HtmlBlock_Fragment
  ) | (
    { __typename?: 'InfoPanelBlock' }
    & BlockContent_InfoPanelBlock_Fragment
  ) | (
    { __typename?: 'LookDisplayBlock' }
    & BlockContent_LookDisplayBlock_Fragment
  ) | (
    { __typename?: 'LookListBlock' }
    & BlockContent_LookListBlock_Fragment
  ) | (
    { __typename?: 'PageGridBlock' }
    & BlockContent_PageGridBlock_Fragment
  ) | (
    { __typename?: 'PageSliderBlock' }
    & BlockContent_PageSliderBlock_Fragment
  ) | (
    { __typename?: 'ProductGridSelectorBlock' }
    & BlockContent_ProductGridSelectorBlock_Fragment
  ) | (
    { __typename?: 'ProductListBlock' }
    & BlockContent_ProductListBlock_Fragment
  ) | (
    { __typename?: 'ProductSliderBlock' }
    & BlockContent_ProductSliderBlock_Fragment
  ) | (
    { __typename?: 'USPBlock' }
    & BlockContent_UspBlock_Fragment
  )>> }
);

type ProductPageTacticFragment_TacticBuildYourDiscount_Fragment = (
  { __typename: 'TacticBuildYourDiscount' }
  & Pick<TacticBuildYourDiscount, 'id'>
  & { products?: Maybe<Array<(
    { __typename?: 'Product' }
    & Pick<Product, 'id' | 'name' | 'url'>
    & { primaryAsset?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )>, variants?: Maybe<Array<(
      { __typename?: 'ProductVariant' }
      & Pick<ProductVariant, 'id'>
    )>> }
  )>>, items?: Maybe<Array<(
    { __typename?: 'TacticBuildYourDiscountItem' }
    & { price: (
      { __typename?: 'Price' }
      & PriceFragmentFragment
    ), offers?: Maybe<Array<(
      { __typename?: 'TacticBuildYourDiscountItemOffer' }
      & Pick<TacticBuildYourDiscountItemOffer, 'productID'>
      & { offer: (
        { __typename?: 'AddToCartProductTactic' }
        & AddToCartProductTacticFragmentFragment
      ) }
    )>> }
  )>> }
);

type ProductPageTacticFragment_TacticBundleInfo_Fragment = (
  { __typename: 'TacticBundleInfo' }
  & Pick<TacticBundleInfo, 'id' | 'settings'>
  & { bundlePrice?: Maybe<(
    { __typename?: 'AttributePrice' }
    & { difference?: Maybe<(
      { __typename?: 'Money' }
      & MoneyContent_Money_Fragment
    )>, originalPrice?: Maybe<(
      { __typename?: 'Money' }
      & MoneyContent_Money_Fragment
    )>, price?: Maybe<(
      { __typename?: 'Money' }
      & MoneyContent_Money_Fragment
    )> }
  )>, bundleProducts?: Maybe<Array<(
    { __typename?: 'ProductWithQuantity' }
    & Pick<ProductWithQuantity, 'quantity' | 'productID'>
    & { product?: Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'id' | 'name' | 'type' | 'url'>
      & { image?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
        & { dimensions?: Maybe<(
          { __typename?: 'Dimensions' }
          & Pick<Dimensions, 'width' | 'height'>
        )> }
      )>, masterVariant?: Maybe<(
        { __typename?: 'ProductVariant' }
        & Pick<ProductVariant, 'id'>
        & { price?: Maybe<(
          { __typename?: 'Price' }
          & PriceFragmentFragment
        )> }
      )> }
      & ProductSpecificationFragmentFragment
    )> }
  )>> }
);

type ProductPageTacticFragment_TacticComplementaryProducts_Fragment = (
  { __typename: 'TacticComplementaryProducts' }
  & Pick<TacticComplementaryProducts, 'id'>
  & { products?: Maybe<Array<(
    { __typename?: 'Product' }
    & ProductCrossSellAndPersonalizationContentFragment
  )>> }
);

type ProductPageTacticFragment_TacticLinkedProductsColor_Fragment = (
  { __typename: 'TacticLinkedProductsColor' }
  & Pick<TacticLinkedProductsColor, 'id'>
  & { color?: Maybe<(
    { __typename?: 'TacticLinkedProductsGroup' }
    & Pick<TacticLinkedProductsGroup, 'type'>
    & { products?: Maybe<Array<(
      { __typename?: 'Product' }
      & ProductCrossSellAndPersonalizationContentFragment
    )>> }
  )> }
);

type ProductPageTacticFragment_TacticLinkedProductsSizeAndVariation_Fragment = (
  { __typename: 'TacticLinkedProductsSizeAndVariation' }
  & Pick<TacticLinkedProductsSizeAndVariation, 'id'>
  & { size?: Maybe<(
    { __typename?: 'TacticLinkedProductsGroup' }
    & Pick<TacticLinkedProductsGroup, 'type'>
    & { products?: Maybe<Array<(
      { __typename?: 'Product' }
      & ProductCrossSellAndPersonalizationContentFragment
    )>> }
  )>, variation?: Maybe<(
    { __typename?: 'TacticLinkedProductsGroup' }
    & Pick<TacticLinkedProductsGroup, 'type'>
    & { products?: Maybe<Array<(
      { __typename?: 'Product' }
      & ProductCrossSellAndPersonalizationContentFragment
    )>> }
  )> }
);

type ProductPageTacticFragment_TacticLooks_Fragment = (
  { __typename: 'TacticLooks' }
  & Pick<TacticLooks, 'id' | 'settings'>
  & { looks?: Maybe<Array<(
    { __typename?: 'LookTile' }
    & Pick<LookTile, 'id' | 'ambassadorHandle'>
    & { asset?: Maybe<(
      { __typename?: 'DynamicVariable' }
      & ReferenceContent_DynamicVariable_Fragment
    ) | (
      { __typename?: 'EmailVariable' }
      & ReferenceContent_EmailVariable_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & ReferenceContent_ExternalLink_Fragment
    ) | (
      { __typename?: 'Image' }
      & ReferenceContent_Image_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ReferenceContent_ImageAsset_Fragment
    ) | (
      { __typename?: 'ImageResource' }
      & ReferenceContent_ImageResource_Fragment
    ) | (
      { __typename?: 'Link' }
      & ReferenceContent_Link_Fragment
    ) | (
      { __typename?: 'ModalTab' }
      & ReferenceContent_ModalTab_Fragment
    ) | (
      { __typename?: 'Page' }
      & ReferenceContent_Page_Fragment
    ) | (
      { __typename?: 'TileResource' }
      & ReferenceContent_TileResource_Fragment
    ) | (
      { __typename?: 'VideoResource' }
      & ReferenceContent_VideoResource_Fragment
    ) | (
      { __typename?: 'Wordbook' }
      & ReferenceContent_Wordbook_Fragment
    )>, products?: Maybe<Array<(
      { __typename?: 'LookProduct' }
      & Pick<LookProduct, 'productID' | 'x' | 'y'>
    )>> }
  )>>, title?: Maybe<(
    { __typename?: 'Wordbook' }
    & WordbookFragmentFragment
  )> }
);

type ProductPageTacticFragment_TacticMatchingVariant_Fragment = (
  { __typename: 'TacticMatchingVariant' }
  & Pick<TacticMatchingVariant, 'id' | 'type' | 'productID'>
  & { title?: Maybe<(
    { __typename?: 'Wordbook' }
    & WordbookFragmentFragment
  )>, tag?: Maybe<(
    { __typename?: 'Wordbook' }
    & WordbookFragmentFragment
  )>, offer?: Maybe<(
    { __typename?: 'AddToCartProductTactic' }
    & AddToCartProductTacticFragmentFragment
  )>, productHeader?: Maybe<(
    { __typename?: 'Wordbook' }
    & WordbookFragmentFragment
  )>, product?: Maybe<(
    { __typename?: 'Product' }
    & Pick<Product, 'id' | 'name' | 'url'>
    & { primaryAsset?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )>, masterVariant?: Maybe<(
      { __typename?: 'ProductVariant' }
      & { price?: Maybe<(
        { __typename?: 'Price' }
        & Pick<Price, 'currencyCode' | 'value' | 'format'>
        & { discount?: Maybe<(
          { __typename?: 'PriceDiscount' }
          & Pick<PriceDiscount, 'currencyCode' | 'percent' | 'value' | 'format'>
        )> }
      )> }
    )> }
  )> }
);

type ProductPageTacticFragment_TacticOthersBought_Fragment = (
  { __typename: 'TacticOthersBought' }
  & Pick<TacticOthersBought, 'id'>
  & TacticRecommendationsFragment_TacticOthersBought_Fragment
);

type ProductPageTacticFragment_TacticOthersBoughtGrid_Fragment = (
  { __typename: 'TacticOthersBoughtGrid' }
  & Pick<TacticOthersBoughtGrid, 'id'>
  & TacticRecommendationsFragment_TacticOthersBoughtGrid_Fragment
);

type ProductPageTacticFragment_TacticRecommendedForYou_Fragment = (
  { __typename: 'TacticRecommendedForYou' }
  & Pick<TacticRecommendedForYou, 'id'>
  & TacticRecommendationsFragment_TacticRecommendedForYou_Fragment
);

type ProductPageTacticFragment_TacticRelatedProducts_Fragment = (
  { __typename: 'TacticRelatedProducts' }
  & Pick<TacticRelatedProducts, 'id'>
  & { products?: Maybe<Array<(
    { __typename?: 'Product' }
    & ProductCrossSellAndPersonalizationContentFragment
  )>> }
);

type ProductPageTacticFragment_TacticRelativeDiscount_Fragment = (
  { __typename: 'TacticRelativeDiscount' }
  & Pick<TacticRelativeDiscount, 'id' | 'productIDs'>
  & { products?: Maybe<Array<(
    { __typename?: 'Product' }
    & Pick<Product, 'id' | 'name'>
    & { primaryAsset?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )> }
  )>>, relativeDiscounts?: Maybe<Array<(
    { __typename?: 'TacticRelativeDiscountItem' }
    & Pick<TacticRelativeDiscountItem, 'quantity' | 'percentage'>
    & { price?: Maybe<(
      { __typename?: 'Price' }
      & Pick<Price, 'format' | 'value'>
      & { discount?: Maybe<(
        { __typename?: 'PriceDiscount' }
        & Pick<PriceDiscount, 'format' | 'value'>
      )> }
    )> }
  )>> }
);

type ProductPageTacticFragment_TacticSimilarProducts_Fragment = (
  { __typename: 'TacticSimilarProducts' }
  & Pick<TacticSimilarProducts, 'id'>
  & { products?: Maybe<Array<(
    { __typename?: 'Product' }
    & ProductCrossSellAndPersonalizationContentFragment
  )>> }
);

type ProductPageTacticFragment_TacticUpgradeWith_Fragment = (
  { __typename: 'TacticUpgradeWith' }
  & Pick<TacticUpgradeWith, 'id'>
  & { items?: Maybe<Array<(
    { __typename?: 'TacticUpgradeWithItem' }
    & Pick<TacticUpgradeWithItem, 'type'>
    & { product?: Maybe<(
      { __typename?: 'Product' }
      & ProductCrossSellAndPersonalizationContentFragment
    )> }
  )>> }
);

export type ProductPageTacticFragmentFragment = ProductPageTacticFragment_TacticActiveCampaign_Fragment | ProductPageTacticFragment_TacticAssortmentLadder_Fragment | ProductPageTacticFragment_TacticBlocks_Fragment | ProductPageTacticFragment_TacticBuildYourDiscount_Fragment | ProductPageTacticFragment_TacticBundleInfo_Fragment | ProductPageTacticFragment_TacticComplementaryProducts_Fragment | ProductPageTacticFragment_TacticLinkedProductsColor_Fragment | ProductPageTacticFragment_TacticLinkedProductsSizeAndVariation_Fragment | ProductPageTacticFragment_TacticLooks_Fragment | ProductPageTacticFragment_TacticMatchingVariant_Fragment | ProductPageTacticFragment_TacticOthersBought_Fragment | ProductPageTacticFragment_TacticOthersBoughtGrid_Fragment | ProductPageTacticFragment_TacticRecommendedForYou_Fragment | ProductPageTacticFragment_TacticRelatedProducts_Fragment | ProductPageTacticFragment_TacticRelativeDiscount_Fragment | ProductPageTacticFragment_TacticSimilarProducts_Fragment | ProductPageTacticFragment_TacticUpgradeWith_Fragment;

export type ProductTileFragment = (
  { __typename?: 'Product' }
  & Pick<Product, 'id' | 'name' | 'url'>
  & { primaryAsset?: Maybe<(
    { __typename?: 'Asset' }
    & Pick<Asset, 'url'>
  )>, masterVariant?: Maybe<(
    { __typename?: 'ProductVariant' }
    & { price?: Maybe<(
      { __typename?: 'Price' }
      & PriceFragmentFragment
    )> }
  )> }
);

type RecommendationContent_AddToCartPromptSuccess_Fragment = (
  { __typename?: 'AddToCartPromptSuccess' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'placement' | 'type' | 'title' | 'productIDs'>
    & { splitTest?: Maybe<(
      { __typename?: 'SplitTest' }
      & Pick<SplitTest, 'test' | 'groups'>
    )>, products?: Maybe<Array<(
      { __typename?: 'Product' }
      & Pick<Product, 'url' | 'name' | 'type' | 'id'>
      & { availability?: Maybe<(
        { __typename?: 'Availability' }
        & Pick<Availability, 'isInStock' | 'quantity'>
      )>, primaryAsset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, asset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, brand?: Maybe<(
        { __typename?: 'Brand' }
        & Pick<Brand, 'title'>
      )>, masterVariant?: Maybe<(
        { __typename?: 'ProductVariant' }
        & { type?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, personalizations?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
          { __typename?: 'ProductAttribute' }
          & { products?: Maybe<Array<(
            { __typename?: 'Product' }
            & ProductCrossSellAndPersonalizationContentFragment
          )>> }
        ) | { __typename?: 'ProductsWithQuantityAttribute' }>, shortName?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, maxCharacters?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, price?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'countryCode' | 'currencyCode' | 'value' | 'format'>
          & { discount?: Maybe<(
            { __typename?: 'PriceDiscount' }
            & Pick<PriceDiscount, 'currencyCode' | 'percent' | 'value' | 'format'>
            & { code?: Maybe<(
              { __typename?: 'DiscountCode' }
              & Pick<DiscountCode, 'id' | 'context'>
            )> }
          )> }
        )> }
      )> }
    )>> }
  )>> }
);

type RecommendationContent_Cart_Fragment = (
  { __typename?: 'Cart' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'placement' | 'type' | 'title' | 'productIDs'>
    & { splitTest?: Maybe<(
      { __typename?: 'SplitTest' }
      & Pick<SplitTest, 'test' | 'groups'>
    )>, products?: Maybe<Array<(
      { __typename?: 'Product' }
      & Pick<Product, 'url' | 'name' | 'type' | 'id'>
      & { availability?: Maybe<(
        { __typename?: 'Availability' }
        & Pick<Availability, 'isInStock' | 'quantity'>
      )>, primaryAsset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, asset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, brand?: Maybe<(
        { __typename?: 'Brand' }
        & Pick<Brand, 'title'>
      )>, masterVariant?: Maybe<(
        { __typename?: 'ProductVariant' }
        & { type?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, personalizations?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
          { __typename?: 'ProductAttribute' }
          & { products?: Maybe<Array<(
            { __typename?: 'Product' }
            & ProductCrossSellAndPersonalizationContentFragment
          )>> }
        ) | { __typename?: 'ProductsWithQuantityAttribute' }>, shortName?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, maxCharacters?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, price?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'countryCode' | 'currencyCode' | 'value' | 'format'>
          & { discount?: Maybe<(
            { __typename?: 'PriceDiscount' }
            & Pick<PriceDiscount, 'currencyCode' | 'percent' | 'value' | 'format'>
            & { code?: Maybe<(
              { __typename?: 'DiscountCode' }
              & Pick<DiscountCode, 'id' | 'context'>
            )> }
          )> }
        )> }
      )> }
    )>> }
  )>> }
);

type RecommendationContent_TacticBoughtTogether_Fragment = (
  { __typename?: 'TacticBoughtTogether' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'placement' | 'type' | 'title' | 'productIDs'>
    & { splitTest?: Maybe<(
      { __typename?: 'SplitTest' }
      & Pick<SplitTest, 'test' | 'groups'>
    )>, products?: Maybe<Array<(
      { __typename?: 'Product' }
      & Pick<Product, 'url' | 'name' | 'type' | 'id'>
      & { availability?: Maybe<(
        { __typename?: 'Availability' }
        & Pick<Availability, 'isInStock' | 'quantity'>
      )>, primaryAsset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, asset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, brand?: Maybe<(
        { __typename?: 'Brand' }
        & Pick<Brand, 'title'>
      )>, masterVariant?: Maybe<(
        { __typename?: 'ProductVariant' }
        & { type?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, personalizations?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
          { __typename?: 'ProductAttribute' }
          & { products?: Maybe<Array<(
            { __typename?: 'Product' }
            & ProductCrossSellAndPersonalizationContentFragment
          )>> }
        ) | { __typename?: 'ProductsWithQuantityAttribute' }>, shortName?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, maxCharacters?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, price?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'countryCode' | 'currencyCode' | 'value' | 'format'>
          & { discount?: Maybe<(
            { __typename?: 'PriceDiscount' }
            & Pick<PriceDiscount, 'currencyCode' | 'percent' | 'value' | 'format'>
            & { code?: Maybe<(
              { __typename?: 'DiscountCode' }
              & Pick<DiscountCode, 'id' | 'context'>
            )> }
          )> }
        )> }
      )> }
    )>> }
  )>> }
);

type RecommendationContent_TacticOthersBought_Fragment = (
  { __typename?: 'TacticOthersBought' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'placement' | 'type' | 'title' | 'productIDs'>
    & { splitTest?: Maybe<(
      { __typename?: 'SplitTest' }
      & Pick<SplitTest, 'test' | 'groups'>
    )>, products?: Maybe<Array<(
      { __typename?: 'Product' }
      & Pick<Product, 'url' | 'name' | 'type' | 'id'>
      & { availability?: Maybe<(
        { __typename?: 'Availability' }
        & Pick<Availability, 'isInStock' | 'quantity'>
      )>, primaryAsset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, asset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, brand?: Maybe<(
        { __typename?: 'Brand' }
        & Pick<Brand, 'title'>
      )>, masterVariant?: Maybe<(
        { __typename?: 'ProductVariant' }
        & { type?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, personalizations?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
          { __typename?: 'ProductAttribute' }
          & { products?: Maybe<Array<(
            { __typename?: 'Product' }
            & ProductCrossSellAndPersonalizationContentFragment
          )>> }
        ) | { __typename?: 'ProductsWithQuantityAttribute' }>, shortName?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, maxCharacters?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, price?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'countryCode' | 'currencyCode' | 'value' | 'format'>
          & { discount?: Maybe<(
            { __typename?: 'PriceDiscount' }
            & Pick<PriceDiscount, 'currencyCode' | 'percent' | 'value' | 'format'>
            & { code?: Maybe<(
              { __typename?: 'DiscountCode' }
              & Pick<DiscountCode, 'id' | 'context'>
            )> }
          )> }
        )> }
      )> }
    )>> }
  )>> }
);

type RecommendationContent_TacticOthersBoughtGrid_Fragment = (
  { __typename?: 'TacticOthersBoughtGrid' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'placement' | 'type' | 'title' | 'productIDs'>
    & { splitTest?: Maybe<(
      { __typename?: 'SplitTest' }
      & Pick<SplitTest, 'test' | 'groups'>
    )>, products?: Maybe<Array<(
      { __typename?: 'Product' }
      & Pick<Product, 'url' | 'name' | 'type' | 'id'>
      & { availability?: Maybe<(
        { __typename?: 'Availability' }
        & Pick<Availability, 'isInStock' | 'quantity'>
      )>, primaryAsset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, asset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, brand?: Maybe<(
        { __typename?: 'Brand' }
        & Pick<Brand, 'title'>
      )>, masterVariant?: Maybe<(
        { __typename?: 'ProductVariant' }
        & { type?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, personalizations?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
          { __typename?: 'ProductAttribute' }
          & { products?: Maybe<Array<(
            { __typename?: 'Product' }
            & ProductCrossSellAndPersonalizationContentFragment
          )>> }
        ) | { __typename?: 'ProductsWithQuantityAttribute' }>, shortName?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, maxCharacters?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, price?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'countryCode' | 'currencyCode' | 'value' | 'format'>
          & { discount?: Maybe<(
            { __typename?: 'PriceDiscount' }
            & Pick<PriceDiscount, 'currencyCode' | 'percent' | 'value' | 'format'>
            & { code?: Maybe<(
              { __typename?: 'DiscountCode' }
              & Pick<DiscountCode, 'id' | 'context'>
            )> }
          )> }
        )> }
      )> }
    )>> }
  )>> }
);

type RecommendationContent_TacticRecommendedForYou_Fragment = (
  { __typename?: 'TacticRecommendedForYou' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'placement' | 'type' | 'title' | 'productIDs'>
    & { splitTest?: Maybe<(
      { __typename?: 'SplitTest' }
      & Pick<SplitTest, 'test' | 'groups'>
    )>, products?: Maybe<Array<(
      { __typename?: 'Product' }
      & Pick<Product, 'url' | 'name' | 'type' | 'id'>
      & { availability?: Maybe<(
        { __typename?: 'Availability' }
        & Pick<Availability, 'isInStock' | 'quantity'>
      )>, primaryAsset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, asset?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, brand?: Maybe<(
        { __typename?: 'Brand' }
        & Pick<Brand, 'title'>
      )>, masterVariant?: Maybe<(
        { __typename?: 'ProductVariant' }
        & { type?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, personalizations?: Maybe<{ __typename?: 'BaseAttribute' } | { __typename?: 'MoneyAttribute' } | (
          { __typename?: 'ProductAttribute' }
          & { products?: Maybe<Array<(
            { __typename?: 'Product' }
            & ProductCrossSellAndPersonalizationContentFragment
          )>> }
        ) | { __typename?: 'ProductsWithQuantityAttribute' }>, shortName?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, maxCharacters?: Maybe<(
          { __typename?: 'BaseAttribute' }
          & Pick<BaseAttribute, 'key' | 'value'>
        ) | (
          { __typename?: 'MoneyAttribute' }
          & Pick<MoneyAttribute, 'key'>
        ) | (
          { __typename?: 'ProductAttribute' }
          & Pick<ProductAttribute, 'key'>
        ) | (
          { __typename?: 'ProductsWithQuantityAttribute' }
          & Pick<ProductsWithQuantityAttribute, 'key'>
        )>, price?: Maybe<(
          { __typename?: 'Price' }
          & Pick<Price, 'countryCode' | 'currencyCode' | 'value' | 'format'>
          & { discount?: Maybe<(
            { __typename?: 'PriceDiscount' }
            & Pick<PriceDiscount, 'currencyCode' | 'percent' | 'value' | 'format'>
            & { code?: Maybe<(
              { __typename?: 'DiscountCode' }
              & Pick<DiscountCode, 'id' | 'context'>
            )> }
          )> }
        )> }
      )> }
    )>> }
  )>> }
);

export type RecommendationContentFragment = RecommendationContent_AddToCartPromptSuccess_Fragment | RecommendationContent_Cart_Fragment | RecommendationContent_TacticBoughtTogether_Fragment | RecommendationContent_TacticOthersBought_Fragment | RecommendationContent_TacticOthersBoughtGrid_Fragment | RecommendationContent_TacticRecommendedForYou_Fragment;

export type ReturnOptionsByEmailQueryVariables = Exact<{
  orderNumber: Scalars['String'];
  email: Scalars['String'];
}>;


export type ReturnOptionsByEmailQuery = (
  { __typename?: 'Query' }
  & { returnOptionsByEmail?: Maybe<(
    { __typename?: 'ReturnOptions' }
    & Pick<ReturnOptions, 'orderNumber' | 'isSwapEnabled' | 'refundMethods'>
    & { optionLineItems?: Maybe<Array<(
      { __typename?: 'ReturnOptionLineItem' }
      & Pick<ReturnOptionLineItem, 'orderLineItemID' | 'fallbackTitle' | 'isPersonalized' | 'productID' | 'returnableQuantity'>
      & { product?: Maybe<(
        { __typename?: 'Product' }
        & Pick<Product, 'id' | 'name'>
        & { asset?: Maybe<(
          { __typename?: 'Asset' }
          & Pick<Asset, 'url'>
        )>, availability?: Maybe<(
          { __typename?: 'Availability' }
          & Pick<Availability, 'isInStock'>
        )>, variants?: Maybe<Array<(
          { __typename?: 'ProductVariant' }
          & Pick<ProductVariant, 'id'>
          & { size?: Maybe<(
            { __typename?: 'BaseAttribute' }
            & Pick<BaseAttribute, 'value'>
          ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, availability?: Maybe<(
            { __typename?: 'Availability' }
            & Pick<Availability, 'isInStock'>
          )> }
        )>> }
      )> }
    )>>, previousReturns?: Maybe<Array<(
      { __typename?: 'Return' }
      & Pick<Return, 'ID' | 'key' | 'state' | 'createdAt'>
    )>> }
  )> }
);

export type EstimateReturnTotalsQueryVariables = Exact<{
  orderNumber: Scalars['String'];
  returningItems: Array<ReturningItemInput> | ReturningItemInput;
  email: Scalars['String'];
}>;


export type EstimateReturnTotalsQuery = (
  { __typename?: 'Query' }
  & { estimateReturnTotals?: Maybe<(
    { __typename?: 'ReturnTotals' }
    & { shippingToRefund?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currencyCode' | 'value' | 'format'>
    )>, shippingToPay?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currencyCode' | 'value' | 'format'>
    )>, itemsToRefund?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currencyCode' | 'value' | 'format'>
    )>, totalToRefund?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'currencyCode' | 'value' | 'format'>
    )>, swapItems?: Maybe<Array<(
      { __typename?: 'ReturnTotalSwapItem' }
      & Pick<ReturnTotalSwapItem, 'orderLineItemID' | 'quantity' | 'swapToProductKey'>
      & { value?: Maybe<(
        { __typename?: 'Money' }
        & Pick<Money, 'currencyCode' | 'value' | 'format'>
      )> }
    )>> }
  )> }
);

export type CreateReturnMutationVariables = Exact<{
  orderNumber: Scalars['String'];
  returningItems: Array<ReturningItemInput> | ReturningItemInput;
  refundMethod: ReturnRefundMethod;
  email: Scalars['String'];
  bankDetails?: Maybe<ReturnBankDetailsInput>;
}>;


export type CreateReturnMutation = (
  { __typename?: 'Mutation' }
  & { createReturn?: Maybe<(
    { __typename?: 'Return' }
    & Pick<Return, 'state' | 'orderNumber' | 'key' | 'ID'>
  )> }
);

export type CreateOrderReviewMutationVariables = Exact<{
  orderNumber: Scalars['String'];
  reviewToken: Scalars['String'];
  productReviews?: Maybe<Array<OrderReviewProductReviewInput> | OrderReviewProductReviewInput>;
  surveyAnswers?: Maybe<Array<OrderReviewSurveyAnswerInput> | OrderReviewSurveyAnswerInput>;
}>;


export type CreateOrderReviewMutation = (
  { __typename?: 'Mutation' }
  & { createOrderReview?: Maybe<(
    { __typename?: 'OrderReview' }
    & OrderReviewFragmentFragment
  )> }
);

export type OrderReviewQueryVariables = Exact<{
  orderNumber: Scalars['String'];
  reviewToken: Scalars['String'];
}>;


export type OrderReviewQuery = (
  { __typename?: 'Query' }
  & { orderReview?: Maybe<(
    { __typename?: 'OrderReview' }
    & OrderReviewFragmentFragment
  )> }
);

export type SurveyQueryVariables = Exact<{
  orderNumber: Scalars['String'];
  reviewToken: Scalars['String'];
}>;


export type SurveyQuery = (
  { __typename?: 'Query' }
  & { orderReview?: Maybe<(
    { __typename?: 'OrderReview' }
    & { surveyQuestions?: Maybe<Array<(
      { __typename?: 'OrderReviewSurveyQuestion' }
      & Pick<OrderReviewSurveyQuestion, 'id' | 'title' | 'parentOptionID'>
      & { options?: Maybe<Array<(
        { __typename?: 'OrderReviewSurveyQuestionOption' }
        & Pick<OrderReviewSurveyQuestionOption, 'id' | 'title' | 'showTextInput'>
      )>> }
    )>> }
  )> }
);

export type OrderReviewFragmentFragment = (
  { __typename?: 'OrderReview' }
  & Pick<OrderReview, 'id'>
  & { productReviews?: Maybe<Array<(
    { __typename?: 'OrderReviewProductReview' }
    & Pick<OrderReviewProductReview, 'id' | 'isReviewed'>
    & { product?: Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'id' | 'name'>
      & { assets?: Maybe<Array<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
        & { dimensions?: Maybe<(
          { __typename?: 'Dimensions' }
          & Pick<Dimensions, 'height' | 'width'>
        )> }
      )>> }
    )> }
  )>> }
);

export type ShippingInfoPriceFragmentFragment = (
  { __typename?: 'ShippingInfoPrice' }
  & Pick<ShippingInfoPrice, 'style' | 'text'>
  & { value?: Maybe<(
    { __typename?: 'Money' }
    & Pick<Money, 'format'>
  )> }
);

export type ShippingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippingInfoQuery = (
  { __typename?: 'Query' }
  & { shippingInfo?: Maybe<(
    { __typename?: 'ShippingInfo' }
    & { threshold?: Maybe<(
      { __typename?: 'Money' }
      & Pick<Money, 'format'>
    )>, items?: Maybe<Array<(
      { __typename?: 'ShippingInfoItem' }
      & Pick<ShippingInfoItem, 'title'>
      & { deliveryTime?: Maybe<(
        { __typename?: 'ShippingInfoDeliveryTime' }
        & Pick<ShippingInfoDeliveryTime, 'text'>
      )>, logo?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, price?: Maybe<(
        { __typename?: 'ShippingInfoPrice' }
        & ShippingInfoPriceFragmentFragment
      )>, priceBefore?: Maybe<(
        { __typename?: 'ShippingInfoPrice' }
        & ShippingInfoPriceFragmentFragment
      )>, priceAboveThreshold?: Maybe<(
        { __typename?: 'ShippingInfoPrice' }
        & ShippingInfoPriceFragmentFragment
      )> }
    )>> }
  )> }
);

export type MoneyFragment = (
  { __typename?: 'Money' }
  & Pick<Money, 'currencyCode' | 'value' | 'format'>
);

export type StoresGlobalsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type StoresGlobalsQueryQuery = (
  { __typename?: 'Query' }
  & { stores?: Maybe<Array<Maybe<(
    { __typename?: 'Store' }
    & Pick<Store, 'id' | 'parentID' | 'title'>
    & { config?: Maybe<(
      { __typename?: 'StoreConfig' }
      & Pick<StoreConfig, 'adwordsTrackingID' | 'analyticsTrackingID' | 'countryCode' | 'currencyCode' | 'currencyFraction' | 'email' | 'localeCode' | 'merchantAccount' | 'phone' | 'trustpilotBusinessID' | 'trustpilotDomain' | 'urlDomain' | 'urlFull' | 'urlPath' | 'usercentricsEnabled' | 'vatNumber'>
      & { adwordsCurrencyRates?: Maybe<Array<Maybe<(
        { __typename?: 'StoreConfigAdwordsCurrencyRate' }
        & Pick<StoreConfigAdwordsCurrencyRate, 'key' | 'value'>
      )>>>, cheapestShippingPrice?: Maybe<(
        { __typename?: 'Money' }
        & MoneyFragment
      )>, freeShippingThreshold?: Maybe<(
        { __typename?: 'Money' }
        & MoneyFragment
      )>, freeShippingThresholdClub?: Maybe<(
        { __typename?: 'Money' }
        & MoneyFragment
      )>, giftcards?: Maybe<(
        { __typename?: 'StoreGiftcardConfig' }
        & { valueMin?: Maybe<(
          { __typename?: 'Money' }
          & MoneyFragment
        )>, valueMax?: Maybe<(
          { __typename?: 'Money' }
          & MoneyFragment
        )>, predefinedValues?: Maybe<Array<(
          { __typename?: 'Money' }
          & MoneyFragment
        )>> }
      )> }
    )> }
  )>>> }
);

export type SuccessQueryVariables = Exact<{
  orderNumberOverride?: Maybe<Scalars['String']>;
}>;


export type SuccessQuery = (
  { __typename?: 'Query' }
  & { successPage?: Maybe<(
    { __typename?: 'SuccessPage' }
    & Pick<SuccessPage, 'orderNumber' | 'expectedDispatchAt'>
    & { cart?: Maybe<(
      { __typename?: 'Cart' }
      & Pick<Cart, 'id' | 'consents' | 'shippingMethodID' | 'customerID' | 'expectedDelivery'>
      & { availableShippingMethods?: Maybe<Array<(
        { __typename?: 'ShippingMethod' }
        & Pick<ShippingMethod, 'id' | 'isCOD'>
      )>>, billingAddress?: Maybe<(
        { __typename?: 'CartAddress' }
        & Pick<CartAddress, 'email' | 'firstName' | 'lastName' | 'phone' | 'phonePrefix'>
        & { emailHash: CartAddress['email'], phoneHash: CartAddress['phone'] }
      )>, deliveryAddress?: Maybe<(
        { __typename?: 'CartAddress' }
        & Pick<CartAddress, 'firstName' | 'lastName' | 'streetName' | 'additionalStreetInfo' | 'postalCode' | 'city' | 'country' | 'phone'>
      )>, discountCodes?: Maybe<Array<(
        { __typename?: 'CartDiscountCode' }
        & Pick<CartDiscountCode, 'code'>
      )>>, lineItemGroups?: Maybe<Array<(
        { __typename?: 'CartLineItemGroup' }
        & Pick<CartLineItemGroup, 'id' | 'lineItemIDs' | 'type'>
        & { totalPrice?: Maybe<(
          { __typename?: 'Price' }
          & PriceFragmentFragment
        )> }
      )>>, lineItems?: Maybe<Array<(
        { __typename?: 'CartLineItem' }
        & Pick<CartLineItem, 'id' | 'tactic' | 'productID' | 'quantity'>
        & { price?: Maybe<(
          { __typename?: 'Price' }
          & PriceFragmentFragment
        )>, totalPrice?: Maybe<(
          { __typename?: 'Price' }
          & { discount?: Maybe<(
            { __typename?: 'PriceDiscount' }
            & MoneyContent_PriceDiscount_Fragment
          )> }
          & PriceFragmentFragment
          & MoneyContent_Price_Fragment
        )>, errors?: Maybe<Array<(
          { __typename?: 'CartLineItemError' }
          & Pick<CartLineItemError, 'code' | 'message'>
        )>>, product?: Maybe<(
          { __typename?: 'Product' }
          & { masterVariant?: Maybe<(
            { __typename?: 'ProductVariant' }
            & Pick<ProductVariant, 'id'>
            & { isNew?: Maybe<(
              { __typename: 'BaseAttribute' }
              & Pick<BaseAttribute, 'value'>
            ) | { __typename: 'MoneyAttribute' } | { __typename: 'ProductAttribute' } | { __typename: 'ProductsWithQuantityAttribute' }> }
          )>, videoAsset?: Maybe<(
            { __typename?: 'Asset' }
            & Pick<Asset, 'url'>
          )>, variants?: Maybe<Array<(
            { __typename?: 'ProductVariant' }
            & Pick<ProductVariant, 'id'>
            & { size?: Maybe<(
              { __typename: 'BaseAttribute' }
              & Pick<BaseAttribute, 'value'>
            ) | { __typename: 'MoneyAttribute' } | { __typename: 'ProductAttribute' } | { __typename: 'ProductsWithQuantityAttribute' }> }
          )>> }
          & ProductContentFragment
        )>, totalTaxedPrice?: Maybe<(
          { __typename?: 'TaxedPrice' }
          & { totalNet?: Maybe<(
            { __typename?: 'Money' }
            & { base?: Maybe<(
              { __typename?: 'Money' }
              & { plain: Money['format'] }
            )> }
            & MoneyContent_Money_Fragment
          )>, totalGross?: Maybe<(
            { __typename?: 'Money' }
            & MoneyContent_Money_Fragment
          )>, totalTax?: Maybe<(
            { __typename?: 'Money' }
            & MoneyContent_Money_Fragment
          )> }
        )>, type?: Maybe<(
          { __typename: 'CartLineItemTypeBundle' }
          & Pick<CartLineItemTypeBundle, 'link' | 'parent' | 'children' | 'milestoneID'>
        ) | (
          { __typename: 'CartLineItemTypeFreeProduct' }
          & Pick<CartLineItemTypeFreeProduct, 'link' | 'parent' | 'children' | 'milestoneID' | 'disableSizeSelection' | 'hasSelectedVariant'>
        ) | (
          { __typename: 'CartLineItemTypeGeneric' }
          & Pick<CartLineItemTypeGeneric, 'link' | 'parent' | 'children' | 'milestoneID'>
        ) | (
          { __typename: 'CartLineItemTypeGiftcard' }
          & Pick<CartLineItemTypeGiftcard, 'link' | 'parent' | 'children' | 'milestoneID' | 'text'>
          & { amount?: Maybe<(
            { __typename?: 'Money' }
            & Pick<Money, 'format' | 'value' | 'currencyCode'>
          )> }
        ) | (
          { __typename: 'CartLineItemTypeUpsellBundle' }
          & Pick<CartLineItemTypeUpsellBundle, 'link' | 'parent' | 'children' | 'milestoneID'>
        ) | (
          { __typename: 'CartLineItemTypeUpsellGeneric' }
          & Pick<CartLineItemTypeUpsellGeneric, 'link' | 'parent' | 'children' | 'milestoneID'>
        ) | (
          { __typename: 'CartLineItemTypeUpsellPersonalization' }
          & Pick<CartLineItemTypeUpsellPersonalization, 'link' | 'parent' | 'children' | 'milestoneID' | 'text' | 'blobID'>
        )>, variant?: Maybe<(
          { __typename?: 'ProductVariant' }
          & Pick<ProductVariant, 'id'>
          & { type?: Maybe<(
            { __typename?: 'BaseAttribute' }
            & Pick<BaseAttribute, 'value'>
          ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }>, subType?: Maybe<(
            { __typename?: 'BaseAttribute' }
            & Pick<BaseAttribute, 'value'>
          ) | { __typename?: 'MoneyAttribute' } | { __typename?: 'ProductAttribute' } | { __typename?: 'ProductsWithQuantityAttribute' }> }
        )> }
      )>>, totals?: Maybe<Array<(
        { __typename?: 'CartTotal' }
        & Pick<CartTotal, 'id' | 'style' | 'title' | 'text'>
        & { value?: Maybe<(
          { __typename?: 'Money' }
          & MoneyContent_Money_Fragment
        )> }
      )>> }
    )>, profit?: Maybe<(
      { __typename?: 'Profit' }
      & Pick<Profit, 'orderNumber'>
      & { profitInfo?: Maybe<Array<Maybe<(
        { __typename?: 'ProfitInfo' }
        & Pick<ProfitInfo, 'currencyCode'>
        & { grandTotal?: Maybe<(
          { __typename?: 'Money' }
          & MoneyContent_Money_Fragment
        )>, profit?: Maybe<(
          { __typename?: 'Money' }
          & MoneyContent_Money_Fragment
        )>, items?: Maybe<Array<Maybe<(
          { __typename?: 'ProfitItem' }
          & Pick<ProfitItem, 'id'>
          & { profit?: Maybe<(
            { __typename?: 'Money' }
            & MoneyContent_Money_Fragment
          )> }
        )>>> }
      )>>> }
    )> }
  )> }
);

export type AddToCartProductTacticFragmentFragment = (
  { __typename?: 'AddToCartProductTactic' }
  & Pick<AddToCartProductTactic, 'checksum' | 'type'>
  & { price?: Maybe<(
    { __typename?: 'Price' }
    & Pick<Price, 'currencyCode' | 'value' | 'format'>
    & { discount?: Maybe<(
      { __typename?: 'PriceDiscount' }
      & Pick<PriceDiscount, 'currencyCode' | 'percent' | 'value' | 'format'>
    )> }
  )> }
);

type TacticRecommendationsFragment_AddToCartPromptSuccess_Fragment = (
  { __typename?: 'AddToCartPromptSuccess' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'title' | 'type' | 'placement'>
    & { products?: Maybe<Array<(
      { __typename?: 'Product' }
      & ProductTileFragmentFragment
    )>> }
  )>> }
);

type TacticRecommendationsFragment_Cart_Fragment = (
  { __typename?: 'Cart' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'title' | 'type' | 'placement'>
    & { products?: Maybe<Array<(
      { __typename?: 'Product' }
      & ProductTileFragmentFragment
    )>> }
  )>> }
);

type TacticRecommendationsFragment_TacticBoughtTogether_Fragment = (
  { __typename?: 'TacticBoughtTogether' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'title' | 'type' | 'placement'>
    & { products?: Maybe<Array<(
      { __typename?: 'Product' }
      & ProductTileFragmentFragment
    )>> }
  )>> }
);

type TacticRecommendationsFragment_TacticOthersBought_Fragment = (
  { __typename?: 'TacticOthersBought' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'title' | 'type' | 'placement'>
    & { products?: Maybe<Array<(
      { __typename?: 'Product' }
      & ProductTileFragmentFragment
    )>> }
  )>> }
);

type TacticRecommendationsFragment_TacticOthersBoughtGrid_Fragment = (
  { __typename?: 'TacticOthersBoughtGrid' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'title' | 'type' | 'placement'>
    & { products?: Maybe<Array<(
      { __typename?: 'Product' }
      & ProductTileFragmentFragment
    )>> }
  )>> }
);

type TacticRecommendationsFragment_TacticRecommendedForYou_Fragment = (
  { __typename?: 'TacticRecommendedForYou' }
  & { recommendations?: Maybe<Array<(
    { __typename?: 'Recommendation' }
    & Pick<Recommendation, 'id' | 'title' | 'type' | 'placement'>
    & { products?: Maybe<Array<(
      { __typename?: 'Product' }
      & ProductTileFragmentFragment
    )>> }
  )>> }
);

export type TacticRecommendationsFragmentFragment = TacticRecommendationsFragment_AddToCartPromptSuccess_Fragment | TacticRecommendationsFragment_Cart_Fragment | TacticRecommendationsFragment_TacticBoughtTogether_Fragment | TacticRecommendationsFragment_TacticOthersBought_Fragment | TacticRecommendationsFragment_TacticOthersBoughtGrid_Fragment | TacticRecommendationsFragment_TacticRecommendedForYou_Fragment;

export type WordbookFragmentFragment = (
  { __typename?: 'Wordbook' }
  & Pick<Wordbook, 'id' | 'value' | 'defaults' | 'values'>
);

export const BarContentFragmentDoc = gql`
    fragment BarContent on Bar {
  id
  textColor
  backgroundColor
  placement
  priority
  splitTest {
    test
    groups
  }
  type
  theme
  addons
  conditions
  urgencyTimerDateEnd
  urgencyTimerDateStart
  fields {
    ... on LinkField {
      key
      url
      newTab
      references {
        __typename
        ... on Page {
          id
          type
        }
      }
    }
    ... on RTEField {
      key
      value
      referencesWithKey {
        key
        reference {
          ... on DynamicVariable {
            id
            value
            url
          }
          ... on Page {
            id
            type
            title
            url
          }
        }
      }
    }
  }
}
    `;
export const AddToCartProductTacticFragmentFragmentDoc = gql`
    fragment AddToCartProductTacticFragment on AddToCartProductTactic {
  checksum
  type
  price {
    currencyCode
    value
    format
    discount {
      currencyCode
      percent
      value
      format
    }
  }
}
    `;
export const MoneyContentFragmentDoc = gql`
    fragment MoneyContent on IWithMoney {
  currencyCode
  value
  format
  plain: format(mode: NUMBER_PLAIN)
}
    `;
export const PriceFragmentFragmentDoc = gql`
    fragment PriceFragment on Price {
  ...MoneyContent
  discount {
    percent
    code {
      context
    }
    ...MoneyContent
  }
}
    ${MoneyContentFragmentDoc}`;
export const ProductTileFragmentFragmentDoc = gql`
    fragment ProductTileFragment on Product {
  id
  type
  name
  url
  primaryAsset: asset(tag: "primary") {
    url
    tags
  }
  hoverAsset: asset(tag: "hover") {
    url
    tags
  }
  availability {
    isInStock
  }
  masterVariant {
    id
    isBestSeller: attribute(key: "isBestSeller") {
      ... on BaseAttribute {
        value
      }
    }
    isNew: attribute(key: "isNew") {
      ... on BaseAttribute {
        value
      }
    }
    isPopularGift: attribute(key: "isPopularGift") {
      ... on BaseAttribute {
        value
      }
    }
    personalizations: attribute(key: "personalizations") {
      ... on ProductAttribute {
        productIDs
      }
    }
    price {
      ...PriceFragment
    }
  }
}
    ${PriceFragmentFragmentDoc}`;
export const TacticRecommendationsFragmentFragmentDoc = gql`
    fragment TacticRecommendationsFragment on IWithRecommendations {
  recommendations @include(if: $loadRecommendations) {
    id
    title
    type
    placement
    products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
      ...ProductTileFragment
    }
  }
}
    ${ProductTileFragmentFragmentDoc}`;
export const WordbookFragmentFragmentDoc = gql`
    fragment WordbookFragment on Wordbook {
  id
  value
  defaults
  values
}
    `;
export const PersonalizationOptionsFragmentDoc = gql`
    fragment PersonalizationOptions on ProductVariant {
  maxCharacters: attribute(key: "maxCharacters") {
    ... on BaseAttribute {
      value
    }
  }
  type: attribute(key: "type") {
    ... on BaseAttribute {
      value
    }
  }
  legacyID: attribute(key: "legacyOptionID") {
    ... on BaseAttribute {
      value
    }
  }
  shortName: attribute(key: "shortName") {
    ... on BaseAttribute {
      value
    }
  }
  price {
    ...PriceFragment
  }
}
    ${PriceFragmentFragmentDoc}`;
export const ProductCrossSellAndPersonalizationContentFragmentDoc = gql`
    fragment ProductCrossSellAndPersonalizationContent on Product {
  id
  type
  name
  url
  brand {
    title
  }
  primaryAsset: asset(tag: "primary") {
    url
    tags
  }
  moneyShotAsset: asset(tag: "money_shot") {
    url
    tags
  }
  masterVariant {
    id
    ...PersonalizationOptions
    price {
      ...PriceFragment
    }
  }
}
    ${PersonalizationOptionsFragmentDoc}
${PriceFragmentFragmentDoc}`;
export const AddToCartPromptSuccessTacticFragmentFragmentDoc = gql`
    fragment AddToCartPromptSuccessTacticFragment on AddToCartPromptSuccessTactic {
  __typename
  ... on TacticBuildYourDiscount {
    id
  }
  ... on TacticRelativeDiscount {
    id
    productIDs
    products {
      id
      name
      primaryAsset: asset(tag: "primary") {
        url
      }
    }
    relativeDiscounts {
      quantity
      price {
        format
        discount {
          format
          value
        }
        value
      }
      percentage
    }
  }
  ... on TacticAddAndSave {
    id
    offers {
      offer {
        ...AddToCartProductTacticFragment
      }
      productID
      product {
        id
        primaryAsset: asset(tag: "primary") {
          url
        }
        name
        url
      }
    }
  }
  ... on TacticBoughtTogether {
    id
    ...TacticRecommendationsFragment
  }
  ... on TacticMatchingVariant {
    id
    type
    title {
      ...WordbookFragment
    }
    tag {
      ...WordbookFragment
    }
    offer {
      ...AddToCartProductTacticFragment
    }
    productID
    product {
      id
      name
      primaryAsset: asset(tag: "primary") {
        url
      }
      masterVariant {
        price {
          currencyCode
          value
          format
          discount {
            currencyCode
            percent
            value
            format
          }
        }
      }
    }
  }
  ... on TacticUpgradeWith {
    id
    items {
      type
      product {
        ...ProductCrossSellAndPersonalizationContent
      }
    }
  }
}
    ${AddToCartProductTacticFragmentFragmentDoc}
${TacticRecommendationsFragmentFragmentDoc}
${WordbookFragmentFragmentDoc}
${ProductCrossSellAndPersonalizationContentFragmentDoc}`;
export const MilestoneFragmentFragmentDoc = gql`
    fragment MilestoneFragment on Cart {
  milestones {
    title {
      ...WordbookFragment
    }
    steps {
      id
      type
      status
      progress
      title {
        ...WordbookFragment
      }
      option {
        ... on CartMilestoneStepOptionDiscountCode {
          callToAction {
            ...WordbookFragment
          }
          title {
            ...WordbookFragment
          }
          success {
            ...WordbookFragment
          }
          warning {
            ...WordbookFragment
          }
          discountCode
        }
        ... on CartMilestoneStepOptionProducts {
          productIDs
          callToAction {
            ...WordbookFragment
          }
          title {
            ...WordbookFragment
          }
          products(
            mode: PROJECTION
            onlyAvailable: true
            onlyEnabled: true
            onlySafeAvailability: true
          ) {
            categoryIDs
            primaryCategoryIDs
            id
            enabled
            type
            name
            slug
            url
            description
            asset {
              url
              tags
            }
            masterVariant {
              price {
                countryCode
                currencyCode
                value
                format
                discount {
                  currencyCode
                  percent
                  value
                  format
                }
              }
            }
          }
        }
      }
    }
    progress
    asset {
      ... on Wordbook {
        id
        value
        defaults
        values
      }
    }
    backgroundColor
    textColor
    successColor
  }
}
    ${WordbookFragmentFragmentDoc}`;
export const CartContentFragmentDoc = gql`
    fragment CartContent on Cart {
  ...MilestoneFragment
  valid
  id
  checksum
  customerID
  recoverableLineItemIDs
  lineItemGroups {
    id
    lineItemIDs
    totalPrice {
      ...PriceFragment
    }
    type
  }
  lineItems {
    discountText
    id
    tactic
    price {
      ...PriceFragment
    }
    totalPrice {
      ...PriceFragment
    }
    totalTaxedPrice {
      totalNet {
        ...MoneyContent
        base: convert(currencyCode: "DKK") {
          plain: format(mode: NUMBER_PLAIN)
        }
      }
    }
    errors {
      code
      message
      suggestion {
        ...WordbookFragment
      }
    }
    productID
    product(
      mode: PROJECTION
      combineVariants: true
      onlyEnabled: true
      sortVariants: true
    ) {
      id
      type
      name
      url
      categoryIDs
      primaryCategories {
        name(locale: "en-GB")
      }
      availability {
        isInStock
        quantity
      }
      brand {
        title
        url
        logo
        id
      }
      assets {
        tags
      }
      primaryAsset: asset(tag: "primary") {
        url
      }
      variants {
        id
        availability {
          isInStock
          quantity
        }
        size: attribute(key: "size") {
          ... on BaseAttribute {
            value
          }
        }
      }
    }
    quantity
    variant {
      id
      giftWrappings: attribute(key: "giftWrappings") {
        ... on ProductAttribute {
          products(onlyAvailable: true) {
            id
            asset {
              url
            }
            masterVariant {
              price {
                ...MoneyContent
                discount {
                  ...MoneyContent
                }
              }
            }
          }
        }
      }
      size: attribute(key: "size") {
        ... on BaseAttribute {
          value
        }
      }
      isNew: attribute(key: "isNew") {
        ... on BaseAttribute {
          value
        }
      }
      personalizations: attribute(key: "personalizations") {
        ... on ProductAttribute {
          products {
            asset {
              url
            }
            ...ProductCrossSellAndPersonalizationContent
          }
        }
      }
      crossSells: attribute(key: "crossSells") {
        ... on ProductAttribute {
          products {
            id
          }
        }
      }
      type: attribute(key: "type") {
        ... on BaseAttribute {
          value
        }
      }
      subType: attribute(key: "subType") {
        ... on BaseAttribute {
          value
        }
      }
    }
    type {
      ... on IWithCartLineItemLink {
        link
        parent
        children
        milestoneID
      }
      ... on CartLineItemTypeFreeProduct {
        disableSizeSelection
        hasSelectedVariant
      }
      ... on CartLineItemTypeGiftcard {
        text
        amount {
          format
          value
          currencyCode
        }
      }
      ... on CartLineItemTypeUpsellPersonalization {
        text
        blobID
      }
    }
  }
  totals {
    id
    style
    title
    text
    value {
      ...MoneyContent
    }
  }
  freeShipping {
    cheapest {
      currencyCode
      value
      format
    }
    remaining {
      currencyCode
      value
      format
    }
    isFree
    threshold {
      currencyCode
      value
      format
    }
  }
  discountCodes {
    code
    id
    title
  }
  valid
  expectedDelivery
  club {
    isLoggedIn
    balance {
      currencyCode
      format
      value
    }
    value {
      currencyCode
      format
      value
    }
  }
}
    ${MilestoneFragmentFragmentDoc}
${PriceFragmentFragmentDoc}
${MoneyContentFragmentDoc}
${WordbookFragmentFragmentDoc}
${ProductCrossSellAndPersonalizationContentFragmentDoc}`;
export const CartAddressContentFragmentDoc = gql`
    fragment CartAddressContent on Cart {
  billingAddress {
    email
    firstName
    lastName
    company
    streetName
    additionalStreetInfo
    postalCode
    city
    state
    country
    region
    phone
    phonePrefix
    externalID
    externalCustomerID
  }
  shippingAddress {
    email
    firstName
    lastName
    company
    streetName
    additionalStreetInfo
    postalCode
    city
    state
    country
    region
    phone
    phonePrefix
    externalID
    externalCustomerID
  }
}
    `;
export const CartAvailableShippingMethodsFragmentFragmentDoc = gql`
    fragment CartAvailableShippingMethodsFragment on Cart {
  expectedDelivery
  availableShippingMethods {
    id
    key
    deliveryTimeText
    isUnavailable
    isExternalCustomerIDRequired
    price {
      countryCode
      currencyCode
      value
      format
      discount {
        code {
          id
          context
        }
        currencyCode
        percent
        value
        format
      }
    }
    title
    description
    icon
    logo {
      url
    }
    isRecommended
    isServiceLocation
    isCOD
    serviceLocations {
      checksum
      city
      distance
      externalID
      latitude
      longitude
      name
      openingHours {
        closes {
          hours
          minutes
          nanos
          seconds
        }
        dayOfWeek
        opens {
          hours
          minutes
          nanos
          seconds
        }
      }
      postalCode
      streetName
      additionalStreetInfo
      version
    }
  }
}
    `;
export const PageItemFragmentDoc = gql`
    fragment PageItem on Page {
  id
  type
  url
  title
}
    `;
export const LatestPageItemFragmentDoc = gql`
    fragment LatestPageItem on Page {
  ...PageItem
  image {
    url
  }
}
    ${PageItemFragmentDoc}`;
export const PageContentFragmentDoc = gql`
    fragment PageContent on Page {
  id
  type
  url
  openGraph {
    title
    description
    imageURL
    type
  }
}
    `;
export const OpenGraphContentFragmentDoc = gql`
    fragment OpenGraphContent on OpenGraph {
  siteName
  type
  title
  description
  imageURL
}
    `;
export const ProductContentFragmentDoc = gql`
    fragment ProductContent on Product {
  id
  type
  name
  url
  description
  availability {
    isInStock
    quantity
  }
  brand {
    id
    logo
    title
    url
  }
  categoryIDs
  primaryCategories {
    id
    name(locale: "en-GB")
  }
  masterVariant {
    id
    price {
      ...PriceFragment
      clubValue {
        ...MoneyContent
      }
      discount {
        clubValue {
          ...MoneyContent
        }
      }
    }
    basePrice: price(currencyCode: "DKK") {
      plain: format(mode: NUMBER_PLAIN)
      discount {
        plain: format(mode: NUMBER_PLAIN)
      }
    }
    availability {
      isInStock
      quantity
    }
    attributes {
      ... on IAttribute {
        key
      }
      ... on BaseAttribute {
        value
      }
      ... on MoneyAttribute {
        money {
          ...MoneyContent
        }
      }
    }
  }
  primaryAsset: asset(tag: "primary") {
    url
    tags
  }
  moneyShotAsset: asset(tag: "money_shot") {
    url
    tags
  }
  assets {
    url
    tags
    dimensions {
      width
      height
    }
  }
  variants {
    id
    price {
      ...PriceFragment
    }
    availability {
      isInStock
      quantity
    }
    attributes {
      ... on IAttribute {
        key
      }
      ... on BaseAttribute {
        value
      }
      ... on MoneyAttribute {
        money {
          ...MoneyContent
        }
      }
    }
  }
}
    ${PriceFragmentFragmentDoc}
${MoneyContentFragmentDoc}`;
export const ImageAssetFragmentFragmentDoc = gql`
    fragment ImageAssetFragment on ImageAsset {
  image {
    dimensions {
      height
      width
    }
    url
  }
  imageMobile {
    dimensions {
      height
      width
    }
    url
  }
}
    `;
export const ImageResourceImageFragmentFragmentDoc = gql`
    fragment ImageResourceImageFragment on Image {
  url
  dimensions {
    width
    height
  }
  pins {
    x
    y
    reference {
      ... on Page {
        __typename
        id
        type
      }
    }
  }
}
    `;
export const MultipleLinkFieldContentFragmentDoc = gql`
    fragment MultipleLinkFieldContent on MultipleLinkField {
  links {
    url
    newTab
    queryParameters
    references {
      ... on Page {
        id
        type
        title
      }
    }
  }
}
    `;
export const FieldContentFragmentDoc = gql`
    fragment FieldContent on IField {
  __typename
  key
  ... on LinkField {
    key
    url
    newTab
    references {
      __typename
      ... on Page {
        id
        type
      }
    }
  }
  ... on JSONField {
    value
  }
  ... on MultipleLinkField {
    ...MultipleLinkFieldContent
  }
}
    ${MultipleLinkFieldContentFragmentDoc}`;
export const ImageResourceFragmentFragmentDoc = gql`
    fragment ImageResourceFragment on ImageResource {
  id
  image {
    ...ImageResourceImageFragment
  }
  url
  mobileImage {
    ...ImageResourceImageFragment
  }
  mobileURL
  fields {
    ...FieldContent
  }
}
    ${ImageResourceImageFragmentFragmentDoc}
${FieldContentFragmentDoc}`;
export const VideoResourceFragmentFragmentDoc = gql`
    fragment VideoResourceFragment on VideoResource {
  asset {
    type
    key
  }
  settings
  mobileAsset {
    type
    key
  }
}
    `;
export const ReferenceContentFragmentDoc = gql`
    fragment ReferenceContent on Reference {
  __typename
  ... on ExternalLink {
    id
    url
  }
  ... on Link {
    image {
      url
    }
  }
  ... on Page {
    __typename
    id
    type
    title
    url
    brand {
      id
      logo
      title
    }
    openGraph {
      ...OpenGraphContent
    }
    fields {
      ... on ProductField {
        key
        product(
          mode: PROJECTION
          combineVariants: true
          onlyEnabled: true
          sortVariants: true
        ) {
          ...ProductContent
        }
      }
    }
  }
  ... on Media {
    __typename
    id
    title
    captionOptions {
      caption
      references {
        ... on Page {
          __typename
          id
          type
          fields {
            ... on ProductField {
              __typename
              key
              product(
                mode: PROJECTION
                combineVariants: true
                onlyEnabled: true
                sortVariants: true
              ) {
                ...ProductContent
              }
            }
          }
        }
      }
    }
    overlayOptions {
      icon
      caption
      position
    }
  }
  ...ImageAssetFragment
  ...ImageResourceFragment
  ...ImageResourceImageFragment
  ...VideoResourceFragment
  ... on TileResource {
    id
    title
    display
    header
    description {
      key
      referencesWithKey {
        key
        reference {
          ... on Page {
            id
            type
            url
          }
          ... on ExternalLink {
            url
          }
        }
      }
      value
    }
    button {
      text
      link {
        newTab
        url
      }
    }
    campaignTag {
      __typename
      text {
        __typename
        key
        referencesWithKey {
          key
          reference {
            ... on Page {
              id
              type
              url
            }
            ... on ExternalLink {
              url
            }
          }
        }
        value
      }
      appearance {
        __typename
        asset {
          ...ImageAssetFragment
          ...ImageResourceFragment
          ...ImageResourceImageFragment
          ...VideoResourceFragment
        }
        backgroundColor
        textColor
      }
    }
    references {
      ...ImageResourceFragment
      ...ImageResourceImageFragment
    }
    appearance {
      asset {
        ...ImageAssetFragment
        ...ImageResourceFragment
        ...ImageResourceImageFragment
        ...VideoResourceFragment
      }
      backgroundColor
      textColor
    }
  }
}
    ${OpenGraphContentFragmentDoc}
${ProductContentFragmentDoc}
${ImageAssetFragmentFragmentDoc}
${ImageResourceFragmentFragmentDoc}
${ImageResourceImageFragmentFragmentDoc}
${VideoResourceFragmentFragmentDoc}`;
export const BlockAppearanceFragmentFragmentDoc = gql`
    fragment BlockAppearanceFragment on BlockAppearance {
  asset {
    ...ReferenceContent
  }
  backgroundColor
  textColor
  extraColors
  font
}
    ${ReferenceContentFragmentDoc}`;
export const NavigationItemFragmentFragmentDoc = gql`
    fragment NavigationItemFragment on NavigationItem {
  id
  features
  title
  link {
    id
    url
    image {
      url
    }
    references {
      ... on Page {
        id
        type
        title
      }
    }
  }
  appearanceDesktop {
    ...BlockAppearanceFragment
  }
  appearanceMobile {
    ...BlockAppearanceFragment
  }
}
    ${BlockAppearanceFragmentFragmentDoc}`;
export const ProductSpecificationItemFragmentFragmentDoc = gql`
    fragment ProductSpecificationItemFragment on ProductSpecificationItem {
  ... on ProductSpecificationItemReference {
    __typename
    name
    text
    references {
      ... on Page {
        id
        title
        type
        url
      }
    }
  }
  ... on ProductSpecificationItemText {
    __typename
    name
    text
  }
  ... on ProductSpecificationItemUnit {
    __typename
    name
    unit {
      category
      type
    }
    format
  }
}
    `;
export const ProductSpecificationFragmentFragmentDoc = gql`
    fragment ProductSpecificationFragment on Product {
  specifications {
    groups {
      name
      items {
        ...ProductSpecificationItemFragment
        ... on ProductSpecificationItemMultiple {
          name
          items {
            ...ProductSpecificationItemFragment
          }
        }
      }
    }
  }
}
    ${ProductSpecificationItemFragmentFragmentDoc}`;
export const ProductBundleFragmentDoc = gql`
    fragment ProductBundle on Attribute {
  ... on ProductsWithQuantityAttribute {
    products: productsWithQuantity {
      quantity
      productID
      product {
        id
        name
        type
        url
        image: asset(tag: "primary") {
          url
          dimensions {
            width
            height
          }
        }
        ...ProductSpecificationFragment
        masterVariant {
          id
          price {
            ...PriceFragment
          }
        }
      }
    }
  }
}
    ${ProductSpecificationFragmentFragmentDoc}
${PriceFragmentFragmentDoc}`;
export const ProductReviewsFragmentDoc = gql`
    fragment ProductReviews on Product {
  productReviews(cursor: $reviewCursor, limit: $reviewLimit) {
    averageRating
    count
    translatedCount
    cursor
    productReviews {
      id
      createdAt
      customerName
      locale
      localizedText
      localizedTitle
      rating
    }
  }
}
    `;
export const BlockLinkFragmentFragmentDoc = gql`
    fragment BlockLinkFragment on Link {
  id
  overrideTitle
  image {
    url
  }
  imageMobile {
    url
  }
  url
  newTab
  queryParameters
  references {
    ... on Page {
      id
      type
      title
    }
  }
}
    `;
export const ElementsContentFragmentDoc = gql`
    fragment ElementsContent on Elements {
  id
  alignment
  position
  stackingMode
  items {
    __typename
    ... on ElementButton {
      id
      text
      style
      reference {
        ...ReferenceContent
      }
      appearance {
        ...BlockAppearanceFragment
      }
    }
    ... on ElementChip {
      id
      text
      reference {
        ...ReferenceContent
      }
      appearance {
        ...BlockAppearanceFragment
      }
    }
    ... on ElementLabel {
      id
      text
      reference {
        ...ReferenceContent
      }
      appearance {
        ...BlockAppearanceFragment
      }
    }
    ... on ElementTypography {
      id
      text
      htmlElement
      style
      appearance {
        ...BlockAppearanceFragment
      }
    }
    ... on ElementTypographyRTE {
      id
      rte {
        key
        value
      }
      appearance {
        ...BlockAppearanceFragment
      }
    }
  }
}
    ${ReferenceContentFragmentDoc}
${BlockAppearanceFragmentFragmentDoc}`;
export const NestableFieldContentFragmentDoc = gql`
    fragment NestableFieldContent on IField {
  ...FieldContent
  ... on ReferenceField {
    references {
      ...ReferenceContent
      ... on TileResource {
        elements {
          ...ElementsContent
        }
      }
    }
  }
}
    ${FieldContentFragmentDoc}
${ReferenceContentFragmentDoc}
${ElementsContentFragmentDoc}`;
export const FieldsFragmentDoc = gql`
    fragment Fields on IField {
  ...NestableFieldContent
  ... on RTEField {
    key
    referencesWithKey {
      key
      reference {
        ...ReferenceContent
      }
    }
    value
  }
  ... on ObjectField {
    key
    fields {
      ...NestableFieldContent
      ... on ObjectField {
        key
        fields {
          ...NestableFieldContent
        }
      }
    }
  }
  ... on NavigationField {
    key
    navigation {
      id
      title
      link {
        id
        url
        image {
          url
        }
        references {
          ... on Page {
            id
            type
            title
          }
        }
      }
    }
  }
}
    ${NestableFieldContentFragmentDoc}
${ReferenceContentFragmentDoc}`;
export const BlockRteFieldFragmentFragmentDoc = gql`
    fragment BlockRTEFieldFragment on RTEField {
  __typename
  key
  referencesWithKey {
    key
    reference {
      ...ReferenceContent
    }
  }
  value
}
    ${ReferenceContentFragmentDoc}`;
export const PageSliderBlockFragmentDoc = gql`
    fragment PageSliderBlock on PageSliderBlock {
  type
  references {
    __typename
    ... on Page {
      type
      id
      url
      brand {
        id
        logo
        title
      }
      openGraph {
        title
        description
        imageURL
      }
    }
  }
  showDescription
}
    `;
export const ProductListBlockFacetValueFragmentFragmentDoc = gql`
    fragment ProductListBlockFacetValueFragment on ProductListBlockFacetValue {
  id
  key
  name {
    ...WordbookFragment
  }
  color
}
    ${WordbookFragmentFragmentDoc}`;
export const ProductListBlockFragmentFragmentDoc = gql`
    fragment ProductListBlockFragment on ProductListBlock {
  header
  filters
  optionalFilters(boost: $boost)
  limit
  guidedFilters {
    __typename
    ... on IGuidedFilter {
      asset {
        ...ReferenceContent
      }
      backgroundColor
      textColor
      priority
      component
      variant
      header {
        value
      }
      text {
        value
      }
    }
    ... on GuidedFilterAttributeEnum {
      __typename
      attribute
      parameter
      items {
        ... on IGuidedFilterItem {
          backgroundColor
          textColor
          priority
        }
        asset {
          ...ReferenceContent
        }
        key
        canonical
      }
    }
    ... on GuidedFilterLinkResource {
      __typename
      items {
        ... on IGuidedFilterItem {
          backgroundColor
          textColor
          priority
        }
        link {
          ...BlockLinkFragment
        }
      }
    }
  }
  topLinks {
    id
    image {
      url
    }
    imageMobile {
      url
    }
    url
    newTab
    queryParameters
    references {
      ... on Page {
        id
        type
        title
      }
    }
  }
  looks {
    id
    ambassadorHandle
    asset {
      ...ReferenceContent
    }
    products {
      productID
      x
      y
    }
  }
  description {
    ...BlockRTEFieldFragment
  }
  display
  boosts
  facets
  filter
  facetConfig {
    id
    key
    parameter
    type
    name {
      defaults
    }
    facetDescriptionButton {
      ...WordbookFragment
    }
    facetDescriptionIDs
    values {
      ...ProductListBlockFacetValueFragment
    }
    groups {
      id
      key
      name {
        ...WordbookFragment
      }
      values {
        ...ProductListBlockFacetValueFragment
      }
    }
  }
}
    ${ReferenceContentFragmentDoc}
${BlockLinkFragmentFragmentDoc}
${BlockRteFieldFragmentFragmentDoc}
${WordbookFragmentFragmentDoc}
${ProductListBlockFacetValueFragmentFragmentDoc}`;
export const BlockContentFragmentDoc = gql`
    fragment BlockContent on IBlock {
  __typename
  id
  type
  title
  splitTest {
    test
    groups
  }
  appearance {
    ...BlockAppearanceFragment
  }
  common {
    chips {
      appearance {
        ...BlockAppearanceFragment
      }
      link {
        ...BlockLinkFragment
      }
    }
    label {
      appearance {
        ...BlockAppearanceFragment
      }
      text {
        ...WordbookFragment
      }
    }
    position
    status
    title
    titleElement
    text {
      value
    }
    settings
  }
  settings
  ... on IWithFields {
    fields {
      ...Fields
    }
  }
  ... on AccordionListBlock {
    __typename
    accordions {
      title
      fields {
        ...Fields
      }
    }
  }
  ... on ActiveCampaignBlock {
    __typename
    description {
      ...BlockRTEFieldFragment
    }
    highlightText
  }
  ...PageSliderBlock
  ... on GalleryBlock {
    __typename
    slides {
      __typename
      images {
        id
        url
        mobileURL
        captionOptions {
          caption
          references {
            ... on Page {
              __typename
              type
              id
              fields {
                ... on ProductField {
                  __typename
                  key
                  product(
                    mode: PROJECTION
                    combineVariants: true
                    onlyEnabled: true
                    sortVariants: true
                  ) {
                    ...ProductContent
                  }
                }
              }
            }
          }
        }
        fields {
          ...FieldContent
        }
      }
      fields {
        ...Fields
      }
    }
  }
  ... on HTMLBlock {
    __typename
    html
  }
  ... on InfoPanelBlock {
    __typename
    infoPanels {
      icon {
        ...ReferenceContent
      }
      title {
        ...WordbookFragment
      }
      subTitle {
        ...WordbookFragment
      }
      text {
        ...WordbookFragment
      }
    }
  }
  ... on LookDisplayBlock {
    asset {
      ...ReferenceContent
    }
    products {
      product(
        mode: PROJECTION
        combineVariants: true
        onlyEnabled: true
        sortVariants: true
      ) {
        ...ProductTileFragment
      }
      x
      y
    }
  }
  ... on LookListBlock {
    looks {
      id
      url
      ambassadorHandle
      asset {
        ...ReferenceContent
      }
      products {
        productID
        x
        y
      }
    }
  }
  ... on PageGridBlock {
    columns
    references {
      __typename
      ... on Page {
        id
        type
        url
        brand {
          id
          logo
          title
        }
        openGraph {
          title
          description
          imageURL
        }
      }
    }
    showDescription
    titlePosition
  }
  ...ProductListBlockFragment
  ... on ProductSliderBlock {
    facetFilters
    filter
    filters
    header
    limit
    sorting
    slider {
      products(
        mode: PROJECTION
        combineVariants: true
        onlyEnabled: true
        sortVariants: true
      ) {
        ...ProductTileFragment
      }
    }
  }
  ... on USPBlock {
    __typename
    asset {
      ...ReferenceContent
    }
    items {
      id
      link {
        key
        url
        newTab
        references {
          __typename
          ... on Page {
            id
            type
            title
          }
        }
      }
      linkTitle
      title
      text {
        ...BlockRTEFieldFragment
      }
    }
  }
}
    ${BlockAppearanceFragmentFragmentDoc}
${BlockLinkFragmentFragmentDoc}
${WordbookFragmentFragmentDoc}
${FieldsFragmentDoc}
${BlockRteFieldFragmentFragmentDoc}
${PageSliderBlockFragmentDoc}
${ProductContentFragmentDoc}
${FieldContentFragmentDoc}
${ReferenceContentFragmentDoc}
${ProductTileFragmentFragmentDoc}
${ProductListBlockFragmentFragmentDoc}`;
export const DrawerDataFragmentDoc = gql`
    fragment DrawerData on Page {
  id
  type
  title
  blocks {
    ...BlockContent
  }
  settings
  modalTabs {
    id
    title
    blocks {
      ...BlockContent
    }
    appearance {
      ...BlockAppearanceFragment
    }
  }
}
    ${BlockContentFragmentDoc}
${BlockAppearanceFragmentFragmentDoc}`;
export const ProductSizeGuideColumnContentFragmentDoc = gql`
    fragment ProductSizeGuideColumnContent on ProductSizeGuideColumn {
  id
  isHeader
  text {
    ...WordbookFragment
  }
}
    ${WordbookFragmentFragmentDoc}`;
export const ProductSizeGuideContentFragmentDoc = gql`
    fragment ProductSizeGuideContent on Product {
  sizeGuide {
    ...DrawerData
  }
  sizeGuideFits {
    id
    circumference
    title {
      ...WordbookFragment
    }
    fits {
      id
      fit
      fitLabel {
        ...WordbookFragment
      }
      disabled
      quantity
      size
      sizeLabel {
        ...WordbookFragment
      }
    }
  }
  sizeGuideItems {
    id
    title {
      ...WordbookFragment
    }
    headers {
      ...ProductSizeGuideColumnContent
    }
    rows {
      id
      columns {
        ...ProductSizeGuideColumnContent
      }
    }
  }
}
    ${DrawerDataFragmentDoc}
${WordbookFragmentFragmentDoc}
${ProductSizeGuideColumnContentFragmentDoc}`;
export const InjectionSelectorFragmentFragmentDoc = gql`
    fragment InjectionSelectorFragment on InjectionSelector {
  __typename
  ... on InjectionSelectorPages {
    pages {
      type
      id
    }
  }
  ... on InjectionSelectorPageTypes {
    types
  }
  ... on InjectionSelectorProductData {
    brands
    categoryIDs
    collections
    primaryMaterials
    productTypes
  }
}
    `;
export const InjectionPlacementFragmentFragmentDoc = gql`
    fragment InjectionPlacementFragment on InjectionPlacement {
  __typename
  ... on InjectionPlacementBlocks {
    blocks {
      ...BlockContent
    }
  }
  ... on InjectionPlacementBlockTypes {
    types
  }
  ... on InjectionPlacementGlobal {
    global
  }
  ... on InjectionPlacementPosition {
    position
  }
}
    ${BlockContentFragmentDoc}`;
export const ProductPageTacticFragmentFragmentDoc = gql`
    fragment ProductPageTacticFragment on ProductTactic {
  __typename
  ... on TacticAssortmentLadder {
    id
    items {
      id
      iconURL
      header {
        ...WordbookFragment
      }
      text {
        ...WordbookFragment
      }
    }
  }
  ... on TacticBlocks {
    id
    blocks {
      ...BlockContent
    }
  }
  ... on TacticBuildYourDiscount {
    id
    products {
      id
      name
      url
      primaryAsset: asset(tag: "primary") {
        url
      }
      variants {
        id
      }
    }
    items {
      price {
        ...PriceFragment
      }
      offers {
        productID
        offer {
          ...AddToCartProductTacticFragment
        }
      }
    }
  }
  ... on TacticBundleInfo {
    id
    bundlePrice {
      difference {
        ...MoneyContent
      }
      originalPrice {
        ...MoneyContent
      }
      price {
        ...MoneyContent
      }
    }
    bundleProducts {
      quantity
      productID
      product {
        id
        name
        type
        url
        image: asset(tag: "primary") {
          url
          dimensions {
            width
            height
          }
        }
        ...ProductSpecificationFragment
        masterVariant {
          id
          price {
            ...PriceFragment
          }
        }
      }
    }
    settings
  }
  ... on TacticComplementaryProducts {
    id
    products {
      ...ProductCrossSellAndPersonalizationContent
    }
  }
  ... on TacticLinkedProductsColor {
    id
    color {
      type
      products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
        ...ProductCrossSellAndPersonalizationContent
      }
    }
  }
  ... on TacticLinkedProductsSizeAndVariation {
    id
    size {
      type
      products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
        ...ProductCrossSellAndPersonalizationContent
      }
    }
    variation {
      type
      products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
        ...ProductCrossSellAndPersonalizationContent
      }
    }
  }
  ... on TacticLooks {
    id
    looks {
      id
      ambassadorHandle
      asset {
        ...ReferenceContent
      }
      products {
        productID
        x
        y
      }
    }
    settings
    title {
      ...WordbookFragment
    }
  }
  ... on TacticMatchingVariant {
    id
    type
    title {
      ...WordbookFragment
    }
    tag {
      ...WordbookFragment
    }
    offer {
      ...AddToCartProductTacticFragment
    }
    productHeader {
      ...WordbookFragment
    }
    productID
    product {
      id
      name
      url
      primaryAsset: asset(tag: "primary") {
        url
      }
      masterVariant {
        price {
          currencyCode
          value
          format
          discount {
            currencyCode
            percent
            value
            format
          }
        }
      }
    }
  }
  ... on TacticOthersBought {
    id
    ...TacticRecommendationsFragment
  }
  ... on TacticOthersBoughtGrid {
    id
    ...TacticRecommendationsFragment
  }
  ... on TacticRecommendedForYou {
    id
    ...TacticRecommendationsFragment
  }
  ... on TacticRelatedProducts {
    id
    products {
      ...ProductCrossSellAndPersonalizationContent
    }
  }
  ... on TacticRelativeDiscount {
    id
    productIDs
    products {
      id
      name
      primaryAsset: asset(tag: "primary") {
        url
      }
    }
    relativeDiscounts {
      quantity
      price {
        format
        discount {
          format
          value
        }
        value
      }
      percentage
    }
  }
  ... on TacticSimilarProducts {
    id
    products {
      ...ProductCrossSellAndPersonalizationContent
    }
  }
  ... on TacticUpgradeWith {
    id
    items {
      type
      product {
        ...ProductCrossSellAndPersonalizationContent
      }
    }
  }
}
    ${WordbookFragmentFragmentDoc}
${BlockContentFragmentDoc}
${PriceFragmentFragmentDoc}
${AddToCartProductTacticFragmentFragmentDoc}
${MoneyContentFragmentDoc}
${ProductSpecificationFragmentFragmentDoc}
${ProductCrossSellAndPersonalizationContentFragmentDoc}
${ReferenceContentFragmentDoc}
${TacticRecommendationsFragmentFragmentDoc}`;
export const ProductTileFragmentDoc = gql`
    fragment ProductTile on Product {
  id
  name
  url
  primaryAsset: asset(tag: "primary") {
    url
  }
  masterVariant {
    price {
      ...PriceFragment
    }
  }
}
    ${PriceFragmentFragmentDoc}`;
export const RecommendationContentFragmentDoc = gql`
    fragment RecommendationContent on IWithRecommendations {
  recommendations {
    id
    placement
    type
    title
    splitTest {
      test
      groups
    }
    productIDs
    products(onlyEnabled: true) {
      url
      name
      type
      id
      availability {
        isInStock
        quantity
      }
      primaryAsset: asset(tag: "primary") {
        url
      }
      asset {
        url
      }
      brand {
        title
      }
      masterVariant {
        type: attribute(key: "type") {
          ... on IAttribute {
            key
          }
          ... on BaseAttribute {
            value
          }
        }
        personalizations: attribute(key: "personalizations") {
          ... on ProductAttribute {
            products {
              ...ProductCrossSellAndPersonalizationContent
            }
          }
        }
        shortName: attribute(key: "shortName") {
          ... on IAttribute {
            key
          }
          ... on BaseAttribute {
            value
          }
        }
        maxCharacters: attribute(key: "maxCharacters") {
          ... on IAttribute {
            key
          }
          ... on BaseAttribute {
            value
          }
        }
        price {
          countryCode
          currencyCode
          value
          format
          discount {
            code {
              id
              context
            }
            currencyCode
            percent
            value
            format
          }
        }
      }
    }
  }
}
    ${ProductCrossSellAndPersonalizationContentFragmentDoc}`;
export const OrderReviewFragmentFragmentDoc = gql`
    fragment OrderReviewFragment on OrderReview {
  id
  productReviews {
    id
    isReviewed
    product(mode: PROJECTION) {
      id
      name
      assets(tag: "gallery") {
        url
        dimensions {
          height
          width
        }
      }
    }
  }
}
    `;
export const ShippingInfoPriceFragmentFragmentDoc = gql`
    fragment ShippingInfoPriceFragment on ShippingInfoPrice {
  style
  text
  value {
    format
  }
}
    `;
export const MoneyFragmentDoc = gql`
    fragment Money on Money {
  currencyCode
  value
  format
}
    `;
export const GlobalBarsDocument = gql`
    query GlobalBars {
  bars {
    ...BarContent
  }
}
    ${BarContentFragmentDoc}`;

/**
 * __useGlobalBarsQuery__
 *
 * To run a query within a React component, call `useGlobalBarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalBarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalBarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalBarsQuery(baseOptions?: Apollo.QueryHookOptions<GlobalBarsQuery, GlobalBarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalBarsQuery, GlobalBarsQueryVariables>(GlobalBarsDocument, options);
      }
export function useGlobalBarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalBarsQuery, GlobalBarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalBarsQuery, GlobalBarsQueryVariables>(GlobalBarsDocument, options);
        }
export function useGlobalBarsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalBarsQuery, GlobalBarsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalBarsQuery, GlobalBarsQueryVariables>(GlobalBarsDocument, options);
        }
export type GlobalBarsQueryHookResult = ReturnType<typeof useGlobalBarsQuery>;
export type GlobalBarsLazyQueryHookResult = ReturnType<typeof useGlobalBarsLazyQuery>;
export type GlobalBarsSuspenseQueryHookResult = ReturnType<typeof useGlobalBarsSuspenseQuery>;
export type GlobalBarsQueryResult = Apollo.QueryResult<GlobalBarsQuery, GlobalBarsQueryVariables>;
export const AddToCartDocument = gql`
    mutation AddToCart($products: [AddToCartProductInput!]!, $withoutSuccessPrompt: Boolean, $boost: ID, $loadRecommendations: Boolean!) {
  addToCart(products: $products, withoutSuccessPrompt: $withoutSuccessPrompt) {
    addedLineItemIDs
    cart {
      ...CartContent
      ...RecommendationContent
    }
    prompts {
      __typename
      ... on AddToCartPromptError {
        index
        code
        message
      }
      ... on AddToCartPromptPersonalization {
        index
        code
        message
        productID
        selectedPersonalization: product {
          ...ProductCrossSellAndPersonalizationContent
        }
        personalizations: products {
          ...ProductCrossSellAndPersonalizationContent
        }
      }
      ... on AddToCartPromptSelectVariant {
        index
        productID
        product(
          mode: PROJECTION
          combineVariants: true
          onlyEnabled: true
          sortVariants: true
        ) {
          id
          name
          type
          primaryAsset: asset(tag: "primary") {
            url
          }
          ...ProductSizeGuideContent
          fitDimensions {
            id
            title {
              ...WordbookFragment
            }
          }
          variants {
            id
            availability {
              isInStock
              quantity
            }
            fits {
              id
              dimension
              fit {
                ...WordbookFragment
              }
            }
            restock: attribute(key: "restock") {
              ... on BaseAttribute {
                value
              }
            }
            size: attribute(key: "size") {
              ... on BaseAttribute {
                key
                value
              }
            }
          }
        }
        productIDs
        products(
          mode: PROJECTION
          combineVariants: true
          onlyEnabled: true
          sortVariants: true
        ) {
          variants {
            id
            size: attribute(key: "size") {
              ... on BaseAttribute {
                value
              }
            }
          }
        }
      }
      ... on AddToCartPromptSuccess {
        freeShipping {
          isFree
          remaining {
            ...MoneyContent
          }
        }
        primaryLineItemID
        secondaryLineItemIDs
        tactics {
          gold {
            ...AddToCartPromptSuccessTacticFragment
          }
          silver {
            ...AddToCartPromptSuccessTacticFragment
          }
        }
      }
    }
    success
  }
}
    ${CartContentFragmentDoc}
${RecommendationContentFragmentDoc}
${ProductCrossSellAndPersonalizationContentFragmentDoc}
${ProductSizeGuideContentFragmentDoc}
${WordbookFragmentFragmentDoc}
${MoneyContentFragmentDoc}
${AddToCartPromptSuccessTacticFragmentFragmentDoc}`;
export type AddToCartMutationFn = Apollo.MutationFunction<AddToCartMutation, AddToCartMutationVariables>;

/**
 * __useAddToCartMutation__
 *
 * To run a mutation, you first call `useAddToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToCartMutation, { data, loading, error }] = useAddToCartMutation({
 *   variables: {
 *      products: // value for 'products'
 *      withoutSuccessPrompt: // value for 'withoutSuccessPrompt'
 *      boost: // value for 'boost'
 *      loadRecommendations: // value for 'loadRecommendations'
 *   },
 * });
 */
export function useAddToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddToCartMutation, AddToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToCartMutation, AddToCartMutationVariables>(AddToCartDocument, options);
      }
export type AddToCartMutationHookResult = ReturnType<typeof useAddToCartMutation>;
export type AddToCartMutationResult = Apollo.MutationResult<AddToCartMutation>;
export type AddToCartMutationOptions = Apollo.BaseMutationOptions<AddToCartMutation, AddToCartMutationVariables>;
export const AuthenticateCartDocument = gql`
    mutation AuthenticateCart {
  authenticateCart {
    cart {
      ...CartContent
    }
    success
  }
}
    ${CartContentFragmentDoc}`;
export type AuthenticateCartMutationFn = Apollo.MutationFunction<AuthenticateCartMutation, AuthenticateCartMutationVariables>;

/**
 * __useAuthenticateCartMutation__
 *
 * To run a mutation, you first call `useAuthenticateCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateCartMutation, { data, loading, error }] = useAuthenticateCartMutation({
 *   variables: {
 *   },
 * });
 */
export function useAuthenticateCartMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateCartMutation, AuthenticateCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateCartMutation, AuthenticateCartMutationVariables>(AuthenticateCartDocument, options);
      }
export type AuthenticateCartMutationHookResult = ReturnType<typeof useAuthenticateCartMutation>;
export type AuthenticateCartMutationResult = Apollo.MutationResult<AuthenticateCartMutation>;
export type AuthenticateCartMutationOptions = Apollo.BaseMutationOptions<AuthenticateCartMutation, AuthenticateCartMutationVariables>;
export const CartDocument = gql`
    query Cart {
  cart {
    ...CartContent
    ...RecommendationContent
  }
}
    ${CartContentFragmentDoc}
${RecommendationContentFragmentDoc}`;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartQuery(baseOptions?: Apollo.QueryHookOptions<CartQuery, CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartQuery, CartQueryVariables>(CartDocument, options);
      }
export function useCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export function useCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartSuspenseQueryHookResult = ReturnType<typeof useCartSuspenseQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const CartSummaryDocument = gql`
    query CartSummary {
  cart {
    ...CartContent
  }
}
    ${CartContentFragmentDoc}`;

/**
 * __useCartSummaryQuery__
 *
 * To run a query within a React component, call `useCartSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartSummaryQuery(baseOptions?: Apollo.QueryHookOptions<CartSummaryQuery, CartSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartSummaryQuery, CartSummaryQueryVariables>(CartSummaryDocument, options);
      }
export function useCartSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartSummaryQuery, CartSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartSummaryQuery, CartSummaryQueryVariables>(CartSummaryDocument, options);
        }
export function useCartSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CartSummaryQuery, CartSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CartSummaryQuery, CartSummaryQueryVariables>(CartSummaryDocument, options);
        }
export type CartSummaryQueryHookResult = ReturnType<typeof useCartSummaryQuery>;
export type CartSummaryLazyQueryHookResult = ReturnType<typeof useCartSummaryLazyQuery>;
export type CartSummarySuspenseQueryHookResult = ReturnType<typeof useCartSummarySuspenseQuery>;
export type CartSummaryQueryResult = Apollo.QueryResult<CartSummaryQuery, CartSummaryQueryVariables>;
export const CheckoutCartDocument = gql`
    query CheckoutCart {
  checkout {
    addressMetaData(version: 2) {
      showAdditionalStreetInfo
      countries {
        code
        name
      }
      states
      regions
      showRegion
      showState
    }
    paymentMetaData {
      adyenConfig
      braintreeConfig
    }
    isOptInCountry
    cart {
      ...CartContent
      ...CartAddressContent
      ...CartAvailableShippingMethodsFragment
      shippingMethodID
      availablePaymentMethods {
        type
        title
        provider
        id
        logo {
          url
        }
        icons {
          logo {
            url
            tags
            dimensions {
              height
              width
            }
          }
          name
        }
      }
      deliveryAddress {
        email
        firstName
        lastName
        company
        streetName
        additionalStreetInfo
        postalCode
        city
        state
        country
        region
        phone
        phonePrefix
        externalID
        externalCustomerID
      }
    }
  }
}
    ${CartContentFragmentDoc}
${CartAddressContentFragmentDoc}
${CartAvailableShippingMethodsFragmentFragmentDoc}`;

/**
 * __useCheckoutCartQuery__
 *
 * To run a query within a React component, call `useCheckoutCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckoutCartQuery(baseOptions?: Apollo.QueryHookOptions<CheckoutCartQuery, CheckoutCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutCartQuery, CheckoutCartQueryVariables>(CheckoutCartDocument, options);
      }
export function useCheckoutCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutCartQuery, CheckoutCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutCartQuery, CheckoutCartQueryVariables>(CheckoutCartDocument, options);
        }
export function useCheckoutCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutCartQuery, CheckoutCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutCartQuery, CheckoutCartQueryVariables>(CheckoutCartDocument, options);
        }
export type CheckoutCartQueryHookResult = ReturnType<typeof useCheckoutCartQuery>;
export type CheckoutCartLazyQueryHookResult = ReturnType<typeof useCheckoutCartLazyQuery>;
export type CheckoutCartSuspenseQueryHookResult = ReturnType<typeof useCheckoutCartSuspenseQuery>;
export type CheckoutCartQueryResult = Apollo.QueryResult<CheckoutCartQuery, CheckoutCartQueryVariables>;
export const FinalizeCartDocument = gql`
    mutation FinalizeCart($checksum: String, $consents: [String!], $paymentMethodID: ID, $paymentPayload: JSON, $recaptchaToken: String) {
  finalizeCart(
    checksum: $checksum
    consents: $consents
    paymentMethodID: $paymentMethodID
    paymentPayload: $paymentPayload
    recaptchaToken: $recaptchaToken
  ) {
    success
    orderNumber
    paymentPayload
    prompts {
      ... on FinalizeCartPromptError {
        code
        message
      }
    }
    redirect
  }
}
    `;
export type FinalizeCartMutationFn = Apollo.MutationFunction<FinalizeCartMutation, FinalizeCartMutationVariables>;

/**
 * __useFinalizeCartMutation__
 *
 * To run a mutation, you first call `useFinalizeCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeCartMutation, { data, loading, error }] = useFinalizeCartMutation({
 *   variables: {
 *      checksum: // value for 'checksum'
 *      consents: // value for 'consents'
 *      paymentMethodID: // value for 'paymentMethodID'
 *      paymentPayload: // value for 'paymentPayload'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useFinalizeCartMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeCartMutation, FinalizeCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeCartMutation, FinalizeCartMutationVariables>(FinalizeCartDocument, options);
      }
export type FinalizeCartMutationHookResult = ReturnType<typeof useFinalizeCartMutation>;
export type FinalizeCartMutationResult = Apollo.MutationResult<FinalizeCartMutation>;
export type FinalizeCartMutationOptions = Apollo.BaseMutationOptions<FinalizeCartMutation, FinalizeCartMutationVariables>;
export const DetailsForPaymentDocument = gql`
    mutation DetailsForPayment($payload: JSON) {
  getDetailsForPayment(payload: $payload) {
    redirect
    success
    details
  }
}
    `;
export type DetailsForPaymentMutationFn = Apollo.MutationFunction<DetailsForPaymentMutation, DetailsForPaymentMutationVariables>;

/**
 * __useDetailsForPaymentMutation__
 *
 * To run a mutation, you first call `useDetailsForPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetailsForPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detailsForPaymentMutation, { data, loading, error }] = useDetailsForPaymentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useDetailsForPaymentMutation(baseOptions?: Apollo.MutationHookOptions<DetailsForPaymentMutation, DetailsForPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetailsForPaymentMutation, DetailsForPaymentMutationVariables>(DetailsForPaymentDocument, options);
      }
export type DetailsForPaymentMutationHookResult = ReturnType<typeof useDetailsForPaymentMutation>;
export type DetailsForPaymentMutationResult = Apollo.MutationResult<DetailsForPaymentMutation>;
export type DetailsForPaymentMutationOptions = Apollo.BaseMutationOptions<DetailsForPaymentMutation, DetailsForPaymentMutationVariables>;
export const InitializePaymentMethodDocument = gql`
    mutation InitializePaymentMethod($paymentMethodID: ID!, $payload: JSON) {
  initializePaymentMethod(paymentMethodID: $paymentMethodID, payload: $payload) {
    payload
    success
  }
}
    `;
export type InitializePaymentMethodMutationFn = Apollo.MutationFunction<InitializePaymentMethodMutation, InitializePaymentMethodMutationVariables>;

/**
 * __useInitializePaymentMethodMutation__
 *
 * To run a mutation, you first call `useInitializePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializePaymentMethodMutation, { data, loading, error }] = useInitializePaymentMethodMutation({
 *   variables: {
 *      paymentMethodID: // value for 'paymentMethodID'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useInitializePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<InitializePaymentMethodMutation, InitializePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializePaymentMethodMutation, InitializePaymentMethodMutationVariables>(InitializePaymentMethodDocument, options);
      }
export type InitializePaymentMethodMutationHookResult = ReturnType<typeof useInitializePaymentMethodMutation>;
export type InitializePaymentMethodMutationResult = Apollo.MutationResult<InitializePaymentMethodMutation>;
export type InitializePaymentMethodMutationOptions = Apollo.BaseMutationOptions<InitializePaymentMethodMutation, InitializePaymentMethodMutationVariables>;
export const RefreshCartDocument = gql`
    mutation RefreshCart($fixErrors: Boolean) {
  refreshCart(fixErrors: $fixErrors) {
    cart {
      ...CartContent
      ...RecommendationContent
    }
    success
  }
}
    ${CartContentFragmentDoc}
${RecommendationContentFragmentDoc}`;
export type RefreshCartMutationFn = Apollo.MutationFunction<RefreshCartMutation, RefreshCartMutationVariables>;

/**
 * __useRefreshCartMutation__
 *
 * To run a mutation, you first call `useRefreshCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCartMutation, { data, loading, error }] = useRefreshCartMutation({
 *   variables: {
 *      fixErrors: // value for 'fixErrors'
 *   },
 * });
 */
export function useRefreshCartMutation(baseOptions?: Apollo.MutationHookOptions<RefreshCartMutation, RefreshCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshCartMutation, RefreshCartMutationVariables>(RefreshCartDocument, options);
      }
export type RefreshCartMutationHookResult = ReturnType<typeof useRefreshCartMutation>;
export type RefreshCartMutationResult = Apollo.MutationResult<RefreshCartMutation>;
export type RefreshCartMutationOptions = Apollo.BaseMutationOptions<RefreshCartMutation, RefreshCartMutationVariables>;
export const RemoveFromCartDocument = gql`
    mutation RemoveFromCart($lineItemID: ID!) {
  removeFromCart(lineItemIDs: [$lineItemID]) {
    cart {
      ...CartContent
    }
    prompts {
      __typename
      ... on RemoveFromCartPromptError {
        index
        code
        message
      }
    }
    success
  }
}
    ${CartContentFragmentDoc}`;
export type RemoveFromCartMutationFn = Apollo.MutationFunction<RemoveFromCartMutation, RemoveFromCartMutationVariables>;

/**
 * __useRemoveFromCartMutation__
 *
 * To run a mutation, you first call `useRemoveFromCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromCartMutation, { data, loading, error }] = useRemoveFromCartMutation({
 *   variables: {
 *      lineItemID: // value for 'lineItemID'
 *   },
 * });
 */
export function useRemoveFromCartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFromCartMutation, RemoveFromCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFromCartMutation, RemoveFromCartMutationVariables>(RemoveFromCartDocument, options);
      }
export type RemoveFromCartMutationHookResult = ReturnType<typeof useRemoveFromCartMutation>;
export type RemoveFromCartMutationResult = Apollo.MutationResult<RemoveFromCartMutation>;
export type RemoveFromCartMutationOptions = Apollo.BaseMutationOptions<RemoveFromCartMutation, RemoveFromCartMutationVariables>;
export const SetAddressesInCartDocument = gql`
    mutation SetAddressesInCart($shippingAddress: AddressInput!, $billingAddress: AddressInput!) {
  setAddressesInCart(
    shippingAddress: $shippingAddress
    billingAddress: $billingAddress
  ) {
    success
    cart {
      id
      checksum
      ...CartAddressContent
      ...CartAvailableShippingMethodsFragment
      expectedDelivery
      totals {
        id
        style
        title
        text
        value {
          ...MoneyContent
        }
      }
      shippingMethodID
      deliveryAddress {
        email
        firstName
        lastName
        company
        streetName
        additionalStreetInfo
        postalCode
        city
        state
        country
        region
        phone
        phonePrefix
        externalID
        externalCustomerID
      }
    }
  }
}
    ${CartAddressContentFragmentDoc}
${CartAvailableShippingMethodsFragmentFragmentDoc}
${MoneyContentFragmentDoc}`;
export type SetAddressesInCartMutationFn = Apollo.MutationFunction<SetAddressesInCartMutation, SetAddressesInCartMutationVariables>;

/**
 * __useSetAddressesInCartMutation__
 *
 * To run a mutation, you first call `useSetAddressesInCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddressesInCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddressesInCartMutation, { data, loading, error }] = useSetAddressesInCartMutation({
 *   variables: {
 *      shippingAddress: // value for 'shippingAddress'
 *      billingAddress: // value for 'billingAddress'
 *   },
 * });
 */
export function useSetAddressesInCartMutation(baseOptions?: Apollo.MutationHookOptions<SetAddressesInCartMutation, SetAddressesInCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAddressesInCartMutation, SetAddressesInCartMutationVariables>(SetAddressesInCartDocument, options);
      }
export type SetAddressesInCartMutationHookResult = ReturnType<typeof useSetAddressesInCartMutation>;
export type SetAddressesInCartMutationResult = Apollo.MutationResult<SetAddressesInCartMutation>;
export type SetAddressesInCartMutationOptions = Apollo.BaseMutationOptions<SetAddressesInCartMutation, SetAddressesInCartMutationVariables>;
export const SetDiscountCodeInCartDocument = gql`
    mutation SetDiscountCodeInCart($customerID: ID, $discountCode: ID) {
  setDiscountCodeInCart(customerID: $customerID, discountCode: $discountCode) {
    cart {
      ...CartContent
    }
    prompts {
      __typename
      ... on SetDiscountCodeInCartPromptSuccess {
        bars {
          ...BarContent
        }
      }
      ... on SetDiscountCodeInCartPromptError {
        code
        message
      }
    }
    success
  }
}
    ${CartContentFragmentDoc}
${BarContentFragmentDoc}`;
export type SetDiscountCodeInCartMutationFn = Apollo.MutationFunction<SetDiscountCodeInCartMutation, SetDiscountCodeInCartMutationVariables>;

/**
 * __useSetDiscountCodeInCartMutation__
 *
 * To run a mutation, you first call `useSetDiscountCodeInCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDiscountCodeInCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDiscountCodeInCartMutation, { data, loading, error }] = useSetDiscountCodeInCartMutation({
 *   variables: {
 *      customerID: // value for 'customerID'
 *      discountCode: // value for 'discountCode'
 *   },
 * });
 */
export function useSetDiscountCodeInCartMutation(baseOptions?: Apollo.MutationHookOptions<SetDiscountCodeInCartMutation, SetDiscountCodeInCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDiscountCodeInCartMutation, SetDiscountCodeInCartMutationVariables>(SetDiscountCodeInCartDocument, options);
      }
export type SetDiscountCodeInCartMutationHookResult = ReturnType<typeof useSetDiscountCodeInCartMutation>;
export type SetDiscountCodeInCartMutationResult = Apollo.MutationResult<SetDiscountCodeInCartMutation>;
export type SetDiscountCodeInCartMutationOptions = Apollo.BaseMutationOptions<SetDiscountCodeInCartMutation, SetDiscountCodeInCartMutationVariables>;
export const SetQuantityInCartDocument = gql`
    mutation SetQuantityInCart($lineItems: [SetQuantityInCartLineItemInput!]!) {
  setQuantityInCart(lineItems: $lineItems) {
    cart {
      ...CartContent
      ...RecommendationContent
    }
    prompts {
      __typename
      ... on SetQuantityInCartPromptError {
        index
        code
        message
      }
    }
    success
  }
}
    ${CartContentFragmentDoc}
${RecommendationContentFragmentDoc}`;
export type SetQuantityInCartMutationFn = Apollo.MutationFunction<SetQuantityInCartMutation, SetQuantityInCartMutationVariables>;

/**
 * __useSetQuantityInCartMutation__
 *
 * To run a mutation, you first call `useSetQuantityInCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuantityInCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuantityInCartMutation, { data, loading, error }] = useSetQuantityInCartMutation({
 *   variables: {
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
export function useSetQuantityInCartMutation(baseOptions?: Apollo.MutationHookOptions<SetQuantityInCartMutation, SetQuantityInCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetQuantityInCartMutation, SetQuantityInCartMutationVariables>(SetQuantityInCartDocument, options);
      }
export type SetQuantityInCartMutationHookResult = ReturnType<typeof useSetQuantityInCartMutation>;
export type SetQuantityInCartMutationResult = Apollo.MutationResult<SetQuantityInCartMutation>;
export type SetQuantityInCartMutationOptions = Apollo.BaseMutationOptions<SetQuantityInCartMutation, SetQuantityInCartMutationVariables>;
export const SetShippingMethodInCartDeliveryDocument = gql`
    mutation SetShippingMethodInCartDelivery($shippingMethod: ShippingMethodInput!) {
  setShippingMethodInCart(shippingMethod: $shippingMethod) {
    success
    cart {
      id
      checksum
      shippingMethodID
      ...CartAvailableShippingMethodsFragment
      expectedDelivery
      totals {
        id
        style
        title
        text
        value {
          ...MoneyContent
        }
      }
      deliveryAddress {
        email
        firstName
        lastName
        company
        streetName
        additionalStreetInfo
        postalCode
        city
        state
        country
        region
        phone
        phonePrefix
        externalID
        externalCustomerID
      }
    }
  }
}
    ${CartAvailableShippingMethodsFragmentFragmentDoc}
${MoneyContentFragmentDoc}`;
export type SetShippingMethodInCartDeliveryMutationFn = Apollo.MutationFunction<SetShippingMethodInCartDeliveryMutation, SetShippingMethodInCartDeliveryMutationVariables>;

/**
 * __useSetShippingMethodInCartDeliveryMutation__
 *
 * To run a mutation, you first call `useSetShippingMethodInCartDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetShippingMethodInCartDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setShippingMethodInCartDeliveryMutation, { data, loading, error }] = useSetShippingMethodInCartDeliveryMutation({
 *   variables: {
 *      shippingMethod: // value for 'shippingMethod'
 *   },
 * });
 */
export function useSetShippingMethodInCartDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<SetShippingMethodInCartDeliveryMutation, SetShippingMethodInCartDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetShippingMethodInCartDeliveryMutation, SetShippingMethodInCartDeliveryMutationVariables>(SetShippingMethodInCartDeliveryDocument, options);
      }
export type SetShippingMethodInCartDeliveryMutationHookResult = ReturnType<typeof useSetShippingMethodInCartDeliveryMutation>;
export type SetShippingMethodInCartDeliveryMutationResult = Apollo.MutationResult<SetShippingMethodInCartDeliveryMutation>;
export type SetShippingMethodInCartDeliveryMutationOptions = Apollo.BaseMutationOptions<SetShippingMethodInCartDeliveryMutation, SetShippingMethodInCartDeliveryMutationVariables>;
export const SetVariantInCartDocument = gql`
    mutation SetVariantInCart($lineItems: [SetVariantInCartLineItemInput!]!) {
  setVariantInCart(lineItems: $lineItems) {
    cart {
      ...CartContent
    }
    success
  }
}
    ${CartContentFragmentDoc}`;
export type SetVariantInCartMutationFn = Apollo.MutationFunction<SetVariantInCartMutation, SetVariantInCartMutationVariables>;

/**
 * __useSetVariantInCartMutation__
 *
 * To run a mutation, you first call `useSetVariantInCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVariantInCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVariantInCartMutation, { data, loading, error }] = useSetVariantInCartMutation({
 *   variables: {
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
export function useSetVariantInCartMutation(baseOptions?: Apollo.MutationHookOptions<SetVariantInCartMutation, SetVariantInCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetVariantInCartMutation, SetVariantInCartMutationVariables>(SetVariantInCartDocument, options);
      }
export type SetVariantInCartMutationHookResult = ReturnType<typeof useSetVariantInCartMutation>;
export type SetVariantInCartMutationResult = Apollo.MutationResult<SetVariantInCartMutation>;
export type SetVariantInCartMutationOptions = Apollo.BaseMutationOptions<SetVariantInCartMutation, SetVariantInCartMutationVariables>;
export const ShippingMethodDocument = gql`
    query ShippingMethod($shippingMethodId: ID!, $postalCode: String, $streetName: String, $country: String, $city: String) {
  shippingMethod(
    id: $shippingMethodId
    postalCode: $postalCode
    streetName: $streetName
    country: $country
    city: $city
  ) {
    id
    serviceLocations {
      checksum
      city
      distance
      externalID
      latitude
      longitude
      name
      openingHours {
        closes {
          hours
          minutes
          nanos
          seconds
        }
        dayOfWeek
        opens {
          hours
          minutes
          nanos
          seconds
        }
      }
      postalCode
      streetName
      additionalStreetInfo
      version
    }
  }
}
    `;

/**
 * __useShippingMethodQuery__
 *
 * To run a query within a React component, call `useShippingMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingMethodQuery({
 *   variables: {
 *      shippingMethodId: // value for 'shippingMethodId'
 *      postalCode: // value for 'postalCode'
 *      streetName: // value for 'streetName'
 *      country: // value for 'country'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useShippingMethodQuery(baseOptions: Apollo.QueryHookOptions<ShippingMethodQuery, ShippingMethodQueryVariables> & ({ variables: ShippingMethodQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingMethodQuery, ShippingMethodQueryVariables>(ShippingMethodDocument, options);
      }
export function useShippingMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingMethodQuery, ShippingMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingMethodQuery, ShippingMethodQueryVariables>(ShippingMethodDocument, options);
        }
export function useShippingMethodSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShippingMethodQuery, ShippingMethodQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShippingMethodQuery, ShippingMethodQueryVariables>(ShippingMethodDocument, options);
        }
export type ShippingMethodQueryHookResult = ReturnType<typeof useShippingMethodQuery>;
export type ShippingMethodLazyQueryHookResult = ReturnType<typeof useShippingMethodLazyQuery>;
export type ShippingMethodSuspenseQueryHookResult = ReturnType<typeof useShippingMethodSuspenseQuery>;
export type ShippingMethodQueryResult = Apollo.QueryResult<ShippingMethodQuery, ShippingMethodQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ... on Customer {
      id
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MeWithClubDocument = gql`
    query MeWithClub {
  me {
    ... on Customer {
      id
      email
      club {
        history {
          amount {
            format
            currencyCode
            value
          }
          createdAt
          createdAtText
          orderNumber
        }
        expiringTransaction {
          expiresIn {
            ...WordbookFragment
          }
          amount {
            value
            format
            currencyCode
          }
        }
        balance {
          currencyCode
          format
          value
        }
      }
    }
  }
}
    ${WordbookFragmentFragmentDoc}`;

/**
 * __useMeWithClubQuery__
 *
 * To run a query within a React component, call `useMeWithClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeWithClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeWithClubQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeWithClubQuery(baseOptions?: Apollo.QueryHookOptions<MeWithClubQuery, MeWithClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeWithClubQuery, MeWithClubQueryVariables>(MeWithClubDocument, options);
      }
export function useMeWithClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeWithClubQuery, MeWithClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeWithClubQuery, MeWithClubQueryVariables>(MeWithClubDocument, options);
        }
export function useMeWithClubSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeWithClubQuery, MeWithClubQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeWithClubQuery, MeWithClubQueryVariables>(MeWithClubDocument, options);
        }
export type MeWithClubQueryHookResult = ReturnType<typeof useMeWithClubQuery>;
export type MeWithClubLazyQueryHookResult = ReturnType<typeof useMeWithClubLazyQuery>;
export type MeWithClubSuspenseQueryHookResult = ReturnType<typeof useMeWithClubSuspenseQuery>;
export type MeWithClubQueryResult = Apollo.QueryResult<MeWithClubQuery, MeWithClubQueryVariables>;
export const DrawerPageDocument = gql`
    query DrawerPage($type: PageType!, $id: ID, $presentation: PagePresentation = SIDEBAR, $boost: ID) {
  page(type: $type, id: $id, presentation: $presentation) {
    ...DrawerData
  }
}
    ${DrawerDataFragmentDoc}`;

/**
 * __useDrawerPageQuery__
 *
 * To run a query within a React component, call `useDrawerPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrawerPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrawerPageQuery({
 *   variables: {
 *      type: // value for 'type'
 *      id: // value for 'id'
 *      presentation: // value for 'presentation'
 *      boost: // value for 'boost'
 *   },
 * });
 */
export function useDrawerPageQuery(baseOptions: Apollo.QueryHookOptions<DrawerPageQuery, DrawerPageQueryVariables> & ({ variables: DrawerPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DrawerPageQuery, DrawerPageQueryVariables>(DrawerPageDocument, options);
      }
export function useDrawerPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DrawerPageQuery, DrawerPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DrawerPageQuery, DrawerPageQueryVariables>(DrawerPageDocument, options);
        }
export function useDrawerPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DrawerPageQuery, DrawerPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DrawerPageQuery, DrawerPageQueryVariables>(DrawerPageDocument, options);
        }
export type DrawerPageQueryHookResult = ReturnType<typeof useDrawerPageQuery>;
export type DrawerPageLazyQueryHookResult = ReturnType<typeof useDrawerPageLazyQuery>;
export type DrawerPageSuspenseQueryHookResult = ReturnType<typeof useDrawerPageSuspenseQuery>;
export type DrawerPageQueryResult = Apollo.QueryResult<DrawerPageQuery, DrawerPageQueryVariables>;
export const DrawerPagesDocument = gql`
    query DrawerPages($pages: [PageIdentifier!]!, $presentation: PagePresentation = SIDEBAR, $boost: ID) {
  pages(pages: $pages, presentation: $presentation) {
    ...DrawerData
  }
}
    ${DrawerDataFragmentDoc}`;

/**
 * __useDrawerPagesQuery__
 *
 * To run a query within a React component, call `useDrawerPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrawerPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrawerPagesQuery({
 *   variables: {
 *      pages: // value for 'pages'
 *      presentation: // value for 'presentation'
 *      boost: // value for 'boost'
 *   },
 * });
 */
export function useDrawerPagesQuery(baseOptions: Apollo.QueryHookOptions<DrawerPagesQuery, DrawerPagesQueryVariables> & ({ variables: DrawerPagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DrawerPagesQuery, DrawerPagesQueryVariables>(DrawerPagesDocument, options);
      }
export function useDrawerPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DrawerPagesQuery, DrawerPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DrawerPagesQuery, DrawerPagesQueryVariables>(DrawerPagesDocument, options);
        }
export function useDrawerPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DrawerPagesQuery, DrawerPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DrawerPagesQuery, DrawerPagesQueryVariables>(DrawerPagesDocument, options);
        }
export type DrawerPagesQueryHookResult = ReturnType<typeof useDrawerPagesQuery>;
export type DrawerPagesLazyQueryHookResult = ReturnType<typeof useDrawerPagesLazyQuery>;
export type DrawerPagesSuspenseQueryHookResult = ReturnType<typeof useDrawerPagesSuspenseQuery>;
export type DrawerPagesQueryResult = Apollo.QueryResult<DrawerPagesQuery, DrawerPagesQueryVariables>;
export const GlobalCmsDataDocument = gql`
    query GlobalCMSData {
  latestCollections: latestPages(type: COLLECTION, limit: 3) {
    ...LatestPageItem
    brand {
      id
      url
      title
      logo
    }
  }
  pageAboutUs: page(type: ARTICLE, id: "209") {
    ...PageItem
  }
  pageArticles: page(type: ARTICLE, id: "1") {
    ...PageItem
  }
  pageCookiePolicy: page(type: TERMS, id: "310") {
    ...PageItem
  }
  pageCSR: page(type: CSR, id: "773") {
    ...PageItem
  }
  pageFAQ: page(type: LANDINGPAGE, id: "2205") {
    ...PageItem
  }
  pagePress: page(type: PRESS, id: "1") {
    ...PageItem
  }
  pagePrivacyPolicy: page(type: TERMS, id: "309") {
    ...PageItem
  }
  pageReturns: page(type: RETURNS, id: "1") {
    ...PageItem
  }
  pageTerms: page(type: TERMS, id: "136") {
    ...PageItem
  }
  menuGiftGuide: page(type: LANDINGPAGE, id: "2264") {
    ...PageItem
  }
}
    ${LatestPageItemFragmentDoc}
${PageItemFragmentDoc}`;

/**
 * __useGlobalCmsDataQuery__
 *
 * To run a query within a React component, call `useGlobalCmsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalCmsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalCmsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalCmsDataQuery(baseOptions?: Apollo.QueryHookOptions<GlobalCmsDataQuery, GlobalCmsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalCmsDataQuery, GlobalCmsDataQueryVariables>(GlobalCmsDataDocument, options);
      }
export function useGlobalCmsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalCmsDataQuery, GlobalCmsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalCmsDataQuery, GlobalCmsDataQueryVariables>(GlobalCmsDataDocument, options);
        }
export function useGlobalCmsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalCmsDataQuery, GlobalCmsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalCmsDataQuery, GlobalCmsDataQueryVariables>(GlobalCmsDataDocument, options);
        }
export type GlobalCmsDataQueryHookResult = ReturnType<typeof useGlobalCmsDataQuery>;
export type GlobalCmsDataLazyQueryHookResult = ReturnType<typeof useGlobalCmsDataLazyQuery>;
export type GlobalCmsDataSuspenseQueryHookResult = ReturnType<typeof useGlobalCmsDataSuspenseQuery>;
export type GlobalCmsDataQueryResult = Apollo.QueryResult<GlobalCmsDataQuery, GlobalCmsDataQueryVariables>;
export const LatestArticlesAndCollectionsDocument = gql`
    query LatestArticlesAndCollections($excludeArticleIDs: [String!], $excludeCollectionIDs: [String!]) {
  articles: latestPages(type: ARTICLE, limit: 9, excludeIDs: $excludeArticleIDs) {
    ...PageContent
  }
  collections: latestPages(
    type: COLLECTION
    limit: 9
    excludeIDs: $excludeCollectionIDs
  ) {
    ...PageContent
    brand {
      id
      logo
      title
    }
  }
}
    ${PageContentFragmentDoc}`;

/**
 * __useLatestArticlesAndCollectionsQuery__
 *
 * To run a query within a React component, call `useLatestArticlesAndCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestArticlesAndCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestArticlesAndCollectionsQuery({
 *   variables: {
 *      excludeArticleIDs: // value for 'excludeArticleIDs'
 *      excludeCollectionIDs: // value for 'excludeCollectionIDs'
 *   },
 * });
 */
export function useLatestArticlesAndCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<LatestArticlesAndCollectionsQuery, LatestArticlesAndCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestArticlesAndCollectionsQuery, LatestArticlesAndCollectionsQueryVariables>(LatestArticlesAndCollectionsDocument, options);
      }
export function useLatestArticlesAndCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestArticlesAndCollectionsQuery, LatestArticlesAndCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestArticlesAndCollectionsQuery, LatestArticlesAndCollectionsQueryVariables>(LatestArticlesAndCollectionsDocument, options);
        }
export function useLatestArticlesAndCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestArticlesAndCollectionsQuery, LatestArticlesAndCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestArticlesAndCollectionsQuery, LatestArticlesAndCollectionsQueryVariables>(LatestArticlesAndCollectionsDocument, options);
        }
export type LatestArticlesAndCollectionsQueryHookResult = ReturnType<typeof useLatestArticlesAndCollectionsQuery>;
export type LatestArticlesAndCollectionsLazyQueryHookResult = ReturnType<typeof useLatestArticlesAndCollectionsLazyQuery>;
export type LatestArticlesAndCollectionsSuspenseQueryHookResult = ReturnType<typeof useLatestArticlesAndCollectionsSuspenseQuery>;
export type LatestArticlesAndCollectionsQueryResult = Apollo.QueryResult<LatestArticlesAndCollectionsQuery, LatestArticlesAndCollectionsQueryVariables>;
export const GlobalNavigationDocument = gql`
    query GlobalNavigation($boost: ID) {
  navigation(placement: DEFAULT) {
    ...NavigationItemFragment
    blocks {
      ...BlockContent
      ... on GlobalBlock {
        id
        type
        blocks {
          ...BlockContent
        }
      }
    }
    items {
      ...NavigationItemFragment
      items {
        ...NavigationItemFragment
      }
    }
  }
  navigationTop: navigation(placement: TOP) {
    ...NavigationItemFragment
  }
}
    ${NavigationItemFragmentFragmentDoc}
${BlockContentFragmentDoc}`;

/**
 * __useGlobalNavigationQuery__
 *
 * To run a query within a React component, call `useGlobalNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalNavigationQuery({
 *   variables: {
 *      boost: // value for 'boost'
 *   },
 * });
 */
export function useGlobalNavigationQuery(baseOptions?: Apollo.QueryHookOptions<GlobalNavigationQuery, GlobalNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalNavigationQuery, GlobalNavigationQueryVariables>(GlobalNavigationDocument, options);
      }
export function useGlobalNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalNavigationQuery, GlobalNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalNavigationQuery, GlobalNavigationQueryVariables>(GlobalNavigationDocument, options);
        }
export function useGlobalNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalNavigationQuery, GlobalNavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalNavigationQuery, GlobalNavigationQueryVariables>(GlobalNavigationDocument, options);
        }
export type GlobalNavigationQueryHookResult = ReturnType<typeof useGlobalNavigationQuery>;
export type GlobalNavigationLazyQueryHookResult = ReturnType<typeof useGlobalNavigationLazyQuery>;
export type GlobalNavigationSuspenseQueryHookResult = ReturnType<typeof useGlobalNavigationSuspenseQuery>;
export type GlobalNavigationQueryResult = Apollo.QueryResult<GlobalNavigationQuery, GlobalNavigationQueryVariables>;
export const ProductForAddToCartDocument = gql`
    query ProductForAddToCart($id: ID) {
  product(
    id: $id
    mode: PROJECTION
    combineVariants: true
    onlyEnabled: true
    sortVariants: true
  ) {
    ...ProductContent
  }
}
    ${ProductContentFragmentDoc}`;

/**
 * __useProductForAddToCartQuery__
 *
 * To run a query within a React component, call `useProductForAddToCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductForAddToCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductForAddToCartQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductForAddToCartQuery(baseOptions?: Apollo.QueryHookOptions<ProductForAddToCartQuery, ProductForAddToCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductForAddToCartQuery, ProductForAddToCartQueryVariables>(ProductForAddToCartDocument, options);
      }
export function useProductForAddToCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductForAddToCartQuery, ProductForAddToCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductForAddToCartQuery, ProductForAddToCartQueryVariables>(ProductForAddToCartDocument, options);
        }
export function useProductForAddToCartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductForAddToCartQuery, ProductForAddToCartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductForAddToCartQuery, ProductForAddToCartQueryVariables>(ProductForAddToCartDocument, options);
        }
export type ProductForAddToCartQueryHookResult = ReturnType<typeof useProductForAddToCartQuery>;
export type ProductForAddToCartLazyQueryHookResult = ReturnType<typeof useProductForAddToCartLazyQuery>;
export type ProductForAddToCartSuspenseQueryHookResult = ReturnType<typeof useProductForAddToCartSuspenseQuery>;
export type ProductForAddToCartQueryResult = Apollo.QueryResult<ProductForAddToCartQuery, ProductForAddToCartQueryVariables>;
export const ProductReviewsDocument = gql`
    query ProductReviews($type: PageType!, $slug: String, $id: ID, $reviewLimit: Int = 10, $reviewCursor: String = "") {
  page(type: $type, slug: $slug, id: $id) {
    id
    type
    fields {
      ... on ProductField {
        key
        product(mode: PROJECTION, onlyEnabled: true) {
          ...ProductReviews
        }
      }
    }
  }
}
    ${ProductReviewsFragmentDoc}`;

/**
 * __useProductReviewsQuery__
 *
 * To run a query within a React component, call `useProductReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductReviewsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      slug: // value for 'slug'
 *      id: // value for 'id'
 *      reviewLimit: // value for 'reviewLimit'
 *      reviewCursor: // value for 'reviewCursor'
 *   },
 * });
 */
export function useProductReviewsQuery(baseOptions: Apollo.QueryHookOptions<ProductReviewsQuery, ProductReviewsQueryVariables> & ({ variables: ProductReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductReviewsQuery, ProductReviewsQueryVariables>(ProductReviewsDocument, options);
      }
export function useProductReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductReviewsQuery, ProductReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductReviewsQuery, ProductReviewsQueryVariables>(ProductReviewsDocument, options);
        }
export function useProductReviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductReviewsQuery, ProductReviewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductReviewsQuery, ProductReviewsQueryVariables>(ProductReviewsDocument, options);
        }
export type ProductReviewsQueryHookResult = ReturnType<typeof useProductReviewsQuery>;
export type ProductReviewsLazyQueryHookResult = ReturnType<typeof useProductReviewsLazyQuery>;
export type ProductReviewsSuspenseQueryHookResult = ReturnType<typeof useProductReviewsSuspenseQuery>;
export type ProductReviewsQueryResult = Apollo.QueryResult<ProductReviewsQuery, ProductReviewsQueryVariables>;
export const ProductTacticsDocument = gql`
    query ProductTactics($type: PageType!, $slug: String, $id: ID, $loadRecommendations: Boolean = true, $boost: ID) {
  page(type: $type, slug: $slug, id: $id) {
    id
    type
    fields {
      ... on ProductField {
        key
        product(
          mode: PROJECTION
          combineVariants: true
          onlyEnabled: true
          sortVariants: true
        ) {
          tactics {
            gold {
              ...ProductPageTacticFragment
            }
            silver {
              ...ProductPageTacticFragment
            }
            bronze {
              ...ProductPageTacticFragment
            }
          }
        }
      }
    }
  }
}
    ${ProductPageTacticFragmentFragmentDoc}`;

/**
 * __useProductTacticsQuery__
 *
 * To run a query within a React component, call `useProductTacticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTacticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTacticsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      slug: // value for 'slug'
 *      id: // value for 'id'
 *      loadRecommendations: // value for 'loadRecommendations'
 *      boost: // value for 'boost'
 *   },
 * });
 */
export function useProductTacticsQuery(baseOptions: Apollo.QueryHookOptions<ProductTacticsQuery, ProductTacticsQueryVariables> & ({ variables: ProductTacticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductTacticsQuery, ProductTacticsQueryVariables>(ProductTacticsDocument, options);
      }
export function useProductTacticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductTacticsQuery, ProductTacticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductTacticsQuery, ProductTacticsQueryVariables>(ProductTacticsDocument, options);
        }
export function useProductTacticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductTacticsQuery, ProductTacticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductTacticsQuery, ProductTacticsQueryVariables>(ProductTacticsDocument, options);
        }
export type ProductTacticsQueryHookResult = ReturnType<typeof useProductTacticsQuery>;
export type ProductTacticsLazyQueryHookResult = ReturnType<typeof useProductTacticsLazyQuery>;
export type ProductTacticsSuspenseQueryHookResult = ReturnType<typeof useProductTacticsSuspenseQuery>;
export type ProductTacticsQueryResult = Apollo.QueryResult<ProductTacticsQuery, ProductTacticsQueryVariables>;
export const SinglePostDocument = gql`
    query SinglePost($type: PageType!, $slug: String, $id: ID, $breadcrumbsVersion: Int = 1, $presentation: PagePresentation = FULL, $boost: ID) {
  page(type: $type, slug: $slug, id: $id, presentation: $presentation) {
    id
    type
    title
    url
    brand {
      id
      logo
      title
    }
    seo {
      title
      description
      noIndex
      includeInSitemap
    }
    breadcrumbs(version: $breadcrumbsVersion) {
      id
      type
      title
      url
    }
    openGraph {
      ...OpenGraphContent
    }
    alternateLinks {
      locale
      url
    }
    image {
      ...ImageResourceImageFragment
    }
    blocks {
      ...BlockContent
      ... on GlobalBlock {
        id
        type
        blocks {
          ...BlockContent
        }
      }
      ... on ProductListBlock {
        extraBlocks {
          ...BlockContent
        }
        injections {
          id
          slot
          blocks {
            ...BlockContent
          }
        }
        guidedFilters {
          ... on GuidedFilterAttributeEnum {
            items {
              extraBlocks {
                ...BlockContent
              }
              injections {
                id
                slot
                blocks {
                  ...BlockContent
                }
              }
            }
          }
        }
      }
    }
    fields {
      ...Fields
    }
  }
}
    ${OpenGraphContentFragmentDoc}
${ImageResourceImageFragmentFragmentDoc}
${BlockContentFragmentDoc}
${FieldsFragmentDoc}`;

/**
 * __useSinglePostQuery__
 *
 * To run a query within a React component, call `useSinglePostQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinglePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinglePostQuery({
 *   variables: {
 *      type: // value for 'type'
 *      slug: // value for 'slug'
 *      id: // value for 'id'
 *      breadcrumbsVersion: // value for 'breadcrumbsVersion'
 *      presentation: // value for 'presentation'
 *      boost: // value for 'boost'
 *   },
 * });
 */
export function useSinglePostQuery(baseOptions: Apollo.QueryHookOptions<SinglePostQuery, SinglePostQueryVariables> & ({ variables: SinglePostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SinglePostQuery, SinglePostQueryVariables>(SinglePostDocument, options);
      }
export function useSinglePostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SinglePostQuery, SinglePostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SinglePostQuery, SinglePostQueryVariables>(SinglePostDocument, options);
        }
export function useSinglePostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SinglePostQuery, SinglePostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SinglePostQuery, SinglePostQueryVariables>(SinglePostDocument, options);
        }
export type SinglePostQueryHookResult = ReturnType<typeof useSinglePostQuery>;
export type SinglePostLazyQueryHookResult = ReturnType<typeof useSinglePostLazyQuery>;
export type SinglePostSuspenseQueryHookResult = ReturnType<typeof useSinglePostSuspenseQuery>;
export type SinglePostQueryResult = Apollo.QueryResult<SinglePostQuery, SinglePostQueryVariables>;
export const SingleProductDocument = gql`
    query SingleProduct($type: PageType!, $slug: String!, $id: ID, $reviewLimit: Int = 10, $reviewCursor: String = "", $breadcrumbsVersion: Int = 1, $presentation: PagePresentation = FULL, $loadRecommendations: Boolean = false, $boost: ID) {
  page(type: $type, slug: $slug, id: $id, presentation: $presentation) {
    id
    type
    title
    url
    seo {
      title
      description
      noIndex
      includeInSitemap
    }
    breadcrumbs(version: $breadcrumbsVersion) {
      id
      type
      title
      url
    }
    openGraph {
      ...OpenGraphContent
    }
    alternateLinks {
      locale
      url
    }
    blocks {
      ...BlockContent
      ... on GlobalBlock {
        id
        type
        blocks {
          ...BlockContent
        }
      }
      ... on ProductListBlock {
        extraBlocks {
          ...BlockContent
        }
        injections {
          id
          slot
          blocks {
            ...BlockContent
          }
        }
        guidedFilters {
          ... on GuidedFilterAttributeEnum {
            items {
              extraBlocks {
                ...BlockContent
              }
              injections {
                id
                slot
                blocks {
                  ...BlockContent
                }
              }
            }
          }
        }
      }
    }
    fields {
      ... on ProductField {
        key
        product(
          mode: PROJECTION
          combineVariants: true
          onlyEnabled: true
          sortVariants: true
        ) {
          ...ProductContent
          ...ProductReviews
          ...ProductSpecificationFragment
          tactics {
            gold {
              ...ProductPageTacticFragment
            }
            silver {
              ...ProductPageTacticFragment
            }
            bronze {
              ...ProductPageTacticFragment
            }
            temporary {
              ...ProductPageTacticFragment
            }
          }
          categoryIDs
          masterVariant {
            bundleContent: attribute(key: "products") {
              ...ProductBundle
            }
            bundlePrice: attributePrice(key: "products") {
              difference {
                ...MoneyContent
              }
              originalPrice {
                ...MoneyContent
              }
              price {
                ...MoneyContent
              }
            }
            crossSells: attribute(key: "crossSells") {
              ... on ProductAttribute {
                products(onlyAvailable: true) {
                  ...ProductCrossSellAndPersonalizationContent
                }
              }
            }
            personalizations: attribute(key: "personalizations") {
              ... on ProductAttribute {
                products {
                  ...ProductCrossSellAndPersonalizationContent
                }
              }
            }
            linkingDataColors: attribute(key: "primaryColors", locale: "en-GB") {
              ... on BaseAttribute {
                value
              }
            }
            linkingDataMaterials: attribute(key: "primaryMaterials", locale: "en-GB") {
              ... on BaseAttribute {
                value
              }
            }
            linkingDataPrice: price {
              currencyCode
              format(mode: NUMBER_PLAIN, locale: "en-GB")
              discount {
                format(mode: NUMBER_PLAIN, locale: "en-GB")
              }
            }
          }
          linkedProducts {
            type
            productIDs
          }
          houseBrand {
            products(mode: PROJECTION, onlyAvailable: true, onlyEnabled: true) {
              ...ProductTile
            }
          }
        }
      }
    }
  }
}
    ${OpenGraphContentFragmentDoc}
${BlockContentFragmentDoc}
${ProductContentFragmentDoc}
${ProductReviewsFragmentDoc}
${ProductSpecificationFragmentFragmentDoc}
${ProductPageTacticFragmentFragmentDoc}
${ProductBundleFragmentDoc}
${MoneyContentFragmentDoc}
${ProductCrossSellAndPersonalizationContentFragmentDoc}
${ProductTileFragmentDoc}`;

/**
 * __useSingleProductQuery__
 *
 * To run a query within a React component, call `useSingleProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProductQuery({
 *   variables: {
 *      type: // value for 'type'
 *      slug: // value for 'slug'
 *      id: // value for 'id'
 *      reviewLimit: // value for 'reviewLimit'
 *      reviewCursor: // value for 'reviewCursor'
 *      breadcrumbsVersion: // value for 'breadcrumbsVersion'
 *      presentation: // value for 'presentation'
 *      loadRecommendations: // value for 'loadRecommendations'
 *      boost: // value for 'boost'
 *   },
 * });
 */
export function useSingleProductQuery(baseOptions: Apollo.QueryHookOptions<SingleProductQuery, SingleProductQueryVariables> & ({ variables: SingleProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProductQuery, SingleProductQueryVariables>(SingleProductDocument, options);
      }
export function useSingleProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProductQuery, SingleProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProductQuery, SingleProductQueryVariables>(SingleProductDocument, options);
        }
export function useSingleProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleProductQuery, SingleProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleProductQuery, SingleProductQueryVariables>(SingleProductDocument, options);
        }
export type SingleProductQueryHookResult = ReturnType<typeof useSingleProductQuery>;
export type SingleProductLazyQueryHookResult = ReturnType<typeof useSingleProductLazyQuery>;
export type SingleProductSuspenseQueryHookResult = ReturnType<typeof useSingleProductSuspenseQuery>;
export type SingleProductQueryResult = Apollo.QueryResult<SingleProductQuery, SingleProductQueryVariables>;
export const TrackingDataDocument = gql`
    query TrackingData($token: String, $orderNumber: String) {
  tracking(token: $token, orderNumber: $orderNumber) {
    trackingNumber
    orderID
    returnID
    originCountryCode
    destinationCountryCode
    trackingURL
    events {
      state
      subState
      timestamp
      location
      messages
      type
    }
    createdAt
  }
}
    `;

/**
 * __useTrackingDataQuery__
 *
 * To run a query within a React component, call `useTrackingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackingDataQuery({
 *   variables: {
 *      token: // value for 'token'
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useTrackingDataQuery(baseOptions?: Apollo.QueryHookOptions<TrackingDataQuery, TrackingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackingDataQuery, TrackingDataQueryVariables>(TrackingDataDocument, options);
      }
export function useTrackingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackingDataQuery, TrackingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackingDataQuery, TrackingDataQueryVariables>(TrackingDataDocument, options);
        }
export function useTrackingDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrackingDataQuery, TrackingDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrackingDataQuery, TrackingDataQueryVariables>(TrackingDataDocument, options);
        }
export type TrackingDataQueryHookResult = ReturnType<typeof useTrackingDataQuery>;
export type TrackingDataLazyQueryHookResult = ReturnType<typeof useTrackingDataLazyQuery>;
export type TrackingDataSuspenseQueryHookResult = ReturnType<typeof useTrackingDataSuspenseQuery>;
export type TrackingDataQueryResult = Apollo.QueryResult<TrackingDataQuery, TrackingDataQueryVariables>;
export const CustomersGlobalsQueryDocument = gql`
    query CustomersGlobalsQuery($email: String) {
  customer(email: $email) {
    id
  }
}
    `;

/**
 * __useCustomersGlobalsQueryQuery__
 *
 * To run a query within a React component, call `useCustomersGlobalsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersGlobalsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersGlobalsQueryQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCustomersGlobalsQueryQuery(baseOptions?: Apollo.QueryHookOptions<CustomersGlobalsQueryQuery, CustomersGlobalsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersGlobalsQueryQuery, CustomersGlobalsQueryQueryVariables>(CustomersGlobalsQueryDocument, options);
      }
export function useCustomersGlobalsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersGlobalsQueryQuery, CustomersGlobalsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersGlobalsQueryQuery, CustomersGlobalsQueryQueryVariables>(CustomersGlobalsQueryDocument, options);
        }
export function useCustomersGlobalsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomersGlobalsQueryQuery, CustomersGlobalsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomersGlobalsQueryQuery, CustomersGlobalsQueryQueryVariables>(CustomersGlobalsQueryDocument, options);
        }
export type CustomersGlobalsQueryQueryHookResult = ReturnType<typeof useCustomersGlobalsQueryQuery>;
export type CustomersGlobalsQueryLazyQueryHookResult = ReturnType<typeof useCustomersGlobalsQueryLazyQuery>;
export type CustomersGlobalsQuerySuspenseQueryHookResult = ReturnType<typeof useCustomersGlobalsQuerySuspenseQuery>;
export type CustomersGlobalsQueryQueryResult = Apollo.QueryResult<CustomersGlobalsQueryQuery, CustomersGlobalsQueryQueryVariables>;
export const GlobalFacetDescriptionsDocument = gql`
    query GlobalFacetDescriptions {
  facetDescriptions {
    id
    facet
    facetGroup
  }
}
    `;

/**
 * __useGlobalFacetDescriptionsQuery__
 *
 * To run a query within a React component, call `useGlobalFacetDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalFacetDescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalFacetDescriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalFacetDescriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GlobalFacetDescriptionsQuery, GlobalFacetDescriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalFacetDescriptionsQuery, GlobalFacetDescriptionsQueryVariables>(GlobalFacetDescriptionsDocument, options);
      }
export function useGlobalFacetDescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalFacetDescriptionsQuery, GlobalFacetDescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalFacetDescriptionsQuery, GlobalFacetDescriptionsQueryVariables>(GlobalFacetDescriptionsDocument, options);
        }
export function useGlobalFacetDescriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalFacetDescriptionsQuery, GlobalFacetDescriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalFacetDescriptionsQuery, GlobalFacetDescriptionsQueryVariables>(GlobalFacetDescriptionsDocument, options);
        }
export type GlobalFacetDescriptionsQueryHookResult = ReturnType<typeof useGlobalFacetDescriptionsQuery>;
export type GlobalFacetDescriptionsLazyQueryHookResult = ReturnType<typeof useGlobalFacetDescriptionsLazyQuery>;
export type GlobalFacetDescriptionsSuspenseQueryHookResult = ReturnType<typeof useGlobalFacetDescriptionsSuspenseQuery>;
export type GlobalFacetDescriptionsQueryResult = Apollo.QueryResult<GlobalFacetDescriptionsQuery, GlobalFacetDescriptionsQueryVariables>;
export const GlobalInjectionsDocument = gql`
    query GlobalInjections($boost: ID) {
  injections {
    __typename
    ... on AnchorInjection {
      id
      selector {
        ...InjectionSelectorFragment
      }
      placement {
        ...InjectionPlacementFragment
      }
      items {
        __typename
        ... on InjectionTypeAnchor {
          id
          anchor
          blocks {
            ...BlockContent
          }
        }
        ... on InjectionTypeGrid {
          id
          dimensions {
            columns
            x
            y
            width
            height
          }
          blocks {
            ...BlockContent
          }
        }
      }
      splitTest {
        test
        groups
      }
    }
    ... on BlockInjection {
      id
      selector {
        ...InjectionSelectorFragment
      }
      blocks {
        ...BlockContent
      }
      placement {
        ...InjectionPlacementFragment
      }
      placementModifier
      placementOccurrences
      priority
      splitTest {
        test
        groups
      }
    }
  }
}
    ${InjectionSelectorFragmentFragmentDoc}
${InjectionPlacementFragmentFragmentDoc}
${BlockContentFragmentDoc}`;

/**
 * __useGlobalInjectionsQuery__
 *
 * To run a query within a React component, call `useGlobalInjectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalInjectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalInjectionsQuery({
 *   variables: {
 *      boost: // value for 'boost'
 *   },
 * });
 */
export function useGlobalInjectionsQuery(baseOptions?: Apollo.QueryHookOptions<GlobalInjectionsQuery, GlobalInjectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalInjectionsQuery, GlobalInjectionsQueryVariables>(GlobalInjectionsDocument, options);
      }
export function useGlobalInjectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalInjectionsQuery, GlobalInjectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalInjectionsQuery, GlobalInjectionsQueryVariables>(GlobalInjectionsDocument, options);
        }
export function useGlobalInjectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalInjectionsQuery, GlobalInjectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalInjectionsQuery, GlobalInjectionsQueryVariables>(GlobalInjectionsDocument, options);
        }
export type GlobalInjectionsQueryHookResult = ReturnType<typeof useGlobalInjectionsQuery>;
export type GlobalInjectionsLazyQueryHookResult = ReturnType<typeof useGlobalInjectionsLazyQuery>;
export type GlobalInjectionsSuspenseQueryHookResult = ReturnType<typeof useGlobalInjectionsSuspenseQuery>;
export type GlobalInjectionsQueryResult = Apollo.QueryResult<GlobalInjectionsQuery, GlobalInjectionsQueryVariables>;
export const SubscribeToNewsletterDocument = gql`
    mutation SubscribeToNewsletter($email: String!, $source: String, $campaign: String) {
  subscribeToNewsletter(
    input: {email: $email, source: $source, campaign: $campaign}
  )
}
    `;
export type SubscribeToNewsletterMutationFn = Apollo.MutationFunction<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>;

/**
 * __useSubscribeToNewsletterMutation__
 *
 * To run a mutation, you first call `useSubscribeToNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToNewsletterMutation, { data, loading, error }] = useSubscribeToNewsletterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      source: // value for 'source'
 *      campaign: // value for 'campaign'
 *   },
 * });
 */
export function useSubscribeToNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>(SubscribeToNewsletterDocument, options);
      }
export type SubscribeToNewsletterMutationHookResult = ReturnType<typeof useSubscribeToNewsletterMutation>;
export type SubscribeToNewsletterMutationResult = Apollo.MutationResult<SubscribeToNewsletterMutation>;
export type SubscribeToNewsletterMutationOptions = Apollo.BaseMutationOptions<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>;
export const GlobalPaymentMethodsDocument = gql`
    query GlobalPaymentMethods {
  paymentMethods {
    provider
    type
    icons {
      name
      logo {
        dimensions {
          width
          height
        }
        tags
        url
      }
    }
    logo {
      dimensions {
        width
        height
      }
      tags
      url
    }
  }
}
    `;

/**
 * __useGlobalPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGlobalPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GlobalPaymentMethodsQuery, GlobalPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalPaymentMethodsQuery, GlobalPaymentMethodsQueryVariables>(GlobalPaymentMethodsDocument, options);
      }
export function useGlobalPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalPaymentMethodsQuery, GlobalPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalPaymentMethodsQuery, GlobalPaymentMethodsQueryVariables>(GlobalPaymentMethodsDocument, options);
        }
export function useGlobalPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalPaymentMethodsQuery, GlobalPaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalPaymentMethodsQuery, GlobalPaymentMethodsQueryVariables>(GlobalPaymentMethodsDocument, options);
        }
export type GlobalPaymentMethodsQueryHookResult = ReturnType<typeof useGlobalPaymentMethodsQuery>;
export type GlobalPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGlobalPaymentMethodsLazyQuery>;
export type GlobalPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useGlobalPaymentMethodsSuspenseQuery>;
export type GlobalPaymentMethodsQueryResult = Apollo.QueryResult<GlobalPaymentMethodsQuery, GlobalPaymentMethodsQueryVariables>;
export const ProductAnalyticsDocument = gql`
    query ProductAnalytics($id: ID) {
  product(id: $id, mode: PROJECTION) {
    id
    brand {
      title
    }
    categoryIDs
    primaryCategories {
      id
      name(locale: "en-GB")
    }
    masterVariant {
      isNew: attribute(key: "isNew") {
        __typename
        ... on BaseAttribute {
          value
        }
      }
      price {
        discount {
          value
        }
      }
    }
    videoAsset: asset(tag: "video") {
      url
    }
  }
}
    `;

/**
 * __useProductAnalyticsQuery__
 *
 * To run a query within a React component, call `useProductAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductAnalyticsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<ProductAnalyticsQuery, ProductAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductAnalyticsQuery, ProductAnalyticsQueryVariables>(ProductAnalyticsDocument, options);
      }
export function useProductAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductAnalyticsQuery, ProductAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductAnalyticsQuery, ProductAnalyticsQueryVariables>(ProductAnalyticsDocument, options);
        }
export function useProductAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductAnalyticsQuery, ProductAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductAnalyticsQuery, ProductAnalyticsQueryVariables>(ProductAnalyticsDocument, options);
        }
export type ProductAnalyticsQueryHookResult = ReturnType<typeof useProductAnalyticsQuery>;
export type ProductAnalyticsLazyQueryHookResult = ReturnType<typeof useProductAnalyticsLazyQuery>;
export type ProductAnalyticsSuspenseQueryHookResult = ReturnType<typeof useProductAnalyticsSuspenseQuery>;
export type ProductAnalyticsQueryResult = Apollo.QueryResult<ProductAnalyticsQuery, ProductAnalyticsQueryVariables>;
export const SubscribeToBackInStockDocument = gql`
    mutation subscribeToBackInStock($productID: String!, $email: String, $phoneNumber: String) {
  subscribeToBackInStock(
    productID: $productID
    email: $email
    phoneNumber: $phoneNumber
  )
}
    `;
export type SubscribeToBackInStockMutationFn = Apollo.MutationFunction<SubscribeToBackInStockMutation, SubscribeToBackInStockMutationVariables>;

/**
 * __useSubscribeToBackInStockMutation__
 *
 * To run a mutation, you first call `useSubscribeToBackInStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToBackInStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToBackInStockMutation, { data, loading, error }] = useSubscribeToBackInStockMutation({
 *   variables: {
 *      productID: // value for 'productID'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useSubscribeToBackInStockMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToBackInStockMutation, SubscribeToBackInStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToBackInStockMutation, SubscribeToBackInStockMutationVariables>(SubscribeToBackInStockDocument, options);
      }
export type SubscribeToBackInStockMutationHookResult = ReturnType<typeof useSubscribeToBackInStockMutation>;
export type SubscribeToBackInStockMutationResult = Apollo.MutationResult<SubscribeToBackInStockMutation>;
export type SubscribeToBackInStockMutationOptions = Apollo.BaseMutationOptions<SubscribeToBackInStockMutation, SubscribeToBackInStockMutationVariables>;
export const ReturnOptionsByEmailDocument = gql`
    query ReturnOptionsByEmail($orderNumber: String!, $email: String!) {
  returnOptionsByEmail(orderNumber: $orderNumber, email: $email) {
    orderNumber
    isSwapEnabled
    optionLineItems {
      orderLineItemID
      fallbackTitle
      isPersonalized
      productID
      product(combineVariants: true) {
        id
        name
        asset {
          url
        }
        availability {
          isInStock
        }
        variants {
          id
          size: attribute(key: "size") {
            ... on BaseAttribute {
              value
            }
          }
          availability {
            isInStock
          }
        }
      }
      returnableQuantity
    }
    refundMethods
    previousReturns {
      ID
      key
      state
      createdAt
    }
  }
}
    `;

/**
 * __useReturnOptionsByEmailQuery__
 *
 * To run a query within a React component, call `useReturnOptionsByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useReturnOptionsByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReturnOptionsByEmailQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useReturnOptionsByEmailQuery(baseOptions: Apollo.QueryHookOptions<ReturnOptionsByEmailQuery, ReturnOptionsByEmailQueryVariables> & ({ variables: ReturnOptionsByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReturnOptionsByEmailQuery, ReturnOptionsByEmailQueryVariables>(ReturnOptionsByEmailDocument, options);
      }
export function useReturnOptionsByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReturnOptionsByEmailQuery, ReturnOptionsByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReturnOptionsByEmailQuery, ReturnOptionsByEmailQueryVariables>(ReturnOptionsByEmailDocument, options);
        }
export function useReturnOptionsByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReturnOptionsByEmailQuery, ReturnOptionsByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReturnOptionsByEmailQuery, ReturnOptionsByEmailQueryVariables>(ReturnOptionsByEmailDocument, options);
        }
export type ReturnOptionsByEmailQueryHookResult = ReturnType<typeof useReturnOptionsByEmailQuery>;
export type ReturnOptionsByEmailLazyQueryHookResult = ReturnType<typeof useReturnOptionsByEmailLazyQuery>;
export type ReturnOptionsByEmailSuspenseQueryHookResult = ReturnType<typeof useReturnOptionsByEmailSuspenseQuery>;
export type ReturnOptionsByEmailQueryResult = Apollo.QueryResult<ReturnOptionsByEmailQuery, ReturnOptionsByEmailQueryVariables>;
export const EstimateReturnTotalsDocument = gql`
    query EstimateReturnTotals($orderNumber: String!, $returningItems: [ReturningItemInput!]!, $email: String!) {
  estimateReturnTotals(
    orderNumber: $orderNumber
    returningItems: $returningItems
    email: $email
  ) {
    shippingToRefund {
      currencyCode
      value
      format
    }
    shippingToPay {
      currencyCode
      value
      format
    }
    itemsToRefund {
      currencyCode
      value
      format
    }
    totalToRefund {
      currencyCode
      value
      format
    }
    swapItems {
      orderLineItemID
      quantity
      swapToProductKey
      value {
        currencyCode
        value
        format
      }
    }
  }
}
    `;

/**
 * __useEstimateReturnTotalsQuery__
 *
 * To run a query within a React component, call `useEstimateReturnTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimateReturnTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateReturnTotalsQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *      returningItems: // value for 'returningItems'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useEstimateReturnTotalsQuery(baseOptions: Apollo.QueryHookOptions<EstimateReturnTotalsQuery, EstimateReturnTotalsQueryVariables> & ({ variables: EstimateReturnTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstimateReturnTotalsQuery, EstimateReturnTotalsQueryVariables>(EstimateReturnTotalsDocument, options);
      }
export function useEstimateReturnTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstimateReturnTotalsQuery, EstimateReturnTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstimateReturnTotalsQuery, EstimateReturnTotalsQueryVariables>(EstimateReturnTotalsDocument, options);
        }
export function useEstimateReturnTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EstimateReturnTotalsQuery, EstimateReturnTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstimateReturnTotalsQuery, EstimateReturnTotalsQueryVariables>(EstimateReturnTotalsDocument, options);
        }
export type EstimateReturnTotalsQueryHookResult = ReturnType<typeof useEstimateReturnTotalsQuery>;
export type EstimateReturnTotalsLazyQueryHookResult = ReturnType<typeof useEstimateReturnTotalsLazyQuery>;
export type EstimateReturnTotalsSuspenseQueryHookResult = ReturnType<typeof useEstimateReturnTotalsSuspenseQuery>;
export type EstimateReturnTotalsQueryResult = Apollo.QueryResult<EstimateReturnTotalsQuery, EstimateReturnTotalsQueryVariables>;
export const CreateReturnDocument = gql`
    mutation CreateReturn($orderNumber: String!, $returningItems: [ReturningItemInput!]!, $refundMethod: ReturnRefundMethod!, $email: String!, $bankDetails: ReturnBankDetailsInput) {
  createReturn(
    orderNumber: $orderNumber
    returningItems: $returningItems
    refundMethod: $refundMethod
    email: $email
    bankDetails: $bankDetails
  ) {
    state
    orderNumber
    key
    ID
  }
}
    `;
export type CreateReturnMutationFn = Apollo.MutationFunction<CreateReturnMutation, CreateReturnMutationVariables>;

/**
 * __useCreateReturnMutation__
 *
 * To run a mutation, you first call `useCreateReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReturnMutation, { data, loading, error }] = useCreateReturnMutation({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *      returningItems: // value for 'returningItems'
 *      refundMethod: // value for 'refundMethod'
 *      email: // value for 'email'
 *      bankDetails: // value for 'bankDetails'
 *   },
 * });
 */
export function useCreateReturnMutation(baseOptions?: Apollo.MutationHookOptions<CreateReturnMutation, CreateReturnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReturnMutation, CreateReturnMutationVariables>(CreateReturnDocument, options);
      }
export type CreateReturnMutationHookResult = ReturnType<typeof useCreateReturnMutation>;
export type CreateReturnMutationResult = Apollo.MutationResult<CreateReturnMutation>;
export type CreateReturnMutationOptions = Apollo.BaseMutationOptions<CreateReturnMutation, CreateReturnMutationVariables>;
export const CreateOrderReviewDocument = gql`
    mutation CreateOrderReview($orderNumber: String!, $reviewToken: String!, $productReviews: [OrderReviewProductReviewInput!], $surveyAnswers: [OrderReviewSurveyAnswerInput!]) {
  createOrderReview(
    orderNumber: $orderNumber
    reviewToken: $reviewToken
    productReviews: $productReviews
    surveyAnswers: $surveyAnswers
  ) {
    ...OrderReviewFragment
  }
}
    ${OrderReviewFragmentFragmentDoc}`;
export type CreateOrderReviewMutationFn = Apollo.MutationFunction<CreateOrderReviewMutation, CreateOrderReviewMutationVariables>;

/**
 * __useCreateOrderReviewMutation__
 *
 * To run a mutation, you first call `useCreateOrderReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderReviewMutation, { data, loading, error }] = useCreateOrderReviewMutation({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *      reviewToken: // value for 'reviewToken'
 *      productReviews: // value for 'productReviews'
 *      surveyAnswers: // value for 'surveyAnswers'
 *   },
 * });
 */
export function useCreateOrderReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderReviewMutation, CreateOrderReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrderReviewMutation, CreateOrderReviewMutationVariables>(CreateOrderReviewDocument, options);
      }
export type CreateOrderReviewMutationHookResult = ReturnType<typeof useCreateOrderReviewMutation>;
export type CreateOrderReviewMutationResult = Apollo.MutationResult<CreateOrderReviewMutation>;
export type CreateOrderReviewMutationOptions = Apollo.BaseMutationOptions<CreateOrderReviewMutation, CreateOrderReviewMutationVariables>;
export const OrderReviewDocument = gql`
    query OrderReview($orderNumber: String!, $reviewToken: String!) {
  orderReview(orderNumber: $orderNumber, reviewToken: $reviewToken) {
    ...OrderReviewFragment
  }
}
    ${OrderReviewFragmentFragmentDoc}`;

/**
 * __useOrderReviewQuery__
 *
 * To run a query within a React component, call `useOrderReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderReviewQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *      reviewToken: // value for 'reviewToken'
 *   },
 * });
 */
export function useOrderReviewQuery(baseOptions: Apollo.QueryHookOptions<OrderReviewQuery, OrderReviewQueryVariables> & ({ variables: OrderReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderReviewQuery, OrderReviewQueryVariables>(OrderReviewDocument, options);
      }
export function useOrderReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderReviewQuery, OrderReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderReviewQuery, OrderReviewQueryVariables>(OrderReviewDocument, options);
        }
export function useOrderReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderReviewQuery, OrderReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderReviewQuery, OrderReviewQueryVariables>(OrderReviewDocument, options);
        }
export type OrderReviewQueryHookResult = ReturnType<typeof useOrderReviewQuery>;
export type OrderReviewLazyQueryHookResult = ReturnType<typeof useOrderReviewLazyQuery>;
export type OrderReviewSuspenseQueryHookResult = ReturnType<typeof useOrderReviewSuspenseQuery>;
export type OrderReviewQueryResult = Apollo.QueryResult<OrderReviewQuery, OrderReviewQueryVariables>;
export const SurveyDocument = gql`
    query Survey($orderNumber: String!, $reviewToken: String!) {
  orderReview(orderNumber: $orderNumber, reviewToken: $reviewToken) {
    surveyQuestions {
      id
      title
      options {
        id
        title
        showTextInput
      }
      parentOptionID
    }
  }
}
    `;

/**
 * __useSurveyQuery__
 *
 * To run a query within a React component, call `useSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *      reviewToken: // value for 'reviewToken'
 *   },
 * });
 */
export function useSurveyQuery(baseOptions: Apollo.QueryHookOptions<SurveyQuery, SurveyQueryVariables> & ({ variables: SurveyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options);
      }
export function useSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyQuery, SurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options);
        }
export function useSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyQuery, SurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options);
        }
export type SurveyQueryHookResult = ReturnType<typeof useSurveyQuery>;
export type SurveyLazyQueryHookResult = ReturnType<typeof useSurveyLazyQuery>;
export type SurveySuspenseQueryHookResult = ReturnType<typeof useSurveySuspenseQuery>;
export type SurveyQueryResult = Apollo.QueryResult<SurveyQuery, SurveyQueryVariables>;
export const ShippingInfoDocument = gql`
    query ShippingInfo {
  shippingInfo {
    threshold {
      format
    }
    items {
      deliveryTime {
        text
      }
      logo {
        url
      }
      title
      price {
        ...ShippingInfoPriceFragment
      }
      priceBefore {
        ...ShippingInfoPriceFragment
      }
      priceAboveThreshold {
        ...ShippingInfoPriceFragment
      }
    }
  }
}
    ${ShippingInfoPriceFragmentFragmentDoc}`;

/**
 * __useShippingInfoQuery__
 *
 * To run a query within a React component, call `useShippingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useShippingInfoQuery(baseOptions?: Apollo.QueryHookOptions<ShippingInfoQuery, ShippingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingInfoQuery, ShippingInfoQueryVariables>(ShippingInfoDocument, options);
      }
export function useShippingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingInfoQuery, ShippingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingInfoQuery, ShippingInfoQueryVariables>(ShippingInfoDocument, options);
        }
export function useShippingInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShippingInfoQuery, ShippingInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShippingInfoQuery, ShippingInfoQueryVariables>(ShippingInfoDocument, options);
        }
export type ShippingInfoQueryHookResult = ReturnType<typeof useShippingInfoQuery>;
export type ShippingInfoLazyQueryHookResult = ReturnType<typeof useShippingInfoLazyQuery>;
export type ShippingInfoSuspenseQueryHookResult = ReturnType<typeof useShippingInfoSuspenseQuery>;
export type ShippingInfoQueryResult = Apollo.QueryResult<ShippingInfoQuery, ShippingInfoQueryVariables>;
export const StoresGlobalsQueryDocument = gql`
    query StoresGlobalsQuery {
  stores {
    id
    parentID
    title
    config {
      adwordsCurrencyRates {
        key
        value
      }
      adwordsTrackingID
      analyticsTrackingID
      cheapestShippingPrice {
        ...Money
      }
      countryCode
      currencyCode
      currencyFraction
      email
      freeShippingThreshold {
        ...Money
      }
      freeShippingThresholdClub {
        ...Money
      }
      giftcards {
        valueMin {
          ...Money
        }
        valueMax {
          ...Money
        }
        predefinedValues {
          ...Money
        }
      }
      localeCode
      merchantAccount
      phone
      trustpilotBusinessID
      trustpilotDomain
      urlDomain
      urlFull
      urlPath
      usercentricsEnabled
      vatNumber
    }
  }
}
    ${MoneyFragmentDoc}`;

/**
 * __useStoresGlobalsQueryQuery__
 *
 * To run a query within a React component, call `useStoresGlobalsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoresGlobalsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoresGlobalsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoresGlobalsQueryQuery(baseOptions?: Apollo.QueryHookOptions<StoresGlobalsQueryQuery, StoresGlobalsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoresGlobalsQueryQuery, StoresGlobalsQueryQueryVariables>(StoresGlobalsQueryDocument, options);
      }
export function useStoresGlobalsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoresGlobalsQueryQuery, StoresGlobalsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoresGlobalsQueryQuery, StoresGlobalsQueryQueryVariables>(StoresGlobalsQueryDocument, options);
        }
export function useStoresGlobalsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StoresGlobalsQueryQuery, StoresGlobalsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StoresGlobalsQueryQuery, StoresGlobalsQueryQueryVariables>(StoresGlobalsQueryDocument, options);
        }
export type StoresGlobalsQueryQueryHookResult = ReturnType<typeof useStoresGlobalsQueryQuery>;
export type StoresGlobalsQueryLazyQueryHookResult = ReturnType<typeof useStoresGlobalsQueryLazyQuery>;
export type StoresGlobalsQuerySuspenseQueryHookResult = ReturnType<typeof useStoresGlobalsQuerySuspenseQuery>;
export type StoresGlobalsQueryQueryResult = Apollo.QueryResult<StoresGlobalsQueryQuery, StoresGlobalsQueryQueryVariables>;
export const SuccessDocument = gql`
    query success($orderNumberOverride: String) {
  successPage(orderNumberOverride: $orderNumberOverride) {
    orderNumber
    expectedDispatchAt
    cart {
      id
      consents
      shippingMethodID
      availableShippingMethods {
        id
        isCOD
      }
      billingAddress {
        email
        emailHash: email(mode: HASH256)
        firstName
        lastName
        phone
        phoneHash: phone(mode: HASH256)
        phonePrefix
      }
      customerID
      deliveryAddress {
        firstName
        lastName
        streetName
        additionalStreetInfo
        postalCode
        city
        country
        phone
      }
      discountCodes {
        code
      }
      lineItemGroups {
        id
        lineItemIDs
        totalPrice {
          ...PriceFragment
        }
        type
      }
      lineItems {
        id
        tactic
        price {
          ...PriceFragment
        }
        totalPrice {
          ...PriceFragment
          ...MoneyContent
          discount {
            ...MoneyContent
          }
        }
        errors {
          code
          message
        }
        productID
        product(
          mode: PROJECTION
          combineVariants: true
          onlyEnabled: true
          sortVariants: true
        ) {
          ...ProductContent
          masterVariant {
            id
            isNew: attribute(key: "isNew") {
              __typename
              ... on BaseAttribute {
                value
              }
            }
          }
          videoAsset: asset(tag: "video") {
            url
          }
          variants {
            id
            size: attribute(key: "size") {
              __typename
              ... on BaseAttribute {
                value
              }
            }
          }
        }
        totalPrice {
          ...MoneyContent
          discount {
            ...MoneyContent
          }
        }
        totalTaxedPrice {
          totalNet {
            ...MoneyContent
            base: convert(currencyCode: "DKK") {
              plain: format(mode: NUMBER_PLAIN)
            }
          }
          totalGross {
            ...MoneyContent
          }
          totalTax {
            ...MoneyContent
          }
        }
        type {
          __typename
          ... on IWithCartLineItemLink {
            link
            parent
            children
            milestoneID
          }
          ... on CartLineItemTypeFreeProduct {
            disableSizeSelection
            hasSelectedVariant
          }
          ... on CartLineItemTypeGiftcard {
            text
            amount {
              format
              value
              currencyCode
            }
          }
          ... on CartLineItemTypeUpsellPersonalization {
            text
            blobID
          }
        }
        quantity
        variant {
          id
          type: attribute(key: "type") {
            ... on BaseAttribute {
              value
            }
          }
          subType: attribute(key: "subType") {
            ... on BaseAttribute {
              value
            }
          }
        }
      }
      totals {
        id
        style
        title
        text
        value {
          ...MoneyContent
        }
      }
      expectedDelivery
    }
    profit {
      orderNumber
      profitInfo {
        currencyCode
        grandTotal {
          ...MoneyContent
        }
        profit {
          ...MoneyContent
        }
        items {
          id
          profit {
            ...MoneyContent
          }
        }
      }
    }
  }
}
    ${PriceFragmentFragmentDoc}
${MoneyContentFragmentDoc}
${ProductContentFragmentDoc}`;

/**
 * __useSuccessQuery__
 *
 * To run a query within a React component, call `useSuccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuccessQuery({
 *   variables: {
 *      orderNumberOverride: // value for 'orderNumberOverride'
 *   },
 * });
 */
export function useSuccessQuery(baseOptions?: Apollo.QueryHookOptions<SuccessQuery, SuccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuccessQuery, SuccessQueryVariables>(SuccessDocument, options);
      }
export function useSuccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuccessQuery, SuccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuccessQuery, SuccessQueryVariables>(SuccessDocument, options);
        }
export function useSuccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuccessQuery, SuccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuccessQuery, SuccessQueryVariables>(SuccessDocument, options);
        }
export type SuccessQueryHookResult = ReturnType<typeof useSuccessQuery>;
export type SuccessLazyQueryHookResult = ReturnType<typeof useSuccessLazyQuery>;
export type SuccessSuspenseQueryHookResult = ReturnType<typeof useSuccessSuspenseQuery>;
export type SuccessQueryResult = Apollo.QueryResult<SuccessQuery, SuccessQueryVariables>;